import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DynamicObj: any;
  DynamicObject: any;
  Timestamp: any;
};

export type AadharKycConnectSessionDto = {
  __typename?: 'AadharKycConnectSessionDto';
  captchaImage: Scalars['String'];
  sessionId: Scalars['String'];
};

export type ActionRequiredUserPromotedAdvDto = {
  __typename?: 'ActionRequiredUserPromotedAdvDto';
  isActionRequired: Scalars['Boolean'];
};

export type AddRemoveCartQuantityDto = {
  __typename?: 'AddRemoveCartQuantityDto';
  cartSetList: Array<CartSetDetailDto>;
  errorMessage?: Maybe<Scalars['String']>;
  gstRate?: Maybe<Scalars['Float']>;
  totalPrice: Scalars['Float'];
};

export type AddRssFeedDetails = {
  __typename?: 'AddRssFeedDetails';
  _id?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  description: Scalars['String'];
  status: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type AddRssFeedInput = {
  _id?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  status: Scalars['String'];
  url: Scalars['String'];
};

export type AddToCartPayload = {
  categoryId: Scalars['ID'];
  productId: Scalars['ID'];
  productSetId: Scalars['ID'];
  sellerId?: InputMaybe<Scalars['ID']>;
  setPrice: Scalars['Float'];
  setQuantity: Scalars['Float'];
  userId: Scalars['ID'];
};

export type AddUserCreditDebitInput = {
  amount: Scalars['Float'];
  amountType: Scalars['String'];
  description: Scalars['String'];
  userId: Scalars['ID'];
};

export type AdditionalChargesInput = {
  amount: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type AddressDetailsDto = {
  __typename?: 'AddressDetailsDto';
  addressType?: Maybe<Scalars['String']>;
  cityName: Scalars['String'];
  countryCode?: Maybe<Scalars['Float']>;
  fullAddress: Scalars['String'];
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateName: Scalars['String'];
};

export type AddressPayload = {
  addressType?: InputMaybe<Scalars['String']>;
  cityName: Scalars['String'];
  countryCode?: InputMaybe<Scalars['Float']>;
  fullAddress: Scalars['String'];
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateName: Scalars['String'];
};

export type AdminDetails = {
  __typename?: 'AdminDetails';
  _id: Scalars['ID'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  roleId: Scalars['String'];
};

export type AdminInput = {
  email: Scalars['String'];
  fullName: Scalars['String'];
  password: Scalars['String'];
  roleId: Scalars['String'];
};

export type AdminList = {
  __typename?: 'AdminList';
  data: Array<AdminListObject>;
  totalRecords: Scalars['Float'];
};

export type AdminListObject = {
  __typename?: 'AdminListObject';
  _id: Scalars['ID'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  roleId: Scalars['String'];
  roleType: Scalars['String'];
};

export type AdminLogin = {
  __typename?: 'AdminLogin';
  _id: Scalars['ID'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  isSellerRegistrationAllowed?: Maybe<Scalars['Boolean']>;
  refreshToken?: Maybe<Scalars['String']>;
  roleId: Scalars['String'];
  roleType?: Maybe<Scalars['String']>;
  roles: Array<AdminRoles>;
  token?: Maybe<Scalars['String']>;
};

export type AdminLoginResponseDto = {
  __typename?: 'AdminLoginResponseDto';
  code: Scalars['Float'];
  data: AdminLogin;
  message: Scalars['String'];
};

export type AdminRolePermissionTypes = {
  __typename?: 'AdminRolePermissionTypes';
  _id: Scalars['ID'];
  isDefault: Scalars['String'];
  permissionTypeName: Scalars['String'];
  permissionTypeSlug: Scalars['String'];
};

export type AdminRoles = {
  __typename?: 'AdminRoles';
  moduleId: Scalars['ID'];
  moduleName: Scalars['String'];
  moduleSlug: Scalars['String'];
  permissionTypes: Array<AdminRolePermissionTypes>;
};

export type AdminUpdate = {
  __typename?: 'AdminUpdate';
  _id: Scalars['ID'];
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type AdminUpdateResponseDto = {
  __typename?: 'AdminUpdateResponseDto';
  code: Scalars['Float'];
  data: AdminUpdate;
  message: Scalars['String'];
};

export type AppVersionDetialDto = {
  __typename?: 'AppVersionDetialDto';
  appStatus: Scalars['String'];
  isAppActive: Scalars['Boolean'];
};

export type ApproveRejectProductAttributeValueInput = {
  adminVerificationSlug: Scalars['String'];
  attributeValueId: Scalars['ID'];
};

export type AttributeValuesUserDetails = {
  __typename?: 'AttributeValuesUserDetails';
  businessName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BankCreateInput = {
  bankLogo: Scalars['String'];
  bankName: Scalars['String'];
};

export type BankDetailDto = {
  __typename?: 'BankDetailDto';
  _id: Scalars['ID'];
  bankLogo?: Maybe<Scalars['String']>;
  bankName: Scalars['String'];
  isActive: Scalars['String'];
};

export type BankList = {
  __typename?: 'BankList';
  data: Array<BankListDto>;
  totalRecords: Scalars['Float'];
};

export type BankListDto = {
  __typename?: 'BankListDto';
  _id: Scalars['ID'];
  bankName: Scalars['String'];
  isActive: Scalars['String'];
};

export type BrandAddInput = {
  brandDocument: Scalars['String'];
  brandDocumentType: Scalars['String'];
  brandId?: InputMaybe<Scalars['ID']>;
  brandLogo?: InputMaybe<Scalars['String']>;
  brandName?: InputMaybe<Scalars['String']>;
  isBrandOwner: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type BrandDetailDto = {
  __typename?: 'BrandDetailDto';
  _id: Scalars['ID'];
  brandCancelReason?: Maybe<Scalars['String']>;
  brandDocument: Scalars['String'];
  brandDocumentType: Scalars['String'];
  brandLogo?: Maybe<Scalars['String']>;
  brandName: Scalars['String'];
  isBrandOwner?: Maybe<Scalars['Boolean']>;
  isGroupedOrNot?: Maybe<Scalars['Boolean']>;
  userDetails?: Maybe<UserDetailDto>;
  userId: Scalars['ID'];
  verifiedByAdmin: Scalars['String'];
};

export type BrandDetailResponseDto = {
  __typename?: 'BrandDetailResponseDto';
  code: Scalars['Float'];
  data?: Maybe<BrandDetailDto>;
  message: Scalars['String'];
};

export type BrandGroupDetailDto = {
  __typename?: 'BrandGroupDetailDto';
  _id: Scalars['ID'];
  brandCancelReason?: Maybe<Scalars['String']>;
  brandDocument: Scalars['String'];
  brandDocumentType: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  isBrandOwner: Scalars['Boolean'];
  userId: Scalars['ID'];
  userName: Scalars['String'];
  verifiedByAdmin: Scalars['String'];
};

export type BrandGroupList = {
  __typename?: 'BrandGroupList';
  data: Array<BrandGroupDetailDto>;
  totalRecords: Scalars['Float'];
};

export type BrandList = {
  __typename?: 'BrandList';
  data: Array<BrandDetailDto>;
  totalRecords: Scalars['Float'];
};

export type BrandNameExistsDto = {
  __typename?: 'BrandNameExistsDto';
  isBrandOwner: Scalars['Boolean'];
  isExists: Scalars['Boolean'];
};

export type BrandNameExistsResponseDto = {
  __typename?: 'BrandNameExistsResponseDto';
  code: Scalars['Float'];
  data: BrandNameExistsDto;
  message: Scalars['String'];
};

export type BrandNameListDto = {
  __typename?: 'BrandNameListDto';
  _id: Scalars['ID'];
  apiSlug?: Maybe<Scalars['String']>;
  brandLogo?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  parentSubCategoryId?: Maybe<Scalars['ID']>;
  parentSubCategoryName?: Maybe<Scalars['String']>;
};

export type BrandReviewResponseDto = {
  __typename?: 'BrandReviewResponseDto';
  code: Scalars['Float'];
  message: Scalars['String'];
};

export type BrandSectionAddInput = {
  brandId: Scalars['ID'];
  brandImage: Scalars['String'];
  categoryId: Scalars['ID'];
};

export type BrandSectionDetailDto = {
  __typename?: 'BrandSectionDetailDto';
  _id: Scalars['ID'];
  brandId: Scalars['ID'];
  brandImage: Scalars['String'];
  brandName: Scalars['String'];
  categoryId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type BrandSectionListDto = {
  __typename?: 'BrandSectionListDto';
  data: Array<BrandSectionDetailDto>;
  totalRecords: Scalars['Float'];
};

export type BuinessProductDto = {
  __typename?: 'BuinessProductDto';
  brandWebsite: Scalars['String'];
  categoryId: Scalars['ID'];
  categoryLogos?: Maybe<CategoryLogoTypes>;
  categoryName?: Maybe<Scalars['String']>;
  categoryProducts: Array<SubCategoryDetailDto>;
  productDesigns: Scalars['Float'];
  productIds: Array<Scalars['String']>;
  productRangePrice: BuinessProductRangePriceDto;
};

export type BuinessProductInput = {
  brandWebsite: Scalars['String'];
  categoryId: Scalars['ID'];
  productDesigns: Scalars['Float'];
  productIds: Array<Scalars['String']>;
  productRangePrice: BuinessProductRangePriceInput;
};

export type BuinessProductRangePriceDto = {
  __typename?: 'BuinessProductRangePriceDto';
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type BuinessProductRangePriceInput = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type BulkPrice = {
  moqPricePerPiece?: InputMaybe<Scalars['Float']>;
  moqSet: Scalars['Float'];
};

export type BulkPriceDto = {
  __typename?: 'BulkPriceDto';
  moqPricePerPiece?: Maybe<Scalars['Float']>;
  moqSet: Scalars['Float'];
  moqSetPrice?: Maybe<Scalars['Float']>;
};

export type BulkPriceField = {
  days: Scalars['Float'];
  price: Scalars['Float'];
};

export type BulkPriceFieldDto = {
  __typename?: 'BulkPriceFieldDto';
  days: Scalars['Float'];
  price: Scalars['Float'];
};

export type BulkUploadDto = {
  __typename?: 'BulkUploadDto';
  code: Scalars['Float'];
  data: BulkUploadUrlDto;
  message: Scalars['String'];
};

export type BulkUploadHistoryDto = {
  __typename?: 'BulkUploadHistoryDto';
  _id: Scalars['ID'];
  businessName?: Maybe<Scalars['String']>;
  categoryName: Scalars['ID'];
  categorySlug: Scalars['ID'];
  createdAt: Scalars['String'];
  failureCount?: Maybe<Scalars['Float']>;
  sellerName?: Maybe<Scalars['String']>;
  sheetId: Scalars['ID'];
  sheetName: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  successCount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};

export type BulkUploadHistoryListDto = {
  __typename?: 'BulkUploadHistoryListDto';
  data: Array<BulkUploadHistoryDto>;
  totalRecords?: Maybe<Scalars['Float']>;
};

export type BulkUploadSuccessFailureCountDto = {
  __typename?: 'BulkUploadSuccessFailureCountDto';
  failureCount: Scalars['Float'];
  successCount: Scalars['Float'];
};

export type BulkUploadUrlDto = {
  __typename?: 'BulkUploadUrlDto';
  url: Scalars['String'];
};

export type BusinessHours = {
  __typename?: 'BusinessHours';
  close_time: Scalars['String'];
  start_time: Scalars['String'];
};

export type BusinessTimingDto = {
  __typename?: 'BusinessTimingDto';
  sameEveryDay: Scalars['Boolean'];
  shopTimings: Array<ShopTimingDto>;
};

export type BusinessTimingInput = {
  sameEveryDay: Scalars['Boolean'];
  shopTimings: Array<ShopTimingInput>;
};

export type BusinessTypeCreateInput = {
  businessTypeName: Scalars['String'];
};

export type BusinessTypeDetailDto = {
  __typename?: 'BusinessTypeDetailDto';
  _id: Scalars['ID'];
  businessTypeName: Scalars['String'];
  isActive: Scalars['String'];
};

export type BusinessTypeList = {
  __typename?: 'BusinessTypeList';
  data: Array<BusinessTypeDetailDto>;
  totalRecords: Scalars['Float'];
};

export type BuyerDetailsDto = {
  __typename?: 'BuyerDetailsDto';
  _id?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  buyerName: Scalars['String'];
  countryCode?: Maybe<Scalars['Float']>;
  fullAddress: Scalars['String'];
  phoneNumber: Scalars['Float'];
};

export type BuyerProductListDetailsDto = {
  __typename?: 'BuyerProductListDetailsDto';
  data: Array<BuyerSideProductListDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type BuyerSideProductListDetailsDto = {
  __typename?: 'BuyerSideProductListDetailsDto';
  _id: Scalars['ID'];
  averageRatings?: Maybe<Scalars['Float']>;
  brandId?: Maybe<Scalars['ID']>;
  brandName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['ID']>;
  categoryName?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  isAdvertisementProduct?: Maybe<Scalars['Boolean']>;
  isProductWishlisted?: Maybe<Scalars['Boolean']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  listingTitle?: Maybe<Scalars['String']>;
  productCancelReason?: Maybe<Scalars['String']>;
  productImages?: Maybe<Array<ProductImagesListDto>>;
  productPriceDetails?: Maybe<ProductPriceDetails>;
  productStatus?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['ID']>;
  subCategoryName?: Maybe<Scalars['String']>;
  totalReviewCounts?: Maybe<Scalars['Float']>;
  userDetails?: Maybe<UserDetailDto>;
  userId: Scalars['ID'];
  verifiedByAdmin?: Maybe<Scalars['String']>;
};

export type CartDiscountAddUpdateInput = {
  cartValue?: InputMaybe<Scalars['Float']>;
  discount: Scalars['Float'];
};

export type CartDiscountDto = {
  __typename?: 'CartDiscountDto';
  cartValue?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type CartItemDetailsDto = {
  __typename?: 'CartItemDetailsDto';
  cartDiscount?: Maybe<Scalars['Float']>;
  cartDiscountPrice: Scalars['Float'];
  discountedTotalPrice: Scalars['Float'];
  finalPrice: Scalars['Float'];
  individualOrderSummary?: Maybe<OrderSummaryDto>;
  isMovFulFilled?: Maybe<Scalars['Boolean']>;
  sellerId: Scalars['ID'];
  sellerMov?: Maybe<Scalars['Float']>;
  sellerProductsCartList: Array<SellerProductsCartListDto>;
  soldBy: Scalars['String'];
  sourceAddress?: Maybe<UserAddressDto>;
  totalAdditionalDiscountPrice: Scalars['Float'];
  totalGstPrice: Scalars['Float'];
  totalPayableAmount: Scalars['Float'];
};

export type CartItemsDto = {
  __typename?: 'CartItemsDto';
  cartDiscount?: Maybe<Scalars['Float']>;
  categorySlug: Scalars['String'];
  discountedTotalPrice: Scalars['Float'];
  individualOrderSummary?: Maybe<OrderSummaryDto>;
  isMovFulFilled: Scalars['Boolean'];
  products: Array<UserCartProductsDetail>;
  sellerId?: Maybe<Scalars['ID']>;
  sellerMov?: Maybe<Scalars['Float']>;
  soldBy: Scalars['String'];
  sourceAddress?: Maybe<UserAddressDto>;
  totalPrice: Scalars['Float'];
};

export type CartSetDetailDto = {
  __typename?: 'CartSetDetailDto';
  errorMessage?: Maybe<Scalars['String']>;
  productSetId: Scalars['String'];
  setPrice: Scalars['Float'];
  setQuantity: Scalars['Float'];
  totalSetPrice: Scalars['Float'];
};

export type CategoryAttributeByIdInput = {
  __typename?: 'CategoryAttributeByIdInput';
  /** Product Attribute Id */
  _id: Scalars['ID'];
  attributeName: Scalars['String'];
  categoryId: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  isYarnCount?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  subCategoryIds: Array<Scalars['ID']>;
};

export type CategoryAttributeList = {
  __typename?: 'CategoryAttributeList';
  /** Product Attribute Id */
  _id?: Maybe<Scalars['ID']>;
  attributeName: Scalars['String'];
  content?: Maybe<Array<ProductAttributeTypesListDto>>;
  isFilled?: Maybe<Scalars['Boolean']>;
  isRequired: Scalars['Boolean'];
};

export type CategoryAttributeListDetails = {
  __typename?: 'CategoryAttributeListDetails';
  attributeList?: Maybe<Array<CategoryAttributeList>>;
  subCategoryList?: Maybe<Array<SubCategoryDetailDto>>;
};

export type CategoryAttributesListWithPaginationAndSearchData = {
  __typename?: 'CategoryAttributesListWithPaginationAndSearchData';
  _id: Scalars['ID'];
  attributeName: Scalars['String'];
  createdAt?: Maybe<Scalars['Float']>;
  fullAttributeName?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  subCategories: Array<Scalars['String']>;
};

export type CategoryAttributesListWithPaginationAndSearchDto = {
  __typename?: 'CategoryAttributesListWithPaginationAndSearchDto';
  data: Array<CategoryAttributesListWithPaginationAndSearchData>;
  totalRecords?: Maybe<Scalars['Float']>;
};

export type CategoryCreateInput = {
  cashDiscountPercentage: Scalars['Float'];
  categoryBulkUploadInstructions?: InputMaybe<Scalars['String']>;
  categoryLogo: Scalars['String'];
  categoryName: Scalars['String'];
  categorySlug?: InputMaybe<Scalars['String']>;
  comissionRate: Scalars['Float'];
};

export type CategoryDetailDto = {
  __typename?: 'CategoryDetailDto';
  _id: Scalars['ID'];
  bulkUploadSheetVersion?: Maybe<Scalars['Float']>;
  cashDiscountPercentage?: Maybe<Scalars['Float']>;
  categoryBulkUploadInstructions?: Maybe<Scalars['String']>;
  categoryLogo: Scalars['String'];
  categoryName: Scalars['String'];
  categorySlug?: Maybe<Scalars['String']>;
  comissionRate?: Maybe<Scalars['Float']>;
  isActive: Scalars['String'];
};

export type CategoryList = {
  __typename?: 'CategoryList';
  data: Array<CategoryListDto>;
  totalRecords: Scalars['Float'];
};

export type CategoryListDto = {
  __typename?: 'CategoryListDto';
  _id: Scalars['ID'];
  bulkUploadSheetVersion?: Maybe<Scalars['Float']>;
  cashDiscountPercentage?: Maybe<Scalars['Float']>;
  categoryBulkUploadInstructions?: Maybe<Scalars['String']>;
  categoryLogos: CategoryLogoTypes;
  categoryName: Scalars['String'];
  categorySlug?: Maybe<Scalars['String']>;
  comissionRate: Scalars['Float'];
  isActive: Scalars['String'];
  totalBrandSections?: Maybe<Scalars['Float']>;
  totalExploreStyles?: Maybe<Scalars['Float']>;
  totalOffers?: Maybe<Scalars['Float']>;
  totalPopularStyleCodes?: Maybe<Scalars['Float']>;
  totalTopDeals?: Maybe<Scalars['Float']>;
};

export type CategoryLogoTypes = {
  __typename?: 'CategoryLogoTypes';
  medium: Scalars['String'];
  original: Scalars['String'];
  small: Scalars['String'];
};

export type CategoryReturnPolicyDto = {
  __typename?: 'CategoryReturnPolicyDto';
  _id: Scalars['ID'];
  categoryDetails?: Maybe<CategoryListDto>;
  categoryId?: Maybe<Scalars['ID']>;
  days: Scalars['Float'];
  description: Scalars['String'];
  title: Scalars['String'];
};

export type CategoryReturnPolicyList = {
  __typename?: 'CategoryReturnPolicyList';
  data: Array<CategoryReturnPolicyDto>;
  totalRecords: Scalars['Float'];
};

export type CheckPincodeAvailabilityInput = {
  pinCode: Scalars['Float'];
};

export type ChildSubCategoryResponseDto = {
  __typename?: 'ChildSubCategoryResponseDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  childSubCategories?: Maybe<Array<SubCategoryDetailDto>>;
  guidelineDocument?: Maybe<Scalars['String']>;
  isActive: Scalars['String'];
  parentSubCategoryId?: Maybe<Scalars['String']>;
  subCategoryImage: Scalars['String'];
  subCategoryLevel: Scalars['Float'];
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryTabImage?: Maybe<Scalars['String']>;
};

export type CityAddInput = {
  cities: Array<CityCreateInput>;
};

export type CityCreateInput = {
  country_code: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  state_code: Scalars['String'];
};

export type CityListDto = {
  __typename?: 'CityListDto';
  _id: Scalars['ID'];
  country_code: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  state_code: Scalars['String'];
};

export type ClientWarehouseData = {
  __typename?: 'ClientWarehouseData';
  active: Scalars['Boolean'];
  address: Scalars['String'];
  business_days: Array<Scalars['String']>;
  business_hours: BusinessHours;
  client: Scalars['String'];
  largest_vehicle_constraint?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['Float'];
  pincode: Scalars['Float'];
  type_of_clientwarehouse?: Maybe<Scalars['String']>;
};

export type ColorCreateInput = {
  colorCode?: InputMaybe<Scalars['String']>;
  colorName: Scalars['String'];
  isMultiColor?: InputMaybe<Scalars['Boolean']>;
  multiColorImage?: InputMaybe<Scalars['String']>;
};

export type ColorDetailDto = {
  __typename?: 'ColorDetailDto';
  _id: Scalars['ID'];
  colorCode?: Maybe<Scalars['String']>;
  colorName: Scalars['String'];
  isActive: Scalars['String'];
  isMultiColor: Scalars['Boolean'];
  multiColorImage?: Maybe<Scalars['String']>;
};

export type ColorList = {
  __typename?: 'ColorList';
  data: Array<ColorDetailDto>;
  totalRecords: Scalars['Float'];
};

export type Colors = {
  __typename?: 'Colors';
  _id: Scalars['ID'];
  colorName?: Maybe<Scalars['String']>;
};

export type CommodityListDto = {
  __typename?: 'CommodityListDto';
  change: Scalars['String'];
  changesPercentage: Scalars['String'];
  currency: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['String'];
  symbol: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type CommonSuccessResponseDto = {
  __typename?: 'CommonSuccessResponseDto';
  code: Scalars['Float'];
  message: Scalars['String'];
};

export type CountryAddInput = {
  countries: Array<CountryCreateInput>;
};

export type CountryCreateInput = {
  name: Scalars['String'];
  phonecode: Scalars['String'];
  sortname: Scalars['String'];
};

export type CountryListDto = {
  __typename?: 'CountryListDto';
  _id: Scalars['ID'];
  name: Scalars['String'];
  phonecode: Scalars['String'];
  sortname: Scalars['String'];
};

export type CouponCodeAddUpdateInput = {
  _id?: InputMaybe<Scalars['ID']>;
  appliedOrderAmount?: InputMaybe<Scalars['Float']>;
  categoryIds: Array<Scalars['ID']>;
  couponCode: Scalars['String'];
  couponType: Scalars['String'];
  ddCoins?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  endDate: Scalars['Float'];
  isCouponApplyOnOrderAmount: Scalars['Boolean'];
  isDiscountInPercentage?: InputMaybe<Scalars['Boolean']>;
  isFreeDelivery?: InputMaybe<Scalars['Boolean']>;
  restrictNumberOfUsers: Scalars['Boolean'];
  restrictedUsersCount?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['Float'];
  title: Scalars['String'];
  uptoDiscountAmount?: InputMaybe<Scalars['Float']>;
};

export type CouponCodeDetailsDto = {
  __typename?: 'CouponCodeDetailsDto';
  _id: Scalars['ID'];
  appliedOrderAmount?: Maybe<Scalars['Float']>;
  categories?: Maybe<Array<Scalars['String']>>;
  categoryIds: Array<Scalars['ID']>;
  couponCode: Scalars['String'];
  couponDiscountPrice?: Maybe<Scalars['Float']>;
  couponStatus: Scalars['String'];
  couponType: Scalars['String'];
  ddCoins?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  discountAmount?: Maybe<Scalars['Float']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  endDate: Scalars['Float'];
  isCouponApplied?: Maybe<Scalars['Boolean']>;
  isCouponApplyOnOrderAmount: Scalars['Boolean'];
  isDiscountInPercentage?: Maybe<Scalars['Boolean']>;
  isFreeDelivery?: Maybe<Scalars['Boolean']>;
  restrictNumberOfUsers: Scalars['Boolean'];
  restrictedUsersCount?: Maybe<Scalars['Float']>;
  startDate: Scalars['Float'];
  title: Scalars['String'];
  uptoDiscountAmount?: Maybe<Scalars['Float']>;
};

export type CouponCodePaginationListDto = {
  __typename?: 'CouponCodePaginationListDto';
  data: Array<CouponCodeDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type CouponDiscountPayableDto = {
  __typename?: 'CouponDiscountPayableDto';
  cartDiscountPrice: Scalars['Float'];
  couponDiscountPrice: Scalars['Float'];
  discountOnPrice: Scalars['Float'];
  gstRatePrice: Scalars['Float'];
  isFreeDelivery: Scalars['Boolean'];
  totalPayableAmount: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type CouponDiscountPayableResponseDto = {
  __typename?: 'CouponDiscountPayableResponseDto';
  code: Scalars['Float'];
  data: CouponDiscountPayableDto;
  message: Scalars['String'];
};

export type CreateProductAttributeTypesInput = {
  allowToAddNewValue?: InputMaybe<Scalars['Boolean']>;
  fileUrl?: InputMaybe<Scalars['String']>;
  inputType: Scalars['String'];
  isRequired: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  placeholder?: InputMaybe<Scalars['String']>;
  productAttributeGroupId: Scalars['ID'];
  productAttributeId: Scalars['ID'];
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateSetPayload = {
  bulkPrice?: InputMaybe<Array<BulkPrice>>;
  miscellaneous?: InputMaybe<Array<Scalars['String']>>;
  packageDimensions?: InputMaybe<ProductYarnListPackageDimensionsInput>;
  packageWeight?: InputMaybe<ProductYarnListPackageWeightInput>;
  priceMoq: ProductSetPriceMoqDetailInput;
  regularPrice: RegularPrice;
  selectedColors: Array<SelectedColors>;
  sizeIds?: InputMaybe<Array<Scalars['ID']>>;
  unitOfMeasurement: Scalars['String'];
};

export type CreateSetPayloadDto = {
  __typename?: 'CreateSetPayloadDto';
  _id?: Maybe<Scalars['ID']>;
  availableQuantity?: Maybe<Scalars['Float']>;
  bulkPrice?: Maybe<Array<BulkPriceDto>>;
  miscellaneous?: Maybe<Array<Scalars['String']>>;
  packageDimensions?: Maybe<ProductYarnListPackageDimensionsDetailDto>;
  packageWeight?: Maybe<ProductYarnListPackageWeightDetailDto>;
  priceMoq?: Maybe<ProductSetPriceMoqDetailDto>;
  productId?: Maybe<Scalars['ID']>;
  productPriceDetails?: Maybe<ProductPriceDetails>;
  quantityInCart?: Maybe<Scalars['Float']>;
  quantityInSet?: Maybe<Scalars['Float']>;
  quantityUnit?: Maybe<Scalars['String']>;
  regularPrice: RegularPriceDto;
  selectedColors: Array<SelectedColorsDto>;
  setCartAmount?: Maybe<Scalars['Float']>;
  setPrice?: Maybe<Scalars['Float']>;
  setQuantity?: Maybe<Scalars['Float']>;
  sizeIds?: Maybe<Array<Scalars['ID']>>;
  unitOfMeasurement: Scalars['String'];
};

export type CreateUserProductAttributeTypeRelationInput = {
  attributeValueName: Scalars['String'];
  productAttributeTypesId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateWarehouseInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['Float'];
  pinCode: Scalars['String'];
  returnAddress?: InputMaybe<Scalars['String']>;
  returnCity?: InputMaybe<Scalars['String']>;
  returnCountry?: InputMaybe<Scalars['String']>;
  returnPin?: InputMaybe<Scalars['String']>;
  returnState?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  wareHouseName: Scalars['String'];
};

export type DashboardCardObject = {
  __typename?: 'DashboardCardObject';
  count: Scalars['Float'];
  moduleId: Scalars['String'];
  moduleName: Scalars['String'];
  moduleSlug: Scalars['String'];
};

export type DelhiveryCodesResponseDto = {
  __typename?: 'DelhiveryCodesResponseDto';
  delhiveryServiceAvailable?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
};

export type DesignationCreateInput = {
  designationName: Scalars['String'];
};

export type DesignationDetailDto = {
  __typename?: 'DesignationDetailDto';
  _id: Scalars['ID'];
  designationName: Scalars['String'];
  isActive: Scalars['String'];
};

export type DesignationList = {
  __typename?: 'DesignationList';
  data: Array<DesignationDetailDto>;
  totalRecords: Scalars['Float'];
};

export type DetailProductAttributeSetSizesDto = {
  __typename?: 'DetailProductAttributeSetSizesDto';
  categoryId: Scalars['ID'];
  sizeGroupId?: Maybe<Scalars['ID']>;
  sizeGroupTitle?: Maybe<Scalars['String']>;
  subCategoryIds: Array<Scalars['ID']>;
  values: Array<SizeValueDto>;
};

export type DownloadPaymentStatementDetails = {
  __typename?: 'DownloadPaymentStatementDetails';
  paymentStatementUrl: Scalars['String'];
};

export type DownloadPaymentStatementResponseDto = {
  __typename?: 'DownloadPaymentStatementResponseDto';
  code: Scalars['Float'];
  data?: Maybe<DownloadPaymentStatementDetails>;
  message: Scalars['String'];
};

export type EditWareHouseInput = {
  address?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['Float']>;
  pinCode?: InputMaybe<Scalars['String']>;
  registeredName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type EscalateIssueListWithSearchAndPaginationDto = {
  __typename?: 'EscalateIssueListWithSearchAndPaginationDto';
  data: Array<UserEscalatedIssueDetailDto>;
  totalRecords?: Maybe<Scalars['Float']>;
};

export type EscalateIssueSubjectDetailDto = {
  __typename?: 'EscalateIssueSubjectDetailDto';
  _id: Scalars['ID'];
  subject: Scalars['String'];
};

export type ExploreStylesCreateInput = {
  categoryId: Scalars['ID'];
  image: Scalars['String'];
  subCategoryId: Scalars['ID'];
};

export type ExploreStylesDetailDto = {
  __typename?: 'ExploreStylesDetailDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  categorySlug: Scalars['String'];
  image: Scalars['String'];
  subCategoryId: Scalars['String'];
  subCategoryName: Scalars['String'];
};

export type ExploreStylesDetailDtoPaginationList = {
  __typename?: 'ExploreStylesDetailDtoPaginationList';
  data: Array<ExploreStylesDetailDto>;
  totalRecords: Scalars['Float'];
};

export type FaqDetail = {
  __typename?: 'FaqDetail';
  _id: Scalars['ID'];
  answer: Scalars['String'];
  faqTypeDetails: FaqTypeDetailDto;
  faqTypeId: Scalars['ID'];
  question: Scalars['String'];
};

export type FaqInput = {
  answer: Scalars['String'];
  faqTypeId: Scalars['ID'];
  question: Scalars['String'];
};

export type FaqList = {
  __typename?: 'FaqList';
  data: Array<FaqListDto>;
  totalRecords: Scalars['Float'];
};

export type FaqListDto = {
  __typename?: 'FaqListDto';
  _id: Scalars['ID'];
  answer: Scalars['String'];
  faqTypeDetails: FaqTypeDetailDto;
  faqTypeId: Scalars['ID'];
  question: Scalars['String'];
};

export type FaqListObject = {
  __typename?: 'FaqListObject';
  _id: Scalars['ID'];
  answer: Scalars['String'];
  faqTypeId: Scalars['ID'];
  question: Scalars['String'];
};

export type FaqType = {
  __typename?: 'FaqType';
  _id: Scalars['ID'];
  faqTypeName: Scalars['String'];
};

export type FaqTypeDetail = {
  __typename?: 'FaqTypeDetail';
  _id: Scalars['ID'];
  faqTypeName: Scalars['String'];
};

export type FaqTypeDetailDto = {
  __typename?: 'FaqTypeDetailDto';
  _id: Scalars['ID'];
  faqTypeName: Scalars['String'];
};

export type FaqTypeInput = {
  faqTypeName: Scalars['String'];
};

export type FaqTypeList = {
  __typename?: 'FaqTypeList';
  data: Array<FaqType>;
  totalRecords: Scalars['Float'];
};

export type FaqsList = {
  __typename?: 'FaqsList';
  _id: Scalars['ID'];
  faqList: Array<FaqListObject>;
  faqTypeName: Scalars['String'];
};

export type FatchWayBillDto = {
  __typename?: 'FatchWayBillDto';
  code: Scalars['Float'];
  wayBill: Scalars['String'];
};

export type FetchWaybillCountInput = {
  count?: InputMaybe<Scalars['Float']>;
};

export type GstNumberKycDto = {
  __typename?: 'GSTNumberKycDto';
  cityId: Scalars['ID'];
  cityName: Scalars['String'];
  companyPanNumber: Scalars['String'];
  isGstNumberVerified: Scalars['String'];
  pinCode: Scalars['Float'];
  shopNumber: Scalars['String'];
  stateId: Scalars['ID'];
  stateName: Scalars['String'];
  streetAndArea: Scalars['String'];
};

export type GstNumberResponseDto = {
  __typename?: 'GSTNumberResponseDto';
  code: Scalars['Float'];
  data: GstNumberKycDto;
  message: Scalars['String'];
};

export type GeneralSettingDetailsDto = {
  __typename?: 'GeneralSettingDetailsDto';
  allowSellerRegistration: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type GeneralSettingInput = {
  allowSellerRegistration: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type GetAllUsersFeedbacks = {
  __typename?: 'GetAllUsersFeedbacks';
  _id?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Timestamp'];
  description: Scalars['String'];
  rating: Scalars['Float'];
  userDetails: UserDetailDto;
  userId: Scalars['ID'];
};

export type HomeAdvertisementPromotedList = {
  __typename?: 'HomeAdvertisementPromotedList';
  COLLECTION_BANNER?: Maybe<Array<UserPromotedAdvDetailsDto>>;
  DEAL_OF_THE_DAY_BANNER?: Maybe<Array<UserPromotedAdvDetailsDto>>;
  POPULAR_BRANDS_BANNER?: Maybe<Array<UserPromotedAdvDetailsDto>>;
  TOP_BANNER?: Maybe<Array<UserPromotedAdvDetailsDto>>;
};

export type HomePageSubcategoryProductListDetailsDto = {
  __typename?: 'HomePageSubcategoryProductListDetailsDto';
  products?: Maybe<Array<BuyerSideProductListDetailsDto>>;
  subCategoryId?: Maybe<Scalars['ID']>;
  subCategoryName?: Maybe<Scalars['String']>;
};

export type HsnCodeAddUpdateInput = {
  addHsnCodeFileName?: InputMaybe<Scalars['String']>;
  updateHsnCodeFileName?: InputMaybe<Scalars['String']>;
};

export type HsnCodeListDto = {
  __typename?: 'HsnCodeListDto';
  _id: Scalars['ID'];
  hsnCode: Scalars['String'];
  hsnDescription: Scalars['String'];
};

export type HsnCodeListWithPaginationDto = {
  __typename?: 'HsnCodeListWithPaginationDto';
  data: Array<HsnCodeListDto>;
  totalRecords?: Maybe<Scalars['Float']>;
};

export type InvoiceDto = {
  __typename?: 'InvoiceDto';
  fileName?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InvoiceOrderPaymentSummaryInput = {
  cartDiscountPrice?: InputMaybe<Scalars['Float']>;
  couponDiscountPrice?: InputMaybe<Scalars['Float']>;
  deliveryCharge?: InputMaybe<Scalars['Float']>;
  deliveryType?: InputMaybe<Scalars['String']>;
  discountOnPrice?: InputMaybe<Scalars['Float']>;
  gstRatePrice: Scalars['Float'];
  totalPayableAmount: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type InvoicePaymentDetailsDto = {
  __typename?: 'InvoicePaymentDetailsDto';
  cartDiscountPrice?: Maybe<Scalars['Float']>;
  couponDiscountPrice?: Maybe<Scalars['Float']>;
  deliveryCharge?: Maybe<Scalars['Float']>;
  deliveryType?: Maybe<Scalars['String']>;
  discountOnPrice?: Maybe<Scalars['Float']>;
  gstRatePrice: Scalars['Float'];
  isFreeDelivery?: Maybe<Scalars['Boolean']>;
  totalDeliveryCharge?: Maybe<Scalars['Float']>;
  totalPayableAmount: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type JusPayDetailResponseDto = {
  __typename?: 'JusPayDetailResponseDto';
  code: Scalars['Float'];
  data: JusPayResponseDto;
  message: Scalars['String'];
};

export type JusPayOrderDetailsDto = {
  __typename?: 'JusPayOrderDetailsDto';
  jusPayOrderId?: Maybe<Scalars['String']>;
};

export type JusPayResponseDto = {
  __typename?: 'JusPayResponseDto';
  jusPayResponse: Scalars['String'];
};

export type KycDocumentAddInput = {
  kycDocumentName: Scalars['String'];
  kycDocumentSlug: Scalars['String'];
};

export type KycDocumentDetialDto = {
  __typename?: 'KycDocumentDetialDto';
  _id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  kycDocumentDetails?: Maybe<KycDocumentVerificationDetialDto>;
  kycDocumentName: Scalars['String'];
  kycDocumentSlug: Scalars['String'];
};

export type KycDocumentVerificationAddInput = {
  kycDocumentId: Scalars['ID'];
  kycDocumentImage: Scalars['String'];
  kycDocumentStatus?: InputMaybe<Scalars['String']>;
  kycDocumentType: Scalars['String'];
  kycDocumentVerificationNumber: Scalars['String'];
  userId: Scalars['ID'];
  userType?: InputMaybe<Scalars['String']>;
  verifiedByAdmin?: InputMaybe<Scalars['String']>;
};

export type KycDocumentVerificationDetialDto = {
  __typename?: 'KycDocumentVerificationDetialDto';
  _id: Scalars['ID'];
  documentCancelReason?: Maybe<Scalars['String']>;
  kycDocumentId: Scalars['ID'];
  kycDocumentImage?: Maybe<Scalars['String']>;
  kycDocumentStatus: Scalars['String'];
  kycDocumentType?: Maybe<Scalars['String']>;
  kycDocumentVerificationNumber: Scalars['String'];
  userId: Scalars['ID'];
  verifiedByAdmin: Scalars['String'];
};

export type KycDocumentVerificationResponseDto = {
  __typename?: 'KycDocumentVerificationResponseDto';
  code: Scalars['Float'];
  data: KycDocumentVerificationDetialDto;
  message: Scalars['String'];
};

export type KycStatusDetailDto = {
  __typename?: 'KycStatusDetailDto';
  kycStatus: Scalars['String'];
};

export type ManageDocumentDetailsDto = {
  __typename?: 'ManageDocumentDetailsDto';
  documentCreationDate?: Maybe<Scalars['Float']>;
  documentFileName?: Maybe<Scalars['String']>;
  documentName?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
};

export type ManualQuotationDetail = {
  __typename?: 'ManualQuotationDetail';
  _id: Scalars['ID'];
  additionalCharges: Array<AdditionalChargesdto>;
  billingAddress: ShippingBillingAddressDetailDto;
  brokerContactNumber?: Maybe<Scalars['Float']>;
  brokerName?: Maybe<Scalars['String']>;
  buyerCreditBalance?: Maybe<Scalars['Float']>;
  buyerDetails?: Maybe<BuyerDetailsDto>;
  buyerId: Scalars['ID'];
  categoryId: Scalars['ID'];
  cgstAmount?: Maybe<Scalars['String']>;
  cgstPercentage?: Maybe<Scalars['String']>;
  deliveryType: Scalars['String'];
  gstAmount: Scalars['String'];
  gstPercentage: Scalars['String'];
  igstAmount?: Maybe<Scalars['String']>;
  igstPercentage?: Maybe<Scalars['String']>;
  isQuotationCancelled?: Maybe<Scalars['Boolean']>;
  isQuotationCompleted?: Maybe<Scalars['Boolean']>;
  isQuotationConfirmed?: Maybe<Scalars['Boolean']>;
  isSellerBuyerAddressSame?: Maybe<Scalars['Boolean']>;
  paymentTerms: PaymentTermsDto;
  products: Array<ProductQuotationDetailsDto>;
  quotationDescription: Scalars['String'];
  quotationOrderStatus: Scalars['String'];
  receivedOrderAmount: Scalars['Float'];
  roundOffAmount?: Maybe<Scalars['String']>;
  roundOffType?: Maybe<Scalars['String']>;
  salesOrderId?: Maybe<Scalars['String']>;
  sellerId: Scalars['ID'];
  sgstAmount?: Maybe<Scalars['String']>;
  sgstPercentage?: Maybe<Scalars['String']>;
  shippingAddress: ShippingBillingAddressDetailDto;
  termsAndConditions: Scalars['String'];
  totalOrderAmount: Scalars['String'];
  transportDetails?: Maybe<TransportDetailsDto>;
};

export type ManualQuotationGstDetail = {
  __typename?: 'ManualQuotationGSTDetail';
  cgstAmount?: Maybe<Scalars['String']>;
  cgstPercentage?: Maybe<Scalars['String']>;
  gstAmount: Scalars['String'];
  gstPercentage: Scalars['String'];
  igstAmount?: Maybe<Scalars['String']>;
  igstPercentage?: Maybe<Scalars['String']>;
  roundOffAmount?: Maybe<Scalars['String']>;
  roundOffType?: Maybe<Scalars['String']>;
  sgstAmount?: Maybe<Scalars['String']>;
  sgstPercentage?: Maybe<Scalars['String']>;
  totalOrderAmount: Scalars['String'];
};

export type ManualQuotationOrderAddUpdateInput = {
  additionalCharges: Array<AdditionalChargesInput>;
  billingAddress: UserAddressesInput;
  brokerContactNumber?: InputMaybe<Scalars['Float']>;
  brokerName?: InputMaybe<Scalars['String']>;
  buyerId: Scalars['ID'];
  categoryId: Scalars['ID'];
  cgstAmount: Scalars['String'];
  cgstPercentage: Scalars['String'];
  deliveryType: Scalars['String'];
  gstAmount: Scalars['String'];
  gstPercentage: Scalars['String'];
  igstAmount: Scalars['String'];
  igstPercentage: Scalars['String'];
  manualQuotationId?: InputMaybe<Scalars['ID']>;
  paymentTerms: PaymentTermsInput;
  products: Array<ProductsInput>;
  quotationDescription: Scalars['String'];
  roundOffAmount: Scalars['String'];
  roundOffType: Scalars['String'];
  sellerId: Scalars['ID'];
  sgstAmount: Scalars['String'];
  sgstPercentage: Scalars['String'];
  shippingAddress: UserAddressesInput;
  termsAndConditions: Scalars['String'];
  totalOrderAmount: Scalars['String'];
  transportDetails?: InputMaybe<TransportDetailsInput>;
};

export type ManualQuotationOrderDetailsDto = {
  __typename?: 'ManualQuotationOrderDetailsDto';
  _id: Scalars['ID'];
  businessName?: Maybe<Scalars['String']>;
  buyerName: Scalars['String'];
  categoryName: Scalars['String'];
  createdAt: Scalars['Float'];
  quotationOrderStatus: Scalars['String'];
};

export type ManualQuotationOrderList = {
  __typename?: 'ManualQuotationOrderList';
  data: Array<ManualQuotationOrderDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type ManualQuotationOrderProductListDto = {
  __typename?: 'ManualQuotationOrderProductListDto';
  productDescription: Scalars['String'];
  productId: Scalars['ID'];
  productImage?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productThumbNailImage?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  totalAmount: Scalars['Float'];
  unit: Scalars['String'];
  unitPrice: Scalars['Float'];
};

export type ManualQuotationPaymentDetailInput = {
  manualQuotationId: Scalars['ID'];
  offlinePaymentDetails?: InputMaybe<OfflinePaymentDetailInput>;
  onlinePaymentDetails?: InputMaybe<OnlinePaymentDetailInput>;
  paymentMode: Scalars['String'];
};

export type ManualQuotationPaymentDetailsDto = {
  __typename?: 'ManualQuotationPaymentDetailsDto';
  amount: Scalars['Float'];
  paymentDate: Scalars['Float'];
  paymentLink?: Maybe<Scalars['String']>;
  paymentMode: Scalars['String'];
  paymentReferenceNumber?: Maybe<Scalars['Float']>;
  paymentStatus: Scalars['String'];
};

export type ManualQuotationPaymentHistoryList = {
  __typename?: 'ManualQuotationPaymentHistoryList';
  data: Array<ManualQuotationPaymentDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type ManualQuotationSubOrderAddInput = {
  additionalCharges: Array<AdditionalChargesInput>;
  categoryId: Scalars['ID'];
  cgstAmount: Scalars['String'];
  cgstPercentage: Scalars['String'];
  eWayBillNumber?: InputMaybe<Scalars['String']>;
  gstAmount: Scalars['String'];
  gstPercentage: Scalars['String'];
  igstAmount: Scalars['String'];
  igstPercentage: Scalars['String'];
  manualQuotationId: Scalars['ID'];
  products: Array<ProductsInput>;
  quotationDescription: Scalars['String'];
  roundOffAmount: Scalars['String'];
  roundOffType: Scalars['String'];
  salesOrderId: Scalars['String'];
  sgstAmount: Scalars['String'];
  sgstPercentage: Scalars['String'];
  termsAndConditions: Scalars['String'];
  totalOrderAmount: Scalars['String'];
  transportDetails?: InputMaybe<TransportDetailsInput>;
};

export type ManualQuotationSubOrderDetail = {
  __typename?: 'ManualQuotationSubOrderDetail';
  _id: Scalars['ID'];
  additionalCharges: Array<AdditionalChargesdto>;
  buyerDetails?: Maybe<BuyerDetailsDto>;
  cgstAmount?: Maybe<Scalars['String']>;
  cgstPercentage?: Maybe<Scalars['String']>;
  eWayBillNumber?: Maybe<Scalars['String']>;
  gstAmount: Scalars['String'];
  gstPercentage: Scalars['String'];
  igstAmount?: Maybe<Scalars['String']>;
  igstPercentage?: Maybe<Scalars['String']>;
  invoiceNumberId: Scalars['String'];
  manualQuotationOrderId: Scalars['ID'];
  orderVerificationStatus: Scalars['String'];
  products: Array<ProductQuotationDetailsDto>;
  quotationDescription: Scalars['String'];
  receivedOrderAmount: Scalars['Float'];
  roundOffAmount?: Maybe<Scalars['String']>;
  roundOffType?: Maybe<Scalars['String']>;
  sgstAmount?: Maybe<Scalars['String']>;
  sgstPercentage?: Maybe<Scalars['String']>;
  shipmentTrackingDetails?: Maybe<Array<ShipmentTrackingDetailsDto>>;
  subOrderNumberId: Scalars['String'];
  termsAndConditions: Scalars['String'];
  totalOrderAmount: Scalars['String'];
  trackingOrderStatus: Scalars['String'];
  transportDetails?: Maybe<TransportDetailsDto>;
};

export type ManualQuotationSubOrderDetailsDto = {
  __typename?: 'ManualQuotationSubOrderDetailsDto';
  _id: Scalars['ID'];
  createdAt: Scalars['Float'];
  manualQuotationOrderId: Scalars['ID'];
  orderVerificationStatus: Scalars['String'];
  productName: Scalars['String'];
  subOrderNumberId: Scalars['String'];
  trackingOrderStatus: Scalars['String'];
  updatedAt: Scalars['Float'];
};

export type ManualQuotationSubOrderList = {
  __typename?: 'ManualQuotationSubOrderList';
  buyerDetails?: Maybe<BuyerDetailsDto>;
  data: Array<ManualQuotationSubOrderDetailsDto>;
  isQuotationCancelled?: Maybe<Scalars['Boolean']>;
  isQuotationCompleted?: Maybe<Scalars['Boolean']>;
  receivedOrderAmount?: Maybe<Scalars['Float']>;
  salesOrderDocument?: Maybe<Scalars['String']>;
  salesOrderId?: Maybe<Scalars['String']>;
  totalOrderAmount?: Maybe<Scalars['String']>;
  totalRecords: Scalars['Float'];
};

export type ManualQuotationSubOrderListDto = {
  __typename?: 'ManualQuotationSubOrderListDto';
  documents?: Maybe<Array<ManageDocumentDetailsDto>>;
  manualQuotationSubOrderId: Scalars['ID'];
  products?: Maybe<Array<ManualQuotationOrderProductListDto>>;
  shipmentTrackingDetails?: Maybe<Array<ShipmentTrackingDetailsDto>>;
};

export type MillDetailsDto = {
  __typename?: 'MillDetailsDto';
  _id: Scalars['ID'];
  address?: Maybe<Scalars['String']>;
  businessLogo?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
};

export type MillsListDto = {
  __typename?: 'MillsListDto';
  data: Array<MillDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type ModuleInput = {
  collectionName: Scalars['String'];
  moduleName: Scalars['String'];
  moduleSlug: Scalars['String'];
};

export type ModuleObject = {
  __typename?: 'ModuleObject';
  _id: Scalars['ID'];
  collectionName: Scalars['String'];
  moduleName: Scalars['String'];
  moduleSlug: Scalars['String'];
};

export type ModulePermissionList = {
  __typename?: 'ModulePermissionList';
  moduleId: Scalars['ID'];
  moduleName: Scalars['String'];
  moduleSlug: Scalars['String'];
  permissions: Array<PermissionDetail>;
};

export type ModuleType = {
  __typename?: 'ModuleType';
  _id: Scalars['ID'];
  collectionName: Scalars['String'];
  moduleName: Scalars['String'];
  moduleSlug: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  EditWareHouseInput: CommonSuccessResponseDto;
  aadharKycDocumentVerification: KycDocumentVerificationResponseDto;
  actionRequiredOnUserPromotedAdv: ActionRequiredUserPromotedAdvDto;
  activeInActiveSubCategory: CommonSuccessResponseDto;
  addCreditDebitBalance: CommonSuccessResponseDto;
  addDeliveryCharge: CommonSuccessResponseDto;
  addExploreStyle: CommonSuccessResponseDto;
  addFaq: CommonSuccessResponseDto;
  addFaqType: CommonSuccessResponseDto;
  addFeedback: CommonSuccessResponseDto;
  addGeneralSetting: CommonSuccessResponseDto;
  addKycDocument: CommonSuccessResponseDto;
  addManualQuotationPayment: PaymentReceivedResponseDto;
  addManualQuotationSubOrder: CommonSuccessResponseDto;
  addModule: Scalars['String'];
  addOffer: CommonSuccessResponseDto;
  addOrder: OrderDetailResponseDto;
  addPermission: Scalars['String'];
  addPermissionType: PermissionType;
  addPopularStyleCode: CommonSuccessResponseDto;
  addPromoteYourAdv: CommonSuccessResponseDto;
  addRemoveProductWishlist: CommonSuccessResponseDto;
  addRemoveQuantityInCart: AddRemoveCartQuantityDto;
  addRole: CommonSuccessResponseDto;
  addRssNewsUrl: CommonSuccessResponseDto;
  addSampleOrder: CommonSuccessResponseDto;
  addTopDeal: CommonSuccessResponseDto;
  addUpdateAppVersion: CommonSuccessResponseDto;
  addUpdateCartItems: CommonSuccessResponseDto;
  addUpdateCategoryReturnPolicy: CommonSuccessResponseDto;
  addUpdateCouponCode: CommonSuccessResponseDto;
  addUpdateManualQuotationOrder: CommonSuccessResponseDto;
  addUpdateProductName: CommonSuccessResponseDto;
  addUpdateProductSizeChartOrTestReport: CommonSuccessResponseDto;
  addUpdateUserPromotedAdv: UserPromotedAdvDto;
  addUserAddresses: UserAddressesResponseDto;
  addUserBankAccount: UserBankAccountResponseDto;
  addUserBusinessDetail: UserBusinessDetailResponseDto;
  addUserImpression: CommonSuccessResponseDto;
  addUserProductSearch: CommonSuccessResponseDto;
  adminChangePassword: Scalars['String'];
  adminKycDocumentVerification: KycDocumentVerificationResponseDto;
  adminLogin: AdminLoginResponseDto;
  adminLogout: CommonSuccessResponseDto;
  adminUpdate: AdminUpdateResponseDto;
  advertisementVerifiedByAdmin: CommonSuccessResponseDto;
  attributeDeleteById: CommonSuccessResponseDto;
  bankAdd: CommonSuccessResponseDto;
  bankUpdate: CommonSuccessResponseDto;
  brandAdd: BrandDetailResponseDto;
  brandDelete: CommonSuccessResponseDto;
  brandReview: BrandReviewResponseDto;
  brandUpdate: BrandDetailResponseDto;
  businessTypeAdd: CommonSuccessResponseDto;
  businessTypeUpdate: CommonSuccessResponseDto;
  buyerOrderConfirmation: CommonSuccessResponseDto;
  calculateShippingCost: ShippingCostDto;
  cancelManualQuotationOrder: CommonSuccessResponseDto;
  categoryAdd: CommonSuccessResponseDto;
  categoryUpdate: CommonSuccessResponseDto;
  checkBrandNameExists: BrandNameExistsResponseDto;
  cityAdd: Scalars['String'];
  clearAttributeByProductId: CommonSuccessResponseDto;
  cloneProductById: CommonSuccessResponseDto;
  colorAdd: CommonSuccessResponseDto;
  colorUpdate: CommonSuccessResponseDto;
  companyPANKycDocumentVerification: KycDocumentVerificationResponseDto;
  countryAdd: Scalars['String'];
  createAdmin: CommonSuccessResponseDto;
  createBrandSection: CommonSuccessResponseDto;
  createShipment: ShipmentDetailResponseDto;
  createUser: UserResponseDto;
  createWareHouse: WareHouseDetail;
  deletUserPromotedAdv: CommonSuccessResponseDto;
  deleteAdmin: CommonSuccessResponseDto;
  deleteBank: CommonSuccessResponseDto;
  deleteBrandSection: CommonSuccessResponseDto;
  deleteBusinessType: CommonSuccessResponseDto;
  deleteCartProductSet: CommonSuccessResponseDto;
  deleteCategory: CommonSuccessResponseDto;
  deleteCategoryReturnPolicy: CommonSuccessResponseDto;
  deleteColor: CommonSuccessResponseDto;
  deleteCouponCode: CommonSuccessResponseDto;
  deleteDesignation: CommonSuccessResponseDto;
  deleteExploreStyles: CommonSuccessResponseDto;
  deleteFaq: CommonSuccessResponseDto;
  deleteFaqType: CommonSuccessResponseDto;
  deleteFeedbackById: CommonSuccessResponseDto;
  deleteOffers: CommonSuccessResponseDto;
  deletePolicy: CommonSuccessResponseDto;
  deletePopularStyleCodes: CommonSuccessResponseDto;
  deleteProductImages: CommonSuccessResponseDto;
  deleteProductSizeChartTestReport: CommonSuccessResponseDto;
  deleteProducts: CommonSuccessResponseDto;
  deleteRole: CommonSuccessResponseDto;
  deleteStaticPage: CommonSuccessResponseDto;
  deleteStaticPageContentImages: CommonSuccessResponseDto;
  deleteSubCategory: CommonSuccessResponseDto;
  deleteTopDeals: CommonSuccessResponseDto;
  deleteUser: CommonSuccessResponseDto;
  deleteUserAddresses: CommonSuccessResponseDto;
  deleteUserBankAccount: CommonSuccessResponseDto;
  designationAdd: CommonSuccessResponseDto;
  designationUpdate: CommonSuccessResponseDto;
  escalateUserIssue: CommonSuccessResponseDto;
  faqTypeUpdate: CommonSuccessResponseDto;
  faqUpdate: CommonSuccessResponseDto;
  generateAadharKycDocumentOtp: CommonSuccessResponseDto;
  generateAadharKycOtp: CommonSuccessResponseDto;
  generateJusPaySDKPayload: JusPayDetailResponseDto;
  generateManualQuotationPaymentLink: CommonSuccessResponseDto;
  generateNewAccessToken: NewGeneratedAccessTokenResponseDto;
  generateQuotation: CommonSuccessResponseDto;
  generateReOrder: CommonSuccessResponseDto;
  generateSampleReOrder: SampleReorderResponseDto;
  getUserKycStatus: KycStatusDetailDto;
  getWareHouseDetailByUserId: UserWarehouseDetail;
  gstKycDocumentVerification: KycDocumentVerificationResponseDto;
  holdOrderConfirmation: CommonSuccessResponseDto;
  hsnCodeAddUpdate: CommonSuccessResponseDto;
  hsnCodeUpdateById: CommonSuccessResponseDto;
  kycDocumentVerifiedByAdmin: CommonSuccessResponseDto;
  manageAttribute: CommonSuccessResponseDto;
  manageAttributeProductSetSizes: CommonSuccessResponseDto;
  manageDocumentsForManualQuotation: CommonSuccessResponseDto;
  manageProductSetSizes: CommonSuccessResponseDto;
  newsUrlDetailsUpdate: CommonSuccessResponseDto;
  notificationSettings: CommonSuccessResponseDto;
  orderPickUpScheduled: CommonSuccessResponseDto;
  pickupRequest: Scalars['String'];
  policyAdd: CommonSuccessResponseDto;
  policyUpdate: CommonSuccessResponseDto;
  productAddRatingReview: CommonSuccessResponseDto;
  productAddUpdateAdditionalDetails: CommonSuccessResponseDto;
  productAddUpdateBrand: ProductBrandAddUpdateResponseDto;
  productAddUpdateImages: ProductImagesListResponseDto;
  productAttributeAdd: CommonSuccessResponseDto;
  productAttributeTypesAdd: CommonSuccessResponseDto;
  productAttributesValueAdd: ProductAddAttributeValuesDto;
  productDetailsAddUpdate: CommonSuccessResponseDto;
  productImageIsCover: CommonSuccessResponseDto;
  productListingGuidelineAddEdit: CommonSuccessResponseDto;
  productOrderIdRazorpay: RazorPayOrderDto;
  productResubmitById: CommonSuccessResponseDto;
  productSetCreate: ProductAddUpdateCreateSetByIdResponseDto;
  productSetDeleteById: CommonSuccessResponseDto;
  productSetUpdateById: ProductAddUpdateCreateSetByIdResponseDto;
  productVerifiedByAdmin: CommonSuccessResponseDto;
  productYarnListingDetailAddUpdate: CommonSuccessResponseDto;
  promotedAdvOrderIdRazorpay: RazorPayOrderDto;
  publishProduct: CommonSuccessResponseDto;
  quotationMessageRequest: QuotationChatHistoryDetailsDto;
  readNotification: CommonSuccessResponseDto;
  reloadAadharKycCaptchaImage: AadharKycConnectSessionDto;
  removeAppliedCouponCode: CommonSuccessResponseDto;
  removeItemFromCart: CommonSuccessResponseDto;
  reportBuyer: CommonSuccessResponseDto;
  resolveUserEscalatedIssue: CommonSuccessResponseDto;
  reviewAttributeValueById: CommonSuccessResponseDto;
  roleUpdate: CommonSuccessResponseDto;
  sampleOrderPickUpScheduled: CommonSuccessResponseDto;
  sellerApproval: CommonSuccessResponseDto;
  sellerSettingAddUpdate: SellerSettingDetailResponseDto;
  sendMailToBusinessEmail: CommonSuccessResponseDto;
  sendTaxInvoice: CommonSuccessResponseDto;
  seoContentAddEdit: CommonSuccessResponseDto;
  setUserAddressesDefault: CommonSuccessResponseDto;
  setUserBankAccountDefault: CommonSuccessResponseDto;
  shipmentCreate: CommonSuccessResponseDto;
  shipmentDelete: Scalars['String'];
  shipmentTracking: CommonSuccessResponseDto;
  shipmentUpdate: CommonSuccessResponseDto;
  shippingLabelGenerate: ShippingLabelGenerate;
  stateAdd: Scalars['String'];
  staticPageAdd: CommonSuccessResponseDto;
  staticPageUpdate: CommonSuccessResponseDto;
  subCategoryAdd: CommonSuccessResponseDto;
  subCategoryUpdate: CommonSuccessResponseDto;
  udyamAadharKycDocumentVerification: KycDocumentVerificationResponseDto;
  udyogAadharKycDocumentVerification: KycDocumentVerificationResponseDto;
  updateCategoryAttributeById: CommonSuccessResponseDto;
  updateExploreStyle: CommonSuccessResponseDto;
  updateGeneralSetting: CommonSuccessResponseDto;
  updateManualQuotationCompletedStatus: CommonSuccessResponseDto;
  updateManualQuotationConfirmationStatus: CommonSuccessResponseDto;
  updateManualQuotationTrackingOrderStatus: CommonSuccessResponseDto;
  updateOffer: CommonSuccessResponseDto;
  updatePopularStyleCode: CommonSuccessResponseDto;
  updateProductDDFee: CommonSuccessResponseDto;
  updateProductImagesList: ProductImagesListResponseDto;
  updateProductStatus: CommonSuccessResponseDto;
  updatePromoteYourAdv: CommonSuccessResponseDto;
  updateSellerComissionDetails: CommonSuccessResponseDto;
  updateTopDeal: CommonSuccessResponseDto;
  updateTrackingOrderStatusAdmin: CommonSuccessResponseDto;
  updateUserDetailsByAdmin: CommonSuccessResponseDto;
  updateUserPromotedAdv: CommonSuccessResponseDto;
  updateUserPromotedAdvStatus: CommonSuccessResponseDto;
  userActiveInActive: CommonSuccessResponseDto;
  userAddressesUpdateDetails: UserAddressesResponseDto;
  userBankAccountUpdateDetails: UserBankAccountResponseDto;
  userBusinessUpdateDetails: UserBusinessDetailResponseDto;
  userLogout: CommonSuccessResponseDto;
  userTypeUpdate: UserExtendedFieldResponseDto;
  userUpdateDetails: UserResponseDto;
  verifyAadharKycOtp: CommonSuccessResponseDto;
  verifyBusinessEmail: CommonSuccessResponseDto;
  verifyGSTNumberKyc: GstNumberResponseDto;
  verifyIfscCode: VerifyBankNameDto;
  verifyKycAadharDocumentOtp: CommonSuccessResponseDto;
};


export type MutationEditWareHouseInputArgs = {
  input: EditWareHouseInput;
};


export type MutationAadharKycDocumentVerificationArgs = {
  input: KycDocumentVerificationAddInput;
};


export type MutationActionRequiredOnUserPromotedAdvArgs = {
  _id: Scalars['ID'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
};


export type MutationActiveInActiveSubCategoryArgs = {
  _id: Scalars['ID'];
  isActive: Scalars['String'];
};


export type MutationAddCreditDebitBalanceArgs = {
  input: AddUserCreditDebitInput;
};


export type MutationAddDeliveryChargeArgs = {
  deliveryCharge?: InputMaybe<Scalars['Float']>;
  deliveryType: Scalars['String'];
  orderId: Scalars['ID'];
  totalDeliveryCharge?: InputMaybe<Scalars['Float']>;
};


export type MutationAddExploreStyleArgs = {
  input: ExploreStylesCreateInput;
};


export type MutationAddFaqArgs = {
  input: FaqInput;
};


export type MutationAddFaqTypeArgs = {
  input: FaqTypeInput;
};


export type MutationAddFeedbackArgs = {
  description: Scalars['String'];
  rating: Scalars['Float'];
  userId: Scalars['ID'];
};


export type MutationAddGeneralSettingArgs = {
  input: GeneralSettingInput;
};


export type MutationAddKycDocumentArgs = {
  input: KycDocumentAddInput;
};


export type MutationAddManualQuotationPaymentArgs = {
  input: ManualQuotationPaymentDetailInput;
};


export type MutationAddManualQuotationSubOrderArgs = {
  input: ManualQuotationSubOrderAddInput;
};


export type MutationAddModuleArgs = {
  input: ModuleInput;
};


export type MutationAddOfferArgs = {
  input: OffersCreateInput;
};


export type MutationAddOrderArgs = {
  couponCodeId?: InputMaybe<Scalars['ID']>;
  couponDiscountPrice?: InputMaybe<Scalars['Float']>;
  destinationAddress: AddressPayload;
  isFreeDelivery: Scalars['Boolean'];
  jusPayOrderId?: InputMaybe<Scalars['String']>;
  orderNumberId?: InputMaybe<Scalars['String']>;
  orderPayload?: InputMaybe<Array<OrderPayload>>;
  orderType: Scalars['String'];
  shipmentManagementType: Scalars['String'];
};


export type MutationAddPermissionArgs = {
  input: PermissionInput;
};


export type MutationAddPermissionTypeArgs = {
  input: PermissionTypeInput;
};


export type MutationAddPopularStyleCodeArgs = {
  input: PopularStyleCodesCreateInput;
};


export type MutationAddPromoteYourAdvArgs = {
  input: PromoteYourAdvUpdateInput;
};


export type MutationAddRemoveProductWishlistArgs = {
  productId: Scalars['ID'];
  userId: Scalars['ID'];
  wishlistSlug: Scalars['String'];
};


export type MutationAddRemoveQuantityInCartArgs = {
  cartPayload: Array<AddToCartPayload>;
  categorySlug?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddRoleArgs = {
  input: RoleInput;
};


export type MutationAddRssNewsUrlArgs = {
  input: AddRssFeedInput;
};


export type MutationAddSampleOrderArgs = {
  buyerUserId: Scalars['ID'];
  categoryId: Scalars['ID'];
  destinationAddress: AddressPayload;
  isSampleOrderFree: Scalars['Boolean'];
  jusPayOrderId?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  sampleOrderMeasurementUnit: Scalars['String'];
  sampleOrderQuantity: Scalars['Float'];
  sellerUserId: Scalars['ID'];
  shipmentManagementType: Scalars['String'];
  sourceAddress: AddressPayload;
  totalPayableAmount?: InputMaybe<Scalars['Float']>;
};


export type MutationAddTopDealArgs = {
  input: TopDealsCreateInput;
};


export type MutationAddUpdateAppVersionArgs = {
  appType: Scalars['String'];
  minAppVersion: Scalars['String'];
  version: Scalars['String'];
};


export type MutationAddUpdateCartItemsArgs = {
  cartPayload: Array<AddToCartPayload>;
  categorySlug?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddUpdateCategoryReturnPolicyArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryReturnPolicySlug: Scalars['String'];
  days: Scalars['Float'];
  description: Scalars['String'];
  title: Scalars['String'];
};


export type MutationAddUpdateCouponCodeArgs = {
  input: CouponCodeAddUpdateInput;
};


export type MutationAddUpdateManualQuotationOrderArgs = {
  input: ManualQuotationOrderAddUpdateInput;
};


export type MutationAddUpdateProductNameArgs = {
  input: ProductNameAddUpdateInput;
};


export type MutationAddUpdateProductSizeChartOrTestReportArgs = {
  categorySlug: Scalars['String'];
  lastCompletedStep: Scalars['Float'];
  productId: Scalars['ID'];
  sizeChart?: InputMaybe<Scalars['String']>;
  testReport?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationAddUpdateUserPromotedAdvArgs = {
  input: UserPromotedAdvCreateUpdateInput;
};


export type MutationAddUserAddressesArgs = {
  input: UserAddressesAddInput;
};


export type MutationAddUserBankAccountArgs = {
  input: UserBankAccountRegisterInput;
};


export type MutationAddUserBusinessDetailArgs = {
  input: UserBusinessRegisterInput;
};


export type MutationAddUserImpressionArgs = {
  _id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddUserProductSearchArgs = {
  input: UserProductSearchAddInput;
};


export type MutationAdminChangePasswordArgs = {
  _id: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationAdminKycDocumentVerificationArgs = {
  input: KycDocumentVerificationAddInput;
};


export type MutationAdminLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationAdminLogoutArgs = {
  _id: Scalars['ID'];
};


export type MutationAdminUpdateArgs = {
  _id: Scalars['ID'];
  fullName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
};


export type MutationAdvertisementVerifiedByAdminArgs = {
  _id: Scalars['ID'];
  advertisementCancelReason?: InputMaybe<Scalars['String']>;
  verifiedByAdmin: Scalars['String'];
};


export type MutationAttributeDeleteByIdArgs = {
  attributeId: Scalars['ID'];
};


export type MutationBankAddArgs = {
  input: BankCreateInput;
};


export type MutationBankUpdateArgs = {
  _id: Scalars['ID'];
  bankLogo?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
};


export type MutationBrandAddArgs = {
  input: BrandAddInput;
};


export type MutationBrandDeleteArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationBrandReviewArgs = {
  approvalType: Scalars['String'];
  brandId: Scalars['ID'];
  isBrandOwner: Scalars['Boolean'];
  rejectReason?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationBrandUpdateArgs = {
  _id: Scalars['ID'];
  brandCancelReason?: InputMaybe<Scalars['String']>;
  brandDocument: Scalars['String'];
  brandDocumentType: Scalars['String'];
  brandLogo: Scalars['String'];
  brandName: Scalars['String'];
  isBrandOwner?: InputMaybe<Scalars['Boolean']>;
  isGroupedOrNot?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  verifiedByAdmin?: InputMaybe<Scalars['String']>;
};


export type MutationBusinessTypeAddArgs = {
  input: BusinessTypeCreateInput;
};


export type MutationBusinessTypeUpdateArgs = {
  _id: Scalars['ID'];
  businessTypeName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
};


export type MutationBuyerOrderConfirmationArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  orderHoldStatus?: InputMaybe<Scalars['String']>;
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationCalculateShippingCostArgs = {
  input: CalculateShippingCostInput;
};


export type MutationCancelManualQuotationOrderArgs = {
  _id: Scalars['ID'];
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationCategoryAddArgs = {
  input: CategoryCreateInput;
};


export type MutationCategoryUpdateArgs = {
  _id: Scalars['ID'];
  cashDiscountPercentage?: InputMaybe<Scalars['Float']>;
  categoryBulkUploadInstructions?: InputMaybe<Scalars['String']>;
  categoryLogo?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  comissionRate?: InputMaybe<Scalars['Float']>;
  isActive?: InputMaybe<Scalars['String']>;
};


export type MutationCheckBrandNameExistsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  brandName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationCityAddArgs = {
  input: CityAddInput;
};


export type MutationClearAttributeByProductIdArgs = {
  attributeIds?: InputMaybe<Array<Scalars['ID']>>;
  clearAllAttribute: Scalars['Boolean'];
  productId: Scalars['ID'];
};


export type MutationCloneProductByIdArgs = {
  productId: Scalars['ID'];
};


export type MutationColorAddArgs = {
  input: ColorCreateInput;
};


export type MutationColorUpdateArgs = {
  _id: Scalars['ID'];
  colorCode?: InputMaybe<Scalars['String']>;
  colorName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
  isMultiColor?: InputMaybe<Scalars['Boolean']>;
  multiColorImage?: InputMaybe<Scalars['String']>;
};


export type MutationCompanyPanKycDocumentVerificationArgs = {
  input: KycDocumentVerificationAddInput;
};


export type MutationCountryAddArgs = {
  input: CountryAddInput;
};


export type MutationCreateAdminArgs = {
  input: AdminInput;
};


export type MutationCreateBrandSectionArgs = {
  input: BrandSectionAddInput;
};


export type MutationCreateShipmentArgs = {
  eWayBill?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  length?: InputMaybe<Scalars['Float']>;
  orderId?: InputMaybe<Scalars['ID']>;
  weight?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateUserArgs = {
  input: UserRegisterInput;
};


export type MutationCreateWareHouseArgs = {
  input: CreateWarehouseInput;
};


export type MutationDeletUserPromotedAdvArgs = {
  _id: Scalars['ID'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAdminArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteBankArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteBrandSectionArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteBusinessTypeArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteCartProductSetArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  productId: Scalars['ID'];
  productSetId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationDeleteCategoryArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryName?: InputMaybe<Scalars['String']>;
  categorySlug?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteCategoryReturnPolicyArgs = {
  categoryId: Scalars['ID'];
};


export type MutationDeleteColorArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteCouponCodeArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteDesignationArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteExploreStylesArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteFaqArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteFaqTypeArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteFeedbackByIdArgs = {
  feedbackId: Scalars['ID'];
};


export type MutationDeleteOffersArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeletePolicyArgs = {
  _id: Scalars['ID'];
};


export type MutationDeletePopularStyleCodesArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteProductImagesArgs = {
  name: Scalars['String'];
  productId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDeleteProductSizeChartTestReportArgs = {
  categorySlug: Scalars['String'];
  productId: Scalars['ID'];
  sizeChart?: InputMaybe<Scalars['String']>;
  testReport?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationDeleteProductsArgs = {
  categoryId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteRoleArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteStaticPageArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  isTokenByPass?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteStaticPageContentImagesArgs = {
  contentImageName: Scalars['String'];
};


export type MutationDeleteSubCategoryArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteTopDealsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteUserArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type MutationDeleteUserAddressesArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteUserBankAccountArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  ifscCode?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationDesignationAddArgs = {
  input: DesignationCreateInput;
};


export type MutationDesignationUpdateArgs = {
  _id: Scalars['ID'];
  designationName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
};


export type MutationEscalateUserIssueArgs = {
  queryDescription: Scalars['String'];
  subjectId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationFaqTypeUpdateArgs = {
  _id: Scalars['ID'];
  faqTypeName: Scalars['String'];
};


export type MutationFaqUpdateArgs = {
  _id: Scalars['ID'];
  answer: Scalars['String'];
  faqTypeId: Scalars['String'];
  question: Scalars['String'];
};


export type MutationGenerateAadharKycDocumentOtpArgs = {
  captchaImage?: InputMaybe<Scalars['String']>;
  kycDocumentId: Scalars['ID'];
  kycDocumentImage?: InputMaybe<Scalars['String']>;
  kycDocumentStatus?: InputMaybe<Scalars['String']>;
  kycDocumentType?: InputMaybe<Scalars['String']>;
  kycDocumentVerificationNumber?: InputMaybe<Scalars['String']>;
  otp?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['String'];
  userId: Scalars['ID'];
  verifiedByAdmin?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateAadharKycOtpArgs = {
  aadharNumber: Scalars['String'];
  captchaImage: Scalars['String'];
  sessionId: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationGenerateJusPaySdkPayloadArgs = {
  advertisementSlug?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  apiSlug?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationGenerateManualQuotationPaymentLinkArgs = {
  amount: Scalars['Float'];
  buyerId: Scalars['ID'];
  manualQuotationId: Scalars['ID'];
};


export type MutationGenerateNewAccessTokenArgs = {
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};


export type MutationGenerateQuotationArgs = {
  input: RequestForQuoteInput;
};


export type MutationGenerateReOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationGenerateSampleReOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationGetUserKycStatusArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type MutationGetWareHouseDetailByUserIdArgs = {
  input: WarehouseDetailInput;
};


export type MutationGstKycDocumentVerificationArgs = {
  input: KycDocumentVerificationAddInput;
};


export type MutationHoldOrderConfirmationArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  orderHoldStatus?: InputMaybe<Scalars['String']>;
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationHsnCodeAddUpdateArgs = {
  input: HsnCodeAddUpdateInput;
};


export type MutationHsnCodeUpdateByIdArgs = {
  _id: Scalars['ID'];
  hsnCode: Scalars['String'];
  hsnDescription: Scalars['String'];
};


export type MutationKycDocumentVerifiedByAdminArgs = {
  documentCancelReason?: InputMaybe<Scalars['String']>;
  documentVerified: Scalars['String'];
  kycDocumentVerificationId: Scalars['ID'];
};


export type MutationManageAttributeArgs = {
  addUpdatedPayload: Array<ProductAttributeTypesAndValuesInput>;
  attributeId: Scalars['ID'];
  deletedPayload?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationManageAttributeProductSetSizesArgs = {
  input: ProductAttributeSetSizeInput;
};


export type MutationManageDocumentsForManualQuotationArgs = {
  documentFileName: Scalars['String'];
  documentType: Scalars['String'];
  manualQuotationSubOrderId: Scalars['ID'];
};


export type MutationManageProductSetSizesArgs = {
  addUpdatedPayload: Array<ProductSetSizeTypesAndValuesInput>;
  categoryId: Scalars['ID'];
  deletedPayload?: InputMaybe<Array<Scalars['ID']>>;
  subCategoryId: Scalars['ID'];
};


export type MutationNewsUrlDetailsUpdateArgs = {
  input: AddRssFeedInput;
};


export type MutationNotificationSettingsArgs = {
  _id: Scalars['ID'];
  emailNotification: Scalars['Boolean'];
  orderNotification: Scalars['Boolean'];
  pushNotification: Scalars['Boolean'];
  whatsAppNotification: Scalars['Boolean'];
};


export type MutationOrderPickUpScheduledArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  orderHoldStatus?: InputMaybe<Scalars['String']>;
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationPickupRequestArgs = {
  input: PickupRequestInput;
};


export type MutationPolicyAddArgs = {
  input: PolicyInput;
};


export type MutationPolicyUpdateArgs = {
  _id: Scalars['ID'];
  description: Scalars['String'];
  title: Scalars['String'];
};


export type MutationProductAddRatingReviewArgs = {
  input: ProductAddRatingReviewInput;
};


export type MutationProductAddUpdateAdditionalDetailsArgs = {
  input: ProductAddUpdateAdditionalDetailsInput;
};


export type MutationProductAddUpdateBrandArgs = {
  input: ProductAddUpdateBrandInput;
};


export type MutationProductAddUpdateImagesArgs = {
  input: ProductAddUpdateImagesInput;
};


export type MutationProductAttributeAddArgs = {
  input: ProductAttributeCreateInput;
};


export type MutationProductAttributeTypesAddArgs = {
  args: CreateProductAttributeTypesInput;
};


export type MutationProductAttributesValueAddArgs = {
  args: CreateUserProductAttributeTypeRelationInput;
};


export type MutationProductDetailsAddUpdateArgs = {
  attributeId: Scalars['ID'];
  lastCompletedStep: Scalars['Float'];
  payload: Array<ProductDetailsAddUpdatePayload>;
  productId: Scalars['ID'];
  productName?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationProductImageIsCoverArgs = {
  isCover: Scalars['Boolean'];
  name: Scalars['String'];
  productId: Scalars['ID'];
};


export type MutationProductListingGuidelineAddEditArgs = {
  input: ProductListingGuidelineAddEditInput;
};


export type MutationProductOrderIdRazorpayArgs = {
  amount: Scalars['Float'];
};


export type MutationProductResubmitByIdArgs = {
  productId: Scalars['ID'];
};


export type MutationProductSetCreateArgs = {
  categorySlug: Scalars['String'];
  completedStep: Scalars['Float'];
  payload: CreateSetPayload;
  productId: Scalars['ID'];
  productSetCreateCopySlug: Scalars['String'];
};


export type MutationProductSetDeleteByIdArgs = {
  productId: Scalars['String'];
  productSetId: Scalars['String'];
};


export type MutationProductSetUpdateByIdArgs = {
  payload: CreateSetPayload;
  productCreatedSetId: Scalars['ID'];
  productId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationProductVerifiedByAdminArgs = {
  productCancelReason?: InputMaybe<Scalars['String']>;
  productIds: Array<Scalars['ID']>;
  verifiedByAdmin: Scalars['String'];
};


export type MutationProductYarnListingDetailAddUpdateArgs = {
  input: ProductAddUpdateYarnListingDetailsInput;
};


export type MutationPromotedAdvOrderIdRazorpayArgs = {
  amount: Scalars['Float'];
};


export type MutationPublishProductArgs = {
  productId: Scalars['ID'];
};


export type MutationQuotationMessageRequestArgs = {
  buyerId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  messageSenderId: Scalars['ID'];
  messageType: Scalars['String'];
  productId: Scalars['ID'];
  quotationDetails?: InputMaybe<QuotationChatDetailsInput>;
  quotationRequestId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type MutationReadNotificationArgs = {
  _id: Scalars['ID'];
};


export type MutationReloadAadharKycCaptchaImageArgs = {
  sessionId: Scalars['String'];
};


export type MutationRemoveAppliedCouponCodeArgs = {
  couponCodeId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemoveItemFromCartArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  productId: Scalars['ID'];
  productSetId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationReportBuyerArgs = {
  buyerUserId: Scalars['ID'];
  description: Scalars['String'];
  orderId: Scalars['ID'];
  reason: Scalars['String'];
  sellerUserId: Scalars['ID'];
};


export type MutationResolveUserEscalatedIssueArgs = {
  _id: Scalars['ID'];
};


export type MutationReviewAttributeValueByIdArgs = {
  input: ApproveRejectProductAttributeValueInput;
};


export type MutationRoleUpdateArgs = {
  _id: Scalars['ID'];
  permissions: Array<Scalars['String']>;
  roleName: Scalars['String'];
};


export type MutationSampleOrderPickUpScheduledArgs = {
  orderHoldStatus?: InputMaybe<Scalars['String']>;
  orderList?: InputMaybe<Array<Scalars['String']>>;
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationSellerApprovalArgs = {
  cancelReasonTypes?: InputMaybe<Array<Scalars['String']>>;
  sellerCancelReason?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  verifiedByAdmin: Scalars['String'];
};


export type MutationSellerSettingAddUpdateArgs = {
  input: SellerSettingsAddUpdateInput;
};


export type MutationSendMailToBusinessEmailArgs = {
  userId: Scalars['ID'];
};


export type MutationSeoContentAddEditArgs = {
  input: SeoContentInput;
};


export type MutationSetUserAddressesDefaultArgs = {
  _id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationSetUserBankAccountDefaultArgs = {
  _id: Scalars['ID'];
  ifscCode: Scalars['String'];
  isDefault: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationShipmentCreateArgs = {
  input: ShippingCreatetInput;
};


export type MutationShipmentDeleteArgs = {
  input: ShipmentDeleteInput;
};


export type MutationShipmentTrackingArgs = {
  input: ShipmentTrackingInput;
};


export type MutationShipmentUpdateArgs = {
  input: ShippingUpdateInput;
};


export type MutationShippingLabelGenerateArgs = {
  input: ShippingLebbelInput;
};


export type MutationStateAddArgs = {
  input: StateAddInput;
};


export type MutationStaticPageAddArgs = {
  input: StaticPageInput;
};


export type MutationStaticPageUpdateArgs = {
  _id: Scalars['ID'];
  description: Scalars['String'];
  title: Scalars['String'];
};


export type MutationSubCategoryAddArgs = {
  input: SubCategoryCreateInput;
};


export type MutationSubCategoryUpdateArgs = {
  _id: Scalars['ID'];
  categoryId: Scalars['String'];
  parentSubCategoryId?: InputMaybe<Scalars['String']>;
  subCategoryImage?: InputMaybe<Scalars['String']>;
  subCategoryLevel: Scalars['Float'];
  subCategoryName: Scalars['String'];
  subCategoryTabImage?: InputMaybe<Scalars['String']>;
};


export type MutationUdyamAadharKycDocumentVerificationArgs = {
  input: KycDocumentVerificationAddInput;
};


export type MutationUdyogAadharKycDocumentVerificationArgs = {
  input: KycDocumentVerificationAddInput;
};


export type MutationUpdateCategoryAttributeByIdArgs = {
  args: UpdateCategoryAttributeById;
};


export type MutationUpdateExploreStyleArgs = {
  _id: Scalars['ID'];
  image: Scalars['String'];
};


export type MutationUpdateGeneralSettingArgs = {
  allowSellerRegistration: Scalars['Boolean'];
  slug: Scalars['String'];
};


export type MutationUpdateManualQuotationCompletedStatusArgs = {
  _id: Scalars['ID'];
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateManualQuotationConfirmationStatusArgs = {
  _id: Scalars['ID'];
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateManualQuotationTrackingOrderStatusArgs = {
  _id: Scalars['ID'];
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOfferArgs = {
  _id: Scalars['ID'];
  maxOfferDiscount: Scalars['Float'];
  minOfferDiscount: Scalars['Float'];
  offerImage: Scalars['String'];
};


export type MutationUpdatePopularStyleCodeArgs = {
  _id: Scalars['ID'];
  image: Scalars['String'];
};


export type MutationUpdateProductDdFeeArgs = {
  _id: Scalars['ID'];
  ddFee: Scalars['Float'];
};


export type MutationUpdateProductImagesListArgs = {
  input: ProductImagesListUpdateInput;
};


export type MutationUpdateProductStatusArgs = {
  productId: Scalars['ID'];
  productStatus: Scalars['String'];
  productStatusChangedBy: Scalars['String'];
};


export type MutationUpdatePromoteYourAdvArgs = {
  input: PromoteYourAdvUpdateInput;
};


export type MutationUpdateSellerComissionDetailsArgs = {
  categoryId: Scalars['ID'];
  comissionRate: Scalars['Float'];
  userId: Scalars['ID'];
};


export type MutationUpdateTopDealArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  image: Scalars['String'];
  price: Scalars['Float'];
};


export type MutationUpdateTrackingOrderStatusAdminArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  orderHoldStatus?: InputMaybe<Scalars['String']>;
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserDetailsByAdminArgs = {
  _id: Scalars['ID'];
  countryCode?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdateUserPromotedAdvArgs = {
  jusPayOrderId: Scalars['String'];
};


export type MutationUpdateUserPromotedAdvStatusArgs = {
  _id: Scalars['ID'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
};


export type MutationUserActiveInActiveArgs = {
  _id: Scalars['ID'];
  isActive: Scalars['String'];
};


export type MutationUserAddressesUpdateDetailsArgs = {
  _id: Scalars['ID'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType: Scalars['String'];
  cityId: Scalars['ID'];
  countryCode?: InputMaybe<Scalars['Float']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  landMark?: InputMaybe<Scalars['String']>;
  otherAddressTypeName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserBankAccountUpdateDetailsArgs = {
  _id: Scalars['ID'];
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['Float'];
  accountType: Scalars['String'];
  bankName: Scalars['String'];
  ifscCode: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationUserBusinessUpdateDetailsArgs = {
  _id: Scalars['ID'];
  aadharNumber?: InputMaybe<Scalars['String']>;
  annualTurnOver?: InputMaybe<Scalars['String']>;
  businessDescription: Scalars['String'];
  businessEmail?: InputMaybe<Scalars['String']>;
  businessEstablishedDate: Scalars['Float'];
  businessLogo: Scalars['String'];
  businessName: Scalars['String'];
  businessTimings: BusinessTimingInput;
  businessTypeIds: Array<Scalars['String']>;
  cityId: Scalars['ID'];
  companyPanNumber?: InputMaybe<Scalars['String']>;
  gstNumber?: InputMaybe<Scalars['String']>;
  isBusinessEmailVerified?: InputMaybe<Scalars['String']>;
  landMark?: InputMaybe<Scalars['String']>;
  pinCode: Scalars['Float'];
  products?: InputMaybe<Array<BuinessProductInput>>;
  shopNumber: Scalars['String'];
  signatureImage?: InputMaybe<Scalars['String']>;
  stateId: Scalars['ID'];
  streetAndArea: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  userType: Scalars['String'];
};


export type MutationUserLogoutArgs = {
  _id: Scalars['ID'];
  deviceToken?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  platformType: Scalars['String'];
};


export type MutationUserTypeUpdateArgs = {
  _id: Scalars['ID'];
  userType: Scalars['String'];
};


export type MutationUserUpdateDetailsArgs = {
  _id: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationVerifyAadharKycOtpArgs = {
  otp: Scalars['String'];
  sessionId: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationVerifyBusinessEmailArgs = {
  userId: Scalars['ID'];
};


export type MutationVerifyGstNumberKycArgs = {
  businessName: Scalars['String'];
  gstNumber: Scalars['String'];
  kycTypeSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationVerifyIfscCodeArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  ifscCode?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationVerifyKycAadharDocumentOtpArgs = {
  captchaImage?: InputMaybe<Scalars['String']>;
  kycDocumentId: Scalars['ID'];
  kycDocumentImage?: InputMaybe<Scalars['String']>;
  kycDocumentStatus?: InputMaybe<Scalars['String']>;
  kycDocumentType?: InputMaybe<Scalars['String']>;
  kycDocumentVerificationNumber?: InputMaybe<Scalars['String']>;
  otp?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['String'];
  userId: Scalars['ID'];
  verifiedByAdmin?: InputMaybe<Scalars['String']>;
};

export type NewGeneratedAccessTokenDto = {
  __typename?: 'NewGeneratedAccessTokenDto';
  accessToken: Scalars['String'];
};

export type NewGeneratedAccessTokenResponseDto = {
  __typename?: 'NewGeneratedAccessTokenResponseDto';
  code: Scalars['Float'];
  data: NewGeneratedAccessTokenDto;
  message: Scalars['String'];
};

export type NewsList = {
  __typename?: 'NewsList';
  category: Scalars['String'];
  description: Scalars['String'];
  enclosure?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  link: Scalars['String'];
  pubDate: Scalars['String'];
  title: Scalars['String'];
};

export type NewsListDetails = {
  __typename?: 'NewsListDetails';
  _id?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  newsList: NewsList;
  pubDate: Scalars['String'];
};

export type NewsListDto = {
  __typename?: 'NewsListDto';
  data: Array<NewsListDetails>;
  totalRecords: Scalars['Float'];
};

export type NewsRssUrlListDto = {
  __typename?: 'NewsRssUrlListDto';
  data: Array<AddRssFeedDetails>;
  totalUrl: Scalars['Float'];
};

export type OffersCreateInput = {
  brandId: Scalars['ID'];
  categoryId: Scalars['ID'];
  maxOfferDiscount: Scalars['Float'];
  minOfferDiscount: Scalars['Float'];
  offerImage: Scalars['String'];
};

export type OffersDetailDto = {
  __typename?: 'OffersDetailDto';
  _id: Scalars['ID'];
  brandId: Scalars['ID'];
  brandLogo: Scalars['String'];
  brandName: Scalars['String'];
  categoryId: Scalars['String'];
  categoryName: Scalars['String'];
  categorySlug: Scalars['String'];
  maxOfferDiscount: Scalars['Float'];
  minOfferDiscount: Scalars['Float'];
  offerImage: Scalars['String'];
};

export type OffersDetailDtoPaginationList = {
  __typename?: 'OffersDetailDtoPaginationList';
  data: Array<OffersDetailDto>;
  totalRecords: Scalars['Float'];
};

export type OfflinePaymentDetailInput = {
  amount: Scalars['Float'];
  chequeDate?: InputMaybe<Scalars['Float']>;
  chequeNumber?: InputMaybe<Scalars['Float']>;
  offlinePaymentType: Scalars['String'];
  paymentDate?: InputMaybe<Scalars['Float']>;
  paymentReferenceNumber?: InputMaybe<Scalars['Float']>;
};

export type OnlinePaymentDetailInput = {
  amount: Scalars['Float'];
  jusPayOrderId: Scalars['String'];
  paymentLink: Scalars['String'];
  paymentLinkGenerationDate: Scalars['Float'];
};

export type OrderColorDto = {
  __typename?: 'OrderColorDto';
  colorCode?: Maybe<Scalars['String']>;
  colorId: Scalars['ID'];
  colorName: Scalars['String'];
  isMultiColor?: Maybe<Scalars['Boolean']>;
  length?: Maybe<Scalars['Float']>;
  multiColorImage?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type OrderColorPayload = {
  colorCode?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['ID']>;
  colorName?: InputMaybe<Scalars['String']>;
  isMultiColor?: InputMaybe<Scalars['Boolean']>;
  length?: InputMaybe<Scalars['Float']>;
  multiColorImage?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

export type OrderCreateShipmentDetail = {
  __typename?: 'OrderCreateShipmentDetail';
  orderNumber?: Maybe<Scalars['String']>;
  trackingOrderStatus?: Maybe<Scalars['String']>;
  waybill?: Maybe<Scalars['Float']>;
};

export type OrderDetailResponseDto = {
  __typename?: 'OrderDetailResponseDto';
  code: Scalars['Float'];
  data: JusPayOrderDetailsDto;
  message: Scalars['String'];
};

export type OrderDetailsDto = {
  __typename?: 'OrderDetailsDto';
  _id: Scalars['ID'];
  additionalCharges?: Maybe<Array<AdditionalChargesdto>>;
  buyerBusinessName?: Maybe<Scalars['String']>;
  buyerUserDetails?: Maybe<UserDetailsDto>;
  buyerUserId: Scalars['ID'];
  buyerUserName?: Maybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  categoryName?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  couponType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Float']>;
  delhiveryPickupMessage?: Maybe<Scalars['String']>;
  deliveredDate?: Maybe<Scalars['Float']>;
  destinationAddress?: Maybe<AddressDetailsDto>;
  documentName?: Maybe<Scalars['String']>;
  expectedDeliveryDate?: Maybe<Scalars['Float']>;
  invoiceNumberId?: Maybe<Scalars['String']>;
  invoiceOrderPaymentDetails?: Maybe<InvoicePaymentDetailsDto>;
  isBuyerReported?: Maybe<Scalars['Boolean']>;
  isCouponApplied?: Maybe<Scalars['Boolean']>;
  isDeliveryChargeApplied: Scalars['Boolean'];
  isOrderOnHold?: Maybe<Scalars['Boolean']>;
  isPaymentCompleted: Scalars['Boolean'];
  isPickupSchedule?: Maybe<Scalars['Boolean']>;
  isSampleOrder?: Maybe<Scalars['Boolean']>;
  isShipped?: Maybe<Scalars['Boolean']>;
  jusPayOrderId?: Maybe<Scalars['String']>;
  jusPayPaymentStatus?: Maybe<Scalars['String']>;
  manualQuotationOrderId?: Maybe<Scalars['ID']>;
  manualQuotationOrderList?: Maybe<Array<ManualQuotationSubOrderListDto>>;
  orderHoldingDateTime?: Maybe<Scalars['Float']>;
  orderImages?: Maybe<Array<OrderProductImage>>;
  orderNumberId: Scalars['String'];
  orderType?: Maybe<Scalars['String']>;
  orderVerificationStatus: Scalars['String'];
  pickupDetail?: Maybe<OrderPickupDetail>;
  productId?: Maybe<Scalars['ID']>;
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productRatingReviewsDetails?: Maybe<ProductRatingReviewDetailsDto>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  reportBuyerDetails?: Maybe<ReportBuyerDetailsDto>;
  sampleOrderMeasurementUnit?: Maybe<Scalars['String']>;
  sampleOrderQuantity?: Maybe<Scalars['Float']>;
  sampleOrderType?: Maybe<Scalars['String']>;
  sellerBusinessName?: Maybe<Scalars['String']>;
  sellerUserDetails?: Maybe<UserDetailsDto>;
  sellerUserId: Scalars['ID'];
  shipmentManagementType: Scalars['String'];
  shipmentTrackingDetails?: Maybe<Array<ShipmentTrackingDetailsDto>>;
  soldBy?: Maybe<Scalars['String']>;
  sourceAddress?: Maybe<AddressDetailsDto>;
  subOrderList?: Maybe<Array<SubOrderDetailsDto>>;
  totalPackageWeight?: Maybe<Scalars['Float']>;
  trackingOrderStatus: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
  waybill?: Maybe<Scalars['String']>;
};

export type OrderInvoiceInput = {
  orderId: Scalars['ID'];
};

export type OrderListDto = {
  __typename?: 'OrderListDto';
  data: Array<OrderDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type OrderPayload = {
  buyerUserId: Scalars['ID'];
  categoryId: Scalars['ID'];
  invoiceOrderPaymentDetails: InvoiceOrderPaymentSummaryInput;
  sellerUserId: Scalars['ID'];
  sourceAddress: AddressPayload;
  subOrderPayload?: InputMaybe<Array<SubOrderPayload>>;
};

export type OrderPickupDetail = {
  __typename?: 'OrderPickupDetail';
  expectedPackageCount?: Maybe<Scalars['String']>;
  pickupDate?: Maybe<Scalars['String']>;
  pickupId?: Maybe<Scalars['Float']>;
  pickupTime?: Maybe<Scalars['String']>;
};

export type OrderProductImage = {
  __typename?: 'OrderProductImage';
  productImage?: Maybe<Scalars['String']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
};

export type OrderShipmentDetail = {
  __typename?: 'OrderShipmentDetail';
  isPickupSchedule?: Maybe<Scalars['Boolean']>;
  isShipped?: Maybe<Scalars['Boolean']>;
  pickupDetail?: Maybe<OrderPickupDetail>;
  shipmentDetail?: Maybe<Array<PackageDto>>;
};

export type OrderSizeDto = {
  __typename?: 'OrderSizeDto';
  quantity: Scalars['Float'];
  sizeId: Scalars['ID'];
  sizeValue: Scalars['String'];
};

export type OrderSizePayload = {
  quantity: Scalars['Float'];
  sizeId: Scalars['ID'];
  sizeValue: Scalars['String'];
};

export type OrderSummaryDto = {
  __typename?: 'OrderSummaryDto';
  cartDiscountPrice?: Maybe<Scalars['Float']>;
  couponCode?: Maybe<Scalars['String']>;
  couponCodeId?: Maybe<Scalars['String']>;
  couponDiscountPrice?: Maybe<Scalars['Float']>;
  discountOnPrice?: Maybe<Scalars['Float']>;
  gstRatePrice: Scalars['Float'];
  isCouponApplied?: Maybe<Scalars['Boolean']>;
  isFreeDelivery?: Maybe<Scalars['Boolean']>;
  outStandingPayableAmount?: Maybe<Scalars['Float']>;
  totalPackageWeight?: Maybe<Scalars['Float']>;
  totalPayableAmount: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type PackageDto = {
  __typename?: 'PackageDto';
  refnum?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  waybill?: Maybe<Scalars['String']>;
};

export type PaymentDetailsDto = {
  __typename?: 'PaymentDetailsDto';
  _id: Scalars['ID'];
  orderNumberId: Scalars['String'];
  orderType?: Maybe<Scalars['String']>;
  outStandingAmount: Scalars['Float'];
  totalAmount: Scalars['Float'];
  totalPaidAmount: Scalars['Float'];
  updatedAt: Scalars['Float'];
};

export type PaymentListDto = {
  __typename?: 'PaymentListDto';
  data: Array<PaymentDetailsDto>;
  totalPendingAmount?: Maybe<Scalars['Float']>;
  totalRecords: Scalars['Float'];
};

export type PaymentReceivedDetailsDto = {
  __typename?: 'PaymentReceivedDetailsDto';
  receivedOrderAmount?: Maybe<Scalars['Float']>;
};

export type PaymentReceivedResponseDto = {
  __typename?: 'PaymentReceivedResponseDto';
  code: Scalars['Float'];
  data: PaymentReceivedDetailsDto;
  message: Scalars['String'];
};

export type PaymentTermsDetailsDto = {
  __typename?: 'PaymentTermsDetailsDto';
  creditLimitDays?: Maybe<Scalars['Float']>;
  estimatedShippingDate?: Maybe<Scalars['Float']>;
  isAdvancePayment?: Maybe<Scalars['Boolean']>;
  isCreditPayment?: Maybe<Scalars['Boolean']>;
  isPaymentAgainstDelivery?: Maybe<Scalars['Boolean']>;
  isSplitPayment?: Maybe<Scalars['Boolean']>;
  onArrivalPaymentPercentage?: Maybe<Scalars['Float']>;
  onDeliveryPaymentPercentage?: Maybe<Scalars['Float']>;
  paymentTermText?: Maybe<Scalars['String']>;
  paymentTypeText?: Maybe<Scalars['String']>;
  shippingTermType?: Maybe<Scalars['String']>;
};

export type PaymentTermsDto = {
  __typename?: 'PaymentTermsDto';
  creditLimitDays?: Maybe<Scalars['Float']>;
  isAdvancePayment?: Maybe<Scalars['Boolean']>;
  isCreditPayment?: Maybe<Scalars['Boolean']>;
  isPaymentAgainstDelivery?: Maybe<Scalars['Boolean']>;
  isSplitPayment?: Maybe<Scalars['Boolean']>;
  onArrivalPaymentPercentage?: Maybe<Scalars['Float']>;
  onDeliveryPaymentPercentage?: Maybe<Scalars['Float']>;
};

export type PaymentTermsInput = {
  creditLimitDays?: InputMaybe<Scalars['Float']>;
  isAdvancePayment?: InputMaybe<Scalars['Boolean']>;
  isCreditPayment?: InputMaybe<Scalars['Boolean']>;
  isPaymentAgainstDelivery?: InputMaybe<Scalars['Boolean']>;
  isSplitPayment?: InputMaybe<Scalars['Boolean']>;
  onArrivalPaymentPercentage?: InputMaybe<Scalars['Float']>;
  onDeliveryPaymentPercentage?: InputMaybe<Scalars['Float']>;
};

export type PermissionDetail = {
  __typename?: 'PermissionDetail';
  permissionId: Scalars['ID'];
  permissionTypeId: Scalars['ID'];
  permissionTypeName: Scalars['String'];
  permissionTypeSlug: Scalars['String'];
};

export type PermissionInput = {
  moduleId: Scalars['ID'];
  permissionTypeId: Scalars['String'];
};

export type PermissionType = {
  __typename?: 'PermissionType';
  _id: Scalars['ID'];
  isDefault: Scalars['String'];
  permissionTypeName: Scalars['String'];
  permissionTypeSlug: Scalars['String'];
};

export type PermissionTypeInput = {
  permissionTypeName: Scalars['String'];
  permissionTypeSlug: Scalars['String'];
};

export type PermissionsType = {
  __typename?: 'PermissionsType';
  _id: Scalars['ID'];
  moduleId: Scalars['ID'];
  permissionTypeId: Scalars['ID'];
};

export type PickupLocationInput = {
  add: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  pinCode: Scalars['String'];
};

export type PickupRequestInput = {
  expectedPackageCount?: InputMaybe<Scalars['Float']>;
  orderList?: InputMaybe<Array<Scalars['String']>>;
  pickupDate?: InputMaybe<Scalars['String']>;
  pickupLocation?: InputMaybe<Scalars['String']>;
  pickupTime?: InputMaybe<Scalars['String']>;
  sellerId?: InputMaybe<Scalars['ID']>;
};

export type PolicyDetailDto = {
  __typename?: 'PolicyDetailDto';
  _id: Scalars['ID'];
  description: Scalars['String'];
  title: Scalars['String'];
};

export type PolicyInput = {
  description: Scalars['String'];
  title: Scalars['String'];
};

export type PolicyList = {
  __typename?: 'PolicyList';
  data: Array<PolicyDetailDto>;
  totalRecords: Scalars['Float'];
};

export type PopularStyleCodesCreateInput = {
  categoryId: Scalars['ID'];
  image: Scalars['String'];
  subCategoryId: Scalars['ID'];
};

export type PopularStyleCodesDetailDto = {
  __typename?: 'PopularStyleCodesDetailDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  categorySlug: Scalars['String'];
  image: Scalars['String'];
  popularStyleCodeName: Scalars['String'];
  subCategoryId: Scalars['String'];
  subCategoryName: Scalars['String'];
};

export type PopularStyleCodesDetailDtoPaginationList = {
  __typename?: 'PopularStyleCodesDetailDtoPaginationList';
  data: Array<PopularStyleCodesDetailDto>;
  totalRecords: Scalars['Float'];
};

export type PreviewQuotationDetailsDto = {
  __typename?: 'PreviewQuotationDetailsDto';
  _id: Scalars['ID'];
  creditLimitDays?: Maybe<Scalars['Float']>;
  estimatedShippingDate?: Maybe<Scalars['Float']>;
  isAdvancePayment?: Maybe<Scalars['Boolean']>;
  isCreditPayment?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isPaymentAgainstDelivery?: Maybe<Scalars['Boolean']>;
  isPriceIncludeGST?: Maybe<Scalars['Boolean']>;
  isSplitPayment?: Maybe<Scalars['Boolean']>;
  onArrivalPaymentPercentage?: Maybe<Scalars['Float']>;
  onDeliveryPaymentPercentage?: Maybe<Scalars['Float']>;
  paymentTermText?: Maybe<Scalars['String']>;
  productData?: Maybe<ProductDetailsForQuotationDto>;
  quantity?: Maybe<Scalars['Float']>;
  quantityUnit?: Maybe<Scalars['String']>;
  quotationDescription?: Maybe<Scalars['String']>;
  quotationValidity?: Maybe<Scalars['Float']>;
  shippingTermType?: Maybe<Scalars['String']>;
  totalPackageWeight?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type ProductAddAttributeValuesDto = {
  __typename?: 'ProductAddAttributeValuesDto';
  code: Scalars['Float'];
  data: UserProductAttributeTypeRelationDto;
  message: Scalars['String'];
};

export type ProductAddRatingReviewInput = {
  productId: Scalars['ID'];
  ratings: Scalars['Float'];
  reviews: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ProductAddUpdateAdditionalDetailsInput = {
  discount?: InputMaybe<Scalars['Float']>;
  features?: InputMaybe<Array<Scalars['String']>>;
  freeSampleDetails?: InputMaybe<SampleDetailsInput>;
  gstRate: Scalars['Float'];
  hsnCodeId: Scalars['ID'];
  isPricePerPieceIncludesGst: Scalars['Boolean'];
  isSampleAvailable: Scalars['Boolean'];
  lastCompletedStep: Scalars['Float'];
  listingDescription: Scalars['String'];
  listingExpiryDays: Scalars['Float'];
  listingTitle: Scalars['String'];
  moq: Scalars['Float'];
  paidSampleDetails?: InputMaybe<SampleDetailsInput>;
  productAddEditSlug: Scalars['String'];
  productId: Scalars['ID'];
  productVideo?: InputMaybe<Scalars['String']>;
  skuId: Scalars['String'];
};

export type ProductAddUpdateBrandInput = {
  brandId: Scalars['ID'];
  categoryId: Scalars['String'];
  lastCompletedStep: Scalars['Float'];
  productId?: InputMaybe<Scalars['ID']>;
  subCategoryId: Scalars['String'];
  userId: Scalars['ID'];
};

export type ProductAddUpdateCreateSetByIdResponseDto = {
  __typename?: 'ProductAddUpdateCreateSetByIdResponseDto';
  code: Scalars['Float'];
  data: CreateSetPayloadDto;
  message: Scalars['String'];
};

export type ProductAddUpdateImagesInput = {
  lastCompletedStep: Scalars['Float'];
  name: Scalars['String'];
  productAddEditSlug: Scalars['String'];
  productId: Scalars['ID'];
  thumbNailImageName: Scalars['String'];
};

export type ProductAddUpdateYarnListDetailDto = {
  __typename?: 'ProductAddUpdateYarnListDetailDto';
  _id: Scalars['ID'];
  miscellaneous?: Maybe<Array<Scalars['String']>>;
  packageDimensions?: Maybe<ProductYarnListPackageDimensionsDetailDto>;
  packageWeight?: Maybe<ProductYarnListPackageWeightDetailDto>;
  priceMoq: ProductYarnListPriceMoqDetailDto;
  productId: Scalars['ID'];
};

export type ProductAddUpdateYarnListingDetailsInput = {
  lastCompletedStep: Scalars['Float'];
  miscellaneous?: InputMaybe<Array<Scalars['String']>>;
  packageDimensions?: InputMaybe<ProductYarnListPackageDimensionsInput>;
  packageWeight?: InputMaybe<ProductYarnListPackageWeightInput>;
  priceMoq: ProductYarnListPriceMoqInput;
  productId: Scalars['ID'];
};

export type ProductAdditionalDetailsDto = {
  __typename?: 'ProductAdditionalDetailsDto';
  discount?: Maybe<Scalars['Float']>;
  features?: Maybe<Array<Scalars['String']>>;
  freeSampleDetails?: Maybe<SampleDetailsDto>;
  gstRate?: Maybe<Scalars['Float']>;
  hsnCode?: Maybe<Scalars['String']>;
  hsnCodeId?: Maybe<Scalars['ID']>;
  isPricePerPieceIncludesGst?: Maybe<Scalars['Boolean']>;
  isSampleAvailable?: Maybe<Scalars['Boolean']>;
  listingDescription?: Maybe<Scalars['String']>;
  listingExpiryDays?: Maybe<Scalars['Float']>;
  listingExpiryTime?: Maybe<Scalars['Float']>;
  listingTitle?: Maybe<Scalars['String']>;
  moq?: Maybe<Scalars['Float']>;
  paidSampleDetails?: Maybe<SampleDetailsDto>;
  productId?: Maybe<Scalars['ID']>;
  productVideo?: Maybe<Scalars['String']>;
  skuId?: Maybe<Scalars['String']>;
};

export type ProductAttributeContentDto = {
  __typename?: 'ProductAttributeContentDto';
  inputId: Scalars['ID'];
  selectedValues: Array<ProductAttributeSelectedValuesDto>;
};

export type ProductAttributeCreateInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isYarnCount?: InputMaybe<Scalars['Boolean']>;
  status: Scalars['String'];
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProductAttributeListBySubcategoryIdDto = {
  __typename?: 'ProductAttributeListBySubcategoryIdDto';
  _id: Scalars['ID'];
  attributeName: Scalars['String'];
  brandId: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  status: Scalars['String'];
};

export type ProductAttributeSelectedValuesDto = {
  __typename?: 'ProductAttributeSelectedValuesDto';
  colorId?: Maybe<Scalars['ID']>;
  numberValue?: Maybe<Scalars['Float']>;
  textValue?: Maybe<Scalars['String']>;
  threadCountOne?: Maybe<Scalars['Float']>;
  threadCountTwo?: Maybe<Scalars['Float']>;
  uploadedFileName?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['ID']>;
};

export type ProductAttributeSetSizeInput = {
  addUpdatedPayload?: InputMaybe<Array<ProductAttributeSetSizeValuesInput>>;
  apiType: Scalars['String'];
  deletePayload?: InputMaybe<Array<Scalars['ID']>>;
  sizeGroupId?: InputMaybe<Scalars['ID']>;
  sizeGroupTitle?: InputMaybe<Scalars['String']>;
};

export type ProductAttributeSetSizeValuesInput = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  sizeValue: Array<Scalars['String']>;
  subCategoryIds: Array<Scalars['ID']>;
};

export type ProductAttributeTypesAndValuesInput = {
  _id?: InputMaybe<Scalars['ID']>;
  allowToAddNewValue?: InputMaybe<Scalars['Boolean']>;
  inputType: Scalars['String'];
  isInitialValue?: InputMaybe<Scalars['Boolean']>;
  isRequired: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  placeholder?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<UserProductAttributeTypeRelationList>>;
};

export type ProductAttributeTypesAndValuesListDto = {
  __typename?: 'ProductAttributeTypesAndValuesListDto';
  data: Array<ProductAttributeTypesListDto>;
  productsCount?: Maybe<Scalars['Float']>;
};

export type ProductAttributeTypesListDto = {
  __typename?: 'ProductAttributeTypesListDto';
  _id: Scalars['ID'];
  allowToAddNewValue?: Maybe<Scalars['Boolean']>;
  fileUrl?: Maybe<Scalars['String']>;
  inputId?: Maybe<Scalars['ID']>;
  inputType: Scalars['String'];
  isInitialValue?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  placeholder?: Maybe<Scalars['String']>;
  productAttributeGroupId?: Maybe<Scalars['ID']>;
  productAttributeId?: Maybe<Scalars['ID']>;
  reviewAttributeValues?: Maybe<Array<UserProductAttributeTypeRelationListDto>>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  values?: Maybe<Array<UserProductAttributeTypeRelationListDto>>;
};

export type ProductAverageRatingReviewDetailDto = {
  __typename?: 'ProductAverageRatingReviewDetailDto';
  averageRatings: Scalars['Float'];
  starRatingReviewCounts?: Maybe<Array<ProductStarRatingReviewListDto>>;
  totalReviewCounts: Scalars['Float'];
};

export type ProductBrandAddDto = {
  __typename?: 'ProductBrandAddDto';
  productId: Scalars['ID'];
};

export type ProductBrandAddUpdateResponseDto = {
  __typename?: 'ProductBrandAddUpdateResponseDto';
  code: Scalars['Float'];
  data: ProductBrandAddDto;
  message: Scalars['String'];
};

export type ProductDetailsAddUpdatePayload = {
  inputId: Scalars['ID'];
  selectedValues: Array<ProductDetailsAddUpdatePayloadSelectedValues>;
};

export type ProductDetailsAddUpdatePayloadSelectedValues = {
  colors?: InputMaybe<Array<ProductDetailsColorSelectedValues>>;
  numberValue?: InputMaybe<Scalars['Float']>;
  textValue?: InputMaybe<Scalars['String']>;
  threadCountOne?: InputMaybe<Scalars['Float']>;
  threadCountTwo?: InputMaybe<Scalars['Float']>;
  uploadedFileName?: InputMaybe<Scalars['String']>;
  valueId?: InputMaybe<Scalars['ID']>;
};

export type ProductDetailsByIdAttributeDetailDto = {
  __typename?: 'ProductDetailsByIdAttributeDetailDto';
  inputTitle: Scalars['String'];
  values?: Maybe<Array<Scalars['String']>>;
};

export type ProductDetailsByIdDto = {
  __typename?: 'ProductDetailsByIdDto';
  _id: Scalars['ID'];
  additionalDetails?: Maybe<ProductAdditionalDetailsDto>;
  brandId: Scalars['ID'];
  brandName: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  cashDiscountPercentage?: Maybe<Scalars['Float']>;
  categoryReturnPolicyDetails?: Maybe<ReturnPolicyByCategoryId>;
  categorySlug?: Maybe<Scalars['String']>;
  comissionRate?: Maybe<Scalars['Float']>;
  ddFee?: Maybe<Scalars['Float']>;
  gstRate?: Maybe<Scalars['Float']>;
  guidelineDocument?: Maybe<Scalars['String']>;
  guidelineDocumentType?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAddedToCart?: Maybe<Scalars['Boolean']>;
  isFromBulkUpload?: Maybe<Scalars['Boolean']>;
  isProductDeliveryServiceAvailable?: Maybe<Scalars['Boolean']>;
  isProductWishlisted?: Maybe<Scalars['Boolean']>;
  pinCode?: Maybe<Scalars['Float']>;
  prodId: Scalars['ID'];
  productCancelReason?: Maybe<Scalars['String']>;
  productCreatedSets?: Maybe<Array<CreateSetPayloadDto>>;
  productDetails: Array<ProductDetailsByIdAttributeDetailDto>;
  productImages: Array<ProductImagesListDto>;
  productPriceDetails?: Maybe<ProductPriceDetails>;
  productRatingReviewDetails?: Maybe<ProductAverageRatingReviewDetailDto>;
  productRatingReviewList?: Maybe<Array<ProductRatingReviewListDto>>;
  productStatus?: Maybe<Scalars['String']>;
  productStatusChangedBy?: Maybe<Scalars['String']>;
  productYarnListDetailId?: Maybe<Scalars['ID']>;
  productYarnListDetails?: Maybe<ProductAddUpdateYarnListDetailDto>;
  qrCodeImage?: Maybe<Scalars['String']>;
  sellerSettingDetails?: Maybe<SellerSettingsDetailDto>;
  sizeChart?: Maybe<Scalars['String']>;
  soldBy?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['ID']>;
  testReport?: Maybe<Scalars['String']>;
  totalProductAvailableQuantity?: Maybe<Scalars['Float']>;
  userDetails?: Maybe<UserDetailDto>;
  userId: Scalars['ID'];
  verifiedByAdmin?: Maybe<Scalars['String']>;
};

export type ProductDetailsColorSelectedValues = {
  colorCode?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['ID']>;
  colorName?: InputMaybe<Scalars['String']>;
};

export type ProductDetailsDto = {
  __typename?: 'ProductDetailsDto';
  _id: Scalars['ID'];
  additionalDetails?: Maybe<ProductAdditionalDetailsDto>;
  brandDetails?: Maybe<BrandDetailDto>;
  brandId: Scalars['ID'];
  categoryDetails?: Maybe<CategoryDetailDto>;
  categoryId?: Maybe<Scalars['String']>;
  comissionRate?: Maybe<Scalars['Float']>;
  guidelineDocument?: Maybe<Scalars['String']>;
  guidelineDocumentType?: Maybe<Scalars['String']>;
  images?: Maybe<Array<ProductDetailsImagesDto>>;
  isPublished: Scalars['Boolean'];
  lastCompletedStep?: Maybe<Scalars['Float']>;
  productCreatedSets?: Maybe<Array<CreateSetPayloadDto>>;
  productDetails?: Maybe<Array<Scalars['String']>>;
  productProfileStatus: Scalars['String'];
  productStatus: Scalars['String'];
  productYarnListDetailId?: Maybe<Scalars['ID']>;
  productYarnListDetails?: Maybe<ProductAddUpdateYarnListDetailDto>;
  sizeChart?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
  subCategoryName?: Maybe<Scalars['String']>;
  testReport?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type ProductDetailsForQuotationDto = {
  __typename?: 'ProductDetailsForQuotationDto';
  gstRate?: Maybe<Scalars['Float']>;
  productDetails?: Maybe<Array<ProductDetailsByIdAttributeDetailDto>>;
  productImage?: Maybe<Scalars['String']>;
  productImages?: Maybe<Array<ProductImagesListDto>>;
  productName?: Maybe<Scalars['String']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  productVideo?: Maybe<Scalars['String']>;
};

export type ProductDetailsImagesDto = {
  __typename?: 'ProductDetailsImagesDto';
  imagePathUrl?: Maybe<Scalars['String']>;
  isCover: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  thumbNailImageName?: Maybe<Scalars['String']>;
  thumbNailImagePathUrl?: Maybe<Scalars['String']>;
};

export type ProductImagesListDto = {
  __typename?: 'ProductImagesListDto';
  imagePathUrl?: Maybe<Scalars['String']>;
  isCover: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  thumbNailImageName?: Maybe<Scalars['String']>;
  thumbNailImagePathUrl?: Maybe<Scalars['String']>;
};

export type ProductImagesListInput = {
  isCover: Scalars['Boolean'];
  name: Scalars['String'];
  thumbNailImageName: Scalars['String'];
};

export type ProductImagesListResponseDto = {
  __typename?: 'ProductImagesListResponseDto';
  code: Scalars['Float'];
  data: Array<ProductImagesListDto>;
  message: Scalars['String'];
};

export type ProductImagesListUpdateInput = {
  images: Array<ProductImagesListInput>;
  productId: Scalars['ID'];
};

export type ProductListDetailsDto = {
  __typename?: 'ProductListDetailsDto';
  _id: Scalars['ID'];
  averageRatings?: Maybe<Scalars['Float']>;
  brandId?: Maybe<Scalars['ID']>;
  brandName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['ID']>;
  categoryName?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isFromBulkUpload?: Maybe<Scalars['Boolean']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  listingTitle?: Maybe<Scalars['String']>;
  productCancelReason?: Maybe<Scalars['String']>;
  productImage?: Maybe<Scalars['String']>;
  productPriceDetails?: Maybe<ProductPriceDetails>;
  productStatus?: Maybe<Scalars['String']>;
  productStatusChangedBy?: Maybe<Scalars['String']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  quantityInSet?: Maybe<Scalars['Float']>;
  subCategoryId?: Maybe<Scalars['ID']>;
  subCategoryName?: Maybe<Scalars['String']>;
  totalReviewCounts?: Maybe<Scalars['Float']>;
  userDetails?: Maybe<UserDetailDto>;
  userId: Scalars['ID'];
  verifiedByAdmin?: Maybe<Scalars['String']>;
};

export type ProductListForQuotationDto = {
  __typename?: 'ProductListForQuotationDto';
  _id: Scalars['ID'];
  availableQuantity?: Maybe<Scalars['Float']>;
  hsnCode?: Maybe<Scalars['String']>;
  hsnCodeId: Scalars['ID'];
  productDescription?: Maybe<Scalars['String']>;
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type ProductListingDetailsByIdDto = {
  __typename?: 'ProductListingDetailsByIdDto';
  data: ProductDetailsDto;
};

export type ProductListingGuidelineAddEditInput = {
  categoryId: Scalars['String'];
  guidelineDocument: Scalars['String'];
  guidelineDocumentType: Scalars['String'];
  subCategoryId: Scalars['String'];
};

export type ProductListingGuidelineDetails = {
  __typename?: 'ProductListingGuidelineDetails';
  categoryId: Scalars['String'];
  guidelineDocument: Scalars['String'];
  guidelineDocumentType: Scalars['String'];
  subCategoryId: Scalars['String'];
};

export type ProductNameAddUpdateInput = {
  categoryId: Scalars['ID'];
  productAttributeNameIds: Array<Scalars['ID']>;
  subCategoryId: Scalars['ID'];
};

export type ProductNameListBySubcategoryIdDto = {
  __typename?: 'ProductNameListBySubcategoryIdDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  productAttributeNameIds: Array<Scalars['ID']>;
  subCategoryId: Scalars['ID'];
};

export type ProductQuotationDetailsDto = {
  __typename?: 'ProductQuotationDetailsDto';
  _id: Scalars['ID'];
  hsnCode: Scalars['String'];
  hsnCodeId?: Maybe<Scalars['String']>;
  productDescription: Scalars['String'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
  quantity: Scalars['Float'];
  totalAmount: Scalars['String'];
  totalAvailableUnitQuantity?: Maybe<Scalars['Float']>;
  unit: Scalars['String'];
  unitPrice: Scalars['String'];
};

export type ProductRatingReviewDetailsDto = {
  __typename?: 'ProductRatingReviewDetailsDto';
  _id: Scalars['ID'];
  productId: Scalars['ID'];
  ratings: Scalars['Float'];
  reviews: Scalars['ID'];
  userId: Scalars['ID'];
};

export type ProductRatingReviewListDetailsDto = {
  __typename?: 'ProductRatingReviewListDetailsDto';
  data: Array<ProductRatingReviewListDto>;
  totalRecords: Scalars['Float'];
};

export type ProductRatingReviewListDto = {
  __typename?: 'ProductRatingReviewListDto';
  dateOfReview: Scalars['String'];
  ratings: Scalars['Float'];
  reviews: Scalars['String'];
  userName: Scalars['String'];
};

export type ProductSetDetailsDto = {
  __typename?: 'ProductSetDetailsDto';
  availableQuantity?: Maybe<Scalars['Float']>;
  discountedPercentage?: Maybe<Scalars['Float']>;
  discountedPrice?: Maybe<Scalars['Float']>;
  marginPercentage?: Maybe<Scalars['Float']>;
  moq?: Maybe<Scalars['Float']>;
  perPieceMrp?: Maybe<Scalars['Float']>;
  perSetPrice?: Maybe<Scalars['Float']>;
  quantityUnit?: Maybe<Scalars['String']>;
  setPrice?: Maybe<Scalars['Float']>;
  setQuantity?: Maybe<Scalars['Float']>;
  totalCartQuantity?: Maybe<Scalars['Float']>;
  totalSetPrice?: Maybe<Scalars['Float']>;
  unitOfMeasurement?: Maybe<Scalars['String']>;
};

export type ProductSetListDetailsDto = {
  __typename?: 'ProductSetListDetailsDto';
  gstRate?: Maybe<Scalars['Float']>;
  moq?: Maybe<Scalars['Float']>;
  productCreatedSets?: Maybe<Array<CreateSetPayloadDto>>;
  productImages?: Maybe<Array<ProductImagesListDto>>;
  totalProductPrice?: Maybe<Scalars['Float']>;
};

export type ProductSetPriceMoqDetailDto = {
  __typename?: 'ProductSetPriceMoqDetailDto';
  availableQuantity: Scalars['Float'];
  discountedPerPieceMrp?: Maybe<Scalars['Float']>;
  minSetOrder: Scalars['Float'];
  perPieceMrp: Scalars['Float'];
  perPiecePrice: Scalars['Float'];
};

export type ProductSetPriceMoqDetailInput = {
  availableQuantity: Scalars['Float'];
  minSetOrder: Scalars['Float'];
  perPieceMrp: Scalars['Float'];
  perPiecePrice: Scalars['Float'];
  totalAvailableUnitQuantity?: InputMaybe<Scalars['Float']>;
};

export type ProductSetSizeDetailDto = {
  __typename?: 'ProductSetSizeDetailDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  sizeGroupId: Scalars['ID'];
  sizeGroupTitle: Scalars['String'];
  subCategories: Array<Scalars['String']>;
  subCategoryIds: Array<Scalars['ID']>;
  values: Array<SizeValueDto>;
};

export type ProductSetSizeDto = {
  __typename?: 'ProductSetSizeDto';
  categoryId: Scalars['ID'];
  sizeGroupId: Scalars['ID'];
  sizeGroupTitle: Scalars['String'];
  subCategories: Array<Scalars['String']>;
  subCategoryIds: Array<Scalars['ID']>;
  values: Array<SizeValueDto>;
};

export type ProductSetSizeGroupDto = {
  __typename?: 'ProductSetSizeGroupDto';
  _id: Scalars['ID'];
  sizeGroupTitle?: Maybe<Scalars['String']>;
};

export type ProductSetSizeListingByCategoryIdDto = {
  __typename?: 'ProductSetSizeListingByCategoryIdDto';
  data: Array<ProductSetSizeListingDetailsByCategoryIdDto>;
};

export type ProductSetSizeListingBySubCategoryIdDto = {
  __typename?: 'ProductSetSizeListingBySubCategoryIdDto';
  data: Array<ProductSetSizeListingDetailsBySubCategoryIdDto>;
  productCount?: Maybe<Scalars['Float']>;
};

export type ProductSetSizeListingDetailsByCategoryIdDto = {
  __typename?: 'ProductSetSizeListingDetailsByCategoryIdDto';
  _id: Scalars['ID'];
  isActive?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Float']>;
  sizeSets: Array<ProductSetSizeListingDetailsBySubCategoryIdDto>;
  subCategoryImage?: Maybe<Scalars['String']>;
  subCategoryLevel?: Maybe<Scalars['Float']>;
  subCategoryName?: Maybe<Scalars['String']>;
};

export type ProductSetSizeListingDetailsBySubCategoryIdDto = {
  __typename?: 'ProductSetSizeListingDetailsBySubCategoryIdDto';
  _id: Scalars['ID'];
  sizeGroupTitle: Scalars['String'];
  values: Array<ProductSetSizeValueDto>;
};

export type ProductSetSizePaginationDto = {
  __typename?: 'ProductSetSizePaginationDto';
  data: Array<ProductSetSizeDto>;
  totalRecords: Scalars['Float'];
};

export type ProductSetSizeTypesAndValuesInput = {
  _id?: InputMaybe<Scalars['ID']>;
  sizeGroupTitle?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<ProductSetSizeValuesInput>>;
};

export type ProductSetSizeValueDto = {
  __typename?: 'ProductSetSizeValueDto';
  _id: Scalars['ID'];
  categoryId?: Maybe<Scalars['ID']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  sizeGroupId?: Maybe<Scalars['ID']>;
  sizeValue: Scalars['String'];
  subCategoryId?: Maybe<Scalars['ID']>;
};

export type ProductSetSizeValuesInput = {
  _id?: InputMaybe<Scalars['ID']>;
  sizeValue: Scalars['ID'];
};

export type ProductStarRatingReviewListDto = {
  __typename?: 'ProductStarRatingReviewListDto';
  ratingsValue: Scalars['Float'];
  reviewsCount: Scalars['Float'];
};

export type ProductYarnListPackageDimensionsDetailDto = {
  __typename?: 'ProductYarnListPackageDimensionsDetailDto';
  breadth: Scalars['Float'];
  height: Scalars['Float'];
  length: Scalars['Float'];
  unitMeasurement: Scalars['String'];
};

export type ProductYarnListPackageDimensionsInput = {
  breadth: Scalars['Float'];
  height: Scalars['Float'];
  length: Scalars['Float'];
  unitMeasurement: Scalars['String'];
};

export type ProductYarnListPackageWeightDetailDto = {
  __typename?: 'ProductYarnListPackageWeightDetailDto';
  unitMeasurement: Scalars['String'];
  weight: Scalars['Float'];
};

export type ProductYarnListPackageWeightInput = {
  unitMeasurement: Scalars['String'];
  weight: Scalars['Float'];
};

export type ProductYarnListPriceMoqDetailDto = {
  __typename?: 'ProductYarnListPriceMoqDetailDto';
  availableQuantity: Scalars['Float'];
  moq: Scalars['Float'];
  perKgMaxPrice: Scalars['Float'];
  perKgMinPrice: Scalars['Float'];
  perKgMrp: Scalars['Float'];
};

export type ProductYarnListPriceMoqInput = {
  availableQuantity: Scalars['Float'];
  moq: Scalars['Float'];
  perKgMaxPrice: Scalars['Float'];
  perKgMinPrice: Scalars['Float'];
  perKgMrp?: InputMaybe<Scalars['Float']>;
};

export type ProductYarnListingDetailDto = {
  __typename?: 'ProductYarnListingDetailDto';
  availableQuantity?: Maybe<Scalars['Float']>;
  discountedMaxPrice?: Maybe<Scalars['Float']>;
  discountedMinPrice?: Maybe<Scalars['Float']>;
  discountedPercentage?: Maybe<Scalars['Float']>;
  marginPercentage?: Maybe<Scalars['Float']>;
  moq?: Maybe<Scalars['Float']>;
  perKgMaxPrice?: Maybe<Scalars['Float']>;
  perKgMinPrice?: Maybe<Scalars['Float']>;
  perKgMrp?: Maybe<Scalars['Float']>;
  quantityUnit?: Maybe<Scalars['String']>;
  setPrice?: Maybe<Scalars['Float']>;
  setQuantity?: Maybe<Scalars['Float']>;
  totalSetPrice?: Maybe<Scalars['Float']>;
  unitOfMeasurement?: Maybe<Scalars['String']>;
};

export type ProductsInput = {
  hsnCode?: InputMaybe<Scalars['String']>;
  hsnCodeId: Scalars['ID'];
  productDescription: Scalars['String'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
  quantity: Scalars['Float'];
  totalAmount: Scalars['String'];
  unit: Scalars['String'];
  unitPrice: Scalars['String'];
};

export type PromoteYourAdvDetailsDto = {
  __typename?: 'PromoteYourAdvDetailsDto';
  _id: Scalars['ID'];
  advertisementType: Scalars['String'];
  bulkPrice?: Maybe<Array<BulkPriceFieldDto>>;
  categoryId: Scalars['ID'];
  categoryName?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  sectionType: Scalars['String'];
  sectionTypeName: Scalars['String'];
  totalAdvCounts?: Maybe<Scalars['Float']>;
  uniqueImpressions: Scalars['Float'];
};

export type PromoteYourAdvList = {
  __typename?: 'PromoteYourAdvList';
  data: Array<PromoteYourAdvDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type PromoteYourAdvUpdateInput = {
  _id?: InputMaybe<Scalars['ID']>;
  advertisementType: Scalars['String'];
  bulkPrice?: InputMaybe<Array<BulkPriceField>>;
  categoryId: Scalars['ID'];
  price: Scalars['Float'];
  sectionType: Scalars['String'];
  sectionTypeName?: InputMaybe<Scalars['String']>;
  uniqueImpressions: Scalars['Float'];
};

export type PushNotificationDetailDto = {
  __typename?: 'PushNotificationDetailDto';
  _id: Scalars['ID'];
  body: Scalars['String'];
  brandId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Timestamp'];
  isReaded: Scalars['Boolean'];
  kycDocumentVerificationId?: Maybe<Scalars['ID']>;
  manualQuotationOrderId?: Maybe<Scalars['ID']>;
  notificationDetails?: Maybe<Scalars['DynamicObject']>;
  notificationType: Scalars['String'];
  orderId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  quotationId?: Maybe<Scalars['ID']>;
  quotationRequestId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  userId: Scalars['ID'];
  userPromotedAdvId?: Maybe<Scalars['ID']>;
};

export type PushNotificationListDto = {
  __typename?: 'PushNotificationListDto';
  data: Array<PushNotificationDetailDto>;
  totalRecords: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  aadharKycConnectSession: AadharKycConnectSessionDto;
  adminDetails: AdminDetails;
  adminList: AdminList;
  adminPromotedAdvList: UserPromotedAdvList;
  advertisementBrandList: Array<BrandNameListDto>;
  advertisementSellerList: Array<UserDetailDto>;
  applyCouponCode: CouponDiscountPayableResponseDto;
  attributeTypesAndValuesList: ProductAttributeTypesAndValuesListDto;
  bankDetails: BankDetailDto;
  bankList: Array<BankListDto>;
  bankListPagination: BankList;
  brandGroupListById: BrandGroupList;
  brandList: BrandList;
  brandListByProductCategory: Array<BrandDetailDto>;
  brandListByUserId: BrandList;
  brandListWithSearch: Array<BrandNameListDto>;
  brandMillSellerStorePopularProductList: BuyerProductListDetailsDto;
  brandSectionPaginationList: BrandSectionListDto;
  bulkPurchaseProductEnquiry: CommonSuccessResponseDto;
  bulkUploadHistoryList: BulkUploadHistoryListDto;
  bulkUploadSheet: CommonSuccessResponseDto;
  bulkUploadSheetList: BulkUploadHistoryListDto;
  businessTypeDetails: BusinessTypeDetailDto;
  businessTypeList: Array<BusinessTypeDetailDto>;
  businessTypeListPagination: BusinessTypeList;
  buyerSideProductsList: BuyerProductListDetailsDto;
  categoryAttributeListForFilter: CategoryAttributeListDetails;
  categoryAttributesList: Array<CategoryAttributeList>;
  categoryAttributesListWithSearchAndPagination: CategoryAttributesListWithPaginationAndSearchDto;
  categoryDetails: CategoryDetailDto;
  categoryList: Array<CategoryListDto>;
  categoryListPagination: CategoryList;
  changeAdvertisementStatus: CommonSuccessResponseDto;
  checkPincodeAvailability: DelhiveryCodesResponseDto;
  checkoutQuotationOrderDetails?: Maybe<UserCartDetailsDto>;
  cityList: Array<CityListDto>;
  colorDetails: ColorDetailDto;
  colorList: Array<ColorDetailDto>;
  colorListPagination: ColorList;
  commodityList: Array<CommodityListDto>;
  countryList: Array<CountryListDto>;
  couponCodeDetailsById: CouponCodeDetailsDto;
  couponCodeListPagination: CouponCodePaginationListDto;
  createInvoice: InvoiceDto;
  createProductQrCode: CommonSuccessResponseDto;
  dashboardList: Array<DashboardCardObject>;
  deleteBusinessDetails: CommonSuccessResponseDto;
  deleteFailedPaymentDetails: CommonSuccessResponseDto;
  deleteNewsUrlById: CommonSuccessResponseDto;
  deleteProductsFromS3: CommonSuccessResponseDto;
  delhiveryAccessTokenAdd: ThirdPartyAccessTokenDetialDto;
  designationDetails: DesignationDetailDto;
  designationList: Array<DesignationDetailDto>;
  designationListPagination: DesignationList;
  downloadCatalogueTemplate: BulkUploadDto;
  downloadFailureBulkUploadSheet: BulkUploadDto;
  downloadPaymentStatementList: DownloadPaymentStatementResponseDto;
  escalatedIssueSubjectsList: Array<EscalateIssueSubjectDetailDto>;
  escalatedIssuesListByUserId: Array<UserEscalatedIssueDetailDto>;
  exploreCategories: Array<SubCategoryDetailDto>;
  exploreStyleDetailsById: ExploreStylesDetailDto;
  exploreStylesList: Array<ExploreStylesDetailDto>;
  exploreStylesListPagination: ExploreStylesDetailDtoPaginationList;
  faqDetails: FaqDetail;
  faqListPagination: FaqList;
  faqTypeDetails: FaqTypeDetail;
  faqTypeList: Array<FaqType>;
  faqTypeListPagination: FaqTypeList;
  faqsList: Array<FaqsList>;
  fetchWaybill: FatchWayBillDto;
  generalSettingDetails: GeneralSettingDetailsDto;
  generateThumbNailImage: CommonSuccessResponseDto;
  getAllFeedbackList: UserFeedbackListDto;
  getAppVersionDetails: AppVersionDetialDto;
  getCategoryAttributeById: CategoryAttributeByIdInput;
  getCategoryReturnPolicyList: CategoryReturnPolicyList;
  getProductByUserId: UserProductIdDto;
  getProductDetailsById: ProductDetailsByIdDto;
  getProductListAttributeBySubCategoryId: Array<ProductAttributeListBySubcategoryIdDto>;
  getProductNameListBySubCategoryId?: Maybe<ProductNameListBySubcategoryIdDto>;
  getProductRatingsReviewsByProductId: ProductRatingReviewListDetailsDto;
  getProfileCompletionPercenatge: UserProfileCompletionDetail;
  getReturnPolicyCategoryById?: Maybe<CategoryReturnPolicyDto>;
  getSetDetailById: CreateSetPayloadDto;
  getShipmentDetailsByOrderId: OrderShipmentDetail;
  getUserBalance: UserCreditDebitListDto;
  getUserCartItems: UserCartListDto;
  getUserDetails: UserDetailDto;
  getUserDeviceTokens?: Maybe<UserDeviceTokensDto>;
  getUserProductBrandList: Array<UserBrandDetailDto>;
  getUserProductWishlistById: UserProductWishlistsDto;
  hello: Scalars['String'];
  homeAdvertisementPromotedList?: Maybe<HomeAdvertisementPromotedList>;
  homePageSubCategoryProductsList: Array<HomePageSubcategoryProductListDetailsDto>;
  hsnCodeList: Array<HsnCodeListDto>;
  hsnCodeListWithPagination: HsnCodeListWithPaginationDto;
  kycAccessTokenAdd: ThirdPartyAccessTokenDetialDto;
  kycDocumentList: Array<KycDocumentDetialDto>;
  manageDocumentList: Array<ManageDocumentDetailsDto>;
  manualOrderQuotationList: ManualQuotationOrderList;
  manualQuotationDetail: ManualQuotationDetail;
  manualQuotationGSTDetails: ManualQuotationGstDetail;
  manualQuotationPaymentHistoryList: ManualQuotationPaymentHistoryList;
  manualQuotationSubOrderDetail: ManualQuotationSubOrderDetail;
  manualSubOrderQuotationList: ManualQuotationSubOrderList;
  millsList: MillsListDto;
  moduleList: Array<ModuleType>;
  modulePermissionList: Array<ModulePermissionList>;
  newArrivalsProductsList: BuyerProductListDetailsDto;
  newSubCategoryListCms: Array<SubCategoryListResponseDto>;
  newsCategoryList: CategoryListDto;
  newsList: NewsListDto;
  offerDetailsById: OffersDetailDto;
  offersList: Array<OffersDetailDto>;
  offersListPagination: OffersDetailDtoPaginationList;
  orderDetailsById: OrderDetailsDto;
  orderList: OrderListDto;
  orderListForAdmin: OrderListDto;
  orderStatusDetailsJusPay: CommonSuccessResponseDto;
  paymentList: PaymentListDto;
  permissionList: Array<PermissionsType>;
  permissionTypeList: Array<PermissionType>;
  policyDetails: PolicyDetailDto;
  policyList: Array<PolicyDetailDto>;
  policyListPagination: PolicyList;
  popularProductsList: BuyerProductListDetailsDto;
  popularStyleCodesDetailsById: PopularStyleCodesDetailDto;
  popularStyleCodesList: Array<PopularStyleCodesDetailDto>;
  popularStyleCodesListPagination: PopularStyleCodesDetailDtoPaginationList;
  previewQuotationDetailsById?: Maybe<PreviewQuotationDetailsDto>;
  productAdditionDetailsByProductId: ProductAdditionalDetailsDto;
  productAttributeSetSizeListing: ProductSetSizePaginationDto;
  productEnquiry: CommonSuccessResponseDto;
  productListForQuotation: Array<ProductListForQuotationDto>;
  productListingDetailsById: ProductListingDetailsByIdDto;
  productListingGuidelineDetails?: Maybe<ProductListingGuidelineDetails>;
  productSetList: ProductSetListDetailsDto;
  productSetSizeListByCategory: ProductSetSizeListingByCategoryIdDto;
  productSetSizeListBySet: ProductSetSizeListingBySubCategoryIdDto;
  productSetSizeListBySubCategory: ProductSetSizeListingBySubCategoryIdDto;
  productSetSizesGroupDetails: DetailProductAttributeSetSizesDto;
  productSetSizesGroupsListing: Array<ProductSetSizeGroupDto>;
  productYarnListDetailByProductId: ProductAddUpdateYarnListDetailDto;
  productsNearYouList: BuyerProductListDetailsDto;
  promoteYourAdvDetails: PromoteYourAdvDetailsDto;
  promoteYourAdvList: Array<PromoteYourAdvDetailsDto>;
  promoteYourAdvListPagination: PromoteYourAdvList;
  promotedAdvDetails: UserPromotedAdvDetailsDto;
  quotationDetailsById?: Maybe<QuotationDetailsDto>;
  quotationList?: Maybe<QuotationChatListDto>;
  recommendedBrandsList: Array<UserBrandDetailDto>;
  recommendedProductsList: BuyerProductListDetailsDto;
  requestForQuote: CommonSuccessResponseDto;
  resendOTP: CommonSuccessResponseDto;
  roleDetails: Role;
  roleList: Array<Role>;
  rolePaginationList: RolePaginationList;
  rssNewsUrlList: NewsRssUrlListDto;
  sampleOrderCartDetails: SampleOrderDetailsDto;
  sellerBasedOnSameBrandList: Array<MillDetailsDto>;
  sellerComissionDetails?: Maybe<SellerComissionDetail>;
  sellerOrderList: OrderListDto;
  sellerPromotedAdvList: UserPromotedAdvList;
  sellerSettingsById?: Maybe<SellerSettingsDetailDto>;
  sellerShipmentsList: OrderListDto;
  sellerStoreDetails: UserBusinessDetailDto;
  seoContentDetails: SeoContentDetails;
  stateList: Array<StateListDto>;
  staticPageDetails: StaticPageDetailDto;
  staticPageList: Array<StaticPageDetailDto>;
  staticPageListPagination: StaticPageList;
  subCategoryList: Array<SubCategoryListResponseDto>;
  subCategoryListAdvertisement: Array<SubCategoryListDetailBySearchDto>;
  subCategoryListBulkUpload: Array<SubCategoryListResponseDto>;
  subCategoryListByCategory: Array<SubCategoryDetailDto>;
  subCategoryListByParentSubCategory: Array<SubCategoryDetailDto>;
  subCategoryListBySearch: Array<SubCategoryListDetailBySearchDto>;
  subCategoryListBySubParentSubCategory: Array<SubCategoryDetailDto>;
  subCategoryListCms: Array<SubCategoryListResponseDto>;
  topDealsDetailsById: TopDealsDetailDto;
  topDealsList: Array<TopDealsDetailDto>;
  topDealsListPagination: TopDealsListDetailsDto;
  totalUnitSoldAndAmount: TotalSoldQuantityAndAmountDto;
  trendingProductsList: BuyerProductListDetailsDto;
  updateAllowErpAccess: CommonSuccessResponseDto;
  uploadFile: CommonSuccessResponseDto;
  userAddressesList: Array<UserAddressesListDto>;
  userAddressesListForQuotation: Array<UserAddressListForQuotationDto>;
  userAddressesListWithPagination: UserAddressesList;
  userBankAccountList: Array<UserBankAccountDetailDto>;
  userBankAccountListWithPagination: UserBankAccountsList;
  userBusinessDetailsById: UserBusinessDetailDto;
  userCartItemCounts: UserCartItemCountDto;
  userCartItemList: UserCartDetailsDto;
  userCreditList: UserCreditDebitListDto;
  userDetailsById: UserUpdatedViewDetailDto;
  userEscalatedIssuesList: EscalateIssueListWithSearchAndPaginationDto;
  userInterestedProductsList: Array<BuyerSideProductListDetailsDto>;
  userListForQuotation: Array<UserListForQuotationDto>;
  userListPagination: UserList;
  userLogin: UserLogin;
  userMonthDateWisePromotedAdvList: Array<UserPromotedAdvMonthDateCountList>;
  userProductsList: UserProductListDetailsDto;
  userPromotedAdvList: UserPromotedAdvList;
  userPushNotificationList?: Maybe<PushNotificationListDto>;
  userRecentSearch: Array<SearchRecommendationsDetailDto>;
  userRecentViewedProducts: Array<BuyerSideProductListDetailsDto>;
  userRecommendedProductsList: Array<BuyerSideProductListDetailsDto>;
  userSimilarProducts: Array<BuyerSideProductListDetailsDto>;
  verifyMobileNumber: CommonSuccessResponseDto;
  verifyOTP: CommonSuccessResponseDto;
  verifyUser?: Maybe<VerifyUserResponseDto>;
};


export type QueryAadharKycConnectSessionArgs = {
  aadharNumber: Scalars['String'];
  kycSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryAdminDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryAdminListArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  roleId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAdminPromotedAdvListArgs = {
  advertisementStatus?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  sectionTypeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedStatus?: InputMaybe<Scalars['String']>;
};


export type QueryApplyCouponCodeArgs = {
  _id: Scalars['ID'];
  cartDiscountPrice: Scalars['Float'];
  discountOnPrice: Scalars['Float'];
  gstRatePrice: Scalars['Float'];
  totalPayableAmount: Scalars['Float'];
  totalPrice: Scalars['Float'];
  userId: Scalars['ID'];
};


export type QueryAttributeTypesAndValuesListArgs = {
  productAttributeId: Scalars['String'];
};


export type QueryBankDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryBankListArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBankListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBrandGroupListByIdArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBrandListArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBrandListByProductCategoryArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBrandListByUserIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  apiSlug: Scalars['String'];
  filterBy?: InputMaybe<Scalars['String']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandListWithSearchArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBrandMillSellerStorePopularProductListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandSectionPaginationListArgs = {
  categoryId: Scalars['ID'];
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBulkPurchaseProductEnquiryArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryBulkUploadHistoryListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  userId: Scalars['ID'];
};


export type QueryBulkUploadSheetArgs = {
  bulkUploadWorkSheetName?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryBulkUploadSheetListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
};


export type QueryBusinessTypeDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryBusinessTypeListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBuyerSideProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryCategoryAttributeListForFilterArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryCategoryAttributesListArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryCategoryAttributesListWithSearchAndPaginationArgs = {
  categoryId: Scalars['ID'];
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCategoryDetailsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryName?: InputMaybe<Scalars['String']>;
  categorySlug?: InputMaybe<Scalars['String']>;
};


export type QueryCategoryListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryChangeAdvertisementStatusArgs = {
  _id: Scalars['ID'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
};


export type QueryCheckPincodeAvailabilityArgs = {
  input: CheckPincodeAvailabilityInput;
};


export type QueryCheckoutQuotationOrderDetailsArgs = {
  quotationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryCityListArgs = {
  country_code: Scalars['String'];
  state_code: Scalars['String'];
};


export type QueryColorDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryColorListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCouponCodeDetailsByIdArgs = {
  _id: Scalars['ID'];
};


export type QueryCouponCodeListPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByStatus?: InputMaybe<Scalars['String']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryCreateInvoiceArgs = {
  input: OrderInvoiceInput;
};


export type QueryDashboardListArgs = {
  roleId: Scalars['ID'];
};


export type QueryDeleteBusinessDetailsArgs = {
  userId: Scalars['ID'];
};


export type QueryDeleteFailedPaymentDetailsArgs = {
  apiSlug: Scalars['String'];
  jusPayOrderId: Scalars['String'];
};


export type QueryDeleteNewsUrlByIdArgs = {
  _id: Scalars['String'];
};


export type QueryDeleteProductsFromS3Args = {
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryDesignationDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryDesignationListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryDownloadCatalogueTemplateArgs = {
  bulkUploadWorkSheetName?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryDownloadFailureBulkUploadSheetArgs = {
  bulkUploadWorkSheetName?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryDownloadPaymentStatementListArgs = {
  fromDate: Scalars['String'];
  toDate: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryEscalatedIssuesListByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryExploreCategoriesArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryExploreStyleDetailsByIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryExploreStylesListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryExploreStylesListPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryFaqDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryFaqListPaginationArgs = {
  faqTypeId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryFaqTypeDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryFaqTypeListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryFetchWaybillArgs = {
  input: FetchWaybillCountInput;
};


export type QueryGeneralSettingDetailsArgs = {
  slug: Scalars['String'];
};


export type QueryGenerateThumbNailImageArgs = {
  categoryId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAllFeedbackListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
};


export type QueryGetAppVersionDetailsArgs = {
  appType: Scalars['String'];
  version: Scalars['String'];
};


export type QueryGetCategoryAttributeByIdArgs = {
  attributeId: Scalars['String'];
};


export type QueryGetCategoryReturnPolicyListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
};


export type QueryGetProductByUserIdArgs = {
  productId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductDetailsByIdArgs = {
  apiPlatformType?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  productSetId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  userType?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductListAttributeBySubCategoryIdArgs = {
  apiPlatformType?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  productSetId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  userType?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductNameListBySubCategoryIdArgs = {
  apiPlatformType?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  productSetId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  userType?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductRatingsReviewsByProductIdArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  productId: Scalars['String'];
};


export type QueryGetProfileCompletionPercenatgeArgs = {
  _id: Scalars['ID'];
  userType: Scalars['String'];
};


export type QueryGetReturnPolicyCategoryByIdArgs = {
  categoryId: Scalars['ID'];
};


export type QueryGetSetDetailByIdArgs = {
  productId: Scalars['ID'];
  productSetId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetShipmentDetailsByOrderIdArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetUserBalanceArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  userId: Scalars['ID'];
};


export type QueryGetUserCartItemsArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryGetUserDetailsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type QueryGetUserDeviceTokensArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type QueryGetUserProductBrandListArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryGetUserProductWishlistByIdArgs = {
  categoryId: Scalars['ID'];
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryHomeAdvertisementPromotedListArgs = {
  advertisementStatus?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  sectionTypeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedStatus?: InputMaybe<Scalars['String']>;
};


export type QueryHomePageSubCategoryProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryHsnCodeListArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryHsnCodeListWithPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryKycDocumentListArgs = {
  userId: Scalars['ID'];
  userType?: InputMaybe<Scalars['String']>;
};


export type QueryManageDocumentListArgs = {
  _id: Scalars['ID'];
};


export type QueryManualOrderQuotationListArgs = {
  limit: Scalars['Float'];
  manualQuotationOrderId?: InputMaybe<Scalars['ID']>;
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryManualQuotationDetailArgs = {
  _id: Scalars['ID'];
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type QueryManualQuotationGstDetailsArgs = {
  isSellerBuyerAddressSame: Scalars['Boolean'];
  productId: Scalars['ID'];
  totalAmount: Scalars['Float'];
};


export type QueryManualQuotationPaymentHistoryListArgs = {
  limit: Scalars['Float'];
  manualQuotationOrderId?: InputMaybe<Scalars['ID']>;
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryManualQuotationSubOrderDetailArgs = {
  _id: Scalars['ID'];
};


export type QueryManualSubOrderQuotationListArgs = {
  limit: Scalars['Float'];
  manualQuotationOrderId?: InputMaybe<Scalars['ID']>;
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMillsListArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  kycStatusFilter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryModulePermissionListArgs = {
  roleId: Scalars['ID'];
};


export type QueryNewArrivalsProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryNewSubCategoryListCmsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryNewsListArgs = {
  categoryId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryOfferDetailsByIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryOffersListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryOffersListPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryOrderDetailsByIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  orderHoldStatus?: InputMaybe<Scalars['String']>;
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type QueryOrderListArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryOrderListForAdminArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  orderType?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};


export type QueryOrderStatusDetailsJusPayArgs = {
  jusPayOrderId: Scalars['String'];
};


export type QueryPaymentListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  paymentType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryPolicyDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryPolicyListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPopularProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryPopularStyleCodesDetailsByIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryPopularStyleCodesListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryPopularStyleCodesListPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPreviewQuotationDetailsByIdArgs = {
  quotationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryProductAdditionDetailsByProductIdArgs = {
  productId: Scalars['ID'];
};


export type QueryProductAttributeSetSizeListingArgs = {
  categoryId: Scalars['ID'];
  limit: Scalars['Float'];
  page: Scalars['Float'];
};


export type QueryProductEnquiryArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryProductListForQuotationArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryProductListingDetailsByIdArgs = {
  productId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryProductListingGuidelineDetailsArgs = {
  apiPlatformType?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  productSetId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  userType?: InputMaybe<Scalars['String']>;
};


export type QueryProductSetListArgs = {
  productId: Scalars['ID'];
  productSetId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryProductSetSizeListByCategoryArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  setId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryProductSetSizeListBySetArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  setId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryProductSetSizeListBySubCategoryArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  setId?: InputMaybe<Scalars['ID']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryProductSetSizesGroupDetailsArgs = {
  sizeGroupId: Scalars['ID'];
};


export type QueryProductYarnListDetailByProductIdArgs = {
  productId: Scalars['ID'];
};


export type QueryProductsNearYouListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryPromoteYourAdvDetailsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPromoteYourAdvListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPromoteYourAdvListPaginationArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPromotedAdvDetailsArgs = {
  _id: Scalars['ID'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
};


export type QueryQuotationDetailsByIdArgs = {
  buyerId: Scalars['ID'];
  productId: Scalars['ID'];
  sellerId: Scalars['ID'];
  userType: Scalars['String'];
};


export type QueryQuotationListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  userType: Scalars['String'];
};


export type QueryRecommendedBrandsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryRecommendedProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryRequestForQuoteArgs = {
  businessName: Scalars['String'];
  description: Scalars['String'];
  productId: Scalars['ID'];
  quantity: Scalars['Float'];
  unitOfMeasurement: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryResendOtpArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type QueryRoleDetailsArgs = {
  _id: Scalars['ID'];
};


export type QueryRolePaginationListArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySampleOrderCartDetailsArgs = {
  buyerUserId: Scalars['ID'];
  categoryId: Scalars['ID'];
  isSampleOrderFree: Scalars['Boolean'];
  productId: Scalars['ID'];
  sellerUserId: Scalars['ID'];
};


export type QuerySellerBasedOnSameBrandListArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySellerComissionDetailsArgs = {
  categoryId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QuerySellerOrderListArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  orderVerificationStatus?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QuerySellerPromotedAdvListArgs = {
  advertisementStatus?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  sectionTypeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedStatus?: InputMaybe<Scalars['String']>;
};


export type QuerySellerSettingsByIdArgs = {
  userId: Scalars['ID'];
};


export type QuerySellerShipmentsListArgs = {
  userId: Scalars['ID'];
};


export type QuerySellerStoreDetailsArgs = {
  userId: Scalars['ID'];
};


export type QuerySeoContentDetailsArgs = {
  categoryId: Scalars['String'];
  subCategoryId: Scalars['String'];
};


export type QueryStaticPageDetailsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  isTokenByPass?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryStaticPageListPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySubCategoryListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubCategoryListAdvertisementArgs = {
  categoryId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubCategoryListBulkUploadArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubCategoryListByCategoryArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubCategoryListByParentSubCategoryArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubCategoryListBySearchArgs = {
  categoryId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubCategoryListBySubParentSubCategoryArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySubCategoryListCmsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryTopDealsDetailsByIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryTopDealsListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
};


export type QueryTopDealsListPaginationArgs = {
  categoryId: Scalars['ID'];
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTotalUnitSoldAndAmountArgs = {
  userId: Scalars['ID'];
};


export type QueryTrendingProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryUpdateAllowErpAccessArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type QueryUserAddressesListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserAddressesListForQuotationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryUserAddressesListWithPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryUserBankAccountListArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  ifscCode?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserBankAccountListWithPaginationArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryUserBusinessDetailsByIdArgs = {
  userId: Scalars['ID'];
};


export type QueryUserCartItemCountsArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryUserCartItemListArgs = {
  categoryId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryUserCreditListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  userId: Scalars['ID'];
};


export type QueryUserDetailsByIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type QueryUserEscalatedIssuesListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUserInterestedProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryUserListForQuotationArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  kycStatusFilter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserListPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  kycStatusFilter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserLoginArgs = {
  countryCode?: InputMaybe<Scalars['Float']>;
  deviceToken?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['Float'];
  platformType: Scalars['String'];
};


export type QueryUserMonthDateWisePromotedAdvListArgs = {
  advertisementType: Scalars['String'];
  month: Scalars['Float'];
  year: Scalars['Float'];
};


export type QueryUserProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryUserPromotedAdvListArgs = {
  advertisementStatus?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  sectionTypeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedStatus?: InputMaybe<Scalars['String']>;
};


export type QueryUserPushNotificationListArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  userId: Scalars['ID'];
  userType: Scalars['String'];
};


export type QueryUserRecentSearchArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryUserRecentViewedProductsArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryUserRecommendedProductsListArgs = {
  apiSlug?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByAttibutes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySizes?: InputMaybe<Array<Scalars['ID']>>;
  filterBySubCategoryId?: InputMaybe<Scalars['ID']>;
  isFromSellerStore?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  maxOfferDiscount?: InputMaybe<Scalars['Float']>;
  minOfferDiscount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productListType?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  subCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
};


export type QueryUserSimilarProductsArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryVerifyMobileNumberArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};


export type QueryVerifyOtpArgs = {
  otp: Scalars['Float'];
  phoneNumber: Scalars['Float'];
};


export type QueryVerifyUserArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
};

export type QuotationAddtionalDetailsDto = {
  __typename?: 'QuotationAddtionalDetailsDto';
  creditLimitDays?: Maybe<Scalars['Float']>;
  deductedGSTAmount: Scalars['Float'];
  estimatedShippingDate?: Maybe<Scalars['Float']>;
  finalAmount: Scalars['Float'];
  gstRate?: Maybe<Scalars['Float']>;
  isAdvancePayment?: Maybe<Scalars['Boolean']>;
  isCreditPayment?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isPaymentAgainstDelivery?: Maybe<Scalars['Boolean']>;
  isPriceIncludeGST?: Maybe<Scalars['Boolean']>;
  isSplitPayment?: Maybe<Scalars['Boolean']>;
  onArrivalPaymentPercentage?: Maybe<Scalars['Float']>;
  onDeliveryPaymentPercentage?: Maybe<Scalars['Float']>;
  paymentTermText?: Maybe<Scalars['String']>;
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityUnit?: Maybe<Scalars['String']>;
  quotationDescription?: Maybe<Scalars['String']>;
  quotationValidity?: Maybe<Scalars['Float']>;
  shippingTermType?: Maybe<Scalars['String']>;
  totalAmount: Scalars['Float'];
  totalPackageWeight?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type QuotationChatDetailsInput = {
  creditLimitDays?: InputMaybe<Scalars['Float']>;
  estimatedShippingDate: Scalars['Float'];
  isAdvancePayment?: InputMaybe<Scalars['Boolean']>;
  isCreditPayment?: InputMaybe<Scalars['Boolean']>;
  isPaymentAgainstDelivery?: InputMaybe<Scalars['Boolean']>;
  isPriceIncludeGST: Scalars['Boolean'];
  isSplitPayment?: InputMaybe<Scalars['Boolean']>;
  onArrivalPaymentPercentage?: InputMaybe<Scalars['Float']>;
  onDeliveryPaymentPercentage?: InputMaybe<Scalars['Float']>;
  paymentTermText?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  quantityUnit: Scalars['String'];
  quotationDescription: Scalars['String'];
  quotationValidity: Scalars['Float'];
  shippingTermType: Scalars['String'];
  totalPackageWeight?: InputMaybe<Scalars['Float']>;
  unitPrice: Scalars['Float'];
};

export type QuotationChatHistoryDetailsDto = {
  __typename?: 'QuotationChatHistoryDetailsDto';
  _id: Scalars['ID'];
  buyerId: Scalars['ID'];
  createdAt?: Maybe<Scalars['Float']>;
  documentFileName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  messageSenderId: Scalars['ID'];
  messageType: Scalars['String'];
  productId: Scalars['ID'];
  quotationDetails?: Maybe<QuotationGeneratedDetailsDto>;
  quotationRequestId: Scalars['ID'];
  sellerId: Scalars['ID'];
};

export type QuotationChatListDto = {
  __typename?: 'QuotationChatListDto';
  data: Array<QuotationDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type QuotationDetailsDto = {
  __typename?: 'QuotationDetailsDto';
  _id: Scalars['ID'];
  additionalNote?: Maybe<Scalars['String']>;
  buyerId: Scalars['ID'];
  documentFileName?: Maybe<Scalars['String']>;
  gstRate?: Maybe<Scalars['Float']>;
  isQuotationExpired: Scalars['Boolean'];
  lastMessageDate?: Maybe<Scalars['Float']>;
  lastMessageType?: Maybe<Scalars['String']>;
  productData?: Maybe<ProductDetailsForQuotationDto>;
  productId: Scalars['ID'];
  productImage: Scalars['String'];
  productName: Scalars['String'];
  productThumbNailImage?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  quotationChatHistory?: Maybe<Array<QuotationChatHistoryDetailsDto>>;
  sellerId: Scalars['ID'];
  totalPackageWeight?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  userBusinessName?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type QuotationGeneratedDetailsDto = {
  __typename?: 'QuotationGeneratedDetailsDto';
  creditLimitDays?: Maybe<Scalars['Float']>;
  estimatedShippingDate?: Maybe<Scalars['Float']>;
  gstRate?: Maybe<Scalars['Float']>;
  isAdvancePayment?: Maybe<Scalars['Boolean']>;
  isCreditPayment?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isPaymentAgainstDelivery?: Maybe<Scalars['Boolean']>;
  isPriceIncludeGST?: Maybe<Scalars['Boolean']>;
  isSplitPayment?: Maybe<Scalars['Boolean']>;
  onArrivalPaymentPercentage?: Maybe<Scalars['Float']>;
  onDeliveryPaymentPercentage?: Maybe<Scalars['Float']>;
  paymentTermText?: Maybe<Scalars['String']>;
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityUnit?: Maybe<Scalars['String']>;
  quotationDescription?: Maybe<Scalars['String']>;
  quotationValidity?: Maybe<Scalars['Float']>;
  shippingTermType?: Maybe<Scalars['String']>;
  totalPackageWeight?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type RazorPayOrderDetail = {
  __typename?: 'RazorPayOrderDetail';
  orderId: Scalars['String'];
};

export type RazorPayOrderDto = {
  __typename?: 'RazorPayOrderDto';
  code: Scalars['Float'];
  data?: Maybe<RazorPayOrderDetail>;
  message: Scalars['String'];
};

export type RegularPrice = {
  moqSet: Scalars['Float'];
  price: Scalars['Float'];
};

export type RegularPriceDto = {
  __typename?: 'RegularPriceDto';
  moqSet: Scalars['Float'];
  price: Scalars['Float'];
};

export type ReportBuyerDetailsDto = {
  __typename?: 'ReportBuyerDetailsDto';
  _id: Scalars['ID'];
  buyerUserId: Scalars['ID'];
  description: Scalars['String'];
  orderId: Scalars['ID'];
  reason: Scalars['String'];
  sellerUserId: Scalars['ID'];
};

export type RequestForQuoteInput = {
  additionalNote: Scalars['String'];
  businessName?: InputMaybe<Scalars['String']>;
  buyerId: Scalars['ID'];
  isPriceIncludeGST?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['ID'];
  quantity: Scalars['Float'];
  sellerId: Scalars['ID'];
  unit: Scalars['String'];
};

export type ReturnPolicyByCategoryId = {
  __typename?: 'ReturnPolicyByCategoryId';
  categoryId?: Maybe<Scalars['ID']>;
  days: Scalars['Float'];
  description: Scalars['String'];
  title: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  _id: Scalars['ID'];
  permissions: Array<Scalars['String']>;
  roleName: Scalars['String'];
  roleType: Scalars['String'];
};

export type RoleInput = {
  permissions: Array<Scalars['String']>;
  roleName: Scalars['String'];
};

export type RoleListObject = {
  __typename?: 'RoleListObject';
  _id: Scalars['ID'];
  adminCount: Scalars['Float'];
  permissions: Array<Scalars['String']>;
  roleName: Scalars['String'];
  roleType: Scalars['String'];
};

export type RolePaginationList = {
  __typename?: 'RolePaginationList';
  data: Array<RoleListObject>;
  totalRecords: Scalars['Float'];
};

export type SampleDetailsDto = {
  __typename?: 'SampleDetailsDto';
  measurementUnit?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type SampleDetailsInput = {
  measurementUnit: Scalars['String'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type SampleOrderDetailsDto = {
  __typename?: 'SampleOrderDetailsDto';
  buyerUserId: Scalars['ID'];
  categoryId: Scalars['ID'];
  delhiveryCharges?: Maybe<Scalars['Float']>;
  destinationAddress?: Maybe<UserAddressDto>;
  isProductDeliveryServiceAvailable?: Maybe<Scalars['Boolean']>;
  isSampleOrderFree: Scalars['Boolean'];
  measurementUnit: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  productId: Scalars['ID'];
  productImage: Scalars['String'];
  productName: Scalars['String'];
  productThumbNailImage?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  sellerUserId: Scalars['ID'];
  soldBy: Scalars['String'];
  sourceAddress?: Maybe<UserAddressDto>;
  totalCartPrice: Scalars['Float'];
};

export type SampleReOrderDetail = {
  __typename?: 'SampleReOrderDetail';
  buyerUserId: Scalars['ID'];
  categoryId: Scalars['ID'];
  isSampleOrderFree: Scalars['Boolean'];
  productId: Scalars['ID'];
  sellerUserId: Scalars['ID'];
};

export type SampleReorderResponseDto = {
  __typename?: 'SampleReorderResponseDto';
  code: Scalars['Float'];
  data?: Maybe<SampleReOrderDetail>;
  message: Scalars['String'];
};

export type SearchRecommendationsDetailDto = {
  __typename?: 'SearchRecommendationsDetailDto';
  _id: Scalars['ID'];
  apiSlug?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  productName?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['ID']>;
  subCategoryImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type SelectedColors = {
  colorId: Scalars['ID'];
  contents?: InputMaybe<Array<SelectedColorsContentInput>>;
  image: Scalars['String'];
  length?: InputMaybe<Scalars['Float']>;
  thumbNailImage: Scalars['String'];
};

export type SelectedColorsContentDto = {
  __typename?: 'SelectedColorsContentDto';
  quantity?: Maybe<Scalars['Float']>;
  sizeId?: Maybe<Scalars['ID']>;
  sizeValue?: Maybe<Scalars['String']>;
};

export type SelectedColorsContentInput = {
  quantity: Scalars['Float'];
  sizeId: Scalars['ID'];
};

export type SelectedColorsDto = {
  __typename?: 'SelectedColorsDto';
  colorCode?: Maybe<Scalars['String']>;
  colorId: Scalars['ID'];
  colorName?: Maybe<Scalars['String']>;
  contents?: Maybe<Array<SelectedColorsContentDto>>;
  image?: Maybe<Scalars['String']>;
  isMultiColor?: Maybe<Scalars['Boolean']>;
  length?: Maybe<Scalars['Float']>;
  multiColorImage?: Maybe<Scalars['String']>;
  thumbNailImage?: Maybe<Scalars['String']>;
};

export type SellerBusinessAddressDto = {
  __typename?: 'SellerBusinessAddressDto';
  cityId: Scalars['ID'];
  cityName?: Maybe<Scalars['String']>;
  fullAddress: Scalars['String'];
  pinCode: Scalars['Float'];
  stateId: Scalars['ID'];
  stateName?: Maybe<Scalars['String']>;
};

export type SellerComissionDetail = {
  __typename?: 'SellerComissionDetail';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  categoryName?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  comissionRate: Scalars['Float'];
  isDefault: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type SellerProductsCartListDto = {
  __typename?: 'SellerProductsCartListDto';
  cashDiscount?: Maybe<Scalars['Float']>;
  categoryId: Scalars['ID'];
  categorySlug?: Maybe<Scalars['String']>;
  ddFee?: Maybe<Scalars['Float']>;
  discountedTotalProductPrice: Scalars['Float'];
  gstRate?: Maybe<Scalars['Float']>;
  isProductWishListed?: Maybe<Scalars['Boolean']>;
  productId: Scalars['ID'];
  productImage: Scalars['String'];
  productName: Scalars['String'];
  productSetData?: Maybe<CreateSetPayloadDto>;
  productSetId?: Maybe<Scalars['ID']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  sellerId: Scalars['ID'];
  setPrice: Scalars['Float'];
  setQuantity: Scalars['Float'];
  subCategoryId?: Maybe<Scalars['ID']>;
  totalPackageWeight?: Maybe<Scalars['Float']>;
  totalProductPrice: Scalars['Float'];
  totalQuanityInProduct: Scalars['Float'];
  unitOfMeasurement: Scalars['String'];
  unitPrice?: Maybe<Scalars['Float']>;
  userId: Scalars['ID'];
  verifiedByAdmin?: Maybe<Scalars['String']>;
};

export type SellerSettingDetailResponseDto = {
  __typename?: 'SellerSettingDetailResponseDto';
  code: Scalars['Float'];
  data: SellerSettingsDetailDto;
  message: Scalars['String'];
};

export type SellerSettingsAddUpdateInput = {
  cartDiscount?: InputMaybe<Array<CartDiscountAddUpdateInput>>;
  cartMinimumValue?: InputMaybe<Scalars['Float']>;
  geoRestrictions?: InputMaybe<Array<Scalars['String']>>;
  isFreeShipping: Scalars['Boolean'];
  mov?: InputMaybe<Scalars['Float']>;
  stateIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['ID'];
};

export type SellerSettingsDetailDto = {
  __typename?: 'SellerSettingsDetailDto';
  _id: Scalars['ID'];
  cartDiscount?: Maybe<Array<CartDiscountDto>>;
  cartMinimumValue?: Maybe<Scalars['Float']>;
  geoRestrictions?: Maybe<Array<Scalars['String']>>;
  isFreeShipping?: Maybe<Scalars['Boolean']>;
  mov?: Maybe<Scalars['Float']>;
  stateIds?: Maybe<Array<Scalars['String']>>;
  userId: Scalars['ID'];
};

export type SeoContentDetails = {
  __typename?: 'SeoContentDetails';
  _id?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  seoContent?: Maybe<Scalars['String']>;
  subCategoryId?: Maybe<Scalars['String']>;
};

export type SeoContentInput = {
  categoryId: Scalars['String'];
  seoContent: Scalars['String'];
  subCategoryId: Scalars['String'];
};

export type ShipmentDeleteInput = {
  orderId?: InputMaybe<Scalars['ID']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
};

export type ShipmentDetailResponseDto = {
  __typename?: 'ShipmentDetailResponseDto';
  code: Scalars['Float'];
  data?: Maybe<OrderCreateShipmentDetail>;
  message: Scalars['String'];
};

export type ShipmentInput = {
  BuyerAddress: Scalars['String'];
  BuyerName: Scalars['String'];
  addressType: Scalars['String'];
  buyerId?: InputMaybe<Scalars['ID']>;
  city: Scalars['String'];
  codAmount?: InputMaybe<Scalars['Float']>;
  country: Scalars['String'];
  hsnCode?: InputMaybe<Scalars['String']>;
  order: Scalars['String'];
  orderDate: Scalars['Timestamp'];
  orderId?: InputMaybe<Scalars['ID']>;
  paymentMode: Scalars['String'];
  phone: Scalars['String'];
  pinCode: Scalars['String'];
  productsDesc: Scalars['String'];
  quantity: Scalars['Float'];
  returnAdd?: InputMaybe<Scalars['String']>;
  returnCity?: InputMaybe<Scalars['String']>;
  returnCountry?: InputMaybe<Scalars['String']>;
  returnPhone?: InputMaybe<Scalars['String']>;
  returnPin?: InputMaybe<Scalars['String']>;
  returnState?: InputMaybe<Scalars['String']>;
  sellerAddress: Scalars['String'];
  sellerGstTin?: InputMaybe<Scalars['String']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  sellerInv?: InputMaybe<Scalars['String']>;
  sellerName: Scalars['String'];
  shipmentHeight?: InputMaybe<Scalars['Float']>;
  shipmentWidth?: InputMaybe<Scalars['Float']>;
  shippingMode: Scalars['String'];
  state: Scalars['String'];
  totalAmount?: InputMaybe<Scalars['Float']>;
  waybill?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ShipmentTrackingDetailsDto = {
  __typename?: 'ShipmentTrackingDetailsDto';
  trackingDateTime: Scalars['Float'];
  trackingStatus: Scalars['String'];
  trackingStatusName?: Maybe<Scalars['String']>;
};

export type ShipmentTrackingInput = {
  order?: InputMaybe<Scalars['String']>;
  waybill?: InputMaybe<Scalars['Float']>;
};

export type ShippingBillingAddressDetailDto = {
  __typename?: 'ShippingBillingAddressDetailDto';
  _id?: Maybe<Scalars['ID']>;
  addressLine1: Scalars['String'];
  addressType?: Maybe<Scalars['String']>;
  cityId: Scalars['ID'];
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  gstNumber: Scalars['String'];
  otherAddressTypeName?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateId: Scalars['ID'];
  stateName?: Maybe<Scalars['String']>;
};

export type ShippingCostDto = {
  __typename?: 'ShippingCostDto';
  chargedWeight: Scalars['Float'];
  status: Scalars['String'];
  totalAmount: Scalars['Float'];
};

export type ShippingCreatetInput = {
  pickupLocation: PickupLocationInput;
  shipments: ShipmentInput;
};

export type ShippingLabelGenerate = {
  __typename?: 'ShippingLabelGenerate';
  url?: Maybe<Scalars['String']>;
};

export type ShippingLebbelInput = {
  pdf?: InputMaybe<Scalars['Boolean']>;
  waybill?: InputMaybe<Scalars['Float']>;
};

export type ShippingUpdateInput = {
  address?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['Float']>;
  productDetails?: InputMaybe<Scalars['String']>;
  shipmentHeight?: InputMaybe<Scalars['Float']>;
  shipmentLength?: InputMaybe<Scalars['Float']>;
  shipmentWidth?: InputMaybe<Scalars['Float']>;
  waybill?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ShopTimingDto = {
  __typename?: 'ShopTimingDto';
  day: Scalars['String'];
  status: Scalars['Boolean'];
  timings?: Maybe<Array<TimingsDto>>;
};

export type ShopTimingInput = {
  day: Scalars['String'];
  status: Scalars['Boolean'];
  timings?: InputMaybe<Array<TimingsInput>>;
};

export type SizeValueDto = {
  __typename?: 'SizeValueDto';
  _id: Scalars['ID'];
  sizeValue: Scalars['String'];
};

export type StateAddInput = {
  states: Array<StateCreateInput>;
};

export type StateCreateInput = {
  country_code: Scalars['String'];
  name: Scalars['String'];
  state_code: Scalars['String'];
};

export type StateListDto = {
  __typename?: 'StateListDto';
  _id: Scalars['ID'];
  country_code: Scalars['String'];
  name: Scalars['String'];
  state_code: Scalars['String'];
};

export type StaticPageDetailDto = {
  __typename?: 'StaticPageDetailDto';
  _id: Scalars['ID'];
  description: Scalars['String'];
  title: Scalars['String'];
};

export type StaticPageInput = {
  description: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type StaticPageList = {
  __typename?: 'StaticPageList';
  data: Array<StaticPageDetailDto>;
  totalRecords: Scalars['Float'];
};

export type SubCategoryCreateInput = {
  categoryId: Scalars['String'];
  parentSubCategoryId?: InputMaybe<Scalars['String']>;
  subCategoryImage: Scalars['String'];
  subCategoryLevel: Scalars['Float'];
  subCategoryName: Scalars['String'];
  subCategoryTabImage?: InputMaybe<Scalars['String']>;
};

export type SubCategoryDetailDto = {
  __typename?: 'SubCategoryDetailDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  guidelineDocument?: Maybe<Scalars['String']>;
  isActive: Scalars['String'];
  parentSubCategoryId?: Maybe<Scalars['String']>;
  subCategoryImage: Scalars['String'];
  subCategoryLevel: Scalars['Float'];
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryTabImage?: Maybe<Scalars['String']>;
};

export type SubCategoryListDetailBySearchDto = {
  __typename?: 'SubCategoryListDetailBySearchDto';
  _id?: Maybe<Scalars['ID']>;
  apiSlug?: Maybe<Scalars['String']>;
  parentSubCategoryId?: Maybe<Scalars['ID']>;
  parentSubCategoryName: Scalars['String'];
};

export type SubCategoryListResponseDto = {
  __typename?: 'SubCategoryListResponseDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  childSubCategories?: Maybe<Array<ChildSubCategoryResponseDto>>;
  guidelineDocument?: Maybe<Scalars['String']>;
  isActive: Scalars['String'];
  parentSubCategoryId?: Maybe<Scalars['String']>;
  subCategoryImage: Scalars['String'];
  subCategoryLevel: Scalars['Float'];
  subCategoryName?: Maybe<Scalars['String']>;
  subCategoryTabImage?: Maybe<Scalars['String']>;
};

export type SubOrderDetailsDto = {
  __typename?: 'SubOrderDetailsDto';
  _id: Scalars['ID'];
  colors: Array<OrderColorDto>;
  productId?: Maybe<Scalars['ID']>;
  productImage: Scalars['String'];
  productName: Scalars['String'];
  productRatingReviewsDetails?: Maybe<ProductRatingReviewDetailsDto>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  quantityInSet?: Maybe<Scalars['Float']>;
  setPrice: Scalars['Float'];
  setQuantity?: Maybe<Scalars['Float']>;
  sizes?: Maybe<Array<OrderSizeDto>>;
  totalOrderSetPrice?: Maybe<Scalars['Float']>;
  totalOrderSetQuantity?: Maybe<Scalars['Float']>;
  unit: Scalars['String'];
};

export type SubOrderPayload = {
  categoryId?: InputMaybe<Scalars['ID']>;
  colors?: InputMaybe<Array<OrderColorPayload>>;
  orderId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  productSetId?: InputMaybe<Scalars['ID']>;
  quantityInSet?: InputMaybe<Scalars['Float']>;
  sellerId?: InputMaybe<Scalars['ID']>;
  setPrice: Scalars['Float'];
  setQuantity?: InputMaybe<Scalars['Float']>;
  sizes?: InputMaybe<Array<OrderSizePayload>>;
  totalPackageWeight?: InputMaybe<Scalars['Float']>;
  unit: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  quotationMessageSent: QuotationChatHistoryDetailsDto;
};

export type ThirdPartyAccessTokenDetialDto = {
  __typename?: 'ThirdPartyAccessTokenDetialDto';
  _id: Scalars['ID'];
  accessToken: Scalars['String'];
  accessTokenSlug: Scalars['String'];
};

export type TimingsDto = {
  __typename?: 'TimingsDto';
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type TimingsInput = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type TopDealsCreateInput = {
  categoryId: Scalars['ID'];
  image: Scalars['String'];
  price: Scalars['Float'];
  subCategoryId: Scalars['ID'];
};

export type TopDealsDetailDto = {
  __typename?: 'TopDealsDetailDto';
  _id: Scalars['ID'];
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  categorySlug: Scalars['String'];
  dealName: Scalars['String'];
  image: Scalars['String'];
  price: Scalars['Float'];
  subCategoryId: Scalars['String'];
  subCategoryName: Scalars['String'];
};

export type TopDealsListDetailsDto = {
  __typename?: 'TopDealsListDetailsDto';
  data: Array<TopDealsDetailDto>;
  totalRecords: Scalars['Float'];
};

export type TotalSoldQuantityAndAmountDto = {
  __typename?: 'TotalSoldQuantityAndAmountDto';
  totalSellings: Scalars['Float'];
  totalSoldUnits: Scalars['Float'];
};

export type TransportDetailsDto = {
  __typename?: 'TransportDetailsDto';
  transportName?: Maybe<Scalars['String']>;
  vehicleNumber?: Maybe<Scalars['String']>;
};

export type TransportDetailsInput = {
  transportName?: InputMaybe<Scalars['String']>;
  vehicleNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateCategoryAttributeById = {
  attributeId: Scalars['ID'];
  payload: ProductAttributeCreateInput;
};

export type UserAddressDto = {
  __typename?: 'UserAddressDto';
  addressType?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['Float']>;
  fullAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['Float']>;
  pinCode?: Maybe<Scalars['Float']>;
  stateName?: Maybe<Scalars['String']>;
};

export type UserAddressListForQuotationDto = {
  __typename?: 'UserAddressListForQuotationDto';
  _id: Scalars['ID'];
  addressLine1: Scalars['String'];
  addressType: Scalars['String'];
  cityId: Scalars['ID'];
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['Float']>;
  fullAddress: Scalars['String'];
  gstNumber?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  landMark?: Maybe<Scalars['String']>;
  otherAddressTypeName?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateId: Scalars['ID'];
  stateName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UserAddressesAddInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressType: Scalars['String'];
  cityId: Scalars['ID'];
  countryCode?: InputMaybe<Scalars['Float']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  landMark?: InputMaybe<Scalars['String']>;
  otherAddressTypeName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type UserAddressesInput = {
  _id?: InputMaybe<Scalars['ID']>;
  addressLine1: Scalars['String'];
  addressType: Scalars['String'];
  cityId: Scalars['ID'];
  cityName: Scalars['String'];
  countryCode?: InputMaybe<Scalars['Float']>;
  gstNumber?: InputMaybe<Scalars['String']>;
  landMark?: InputMaybe<Scalars['String']>;
  otherAddressTypeName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateId: Scalars['ID'];
  stateName: Scalars['String'];
};

export type UserAddressesList = {
  __typename?: 'UserAddressesList';
  data: Array<UserAddressesListDto>;
  totalRecords: Scalars['Float'];
};

export type UserAddressesListDto = {
  __typename?: 'UserAddressesListDto';
  _id: Scalars['ID'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressType: Scalars['String'];
  cityId: Scalars['ID'];
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['Float']>;
  isDefault: Scalars['Boolean'];
  landMark?: Maybe<Scalars['String']>;
  otherAddressTypeName?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['Float'];
  pinCode: Scalars['Float'];
  stateId: Scalars['ID'];
  stateName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UserAddressesResponseDto = {
  __typename?: 'UserAddressesResponseDto';
  code: Scalars['Float'];
  data: UserAddressesListDto;
  message: Scalars['String'];
};

export type UserBankAccountDetailDto = {
  __typename?: 'UserBankAccountDetailDto';
  _id: Scalars['ID'];
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['Float'];
  accountType: Scalars['String'];
  bankName: Scalars['String'];
  ifscCode: Scalars['String'];
  isDefault: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type UserBankAccountRegisterInput = {
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['Float'];
  accountType: Scalars['String'];
  bankName: Scalars['String'];
  ifscCode: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type UserBankAccountResponseDto = {
  __typename?: 'UserBankAccountResponseDto';
  code: Scalars['Float'];
  data: UserBankAccountDetailDto;
  message: Scalars['String'];
};

export type UserBankAccountsList = {
  __typename?: 'UserBankAccountsList';
  data: Array<UserBankAccountDetailDto>;
  totalRecords: Scalars['Float'];
};

export type UserBrandDetailDto = {
  __typename?: 'UserBrandDetailDto';
  _id: Scalars['ID'];
  brandLogo: Scalars['String'];
  brandName: Scalars['String'];
};

export type UserBusinessDetailDto = {
  __typename?: 'UserBusinessDetailDto';
  _id: Scalars['ID'];
  aadharNumber?: Maybe<Scalars['String']>;
  annualTurnOver?: Maybe<Scalars['String']>;
  businessDescription?: Maybe<Scalars['String']>;
  businessEmail?: Maybe<Scalars['String']>;
  businessEstablishedDate?: Maybe<Scalars['Float']>;
  businessLogo?: Maybe<Scalars['String']>;
  businessName: Scalars['String'];
  businessTimings?: Maybe<BusinessTimingDto>;
  businessTypeIds: Array<Scalars['String']>;
  businessTypes?: Maybe<Array<BusinessTypeDetailDto>>;
  cityId?: Maybe<Scalars['ID']>;
  cityName?: Maybe<Scalars['String']>;
  companyPanNumber?: Maybe<Scalars['String']>;
  gstNumber?: Maybe<Scalars['String']>;
  isAadharNumberVerified?: Maybe<Scalars['String']>;
  isBusinessEmailVerified?: Maybe<Scalars['String']>;
  isGstNumberVerified?: Maybe<Scalars['String']>;
  landMark?: Maybe<Scalars['String']>;
  pinCode?: Maybe<Scalars['Float']>;
  products?: Maybe<Array<BuinessProductDto>>;
  shopNumber?: Maybe<Scalars['String']>;
  signatureImage?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['ID']>;
  stateName?: Maybe<Scalars['String']>;
  streetAndArea?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UserBusinessDetailResponseDto = {
  __typename?: 'UserBusinessDetailResponseDto';
  code: Scalars['Float'];
  data: UserBusinessDetailDto;
  message: Scalars['String'];
};

export type UserBusinessRegisterInput = {
  aadharNumber?: InputMaybe<Scalars['String']>;
  annualTurnOver?: InputMaybe<Scalars['String']>;
  businessDescription: Scalars['String'];
  businessEmail?: InputMaybe<Scalars['String']>;
  businessEstablishedDate: Scalars['Float'];
  businessLogo: Scalars['String'];
  businessName?: InputMaybe<Scalars['String']>;
  businessTimings: BusinessTimingInput;
  businessTypeIds: Array<Scalars['String']>;
  cityId: Scalars['ID'];
  companyPanNumber?: InputMaybe<Scalars['String']>;
  gstNumber?: InputMaybe<Scalars['String']>;
  landMark?: InputMaybe<Scalars['String']>;
  pinCode: Scalars['Float'];
  products?: InputMaybe<Array<BuinessProductInput>>;
  shopNumber: Scalars['String'];
  signatureImage?: InputMaybe<Scalars['String']>;
  stateId: Scalars['ID'];
  streetAndArea: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  userType: Scalars['String'];
};

export type UserCartDetailsDto = {
  __typename?: 'UserCartDetailsDto';
  destinationAddress?: Maybe<UserAddressDto>;
  orderSummary?: Maybe<OrderSummaryDto>;
  paymentTerms?: Maybe<PaymentTermsDetailsDto>;
  totalCartPrice: Scalars['Float'];
  userCartList: Array<CartItemDetailsDto>;
};

export type UserCartItemCountDto = {
  __typename?: 'UserCartItemCountDto';
  userCartItemCounts: Scalars['Float'];
};

export type UserCartListDto = {
  __typename?: 'UserCartListDto';
  destinationAddress?: Maybe<UserAddressDto>;
  orderSummary?: Maybe<OrderSummaryDto>;
  totalCartPrice: Scalars['Float'];
  userCartList: Array<CartItemsDto>;
};

export type UserCartProductsDetail = {
  __typename?: 'UserCartProductsDetail';
  _id: Scalars['ID'];
  additionalDiscount: Scalars['Float'];
  cashDiscountPercentage: Scalars['Float'];
  ddFee: Scalars['Float'];
  discountedTotalProductPrice: Scalars['Float'];
  gstRate: Scalars['Float'];
  isProductWishListed: Scalars['Boolean'];
  listingTitle: Scalars['String'];
  productCreatedSets: Array<CreateSetPayloadDto>;
  productImages: Array<ProductImagesListDto>;
  productPriceDetails: ProductPriceDetails;
  subCategoryId: Scalars['ID'];
  totalProductPrice: Scalars['Float'];
  verifiedByAdmin: Scalars['String'];
};

export type UserCartSetSizes = {
  __typename?: 'UserCartSetSizes';
  sizeValue: Scalars['String'];
};

export type UserCreditDebitBalanceDto = {
  __typename?: 'UserCreditDebitBalanceDto';
  _id?: Maybe<Scalars['ID']>;
  amount?: Maybe<Scalars['Float']>;
  amountType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Timestamp']>;
  description?: Maybe<Scalars['String']>;
  orderNumberId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type UserCreditDebitListDto = {
  __typename?: 'UserCreditDebitListDto';
  data: Array<UserCreditDebitBalanceDto>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalRecords?: Maybe<Scalars['Float']>;
};

export type UserDetailDto = {
  __typename?: 'UserDetailDto';
  _id: Scalars['ID'];
  businessAreaPincode?: Maybe<Scalars['Float']>;
  businessEmail?: Maybe<Scalars['String']>;
  businessLogo?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  buyerProfileCompletionPercentage?: Maybe<Scalars['Float']>;
  cancelReasonTypes?: Maybe<Array<Scalars['String']>>;
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['Float']>;
  email: Scalars['String'];
  emailNotification: Scalars['Boolean'];
  emailVerificationStatus: Scalars['String'];
  isActive: Scalars['String'];
  isAllowErpAccess?: Maybe<Scalars['Boolean']>;
  isSellerApplied: Scalars['Boolean'];
  isSellerRegistrationAllowed?: Maybe<Scalars['Boolean']>;
  juspayCustomerId?: Maybe<Scalars['String']>;
  kycStatus: Scalars['String'];
  languageType: Scalars['String'];
  name: Scalars['String'];
  orderNotification: Scalars['Boolean'];
  phoneNumber: Scalars['Float'];
  phoneVerificationStatus: Scalars['String'];
  pushNotification: Scalars['Boolean'];
  referralCode?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  sellerCancelReason?: Maybe<Scalars['String']>;
  sellerProfileCompletionPercentage?: Maybe<Scalars['Float']>;
  stateName?: Maybe<Scalars['String']>;
  streetAndArea?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  userType: Scalars['String'];
  verifiedByAdmin?: Maybe<Scalars['String']>;
  whatsAppNotification: Scalars['Boolean'];
};

export type UserDetailsDto = {
  __typename?: 'UserDetailsDto';
  businessName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['Float']>;
};

export type UserDeviceTokensDto = {
  __typename?: 'UserDeviceTokensDto';
  deviceTokens?: Maybe<Array<Scalars['String']>>;
};

export type UserDevicesInput = {
  deviceToken?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  platformType: Scalars['String'];
};

export type UserEscalatedIssueDetailDto = {
  __typename?: 'UserEscalatedIssueDetailDto';
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Float']>;
  queryDescription: Scalars['String'];
  status: Scalars['String'];
  subject: Scalars['String'];
  subjectId: Scalars['ID'];
  ticketId: Scalars['String'];
  userDetail?: Maybe<UserDetailDto>;
  userId: Scalars['ID'];
};

export type UserExtendedFieldDto = {
  __typename?: 'UserExtendedFieldDto';
  cancelReasonTypes?: Maybe<Array<Scalars['String']>>;
  isBankAccountExists: Scalars['Boolean'];
  isBusinessDetailsExists: Scalars['Boolean'];
  isKycDocumentVerificationExists: Scalars['Boolean'];
  isSellerApplied: Scalars['Boolean'];
  isSwitchToSeller?: Maybe<Scalars['Boolean']>;
  isUserAddressExists?: Maybe<Scalars['Boolean']>;
  sellerCancelReason?: Maybe<Scalars['String']>;
  verifiedByAdmin?: Maybe<Scalars['String']>;
};

export type UserExtendedFieldResponseDto = {
  __typename?: 'UserExtendedFieldResponseDto';
  code: Scalars['Float'];
  data: UserExtendedFieldDto;
  message: Scalars['String'];
};

export type UserFeedbackListDto = {
  __typename?: 'UserFeedbackListDto';
  data: Array<GetAllUsersFeedbacks>;
  totalRecords: Scalars['Float'];
};

export type UserKycDocumentDetialDto = {
  __typename?: 'UserKycDocumentDetialDto';
  _id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  kycDocumentName: Scalars['String'];
  kycDocumentSlug: Scalars['String'];
};

export type UserKycDocumentVerificationDetialDto = {
  __typename?: 'UserKycDocumentVerificationDetialDto';
  _id: Scalars['ID'];
  documentCancelReason?: Maybe<Scalars['String']>;
  kycDocumentDetails?: Maybe<UserKycDocumentDetialDto>;
  kycDocumentId: Scalars['ID'];
  kycDocumentImage?: Maybe<Scalars['String']>;
  kycDocumentStatus: Scalars['String'];
  kycDocumentType?: Maybe<Scalars['String']>;
  kycDocumentVerificationNumber: Scalars['String'];
  userId: Scalars['ID'];
  verifiedByAdmin: Scalars['String'];
};

export type UserList = {
  __typename?: 'UserList';
  data: Array<UserDetailDto>;
  totalRecords: Scalars['Float'];
};

export type UserListForQuotationDto = {
  __typename?: 'UserListForQuotationDto';
  _id: Scalars['ID'];
  businessName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['Float']>;
  creditLimitAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  phoneNumber: Scalars['Float'];
  sellerBusinessAddressDetails?: Maybe<SellerBusinessAddressDto>;
};

export type UserLogin = {
  __typename?: 'UserLogin';
  code: Scalars['Float'];
  data: UserDetailDto;
  message: Scalars['String'];
};

export type UserProductAttributeTypeRelationColorListDto = {
  __typename?: 'UserProductAttributeTypeRelationColorListDto';
  colorCode?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['ID']>;
  colorName?: Maybe<Scalars['String']>;
};

export type UserProductAttributeTypeRelationDto = {
  __typename?: 'UserProductAttributeTypeRelationDto';
  _id: Scalars['ID'];
  attributeValueName: Scalars['String'];
  productAttributeTypesId: Scalars['ID'];
  userId?: Maybe<Array<Scalars['ID']>>;
};

export type UserProductAttributeTypeRelationList = {
  _id?: InputMaybe<Scalars['ID']>;
  attributeValueName: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type UserProductAttributeTypeRelationListDto = {
  __typename?: 'UserProductAttributeTypeRelationListDto';
  _id?: Maybe<Scalars['ID']>;
  attributeValueName?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<UserProductAttributeTypeRelationColorListDto>>;
  isSelected?: Maybe<Scalars['Boolean']>;
  isUserAttribute?: Maybe<Scalars['Boolean']>;
  numberValue?: Maybe<Scalars['Float']>;
  textValue?: Maybe<Scalars['String']>;
  threadCountOne?: Maybe<Scalars['Float']>;
  threadCountTwo?: Maybe<Scalars['Float']>;
  uploadedFileName?: Maybe<Scalars['String']>;
  userDetails?: Maybe<Array<AttributeValuesUserDetails>>;
  userId?: Maybe<Array<Scalars['ID']>>;
  valueId?: Maybe<Scalars['ID']>;
  verifiedByAdmin?: Maybe<Scalars['String']>;
};

export type UserProductIdDto = {
  __typename?: 'UserProductIdDto';
  productExist?: Maybe<Scalars['Boolean']>;
};

export type UserProductListDetailsDto = {
  __typename?: 'UserProductListDetailsDto';
  data: Array<ProductListDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type UserProductSearchAddInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  productName?: InputMaybe<Scalars['String']>;
  subCategoryId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type UserProductWishlistsDto = {
  __typename?: 'UserProductWishlistsDto';
  data: Array<BuyerSideProductListDetailsDto>;
  totalRecords?: Maybe<Scalars['Float']>;
};

export type UserProfileCompletionDetail = {
  __typename?: 'UserProfileCompletionDetail';
  buyerProfileCompletionPercentage?: Maybe<Scalars['Float']>;
  sellerProfileCompletionPercentage?: Maybe<Scalars['Float']>;
};

export type UserPromotedAdvCreateUpdateInput = {
  _id?: InputMaybe<Scalars['ID']>;
  addedBy: Scalars['String'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
  advertisementType: Scalars['String'];
  bannerDescription?: InputMaybe<Scalars['String']>;
  bannerImageMobile?: InputMaybe<Scalars['String']>;
  bannerImageWeb?: InputMaybe<Scalars['String']>;
  bannerTitle?: InputMaybe<Scalars['String']>;
  bannerType?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  categoryId: Scalars['ID'];
  endDate: Scalars['Float'];
  jusPayOrderId?: InputMaybe<Scalars['String']>;
  jusPayPaymentStatus?: InputMaybe<Scalars['String']>;
  perDayPrice: Scalars['Float'];
  productId?: InputMaybe<Scalars['ID']>;
  sectionTypeId: Scalars['ID'];
  sellerId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Float'];
  subCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  totalDays: Scalars['Float'];
  totalPayableAmount: Scalars['Float'];
  userId?: InputMaybe<Scalars['ID']>;
  verifiedByAdmin?: InputMaybe<Scalars['String']>;
};

export type UserPromotedAdvDetailsDto = {
  __typename?: 'UserPromotedAdvDetailsDto';
  _id: Scalars['ID'];
  addedBy: Scalars['String'];
  advertisementCancelReason?: Maybe<Scalars['String']>;
  advertisementStatus?: Maybe<Scalars['String']>;
  advertisementType: Scalars['String'];
  bannerDescription?: Maybe<Scalars['String']>;
  bannerImageMobile?: Maybe<Scalars['String']>;
  bannerImageWeb?: Maybe<Scalars['String']>;
  bannerTitle?: Maybe<Scalars['String']>;
  bannerType?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['ID']>;
  brandName?: Maybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  endDate: Scalars['Float'];
  isPaymentDone?: Maybe<Scalars['Boolean']>;
  jusPayPaymentStatus?: Maybe<Scalars['String']>;
  perDayPrice: Scalars['Float'];
  productId?: Maybe<Scalars['ID']>;
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productThumbNailImage?: Maybe<Scalars['String']>;
  sectionTypeId: Scalars['ID'];
  sectionTypeName?: Maybe<Scalars['String']>;
  sellerBusinessName?: Maybe<Scalars['String']>;
  sellerId?: Maybe<Scalars['ID']>;
  startDate: Scalars['Float'];
  subCategoryIds?: Maybe<Array<Scalars['String']>>;
  totalDays: Scalars['Float'];
  totalPayableAmount: Scalars['Float'];
  userId?: Maybe<Scalars['ID']>;
  verifiedByAdmin?: Maybe<Scalars['String']>;
};

export type UserPromotedAdvDto = {
  __typename?: 'UserPromotedAdvDto';
  code: Scalars['Float'];
  data?: Maybe<UserPromotedAdvDetailsDto>;
  message: Scalars['String'];
};

export type UserPromotedAdvList = {
  __typename?: 'UserPromotedAdvList';
  data: Array<UserPromotedAdvDetailsDto>;
  totalRecords: Scalars['Float'];
};

export type UserPromotedAdvMonthDateCountList = {
  __typename?: 'UserPromotedAdvMonthDateCountList';
  count: Scalars['Float'];
  date: Scalars['String'];
  isDateDisabled: Scalars['Boolean'];
};

export type UserRegisterInput = {
  countryCode?: InputMaybe<Scalars['Float']>;
  devices: Array<UserDevicesInput>;
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['Float'];
  referralCode?: InputMaybe<Scalars['String']>;
};

export type UserResponseDto = {
  __typename?: 'UserResponseDto';
  code: Scalars['Float'];
  data: UserDetailDto;
  message: Scalars['String'];
};

export type UserUpdatedViewDetailDto = {
  __typename?: 'UserUpdatedViewDetailDto';
  sellerComissionList?: Maybe<Array<SellerComissionDetail>>;
  userAddressesCounts?: Maybe<Scalars['Float']>;
  userBankAccountCounts?: Maybe<Scalars['Float']>;
  userBusinessDetails?: Maybe<UserBusinessDetailDto>;
  userKycDocumentVerificationList?: Maybe<Array<UserKycDocumentVerificationDetialDto>>;
  userPersonalDetails: UserViewDetailDto;
};

export type UserVerifyDto = {
  __typename?: 'UserVerifyDto';
  isUserVerified: Scalars['Boolean'];
};

export type UserViewDetailDto = {
  __typename?: 'UserViewDetailDto';
  _id: Scalars['ID'];
  cancelReasonTypes?: Maybe<Array<Scalars['String']>>;
  countryCode?: Maybe<Scalars['Float']>;
  email: Scalars['String'];
  emailNotification?: Maybe<Scalars['Boolean']>;
  isAllowErpAccess?: Maybe<Scalars['Boolean']>;
  isSellerApplied: Scalars['Boolean'];
  kycStatus: Scalars['String'];
  languageType: Scalars['String'];
  name: Scalars['String'];
  orderNotification?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['Float'];
  pushNotification?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  sellerCancelReason?: Maybe<Scalars['String']>;
  sellerProfileCompletionPercentage?: Maybe<Scalars['Float']>;
  userType: Scalars['String'];
  verifiedByAdmin?: Maybe<Scalars['String']>;
  whatsAppNotification?: Maybe<Scalars['Boolean']>;
};

export type UserWarehouseDetail = {
  __typename?: 'UserWarehouseDetail';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['Float']>;
  pinCode?: Maybe<Scalars['String']>;
  returnAddress?: Maybe<Scalars['String']>;
  returnCity?: Maybe<Scalars['String']>;
  returnCountry?: Maybe<Scalars['String']>;
  returnPin?: Maybe<Scalars['String']>;
  returnState?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  wareHouseDetails?: Maybe<Scalars['DynamicObj']>;
  wareHouseName?: Maybe<Scalars['String']>;
};

export type VerifyBankNameDto = {
  __typename?: 'VerifyBankNameDto';
  bankName: Scalars['String'];
};

export type VerifyUserResponseDto = {
  __typename?: 'VerifyUserResponseDto';
  code: Scalars['Float'];
  data: UserVerifyDto;
  message: Scalars['String'];
};

export type WareHouseDetail = {
  __typename?: 'WareHouseDetail';
  message: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type WarehouseDetailInput = {
  userId?: InputMaybe<Scalars['ID']>;
};

export type AdditionalChargesdto = {
  __typename?: 'additionalChargesdto';
  _id?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type CalculateShippingCostInput = {
  WeightinGram?: InputMaybe<Scalars['Float']>;
  billingMode?: InputMaybe<Scalars['String']>;
  cod?: InputMaybe<Scalars['Float']>;
  destinationPincode?: InputMaybe<Scalars['Float']>;
  originPincode?: InputMaybe<Scalars['Float']>;
  paymentMode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type CategoryDetails = {
  __typename?: 'categoryDetails';
  _id?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  urlId?: Maybe<Scalars['String']>;
};

export type ProductPriceDetails = ProductSetDetailsDto | ProductYarnListingDetailDto;

export type SellerBuyerDetails = {
  __typename?: 'sellerBuyerDetails';
  businessName: Scalars['String'];
  countryCode?: Maybe<Scalars['Float']>;
  email: Scalars['String'];
  fullAddress: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['Float'];
};

export type AdminListQueryVariables = Exact<{
  roleId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type AdminListQuery = { __typename?: 'Query', adminList: { __typename: 'AdminList', totalRecords: number, data: Array<{ __typename: 'AdminListObject', _id: string, fullName: string, email: string, roleId: string, roleType: string }> } };

export type AdminDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type AdminDetailsQuery = { __typename?: 'Query', adminDetails: { __typename?: 'AdminDetails', _id: string, fullName: string, email: string, roleId: string } };

export type RoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleListQuery = { __typename?: 'Query', roleList: Array<{ __typename?: 'Role', _id: string, roleName: string, permissions: Array<string>, roleType: string }> };

export type CreateAdminMutationVariables = Exact<{
  fullName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  roleId: Scalars['String'];
}>;


export type CreateAdminMutation = { __typename?: 'Mutation', createAdmin: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteAdminMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteAdminMutation = { __typename?: 'Mutation', deleteAdmin: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdateGeneralSettingMutationVariables = Exact<{
  slug: Scalars['String'];
  allowSellerRegistration: Scalars['Boolean'];
}>;


export type UpdateGeneralSettingMutation = { __typename?: 'Mutation', updateGeneralSetting: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AdminPromotedAdvListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
  sectionTypeId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
}>;


export type AdminPromotedAdvListQuery = { __typename?: 'Query', adminPromotedAdvList: { __typename?: 'UserPromotedAdvList', totalRecords: number, data: Array<{ __typename?: 'UserPromotedAdvDetailsDto', _id: string, sectionTypeId: string, userId?: string | null, advertisementType: string, bannerTitle?: string | null, bannerDescription?: string | null, perDayPrice: number, startDate: number, endDate: number, totalDays: number, totalPayableAmount: number, categoryId: string, bannerType?: string | null, brandId?: string | null, sellerId?: string | null, productId?: string | null, subCategoryIds?: Array<string> | null, addedBy: string, brandName?: string | null, productName?: string | null, productImage?: string | null, sellerBusinessName?: string | null, advertisementStatus?: string | null, advertisementCancelReason?: string | null, bannerImageMobile?: string | null, bannerImageWeb?: string | null, verifiedByAdmin?: string | null, sectionTypeName?: string | null, isPaymentDone?: boolean | null }> } };

export type AdvertisementVerifiedByAdminMutationVariables = Exact<{
  id: Scalars['ID'];
  verifiedByAdmin: Scalars['String'];
  advertisementCancelReason?: InputMaybe<Scalars['String']>;
}>;


export type AdvertisementVerifiedByAdminMutation = { __typename?: 'Mutation', advertisementVerifiedByAdmin: { __typename?: 'CommonSuccessResponseDto', message: string, code: number } };

export type ActionRequiredOnUserPromotedAdvMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActionRequiredOnUserPromotedAdvMutation = { __typename?: 'Mutation', actionRequiredOnUserPromotedAdv: { __typename?: 'ActionRequiredUserPromotedAdvDto', isActionRequired: boolean } };

export type ProductAttributeAddMutationVariables = Exact<{
  input: ProductAttributeCreateInput;
}>;


export type ProductAttributeAddMutation = { __typename?: 'Mutation', productAttributeAdd: { __typename: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetCategoryAttributeByIdQueryVariables = Exact<{
  attributeId: Scalars['String'];
}>;


export type GetCategoryAttributeByIdQuery = { __typename?: 'Query', getCategoryAttributeById: { __typename?: 'CategoryAttributeByIdInput', _id: string, categoryId: string, subCategoryIds: Array<string>, attributeName: string, isRequired: boolean, status?: string | null, isYarnCount?: boolean | null } };

export type UpdateCategoryAttributeByIdMutationVariables = Exact<{
  args: UpdateCategoryAttributeById;
}>;


export type UpdateCategoryAttributeByIdMutation = { __typename?: 'Mutation', updateCategoryAttributeById: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type CategoryAttributesListWithSearchAndPaginationQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type CategoryAttributesListWithSearchAndPaginationQuery = { __typename?: 'Query', categoryAttributesListWithSearchAndPagination: { __typename?: 'CategoryAttributesListWithPaginationAndSearchDto', totalRecords?: number | null, data: Array<{ __typename?: 'CategoryAttributesListWithPaginationAndSearchData', _id: string, attributeName: string, productCount?: number | null, status: string, subCategories: Array<string>, fullAttributeName?: string | null, createdAt?: number | null }> } };

export type AttributeTypesAndValuesListQueryVariables = Exact<{
  productAttributeId: Scalars['String'];
}>;


export type AttributeTypesAndValuesListQuery = { __typename?: 'Query', attributeTypesAndValuesList: { __typename?: 'ProductAttributeTypesAndValuesListDto', productsCount?: number | null, data: Array<{ __typename?: 'ProductAttributeTypesListDto', _id: string, productAttributeId?: string | null, inputType: string, label?: string | null, placeholder?: string | null, title?: string | null, min?: number | null, max?: number | null, isRequired?: boolean | null, allowToAddNewValue?: boolean | null, suffix?: string | null, isInitialValue?: boolean | null, values?: Array<{ __typename?: 'UserProductAttributeTypeRelationListDto', _id?: string | null, attributeValueName?: string | null }> | null, reviewAttributeValues?: Array<{ __typename?: 'UserProductAttributeTypeRelationListDto', _id?: string | null, attributeValueName?: string | null, verifiedByAdmin?: string | null, userDetails?: Array<{ __typename?: 'AttributeValuesUserDetails', businessName?: string | null, name: string }> | null }> | null }> } };

export type ManageAttributeMutationVariables = Exact<{
  attributeId: Scalars['ID'];
  addUpdatedPayload: Array<ProductAttributeTypesAndValuesInput> | ProductAttributeTypesAndValuesInput;
  deletedPayload?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ManageAttributeMutation = { __typename?: 'Mutation', manageAttribute: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AttributeDeleteByIdMutationVariables = Exact<{
  attributeId: Scalars['ID'];
}>;


export type AttributeDeleteByIdMutation = { __typename?: 'Mutation', attributeDeleteById: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ReviewAttributeValueByIdMutationVariables = Exact<{
  input: ApproveRejectProductAttributeValueInput;
}>;


export type ReviewAttributeValueByIdMutation = { __typename?: 'Mutation', reviewAttributeValueById: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AdminLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AdminLoginMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'AdminLoginResponseDto', code: number, message: string, data: { __typename?: 'AdminLogin', _id: string, fullName: string, email: string, token?: string | null, refreshToken?: string | null, roleType?: string | null, roleId: string, isSellerRegistrationAllowed?: boolean | null, roles: Array<{ __typename?: 'AdminRoles', moduleId: string, moduleName: string, moduleSlug: string, permissionTypes: Array<{ __typename: 'AdminRolePermissionTypes', _id: string, permissionTypeName: string, permissionTypeSlug: string, isDefault: string }> }> } } };

export type GenerateNewAccessTokenMutationVariables = Exact<{
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
}>;


export type GenerateNewAccessTokenMutation = { __typename?: 'Mutation', generateNewAccessToken: { __typename?: 'NewGeneratedAccessTokenResponseDto', code: number, message: string, data: { __typename?: 'NewGeneratedAccessTokenDto', accessToken: string } } };

export type BankListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type BankListPaginationQuery = { __typename?: 'Query', bankListPagination: { __typename: 'BankList', totalRecords: number, data: Array<{ __typename: 'BankListDto', _id: string, bankName: string, isActive: string }> } };

export type BankDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type BankDetailsQuery = { __typename?: 'Query', bankDetails: { __typename: 'BankDetailDto', _id: string, bankName: string, bankLogo?: string | null, isActive: string } };

export type BankAddMutationVariables = Exact<{
  bankName: Scalars['String'];
  bankLogo: Scalars['String'];
}>;


export type BankAddMutation = { __typename?: 'Mutation', bankAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type BankUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  bankName?: InputMaybe<Scalars['String']>;
  bankLogo?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
}>;


export type BankUpdateMutation = { __typename?: 'Mutation', bankUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteBankMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteBankMutation = { __typename?: 'Mutation', deleteBank: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetBrandListQueryVariables = Exact<{
  filterBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type GetBrandListQuery = { __typename?: 'Query', brandList: { __typename?: 'BrandList', totalRecords: number, data: Array<{ __typename: 'BrandDetailDto', _id: string, userId: string, brandName: string, brandLogo?: string | null, brandDocument: string, brandDocumentType: string, isBrandOwner?: boolean | null, verifiedByAdmin: string, brandCancelReason?: string | null, userDetails?: { __typename?: 'UserDetailDto', businessName?: string | null, name: string } | null }> } };

export type BrandReviewMutationVariables = Exact<{
  brandId: Scalars['ID'];
  isBrandOwner: Scalars['Boolean'];
  approvalType: Scalars['String'];
  userId: Scalars['ID'];
  rejectReason?: InputMaybe<Scalars['String']>;
}>;


export type BrandReviewMutation = { __typename?: 'Mutation', brandReview: { __typename?: 'BrandReviewResponseDto', code: number, message: string } };

export type BrandGroupListByIdQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  brandId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type BrandGroupListByIdQuery = { __typename?: 'Query', brandGroupListById: { __typename?: 'BrandGroupList', totalRecords: number, data: Array<{ __typename?: 'BrandGroupDetailDto', _id: string, userId: string, brandDocument: string, brandDocumentType: string, isBrandOwner: boolean, verifiedByAdmin: string, brandCancelReason?: string | null, businessName?: string | null, userName: string }> } };

export type BrandListWithSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandListWithSearchQuery = { __typename?: 'Query', brandListWithSearch: Array<{ __typename?: 'BrandNameListDto', _id: string, brandName?: string | null, brandLogo?: string | null }> };

export type BrandListByProductCategoryQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type BrandListByProductCategoryQuery = { __typename?: 'Query', brandListByProductCategory: Array<{ __typename?: 'BrandDetailDto', _id: string, userId: string, brandName: string, brandLogo?: string | null, brandDocument: string, brandDocumentType: string, isBrandOwner?: boolean | null, isGroupedOrNot?: boolean | null, verifiedByAdmin: string, brandCancelReason?: string | null, userDetails?: { __typename?: 'UserDetailDto', _id: string, email: string, phoneNumber: number, languageType: string, phoneVerificationStatus: string, businessName?: string | null, name: string, referralCode?: string | null, emailVerificationStatus: string, kycStatus: string, orderNotification: boolean, emailNotification: boolean, pushNotification: boolean, whatsAppNotification: boolean, isActive: string, token?: string | null, refreshToken?: string | null, userType: string, buyerProfileCompletionPercentage?: number | null, sellerProfileCompletionPercentage?: number | null, businessLogo?: string | null, isSellerApplied: boolean, verifiedByAdmin?: string | null, sellerCancelReason?: string | null, cancelReasonTypes?: Array<string> | null, isSellerRegistrationAllowed?: boolean | null, juspayCustomerId?: string | null } | null }> };

export type CreateBrandSectionMutationVariables = Exact<{
  input: BrandSectionAddInput;
}>;


export type CreateBrandSectionMutation = { __typename?: 'Mutation', createBrandSection: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type BrandSectionPaginationListQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type BrandSectionPaginationListQuery = { __typename?: 'Query', brandSectionPaginationList: { __typename?: 'BrandSectionListDto', totalRecords: number, data: Array<{ __typename?: 'BrandSectionDetailDto', _id: string, brandId: string, categoryId: string, brandImage: string, brandName: string }> } };

export type DeleteBrandSectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteBrandSectionMutation = { __typename?: 'Mutation', deleteBrandSection: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type BulkUploadSheetListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type BulkUploadSheetListQuery = { __typename?: 'Query', bulkUploadSheetList: { __typename?: 'BulkUploadHistoryListDto', totalRecords?: number | null, data: Array<{ __typename?: 'BulkUploadHistoryDto', _id: string, userId: string, sheetId: string, sheetName: string, categorySlug: string, categoryName: string, sellerName?: string | null, businessName?: string | null, createdAt: string, updatedAt: string, successCount?: number | null, failureCount?: number | null, status?: string | null }> } };

export type UserBulkProductsListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
  apiSlug?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['ID']>;
}>;


export type UserBulkProductsListQuery = { __typename?: 'Query', userProductsList: { __typename?: 'UserProductListDetailsDto', totalRecords: number, data: Array<{ __typename?: 'ProductListDetailsDto', _id: string, categorySlug?: string | null, listingTitle?: string | null, brandName?: string | null, categoryName?: string | null, subCategoryName?: string | null, productStatus?: string | null, verifiedByAdmin?: string | null, productCancelReason?: string | null, productImage?: string | null, userDetails?: { __typename?: 'UserDetailDto', businessName?: string | null } | null }> } };

export type BusinessTypeListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type BusinessTypeListPaginationQuery = { __typename?: 'Query', businessTypeListPagination: { __typename: 'BusinessTypeList', totalRecords: number, data: Array<{ __typename: 'BusinessTypeDetailDto', _id: string, businessTypeName: string, isActive: string }> } };

export type BusinessTypeDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type BusinessTypeDetailsQuery = { __typename?: 'Query', businessTypeDetails: { __typename: 'BusinessTypeDetailDto', _id: string, businessTypeName: string, isActive: string } };

export type DeleteBusinessTypeMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteBusinessTypeMutation = { __typename?: 'Mutation', deleteBusinessType: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type BusinessTypeUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  businessTypeName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
}>;


export type BusinessTypeUpdateMutation = { __typename?: 'Mutation', businessTypeUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type BusinessTypeAddMutationVariables = Exact<{
  businessTypeName: Scalars['String'];
}>;


export type BusinessTypeAddMutation = { __typename?: 'Mutation', businessTypeAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type CategoryListPaginationQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type CategoryListPaginationQuery = { __typename?: 'Query', categoryListPagination: { __typename?: 'CategoryList', totalRecords: number, data: Array<{ __typename?: 'CategoryListDto', _id: string, categoryName: string, isActive: string, categorySlug?: string | null, categoryBulkUploadInstructions?: string | null, bulkUploadSheetVersion?: number | null, cashDiscountPercentage?: number | null, comissionRate: number, totalPopularStyleCodes?: number | null, totalOffers?: number | null, totalTopDeals?: number | null, totalExploreStyles?: number | null, totalBrandSections?: number | null, categoryLogos: { __typename?: 'CategoryLogoTypes', original: string, medium: string, small: string } }> } };

export type CategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoryListQuery = { __typename?: 'Query', categoryList: Array<{ __typename: 'CategoryListDto', _id: string, categoryName: string, categorySlug?: string | null, cashDiscountPercentage?: number | null, comissionRate: number }> };

export type CategoryDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type CategoryDetailsQuery = { __typename?: 'Query', categoryDetails: { __typename: 'CategoryDetailDto', _id: string, categoryName: string, categorySlug?: string | null, categoryLogo: string, isActive: string, comissionRate?: number | null, cashDiscountPercentage?: number | null, categoryBulkUploadInstructions?: string | null } };

export type CategoryAddMutationVariables = Exact<{
  categoryLogo: Scalars['String'];
  categoryName: Scalars['String'];
  cashDiscountPercentage: Scalars['Float'];
  comissionRate: Scalars['Float'];
  categoryBulkUploadInstructions?: InputMaybe<Scalars['String']>;
}>;


export type CategoryAddMutation = { __typename?: 'Mutation', categoryAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type CategoryUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  categoryName?: InputMaybe<Scalars['String']>;
  categoryLogo?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
  comissionRate?: InputMaybe<Scalars['Float']>;
  cashDiscountPercentage?: InputMaybe<Scalars['Float']>;
  categoryBulkUploadInstructions?: InputMaybe<Scalars['String']>;
}>;


export type CategoryUpdateMutation = { __typename?: 'Mutation', categoryUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteCategoryMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type SubCategoryAddMutationVariables = Exact<{
  input: SubCategoryCreateInput;
}>;


export type SubCategoryAddMutation = { __typename?: 'Mutation', subCategoryAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type SubCategoryUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  subCategoryName: Scalars['String'];
  categoryId: Scalars['String'];
  subCategoryLevel: Scalars['Float'];
  subCategoryImage?: InputMaybe<Scalars['String']>;
  subCategoryTabImage?: InputMaybe<Scalars['String']>;
  parentSubCategoryId?: InputMaybe<Scalars['String']>;
}>;


export type SubCategoryUpdateMutation = { __typename?: 'Mutation', subCategoryUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type SubCategoryListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
}>;


export type SubCategoryListQuery = { __typename?: 'Query', subCategoryListCms: Array<{ __typename: 'SubCategoryListResponseDto', _id: string, subCategoryName?: string | null, subCategoryImage: string, subCategoryTabImage?: string | null, categoryId: string, parentSubCategoryId?: string | null, subCategoryLevel: number, isActive: string, childSubCategories?: Array<{ __typename: 'ChildSubCategoryResponseDto', _id: string, subCategoryName?: string | null, subCategoryImage: string, categoryId: string, parentSubCategoryId?: string | null, subCategoryLevel: number, isActive: string, childSubCategories?: Array<{ __typename: 'SubCategoryDetailDto', _id: string, subCategoryName?: string | null, subCategoryImage: string, categoryId: string, parentSubCategoryId?: string | null, subCategoryLevel: number, isActive: string }> | null }> | null }> };

export type NewSubCategoryListCmsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  parentSubCategoryId?: InputMaybe<Scalars['ID']>;
}>;


export type NewSubCategoryListCmsQuery = { __typename?: 'Query', newSubCategoryListCms: Array<{ __typename: 'SubCategoryListResponseDto', _id: string, subCategoryName?: string | null, subCategoryImage: string, subCategoryTabImage?: string | null, categoryId: string, parentSubCategoryId?: string | null, subCategoryLevel: number, isActive: string, childSubCategories?: Array<{ __typename: 'ChildSubCategoryResponseDto', _id: string, subCategoryName?: string | null, subCategoryImage: string, categoryId: string, parentSubCategoryId?: string | null, subCategoryLevel: number, isActive: string, childSubCategories?: Array<{ __typename: 'SubCategoryDetailDto', _id: string, subCategoryName?: string | null, subCategoryImage: string, categoryId: string, parentSubCategoryId?: string | null, subCategoryLevel: number, isActive: string }> | null }> | null }> };

export type DeleteSubCategoryMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteSubCategoryMutation = { __typename?: 'Mutation', deleteSubCategory: { __typename: 'CommonSuccessResponseDto', code: number, message: string } };

export type SubCategoryListBySearchQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type SubCategoryListBySearchQuery = { __typename?: 'Query', subCategoryListBySearch: Array<{ __typename: 'SubCategoryListDetailBySearchDto', _id?: string | null, parentSubCategoryId?: string | null, parentSubCategoryName: string }> };

export type ActiveInActiveSubCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  isActive: Scalars['String'];
}>;


export type ActiveInActiveSubCategoryMutation = { __typename?: 'Mutation', activeInActiveSubCategory: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ProductListingGuidelineAddEditMutationVariables = Exact<{
  input: ProductListingGuidelineAddEditInput;
}>;


export type ProductListingGuidelineAddEditMutation = { __typename?: 'Mutation', productListingGuidelineAddEdit: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ProductListingGuidelineDetailsQueryVariables = Exact<{
  subCategoryId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
}>;


export type ProductListingGuidelineDetailsQuery = { __typename?: 'Query', productListingGuidelineDetails?: { __typename?: 'ProductListingGuidelineDetails', categoryId: string, subCategoryId: string, guidelineDocument: string, guidelineDocumentType: string } | null };

export type SeoContentAddEditMutationVariables = Exact<{
  input: SeoContentInput;
}>;


export type SeoContentAddEditMutation = { __typename?: 'Mutation', seoContentAddEdit: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type SeoContentDetailsQueryVariables = Exact<{
  categoryId: Scalars['String'];
  subCategoryId: Scalars['String'];
}>;


export type SeoContentDetailsQuery = { __typename?: 'Query', seoContentDetails: { __typename?: 'SeoContentDetails', _id?: string | null, categoryId?: string | null, subCategoryId?: string | null, seoContent?: string | null } };

export type DeleteCategoryReturnPolicyMutationVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type DeleteCategoryReturnPolicyMutation = { __typename?: 'Mutation', deleteCategoryReturnPolicy: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetCategoryReturnPolicyListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type GetCategoryReturnPolicyListQuery = { __typename?: 'Query', getCategoryReturnPolicyList: { __typename?: 'CategoryReturnPolicyList', totalRecords: number, data: Array<{ __typename?: 'CategoryReturnPolicyDto', _id: string, categoryId?: string | null, title: string, description: string, days: number, categoryDetails?: { __typename?: 'CategoryListDto', _id: string, categoryName: string, isActive: string, categorySlug?: string | null, categoryLogos: { __typename?: 'CategoryLogoTypes', original: string, medium: string, small: string } } | null }> } };

export type AddUpdateCategoryReturnPolicyMutationVariables = Exact<{
  title: Scalars['String'];
  description: Scalars['String'];
  categoryReturnPolicySlug: Scalars['String'];
  categoryId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  days: Scalars['Float'];
}>;


export type AddUpdateCategoryReturnPolicyMutation = { __typename?: 'Mutation', addUpdateCategoryReturnPolicy: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetReturnPolicyCategoryByIdQueryVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type GetReturnPolicyCategoryByIdQuery = { __typename?: 'Query', getReturnPolicyCategoryById?: { __typename?: 'CategoryReturnPolicyDto', _id: string, categoryId?: string | null, title: string, description: string, days: number, categoryDetails?: { __typename?: 'CategoryListDto', _id: string, categoryName: string, categorySlug?: string | null, isActive: string, categoryLogos: { __typename?: 'CategoryLogoTypes', medium: string, original: string, small: string } } | null } | null };

export type ColorListPaginationQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ColorListPaginationQuery = { __typename?: 'Query', colorListPagination: { __typename?: 'ColorList', totalRecords: number, data: Array<{ __typename?: 'ColorDetailDto', _id: string, colorCode?: string | null, colorName: string, isActive: string, isMultiColor: boolean, multiColorImage?: string | null }> } };

export type ColorDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ColorDetailsQuery = { __typename?: 'Query', colorDetails: { __typename?: 'ColorDetailDto', _id: string, colorCode?: string | null, colorName: string, isActive: string, isMultiColor: boolean, multiColorImage?: string | null } };

export type ColorAddMutationVariables = Exact<{
  input: ColorCreateInput;
}>;


export type ColorAddMutation = { __typename?: 'Mutation', colorAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ColorUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  colorCode?: InputMaybe<Scalars['String']>;
  colorName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
  isMultiColor?: InputMaybe<Scalars['Boolean']>;
  multiColorImage?: InputMaybe<Scalars['String']>;
}>;


export type ColorUpdateMutation = { __typename?: 'Mutation', colorUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteColorMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteColorMutation = { __typename?: 'Mutation', deleteColor: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DashboardListQueryVariables = Exact<{
  roleId: Scalars['ID'];
}>;


export type DashboardListQuery = { __typename?: 'Query', dashboardList: Array<{ __typename?: 'DashboardCardObject', moduleId: string, moduleName: string, moduleSlug: string, count: number }> };

export type DeleteContentImageMutationVariables = Exact<{
  contentImageName: Scalars['String'];
}>;


export type DeleteContentImageMutation = { __typename?: 'Mutation', deleteStaticPageContentImages: { __typename: 'CommonSuccessResponseDto', code: number, message: string } };

export type DesignationListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type DesignationListPaginationQuery = { __typename?: 'Query', designationListPagination: { __typename: 'DesignationList', totalRecords: number, data: Array<{ __typename: 'DesignationDetailDto', _id: string, designationName: string, isActive: string }> } };

export type DesignationDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DesignationDetailsQuery = { __typename?: 'Query', designationDetails: { __typename: 'DesignationDetailDto', _id: string, designationName: string, isActive: string } };

export type DesignationListQueryVariables = Exact<{ [key: string]: never; }>;


export type DesignationListQuery = { __typename?: 'Query', designationList: Array<{ __typename: 'DesignationDetailDto', _id: string, designationName: string, isActive: string }> };

export type DeleteDesignationMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteDesignationMutation = { __typename?: 'Mutation', deleteDesignation: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DesignationUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  designationName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['String']>;
}>;


export type DesignationUpdateMutation = { __typename?: 'Mutation', designationUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DesignationAddMutationVariables = Exact<{
  designationName: Scalars['String'];
}>;


export type DesignationAddMutation = { __typename?: 'Mutation', designationAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ExploreStylesListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
}>;


export type ExploreStylesListQuery = { __typename?: 'Query', exploreStylesList: Array<{ __typename?: 'ExploreStylesDetailDto', _id: string, image: string, categoryId: string, subCategoryId: string, categoryName: string, categorySlug: string, subCategoryName: string }> };

export type ExploreStyleDetailsByIdQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type ExploreStyleDetailsByIdQuery = { __typename?: 'Query', exploreStyleDetailsById: { __typename?: 'ExploreStylesDetailDto', _id: string, image: string, categoryId: string, subCategoryId: string, categoryName: string, categorySlug: string, subCategoryName: string } };

export type DeleteExploreStylesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteExploreStylesMutation = { __typename?: 'Mutation', deleteExploreStyles: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AddExploreStyleMutationVariables = Exact<{
  input: ExploreStylesCreateInput;
}>;


export type AddExploreStyleMutation = { __typename?: 'Mutation', addExploreStyle: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdateExploreStyleMutationVariables = Exact<{
  id: Scalars['ID'];
  image: Scalars['String'];
}>;


export type UpdateExploreStyleMutation = { __typename?: 'Mutation', updateExploreStyle: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ExploreStylesListPaginationQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExploreStylesListPaginationQuery = { __typename?: 'Query', exploreStylesListPagination: { __typename?: 'ExploreStylesDetailDtoPaginationList', totalRecords: number, data: Array<{ __typename?: 'ExploreStylesDetailDto', _id: string, image: string, categoryId: string, subCategoryId: string, categoryName: string, categorySlug: string, subCategoryName: string }> } };

export type FaqTypeListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type FaqTypeListPaginationQuery = { __typename?: 'Query', faqTypeListPagination: { __typename: 'FaqTypeList', totalRecords: number, data: Array<{ __typename: 'FaqType', _id: string, faqTypeName: string }> } };

export type FaqTypeDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type FaqTypeDetailsQuery = { __typename?: 'Query', faqTypeDetails: { __typename: 'FaqTypeDetail', _id: string, faqTypeName: string } };

export type AddFaqTypeMutationVariables = Exact<{
  faqTypeName: Scalars['String'];
}>;


export type AddFaqTypeMutation = { __typename?: 'Mutation', addFaqType: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type FaqTypeUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  faqTypeName: Scalars['String'];
}>;


export type FaqTypeUpdateMutation = { __typename?: 'Mutation', faqTypeUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteFaqTypeMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteFaqTypeMutation = { __typename?: 'Mutation', deleteFaqType: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type FaqTypeListQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqTypeListQuery = { __typename?: 'Query', faqTypeList: Array<{ __typename: 'FaqType', _id: string, faqTypeName: string }> };

export type FaqDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type FaqDetailsQuery = { __typename?: 'Query', faqDetails: { __typename: 'FaqDetail', _id: string, faqTypeId: string, question: string, answer: string, faqTypeDetails: { __typename: 'FaqTypeDetailDto', _id: string, faqTypeName: string } } };

export type FaqListPaginationQueryVariables = Exact<{
  faqTypeId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type FaqListPaginationQuery = { __typename?: 'Query', faqListPagination: { __typename: 'FaqList', totalRecords: number, data: Array<{ __typename?: 'FaqListDto', _id: string, faqTypeId: string, question: string, answer: string, faqTypeDetails: { __typename: 'FaqTypeDetailDto', _id: string, faqTypeName: string } }> } };

export type AddFaqMutationVariables = Exact<{
  faqTypeId: Scalars['ID'];
  question: Scalars['String'];
  answer: Scalars['String'];
}>;


export type AddFaqMutation = { __typename?: 'Mutation', addFaq: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type FaqUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  faqTypeId: Scalars['String'];
  question: Scalars['String'];
  answer: Scalars['String'];
}>;


export type FaqUpdateMutation = { __typename?: 'Mutation', faqUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteFaqMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteFaqMutation = { __typename?: 'Mutation', deleteFaq: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteFeedbackByIdMutationVariables = Exact<{
  feedbackId: Scalars['ID'];
}>;


export type DeleteFeedbackByIdMutation = { __typename?: 'Mutation', deleteFeedbackById: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetAllFeedbackListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type GetAllFeedbackListQuery = { __typename?: 'Query', getAllFeedbackList: { __typename?: 'UserFeedbackListDto', totalRecords: number, data: Array<{ __typename?: 'GetAllUsersFeedbacks', _id?: string | null, userId: string, rating: number, description: string, createdAt: any, userDetails: { __typename?: 'UserDetailDto', email: string, phoneNumber: number, businessName?: string | null, name: string } }> } };

export type HsnCodeListQueryVariables = Exact<{ [key: string]: never; }>;


export type HsnCodeListQuery = { __typename?: 'Query', hsnCodeList: Array<{ __typename?: 'HsnCodeListDto', _id: string, hsnCode: string, hsnDescription: string }> };

export type HsnCodeListWithPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type HsnCodeListWithPaginationQuery = { __typename?: 'Query', hsnCodeListWithPagination: { __typename?: 'HsnCodeListWithPaginationDto', totalRecords?: number | null, data: Array<{ __typename?: 'HsnCodeListDto', _id: string, hsnCode: string, hsnDescription: string }> } };

export type HsnCodeUpdateByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  hsnCode: Scalars['String'];
  hsnDescription: Scalars['String'];
}>;


export type HsnCodeUpdateByIdMutation = { __typename?: 'Mutation', hsnCodeUpdateById: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type HsnCodeAddUpdateMutationVariables = Exact<{
  input: HsnCodeAddUpdateInput;
}>;


export type HsnCodeAddUpdateMutation = { __typename?: 'Mutation', hsnCodeAddUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AddRssNewsUrlMutationVariables = Exact<{
  input: AddRssFeedInput;
}>;


export type AddRssNewsUrlMutation = { __typename?: 'Mutation', addRssNewsUrl: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type RssNewsUrlListQueryVariables = Exact<{ [key: string]: never; }>;


export type RssNewsUrlListQuery = { __typename?: 'Query', rssNewsUrlList: { __typename?: 'NewsRssUrlListDto', totalUrl: number, data: Array<{ __typename?: 'AddRssFeedDetails', _id?: string | null, url?: string | null, description: string, status: string }> } };

export type DeleteNewsUrlByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteNewsUrlByIdQuery = { __typename?: 'Query', deleteNewsUrlById: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AddOfferMutationVariables = Exact<{
  input: OffersCreateInput;
}>;


export type AddOfferMutation = { __typename?: 'Mutation', addOffer: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteOffersMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteOffersMutation = { __typename?: 'Mutation', deleteOffers: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type OffersListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
}>;


export type OffersListQuery = { __typename?: 'Query', offersList: Array<{ __typename?: 'OffersDetailDto', _id: string, brandId: string, categoryId: string, categoryName: string, categorySlug: string, offerImage: string, brandName: string, brandLogo: string, minOfferDiscount: number, maxOfferDiscount: number }> };

export type OfferDetailsByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
}>;


export type OfferDetailsByIdQuery = { __typename?: 'Query', offerDetailsById: { __typename?: 'OffersDetailDto', _id: string, brandId: string, categoryId: string, categoryName: string, categorySlug: string, offerImage: string, brandName: string, brandLogo: string, minOfferDiscount: number, maxOfferDiscount: number } };

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['ID'];
  offerImage: Scalars['String'];
  minOfferDiscount: Scalars['Float'];
  maxOfferDiscount: Scalars['Float'];
}>;


export type UpdateOfferMutation = { __typename?: 'Mutation', updateOffer: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type OffersListPaginationQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type OffersListPaginationQuery = { __typename?: 'Query', offersListPagination: { __typename?: 'OffersDetailDtoPaginationList', totalRecords: number, data: Array<{ __typename?: 'OffersDetailDto', _id: string, brandId: string, categoryId: string, categoryName: string, categorySlug: string, offerImage: string, brandName: string, brandLogo: string, minOfferDiscount: number, maxOfferDiscount: number }> } };

export type CouponCodeListPaginationQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  categoryId?: InputMaybe<Scalars['ID']>;
  filterByStatus?: InputMaybe<Scalars['String']>;
}>;


export type CouponCodeListPaginationQuery = { __typename?: 'Query', couponCodeListPagination: { __typename?: 'CouponCodePaginationListDto', totalRecords: number, data: Array<{ __typename?: 'CouponCodeDetailsDto', _id: string, categoryIds: Array<string>, couponType: string, couponStatus: string, couponCode: string, startDate: number, endDate: number, title: string, description: string, restrictNumberOfUsers: boolean, restrictedUsersCount?: number | null, isCouponApplyOnOrderAmount: boolean, appliedOrderAmount?: number | null, ddCoins?: number | null, isFreeDelivery?: boolean | null, isDiscountInPercentage?: boolean | null, discountPercentage?: number | null, discountAmount?: number | null, uptoDiscountAmount?: number | null, categories?: Array<string> | null }> } };

export type CouponCodeDetailsByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CouponCodeDetailsByIdQuery = { __typename?: 'Query', couponCodeDetailsById: { __typename?: 'CouponCodeDetailsDto', _id: string, categoryIds: Array<string>, couponType: string, couponStatus: string, couponCode: string, startDate: number, endDate: number, title: string, description: string, restrictNumberOfUsers: boolean, restrictedUsersCount?: number | null, isCouponApplyOnOrderAmount: boolean, appliedOrderAmount?: number | null, ddCoins?: number | null, isFreeDelivery?: boolean | null, isDiscountInPercentage?: boolean | null, discountPercentage?: number | null, discountAmount?: number | null, uptoDiscountAmount?: number | null, categories?: Array<string> | null } };

export type AddUpdateCouponCodeMutationVariables = Exact<{
  input: CouponCodeAddUpdateInput;
}>;


export type AddUpdateCouponCodeMutation = { __typename?: 'Mutation', addUpdateCouponCode: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteCouponCodeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCouponCodeMutation = { __typename?: 'Mutation', deleteCouponCode: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type OrderListForAdminQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
}>;


export type OrderListForAdminQuery = { __typename?: 'Query', orderListForAdmin: { __typename?: 'OrderListDto', totalRecords: number, data: Array<{ __typename?: 'OrderDetailsDto', _id: string, buyerUserId: string, sellerUserId: string, categoryId: string, orderNumberId: string, orderVerificationStatus: string, trackingOrderStatus: string, shipmentManagementType: string, isPaymentCompleted: boolean, isDeliveryChargeApplied: boolean, expectedDeliveryDate?: number | null, buyerBusinessName?: string | null, sellerBusinessName?: string | null, categoryName?: string | null, categorySlug?: string | null, createdAt?: number | null, updatedAt?: number | null, manualQuotationOrderId?: string | null, orderImages?: Array<{ __typename?: 'OrderProductImage', productImage?: string | null }> | null }> } };

export type OrderDetailsByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type OrderDetailsByIdQuery = { __typename?: 'Query', orderDetailsById: { __typename?: 'OrderDetailsDto', _id: string, buyerUserId: string, sellerUserId: string, categoryId: string, orderNumberId: string, invoiceNumberId?: string | null, orderVerificationStatus: string, trackingOrderStatus: string, shipmentManagementType: string, isPaymentCompleted: boolean, isDeliveryChargeApplied: boolean, expectedDeliveryDate?: number | null, totalPackageWeight?: number | null, buyerBusinessName?: string | null, sellerBusinessName?: string | null, categoryName?: string | null, categorySlug?: string | null, productImage?: string | null, productName?: string | null, createdAt?: number | null, updatedAt?: number | null, soldBy?: string | null, buyerUserName?: string | null, deliveredDate?: number | null, isBuyerReported?: boolean | null, isOrderOnHold?: boolean | null, orderHoldingDateTime?: number | null, isCouponApplied?: boolean | null, couponType?: string | null, isSampleOrder?: boolean | null, sampleOrderType?: string | null, sampleOrderQuantity?: number | null, sampleOrderMeasurementUnit?: string | null, orderImages?: Array<{ __typename?: 'OrderProductImage', productImage?: string | null }> | null, subOrderList?: Array<{ __typename?: 'SubOrderDetailsDto', productImage: string, productName: string, _id: string, setQuantity?: number | null, setPrice: number, unit: string, quantityInSet?: number | null, totalOrderSetQuantity?: number | null, totalOrderSetPrice?: number | null, colors: Array<{ __typename?: 'OrderColorDto', colorId: string, colorName: string, colorCode?: string | null, length?: number | null, quantity?: number | null }>, sizes?: Array<{ __typename?: 'OrderSizeDto', sizeId: string, sizeValue: string, quantity: number }> | null }> | null, invoiceOrderPaymentDetails?: { __typename?: 'InvoicePaymentDetailsDto', totalPrice: number, discountOnPrice?: number | null, gstRatePrice: number, cartDiscountPrice?: number | null, totalPayableAmount: number, deliveryCharge?: number | null, totalDeliveryCharge?: number | null, couponDiscountPrice?: number | null, isFreeDelivery?: boolean | null, deliveryType?: string | null } | null, sourceAddress?: { __typename?: 'AddressDetailsDto', cityName: string, stateName: string, fullAddress: string, pinCode: number, phoneNumber: number, addressType?: string | null } | null, destinationAddress?: { __typename?: 'AddressDetailsDto', cityName: string, stateName: string, fullAddress: string, pinCode: number, phoneNumber: number, addressType?: string | null } | null, buyerUserDetails?: { __typename?: 'UserDetailsDto', name?: string | null, businessName?: string | null, email?: string | null, phoneNumber?: number | null, fullAddress?: string | null } | null, sellerUserDetails?: { __typename?: 'UserDetailsDto', name?: string | null, businessName?: string | null, email?: string | null, phoneNumber?: number | null, fullAddress?: string | null } | null, shipmentTrackingDetails?: Array<{ __typename?: 'ShipmentTrackingDetailsDto', trackingStatus: string, trackingStatusName?: string | null, trackingDateTime: number }> | null, reportBuyerDetails?: { __typename?: 'ReportBuyerDetailsDto', _id: string, orderId: string, buyerUserId: string, sellerUserId: string, reason: string, description: string } | null } };

export type AddDeliveryChargeMutationVariables = Exact<{
  orderId: Scalars['ID'];
  deliveryCharge?: InputMaybe<Scalars['Float']>;
  totalDeliveryCharge?: InputMaybe<Scalars['Float']>;
  deliveryType: Scalars['String'];
}>;


export type AddDeliveryChargeMutation = { __typename?: 'Mutation', addDeliveryCharge: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdateTrackingOrderStatusAdminMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTrackingOrderStatusAdminMutation = { __typename?: 'Mutation', updateTrackingOrderStatusAdmin: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type PolicyListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type PolicyListPaginationQuery = { __typename?: 'Query', policyListPagination: { __typename: 'PolicyList', totalRecords: number, data: Array<{ __typename: 'PolicyDetailDto', _id: string, title: string, description: string }> } };

export type PolicyDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type PolicyDetailsQuery = { __typename?: 'Query', policyDetails: { __typename: 'PolicyDetailDto', _id: string, title: string, description: string } };

export type PolicyAddMutationVariables = Exact<{
  title: Scalars['String'];
  description: Scalars['String'];
}>;


export type PolicyAddMutation = { __typename?: 'Mutation', policyAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type PolicyUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
}>;


export type PolicyUpdateMutation = { __typename?: 'Mutation', policyUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeletePolicyMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeletePolicyMutation = { __typename?: 'Mutation', deletePolicy: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type PopularStyleCodesListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
}>;


export type PopularStyleCodesListQuery = { __typename?: 'Query', popularStyleCodesList: Array<{ __typename?: 'PopularStyleCodesDetailDto', _id: string, popularStyleCodeName: string, image: string, categoryId: string, subCategoryId: string, categoryName: string, categorySlug: string, subCategoryName: string }> };

export type PopularStyleCodesDetailsByIdQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type PopularStyleCodesDetailsByIdQuery = { __typename?: 'Query', popularStyleCodesDetailsById: { __typename?: 'PopularStyleCodesDetailDto', _id: string, popularStyleCodeName: string, image: string, categoryId: string, subCategoryId: string, categoryName: string, categorySlug: string, subCategoryName: string } };

export type DeletePopularStyleCodesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type DeletePopularStyleCodesMutation = { __typename?: 'Mutation', deletePopularStyleCodes: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AddPopularStyleCodeMutationVariables = Exact<{
  input: PopularStyleCodesCreateInput;
}>;


export type AddPopularStyleCodeMutation = { __typename?: 'Mutation', addPopularStyleCode: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdatePopularStyleCodeMutationVariables = Exact<{
  id: Scalars['ID'];
  image: Scalars['String'];
}>;


export type UpdatePopularStyleCodeMutation = { __typename?: 'Mutation', updatePopularStyleCode: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type PopularStyleCodesListPaginationQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type PopularStyleCodesListPaginationQuery = { __typename?: 'Query', popularStyleCodesListPagination: { __typename?: 'PopularStyleCodesDetailDtoPaginationList', totalRecords: number, data: Array<{ __typename?: 'PopularStyleCodesDetailDto', _id: string, popularStyleCodeName: string, image: string, categoryId: string, subCategoryId: string, categoryName: string, categorySlug: string, subCategoryName: string }> } };

export type UserProductsListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
  productStatus?: InputMaybe<Scalars['String']>;
  verifiedByAdmin?: InputMaybe<Scalars['ID']>;
  apiSlug?: InputMaybe<Scalars['String']>;
}>;


export type UserProductsListQuery = { __typename?: 'Query', userProductsList: { __typename?: 'UserProductListDetailsDto', totalRecords: number, data: Array<{ __typename?: 'ProductListDetailsDto', _id: string, categorySlug?: string | null, listingTitle?: string | null, brandName?: string | null, categoryName?: string | null, subCategoryName?: string | null, productStatus?: string | null, verifiedByAdmin?: string | null, productCancelReason?: string | null, productImage?: string | null, productStatusChangedBy?: string | null, userDetails?: { __typename?: 'UserDetailDto', businessName?: string | null } | null }> } };

export type UpdateProductStatusMutationVariables = Exact<{
  productId: Scalars['ID'];
  productStatusChangedBy: Scalars['String'];
  productStatus: Scalars['String'];
}>;


export type UpdateProductStatusMutation = { __typename?: 'Mutation', updateProductStatus: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ProductVerifiedByAdminMutationVariables = Exact<{
  productIds: Array<Scalars['ID']> | Scalars['ID'];
  verifiedByAdmin: Scalars['String'];
  productCancelReason?: InputMaybe<Scalars['String']>;
}>;


export type ProductVerifiedByAdminMutation = { __typename?: 'Mutation', productVerifiedByAdmin: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetProductListAttributeBySubCategoryIdQueryVariables = Exact<{
  subCategoryId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProductListAttributeBySubCategoryIdQuery = { __typename?: 'Query', getProductListAttributeBySubCategoryId: Array<{ __typename?: 'ProductAttributeListBySubcategoryIdDto', _id: string, attributeName: string, isRequired: boolean, status: string }> };

export type AddUpdateProductNameMutationVariables = Exact<{
  input: ProductNameAddUpdateInput;
}>;


export type AddUpdateProductNameMutation = { __typename?: 'Mutation', addUpdateProductName: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetProductNameListBySubCategoryIdQueryVariables = Exact<{
  subCategoryId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProductNameListBySubCategoryIdQuery = { __typename?: 'Query', getProductNameListBySubCategoryId?: { __typename?: 'ProductNameListBySubcategoryIdDto', _id: string, categoryId: string, subCategoryId: string, productAttributeNameIds: Array<string> } | null };

export type GetProductDetailsByIdQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['ID']>;
  apiPlatformType?: InputMaybe<Scalars['String']>;
}>;


export type GetProductDetailsByIdQuery = { __typename?: 'Query', getProductDetailsById: { __typename?: 'ProductDetailsByIdDto', _id: string, userId: string, brandId: string, brandName: string, productStatus?: string | null, verifiedByAdmin?: string | null, productCancelReason?: string | null, productYarnListDetailId?: string | null, prodId: string, ddFee?: number | null, cashDiscountPercentage?: number | null, soldBy?: string | null, categorySlug?: string | null, sizeChart?: string | null, testReport?: string | null, userDetails?: { __typename?: 'UserDetailDto', businessName?: string | null, name: string, email: string, phoneNumber: number } | null, productImages: Array<{ __typename?: 'ProductImagesListDto', name?: string | null, isCover: boolean, imagePathUrl?: string | null }>, productDetails: Array<{ __typename?: 'ProductDetailsByIdAttributeDetailDto', inputTitle: string, values?: Array<string> | null }>, additionalDetails?: { __typename?: 'ProductAdditionalDetailsDto', productId?: string | null, listingTitle?: string | null, listingDescription?: string | null, moq?: number | null, skuId?: string | null, hsnCodeId?: string | null, hsnCode?: string | null, gstRate?: number | null, isPricePerPieceIncludesGst?: boolean | null, listingExpiryDays?: number | null, isSampleAvailable?: boolean | null, discount?: number | null, productVideo?: string | null, features?: Array<string> | null, freeSampleDetails?: { __typename?: 'SampleDetailsDto', quantity?: number | null, price?: number | null, measurementUnit?: string | null } | null, paidSampleDetails?: { __typename?: 'SampleDetailsDto', quantity?: number | null, price?: number | null, measurementUnit?: string | null } | null } | null, productCreatedSets?: Array<{ __typename?: 'CreateSetPayloadDto', _id?: string | null, productId?: string | null, miscellaneous?: Array<string> | null, unitOfMeasurement: string, setPrice?: number | null, quantityInSet?: number | null, quantityUnit?: string | null, selectedColors: Array<{ __typename?: 'SelectedColorsDto', colorId: string, colorCode?: string | null, colorName?: string | null, image?: string | null, length?: number | null, contents?: Array<{ __typename?: 'SelectedColorsContentDto', sizeId?: string | null, quantity?: number | null, sizeValue?: string | null }> | null }>, priceMoq?: { __typename?: 'ProductSetPriceMoqDetailDto', minSetOrder: number, perPiecePrice: number, perPieceMrp: number, availableQuantity: number } | null, regularPrice: { __typename?: 'RegularPriceDto', moqSet: number, price: number }, bulkPrice?: Array<{ __typename?: 'BulkPriceDto', moqSet: number, moqPricePerPiece?: number | null }> | null, packageWeight?: { __typename?: 'ProductYarnListPackageWeightDetailDto', unitMeasurement: string, weight: number } | null, packageDimensions?: { __typename?: 'ProductYarnListPackageDimensionsDetailDto', unitMeasurement: string, length: number, breadth: number, height: number } | null }> | null, productYarnListDetails?: { __typename?: 'ProductAddUpdateYarnListDetailDto', _id: string, productId: string, miscellaneous?: Array<string> | null, priceMoq: { __typename?: 'ProductYarnListPriceMoqDetailDto', moq: number, perKgMrp: number, perKgMinPrice: number, perKgMaxPrice: number, availableQuantity: number }, packageWeight?: { __typename?: 'ProductYarnListPackageWeightDetailDto', unitMeasurement: string, weight: number } | null, packageDimensions?: { __typename?: 'ProductYarnListPackageDimensionsDetailDto', unitMeasurement: string, length: number, breadth: number, height: number } | null } | null, productRatingReviewDetails?: { __typename?: 'ProductAverageRatingReviewDetailDto', averageRatings: number, totalReviewCounts: number, starRatingReviewCounts?: Array<{ __typename?: 'ProductStarRatingReviewListDto', ratingsValue: number, reviewsCount: number }> | null } | null, productPriceDetails?: { __typename?: 'ProductSetDetailsDto', perSetPrice?: number | null, discountedPrice?: number | null, perPieceMrp?: number | null, moq?: number | null, unitOfMeasurement?: string | null, marginPercentage?: number | null } | { __typename?: 'ProductYarnListingDetailDto', discountedMinPrice?: number | null, discountedMaxPrice?: number | null, moq?: number | null, perKgMrp?: number | null, perKgMinPrice?: number | null, perKgMaxPrice?: number | null, unitOfMeasurement?: string | null, availableQuantity?: number | null, marginPercentage?: number | null } | null } };

export type GetProductRatingsReviewsByProductIdQueryVariables = Exact<{
  productId: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type GetProductRatingsReviewsByProductIdQuery = { __typename?: 'Query', getProductRatingsReviewsByProductId: { __typename?: 'ProductRatingReviewListDetailsDto', totalRecords: number, data: Array<{ __typename?: 'ProductRatingReviewListDto', ratings: number, reviews: string, userName: string, dateOfReview: string }> } };

export type ProductSetSizeListByCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type ProductSetSizeListByCategoryQuery = { __typename?: 'Query', productSetSizeListByCategory: { __typename?: 'ProductSetSizeListingByCategoryIdDto', data: Array<{ __typename?: 'ProductSetSizeListingDetailsByCategoryIdDto', _id: string, subCategoryName?: string | null, subCategoryImage?: string | null, subCategoryLevel?: number | null, isActive?: string | null, productCount?: number | null, sizeSets: Array<{ __typename?: 'ProductSetSizeListingDetailsBySubCategoryIdDto', _id: string, sizeGroupTitle: string, values: Array<{ __typename?: 'ProductSetSizeValueDto', _id: string, sizeValue: string }> }> }> } };

export type ProductSetSizeListBySubCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  subCategoryId?: InputMaybe<Scalars['ID']>;
}>;


export type ProductSetSizeListBySubCategoryQuery = { __typename?: 'Query', productSetSizeListBySubCategory: { __typename?: 'ProductSetSizeListingBySubCategoryIdDto', productCount?: number | null, data: Array<{ __typename?: 'ProductSetSizeListingDetailsBySubCategoryIdDto', _id: string, sizeGroupTitle: string, values: Array<{ __typename?: 'ProductSetSizeValueDto', _id: string, sizeValue: string }> }> } };

export type ManageProductSetSizesMutationVariables = Exact<{
  categoryId: Scalars['ID'];
  subCategoryId: Scalars['ID'];
  deletedPayload?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  addUpdatedPayload: Array<ProductSetSizeTypesAndValuesInput> | ProductSetSizeTypesAndValuesInput;
}>;


export type ManageProductSetSizesMutation = { __typename?: 'Mutation', manageProductSetSizes: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ProductAttributeSetSizeListingQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type ProductAttributeSetSizeListingQuery = { __typename?: 'Query', productAttributeSetSizeListing: { __typename?: 'ProductSetSizePaginationDto', totalRecords: number, data: Array<{ __typename?: 'ProductSetSizeDto', sizeGroupId: string, categoryId: string, sizeGroupTitle: string, subCategoryIds: Array<string>, subCategories: Array<string>, values: Array<{ __typename?: 'SizeValueDto', _id: string, sizeValue: string }> }> } };

export type ProductSetSizesGroupsListingQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductSetSizesGroupsListingQuery = { __typename?: 'Query', productSetSizesGroupsListing: Array<{ __typename?: 'ProductSetSizeGroupDto', _id: string, sizeGroupTitle?: string | null }> };

export type ManageAttributeProductSetSizesMutationVariables = Exact<{
  input: ProductAttributeSetSizeInput;
}>;


export type ManageAttributeProductSetSizesMutation = { __typename?: 'Mutation', manageAttributeProductSetSizes: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ProductSetSizesGroupDetailsQueryVariables = Exact<{
  sizeGroupId: Scalars['ID'];
}>;


export type ProductSetSizesGroupDetailsQuery = { __typename?: 'Query', productSetSizesGroupDetails: { __typename?: 'DetailProductAttributeSetSizesDto', categoryId: string, subCategoryIds: Array<string>, sizeGroupId?: string | null, sizeGroupTitle?: string | null, values: Array<{ __typename?: 'SizeValueDto', _id: string, sizeValue: string }> } };

export type AdminUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  fullName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
}>;


export type AdminUpdateMutation = { __typename?: 'Mutation', adminUpdate: { __typename?: 'AdminUpdateResponseDto', code: number, message: string, data: { __typename: 'AdminUpdate', _id: string, fullName: string } } };

export type PromoteYourAdvListPaginationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type PromoteYourAdvListPaginationQuery = { __typename?: 'Query', promoteYourAdvListPagination: { __typename?: 'PromoteYourAdvList', totalRecords: number, data: Array<{ __typename?: 'PromoteYourAdvDetailsDto', _id: string, price: number, categoryId: string, categoryName?: string | null, advertisementType: string, sectionType: string, sectionTypeName: string, uniqueImpressions: number, totalAdvCounts?: number | null, bulkPrice?: Array<{ __typename?: 'BulkPriceFieldDto', price: number, days: number }> | null }> } };

export type PromoteYourAdvDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type PromoteYourAdvDetailsQuery = { __typename?: 'Query', promoteYourAdvDetails: { __typename?: 'PromoteYourAdvDetailsDto', _id: string, price: number, categoryId: string, categoryName?: string | null, advertisementType: string, sectionType: string, sectionTypeName: string, uniqueImpressions: number, bulkPrice?: Array<{ __typename?: 'BulkPriceFieldDto', price: number, days: number }> | null } };

export type UpdatePromoteYourAdvMutationVariables = Exact<{
  input: PromoteYourAdvUpdateInput;
}>;


export type UpdatePromoteYourAdvMutation = { __typename?: 'Mutation', updatePromoteYourAdv: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AddPromoteYourAdvMutationVariables = Exact<{
  input: PromoteYourAdvUpdateInput;
}>;


export type AddPromoteYourAdvMutation = { __typename?: 'Mutation', addPromoteYourAdv: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AdvertisementSellerListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdvertisementSellerListQuery = { __typename?: 'Query', advertisementSellerList: Array<{ __typename?: 'UserDetailDto', email: string, _id: string, businessName?: string | null }> };

export type SubCategoryListAdvertisementQueryVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type SubCategoryListAdvertisementQuery = { __typename?: 'Query', subCategoryListAdvertisement: Array<{ __typename?: 'SubCategoryListDetailBySearchDto', _id?: string | null, parentSubCategoryId?: string | null, parentSubCategoryName: string }> };

export type AdvertisementBrandListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdvertisementBrandListQuery = { __typename?: 'Query', advertisementBrandList: Array<{ __typename?: 'BrandNameListDto', _id: string, brandName?: string | null, brandLogo?: string | null, parentSubCategoryId?: string | null, parentSubCategoryName?: string | null, apiSlug?: string | null }> };

export type AddUpdateUserPromotedAdvMutationVariables = Exact<{
  input: UserPromotedAdvCreateUpdateInput;
}>;


export type AddUpdateUserPromotedAdvMutation = { __typename?: 'Mutation', addUpdateUserPromotedAdv: { __typename?: 'UserPromotedAdvDto', code: number, message: string } };

export type UpdateUserPromotedAdvStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  advertisementStatus?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserPromotedAdvStatusMutation = { __typename?: 'Mutation', updateUserPromotedAdvStatus: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeletUserPromotedAdvMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletUserPromotedAdvMutation = { __typename?: 'Mutation', deletUserPromotedAdv: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ManualOrderQuotationListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type ManualOrderQuotationListQuery = { __typename?: 'Query', manualOrderQuotationList: { __typename?: 'ManualQuotationOrderList', totalRecords: number, data: Array<{ __typename?: 'ManualQuotationOrderDetailsDto', _id: string, categoryName: string, quotationOrderStatus: string, buyerName: string, businessName?: string | null, createdAt: number }> } };

export type AddManualQuotationPaymentMutationVariables = Exact<{
  input: ManualQuotationPaymentDetailInput;
}>;


export type AddManualQuotationPaymentMutation = { __typename?: 'Mutation', addManualQuotationPayment: { __typename?: 'PaymentReceivedResponseDto', code: number, message: string, data: { __typename?: 'PaymentReceivedDetailsDto', receivedOrderAmount?: number | null } } };

export type AddUpdateManualQuotationOrderMutationVariables = Exact<{
  input: ManualQuotationOrderAddUpdateInput;
}>;


export type AddUpdateManualQuotationOrderMutation = { __typename?: 'Mutation', addUpdateManualQuotationOrder: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ManualQuotationDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManualQuotationDetailQuery = { __typename?: 'Query', manualQuotationDetail: { __typename?: 'ManualQuotationDetail', _id: string, categoryId: string, buyerId: string, sellerId: string, quotationOrderStatus: string, brokerName?: string | null, brokerContactNumber?: number | null, deliveryType: string, buyerCreditBalance?: number | null, quotationDescription: string, termsAndConditions: string, receivedOrderAmount: number, gstPercentage: string, gstAmount: string, cgstPercentage?: string | null, cgstAmount?: string | null, sgstPercentage?: string | null, sgstAmount?: string | null, igstPercentage?: string | null, igstAmount?: string | null, totalOrderAmount: string, roundOffType?: string | null, roundOffAmount?: string | null, isQuotationConfirmed?: boolean | null, isQuotationCompleted?: boolean | null, isQuotationCancelled?: boolean | null, isSellerBuyerAddressSame?: boolean | null, salesOrderId?: string | null, products: Array<{ __typename?: 'ProductQuotationDetailsDto', _id: string, productId: string, productName: string, unitPrice: string, quantity: number, totalAmount: string, productDescription: string, unit: string, hsnCode: string, hsnCodeId?: string | null }>, shippingAddress: { __typename?: 'ShippingBillingAddressDetailDto', _id?: string | null, phoneNumber: number, addressLine1: string, cityId: string, stateId: string, pinCode: number, addressType?: string | null, cityName?: string | null, stateName?: string | null, otherAddressTypeName?: string | null, gstNumber: string, fullAddress?: string | null, countryCode?: number | null }, billingAddress: { __typename?: 'ShippingBillingAddressDetailDto', _id?: string | null, phoneNumber: number, addressLine1: string, cityId: string, stateId: string, pinCode: number, addressType?: string | null, cityName?: string | null, stateName?: string | null, otherAddressTypeName?: string | null, gstNumber: string, fullAddress?: string | null, countryCode?: number | null }, additionalCharges: Array<{ __typename?: 'additionalChargesdto', _id?: string | null, type: string, title: string, amount: number }>, paymentTerms: { __typename?: 'PaymentTermsDto', isAdvancePayment?: boolean | null, isPaymentAgainstDelivery?: boolean | null, isCreditPayment?: boolean | null, creditLimitDays?: number | null, isSplitPayment?: boolean | null, onArrivalPaymentPercentage?: number | null, onDeliveryPaymentPercentage?: number | null }, transportDetails?: { __typename?: 'TransportDetailsDto', transportName?: string | null, vehicleNumber?: string | null } | null, buyerDetails?: { __typename?: 'BuyerDetailsDto', _id?: string | null, fullAddress: string, buyerName: string, businessName?: string | null, phoneNumber: number } | null } };

export type UserListForQuotationQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  filterBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type UserListForQuotationQuery = { __typename?: 'Query', userListForQuotation: Array<{ __typename?: 'UserListForQuotationDto', _id: string, businessName?: string | null, creditLimitAmount?: number | null, name: string, phoneNumber: number, sellerBusinessAddressDetails?: { __typename?: 'SellerBusinessAddressDto', fullAddress: string, cityId: string, stateId: string, pinCode: number, cityName?: string | null, stateName?: string | null } | null }> };

export type UserAddressesListForQuotationQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserAddressesListForQuotationQuery = { __typename?: 'Query', userAddressesListForQuotation: Array<{ __typename?: 'UserAddressListForQuotationDto', _id: string, userId: string, phoneNumber: number, addressLine1: string, cityName?: string | null, stateName?: string | null, landMark?: string | null, cityId: string, stateId: string, pinCode: number, addressType: string, otherAddressTypeName?: string | null, fullAddress: string, isDefault: boolean, gstNumber?: string | null }> };

export type GenerateJusPaySdkPayloadMutationVariables = Exact<{
  userId: Scalars['ID'];
  amount: Scalars['Float'];
}>;


export type GenerateJusPaySdkPayloadMutation = { __typename?: 'Mutation', generateJusPaySDKPayload: { __typename?: 'JusPayDetailResponseDto', code: number, message: string, data: { __typename?: 'JusPayResponseDto', jusPayResponse: string } } };

export type CreateUserMutationVariables = Exact<{
  input: UserRegisterInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserResponseDto', code: number, message: string, data: { __typename?: 'UserDetailDto', _id: string, email: string, phoneNumber: number, name: string } } };

export type ManualSubOrderQuotationListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  manualQuotationOrderId?: InputMaybe<Scalars['ID']>;
}>;


export type ManualSubOrderQuotationListQuery = { __typename?: 'Query', manualSubOrderQuotationList: { __typename?: 'ManualQuotationSubOrderList', totalRecords: number, isQuotationCancelled?: boolean | null, totalOrderAmount?: string | null, receivedOrderAmount?: number | null, salesOrderId?: string | null, salesOrderDocument?: string | null, isQuotationCompleted?: boolean | null, data: Array<{ __typename?: 'ManualQuotationSubOrderDetailsDto', _id: string, manualQuotationOrderId: string, subOrderNumberId: string, productName: string, orderVerificationStatus: string, trackingOrderStatus: string, createdAt: number, updatedAt: number }>, buyerDetails?: { __typename?: 'BuyerDetailsDto', _id?: string | null, fullAddress: string, buyerName: string, businessName?: string | null, phoneNumber: number } | null } };

export type AddManualQuotationSubOrderMutationVariables = Exact<{
  input: ManualQuotationSubOrderAddInput;
}>;


export type AddManualQuotationSubOrderMutation = { __typename?: 'Mutation', addManualQuotationSubOrder: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ManualQuotationGstDetailsQueryVariables = Exact<{
  productId: Scalars['ID'];
  totalAmount: Scalars['Float'];
  isSellerBuyerAddressSame: Scalars['Boolean'];
}>;


export type ManualQuotationGstDetailsQuery = { __typename?: 'Query', manualQuotationGSTDetails: { __typename?: 'ManualQuotationGSTDetail', gstPercentage: string, gstAmount: string, cgstPercentage?: string | null, cgstAmount?: string | null, sgstPercentage?: string | null, sgstAmount?: string | null, igstPercentage?: string | null, igstAmount?: string | null, totalOrderAmount: string, roundOffType?: string | null, roundOffAmount?: string | null } };

export type UpdateManualQuotationConfirmationStatusMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateManualQuotationConfirmationStatusMutation = { __typename?: 'Mutation', updateManualQuotationConfirmationStatus: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdateManualQuotationCompletedStatusMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateManualQuotationCompletedStatusMutation = { __typename?: 'Mutation', updateManualQuotationCompletedStatus: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ManualQuotationSubOrderDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManualQuotationSubOrderDetailQuery = { __typename?: 'Query', manualQuotationSubOrderDetail: { __typename?: 'ManualQuotationSubOrderDetail', _id: string, manualQuotationOrderId: string, trackingOrderStatus: string, orderVerificationStatus: string, subOrderNumberId: string, invoiceNumberId: string, quotationDescription: string, termsAndConditions: string, receivedOrderAmount: number, gstPercentage: string, gstAmount: string, cgstPercentage?: string | null, cgstAmount?: string | null, sgstPercentage?: string | null, sgstAmount?: string | null, igstPercentage?: string | null, igstAmount?: string | null, totalOrderAmount: string, roundOffType?: string | null, roundOffAmount?: string | null, eWayBillNumber?: string | null, products: Array<{ __typename?: 'ProductQuotationDetailsDto', _id: string, productId: string, productName: string, unitPrice: string, quantity: number, totalAmount: string, productDescription: string, unit: string, hsnCode: string, hsnCodeId?: string | null }>, additionalCharges: Array<{ __typename?: 'additionalChargesdto', _id?: string | null, type: string, title: string, amount: number }>, transportDetails?: { __typename?: 'TransportDetailsDto', transportName?: string | null, vehicleNumber?: string | null } | null, buyerDetails?: { __typename?: 'BuyerDetailsDto', _id?: string | null, fullAddress: string, buyerName: string, businessName?: string | null, phoneNumber: number } | null, shipmentTrackingDetails?: Array<{ __typename?: 'ShipmentTrackingDetailsDto', trackingStatus: string, trackingStatusName?: string | null, trackingDateTime: number }> | null } };

export type UpdateManualQuotationTrackingOrderStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  trackingOrderStatus?: InputMaybe<Scalars['String']>;
}>;


export type UpdateManualQuotationTrackingOrderStatusMutation = { __typename?: 'Mutation', updateManualQuotationTrackingOrderStatus: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ManualQuotationPaymentHistoryListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  manualQuotationOrderId?: InputMaybe<Scalars['ID']>;
}>;


export type ManualQuotationPaymentHistoryListQuery = { __typename?: 'Query', manualQuotationPaymentHistoryList: { __typename?: 'ManualQuotationPaymentHistoryList', totalRecords: number, data: Array<{ __typename?: 'ManualQuotationPaymentDetailsDto', paymentLink?: string | null, paymentReferenceNumber?: number | null, paymentMode: string, amount: number, paymentDate: number, paymentStatus: string }> } };

export type ProductListForQuotationQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ProductListForQuotationQuery = { __typename?: 'Query', productListForQuotation: Array<{ __typename?: 'ProductListForQuotationDto', _id: string, productName?: string | null, productImage?: string | null, productDescription?: string | null, hsnCodeId: string, hsnCode?: string | null, unit?: string | null, availableQuantity?: number | null }> };

export type ManageDocumentsForManualQuotationMutationVariables = Exact<{
  manualQuotationSubOrderId: Scalars['ID'];
  documentType: Scalars['String'];
  documentFileName: Scalars['String'];
}>;


export type ManageDocumentsForManualQuotationMutation = { __typename?: 'Mutation', manageDocumentsForManualQuotation: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type ManageDocumentListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ManageDocumentListQuery = { __typename?: 'Query', manageDocumentList: Array<{ __typename?: 'ManageDocumentDetailsDto', documentType?: string | null, documentName?: string | null, documentCreationDate?: number | null, documentFileName?: string | null }> };

export type CancelManualQuotationOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelManualQuotationOrderMutation = { __typename?: 'Mutation', cancelManualQuotationOrder: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type RolePaginationListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type RolePaginationListQuery = { __typename?: 'Query', rolePaginationList: { __typename?: 'RolePaginationList', totalRecords: number, data: Array<{ __typename?: 'RoleListObject', _id: string, roleName: string, permissions: Array<string>, roleType: string, adminCount: number }> } };

export type ModulePermissionListQueryVariables = Exact<{
  roleId: Scalars['ID'];
}>;


export type ModulePermissionListQuery = { __typename?: 'Query', modulePermissionList: Array<{ __typename: 'ModulePermissionList', moduleId: string, moduleName: string, moduleSlug: string, permissions: Array<{ __typename: 'PermissionDetail', permissionTypeId: string, permissionId: string, permissionTypeName: string, permissionTypeSlug: string }> }> };

export type RoleDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type RoleDetailsQuery = { __typename?: 'Query', roleDetails: { __typename?: 'Role', _id: string, roleName: string, permissions: Array<string> } };

export type AddRoleMutationVariables = Exact<{
  roleName: Scalars['String'];
  permissions: Array<Scalars['String']> | Scalars['String'];
}>;


export type AddRoleMutation = { __typename?: 'Mutation', addRole: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type RoleUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  roleName: Scalars['String'];
  permissions: Array<Scalars['String']> | Scalars['String'];
}>;


export type RoleUpdateMutation = { __typename?: 'Mutation', roleUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteRoleMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type SellerPromotedAdvListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  sectionTypeId?: InputMaybe<Scalars['ID']>;
  advertisementStatus?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<Scalars['String']>;
}>;


export type SellerPromotedAdvListQuery = { __typename?: 'Query', sellerPromotedAdvList: { __typename?: 'UserPromotedAdvList', totalRecords: number, data: Array<{ __typename?: 'UserPromotedAdvDetailsDto', _id: string, sectionTypeId: string, userId?: string | null, advertisementType: string, bannerTitle?: string | null, bannerDescription?: string | null, perDayPrice: number, startDate: number, endDate: number, totalDays: number, totalPayableAmount: number, categoryId: string, bannerType?: string | null, brandId?: string | null, sellerId?: string | null, productId?: string | null, subCategoryIds?: Array<string> | null, addedBy: string, brandName?: string | null, productName?: string | null, productImage?: string | null, sellerBusinessName?: string | null, verifiedByAdmin?: string | null, advertisementCancelReason?: string | null, advertisementStatus?: string | null, bannerImageMobile?: string | null, bannerImageWeb?: string | null, isPaymentDone?: boolean | null, sectionTypeName?: string | null, jusPayPaymentStatus?: string | null }> } };

export type StateListQueryVariables = Exact<{ [key: string]: never; }>;


export type StateListQuery = { __typename?: 'Query', stateList: Array<{ __typename?: 'StateListDto', _id: string, name: string, country_code: string, state_code: string }> };

export type CityListQueryVariables = Exact<{
  countryCode: Scalars['String'];
  stateCode: Scalars['String'];
}>;


export type CityListQuery = { __typename?: 'Query', cityList: Array<{ __typename?: 'CityListDto', _id: string, name: string, country_code: string, state_code: string, latitude?: number | null, longitude?: number | null }> };

export type StaticPageListPaginationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type StaticPageListPaginationQuery = { __typename?: 'Query', staticPageListPagination: { __typename: 'StaticPageList', totalRecords: number, data: Array<{ __typename: 'StaticPageDetailDto', _id: string, title: string, description: string }> } };

export type StaticPageDetailsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type StaticPageDetailsQuery = { __typename?: 'Query', staticPageDetails: { __typename: 'StaticPageDetailDto', _id: string, title: string, description: string } };

export type StaticPageAddMutationVariables = Exact<{
  title: Scalars['String'];
  slug: Scalars['String'];
  description: Scalars['String'];
}>;


export type StaticPageAddMutation = { __typename?: 'Mutation', staticPageAdd: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type StaticPageUpdateMutationVariables = Exact<{
  _id: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
}>;


export type StaticPageUpdateMutation = { __typename?: 'Mutation', staticPageUpdate: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type DeleteStaticPageMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteStaticPageMutation = { __typename?: 'Mutation', deleteStaticPage: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type TopDealsListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
}>;


export type TopDealsListQuery = { __typename?: 'Query', topDealsList: Array<{ __typename?: 'TopDealsDetailDto', _id: string, dealName: string, image: string, categoryId: string, subCategoryId: string, price: number, categoryName: string, categorySlug: string, subCategoryName: string }> };

export type TopDealsListPaginationQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type TopDealsListPaginationQuery = { __typename?: 'Query', topDealsListPagination: { __typename?: 'TopDealsListDetailsDto', totalRecords: number, data: Array<{ __typename?: 'TopDealsDetailDto', _id: string, dealName: string, image: string, categoryId: string, subCategoryId: string, price: number, categoryName: string, categorySlug: string, subCategoryName: string }> } };

export type TopDealsDetailsByIdQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type TopDealsDetailsByIdQuery = { __typename?: 'Query', topDealsDetailsById: { __typename?: 'TopDealsDetailDto', _id: string, dealName: string, image: string, categoryId: string, subCategoryId: string, price: number, categoryName: string, categorySlug: string, subCategoryName: string } };

export type DeleteTopDealsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteTopDealsMutation = { __typename?: 'Mutation', deleteTopDeals: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type AddTopDealMutationVariables = Exact<{
  input: TopDealsCreateInput;
}>;


export type AddTopDealMutation = { __typename?: 'Mutation', addTopDeal: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdateTopDealMutationVariables = Exact<{
  image: Scalars['String'];
  price: Scalars['Float'];
  id?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateTopDealMutation = { __typename?: 'Mutation', updateTopDeal: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UserListPaginationQueryVariables = Exact<{
  filterBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  kycStatusFilter?: InputMaybe<Scalars['String']>;
}>;


export type UserListPaginationQuery = { __typename?: 'Query', userListPagination: { __typename: 'UserList', totalRecords: number, data: Array<{ __typename?: 'UserDetailDto', _id: string, email: string, phoneNumber: number, name: string, isActive: string, businessName?: string | null, userType: string, kycStatus: string }> } };

export type DeleteUserMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UserUpdateActiveStatusMutationVariables = Exact<{
  _id: Scalars['ID'];
  isActive: Scalars['String'];
}>;


export type UserUpdateActiveStatusMutation = { __typename?: 'Mutation', userActiveInActive: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UserDetailsByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type UserDetailsByIdQuery = { __typename?: 'Query', userDetailsById: { __typename?: 'UserUpdatedViewDetailDto', userBankAccountCounts?: number | null, userAddressesCounts?: number | null, userPersonalDetails: { __typename?: 'UserViewDetailDto', _id: string, email: string, phoneNumber: number, countryCode?: number | null, languageType: string, name: string, referralCode?: string | null, userType: string, kycStatus: string, sellerCancelReason?: string | null, verifiedByAdmin?: string | null, isSellerApplied: boolean, cancelReasonTypes?: Array<string> | null, sellerProfileCompletionPercentage?: number | null, isAllowErpAccess?: boolean | null }, userBusinessDetails?: { __typename?: 'UserBusinessDetailDto', _id: string, userId: string, businessName: string, businessTypeIds: Array<string>, businessLogo?: string | null, businessDescription?: string | null, businessEstablishedDate?: number | null, isGstNumberVerified?: string | null, gstNumber?: string | null, companyPanNumber?: string | null, shopNumber?: string | null, streetAndArea?: string | null, landMark?: string | null, cityName?: string | null, stateName?: string | null, pinCode?: number | null, signatureImage?: string | null, aadharNumber?: string | null, businessEmail?: string | null, isAadharNumberVerified?: string | null, isBusinessEmailVerified?: string | null, annualTurnOver?: string | null, unit?: string | null, businessTypes?: Array<{ __typename?: 'BusinessTypeDetailDto', _id: string, businessTypeName: string }> | null, products?: Array<{ __typename?: 'BuinessProductDto', categoryId: string, categoryName?: string | null, productIds: Array<string>, productDesigns: number, brandWebsite: string, categoryLogos?: { __typename?: 'CategoryLogoTypes', original: string, medium: string, small: string } | null, categoryProducts: Array<{ __typename?: 'SubCategoryDetailDto', _id: string, subCategoryName?: string | null, subCategoryImage: string, categoryId: string, parentSubCategoryId?: string | null, subCategoryLevel: number, isActive: string }>, productRangePrice: { __typename?: 'BuinessProductRangePriceDto', from: number, to: number } }> | null, businessTimings?: { __typename?: 'BusinessTimingDto', sameEveryDay: boolean, shopTimings: Array<{ __typename?: 'ShopTimingDto', day: string, status: boolean, timings?: Array<{ __typename?: 'TimingsDto', startTime: string, endTime: string }> | null }> } | null } | null, userKycDocumentVerificationList?: Array<{ __typename?: 'UserKycDocumentVerificationDetialDto', _id: string, userId: string, kycDocumentId: string, kycDocumentVerificationNumber: string, kycDocumentImage?: string | null, kycDocumentType?: string | null, kycDocumentStatus: string, documentCancelReason?: string | null, verifiedByAdmin: string, kycDocumentDetails?: { __typename?: 'UserKycDocumentDetialDto', _id: string, kycDocumentName: string, kycDocumentSlug: string, isRequired: boolean } | null }> | null, sellerComissionList?: Array<{ __typename?: 'SellerComissionDetail', _id: string, userId: string, categoryId: string, categoryName?: string | null, categorySlug?: string | null, isDefault: boolean, comissionRate: number }> | null } };

export type UserBankAccountListWithPaginationQueryVariables = Exact<{
  userId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type UserBankAccountListWithPaginationQuery = { __typename?: 'Query', userBankAccountListWithPagination: { __typename?: 'UserBankAccountsList', totalRecords: number, data: Array<{ __typename?: 'UserBankAccountDetailDto', _id: string, userId: string, ifscCode: string, accountNumber: number, accountType: string, accountHolderName: string, isDefault: boolean, bankName: string }> } };

export type UserAddressesListWithPaginationQueryVariables = Exact<{
  userId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
}>;


export type UserAddressesListWithPaginationQuery = { __typename?: 'Query', userAddressesListWithPagination: { __typename?: 'UserAddressesList', totalRecords: number, data: Array<{ __typename?: 'UserAddressesListDto', _id: string, userId: string, phoneNumber: number, addressLine1: string, addressLine2?: string | null, landMark?: string | null, cityId: string, stateId: string, pinCode: number, addressType: string, isDefault: boolean, cityName?: string | null, stateName?: string | null }> } };

export type KycDocumentVerifiedByAdminMutationVariables = Exact<{
  kycDocumentVerificationId: Scalars['ID'];
  documentVerified: Scalars['String'];
  documentCancelReason?: InputMaybe<Scalars['String']>;
}>;


export type KycDocumentVerifiedByAdminMutation = { __typename?: 'Mutation', kycDocumentVerifiedByAdmin: { __typename: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetUserKycStatusMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetUserKycStatusMutation = { __typename?: 'Mutation', getUserKycStatus: { __typename?: 'KycStatusDetailDto', kycStatus: string } };

export type UpdateSellerComissionDetailsMutationVariables = Exact<{
  userId: Scalars['ID'];
  categoryId: Scalars['ID'];
  comissionRate: Scalars['Float'];
}>;


export type UpdateSellerComissionDetailsMutation = { __typename?: 'Mutation', updateSellerComissionDetails: { __typename?: 'CommonSuccessResponseDto', message: string, code: number } };

export type SellerApprovalMutationVariables = Exact<{
  userId: Scalars['ID'];
  verifiedByAdmin: Scalars['String'];
  sellerCancelReason?: InputMaybe<Scalars['String']>;
  cancelReasonTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SellerApprovalMutation = { __typename?: 'Mutation', sellerApproval: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type GetUserBalanceQueryVariables = Exact<{
  userId: Scalars['ID'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type GetUserBalanceQuery = { __typename?: 'Query', getUserBalance: { __typename?: 'UserCreditDebitListDto', totalAmount?: number | null, totalRecords?: number | null, data: Array<{ __typename?: 'UserCreditDebitBalanceDto', _id?: string | null, userId?: string | null, amount?: number | null, description?: string | null, amountType?: string | null, orderNumberId?: string | null, createdAt?: any | null }> } };

export type AddCreditDebitBalanceMutationVariables = Exact<{
  input: AddUserCreditDebitInput;
}>;


export type AddCreditDebitBalanceMutation = { __typename?: 'Mutation', addCreditDebitBalance: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdateAllowErpAccessQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateAllowErpAccessQuery = { __typename?: 'Query', updateAllowErpAccess: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UpdateUserDetailsByAdminMutationVariables = Exact<{
  id: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['Float']>;
  countryCode?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateUserDetailsByAdminMutation = { __typename?: 'Mutation', updateUserDetailsByAdmin: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type UserEscalatedIssuesListQueryVariables = Exact<{
  page: Scalars['Float'];
  limit: Scalars['Float'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type UserEscalatedIssuesListQuery = { __typename?: 'Query', userEscalatedIssuesList: { __typename?: 'EscalateIssueListWithSearchAndPaginationDto', totalRecords?: number | null, data: Array<{ __typename?: 'UserEscalatedIssueDetailDto', _id: string, userId: string, subject: string, queryDescription: string, status: string, ticketId: string, createdAt?: number | null, userDetail?: { __typename?: 'UserDetailDto', name: string, businessName?: string | null } | null }> } };

export type ResolveUserEscalatedIssueMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResolveUserEscalatedIssueMutation = { __typename?: 'Mutation', resolveUserEscalatedIssue: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };

export type VerifyBusinessEmailMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type VerifyBusinessEmailMutation = { __typename?: 'Mutation', verifyBusinessEmail: { __typename?: 'CommonSuccessResponseDto', code: number, message: string } };


export const AdminListDocument = gql`
    query adminList($roleId: ID, $search: String, $page: Float, $limit: Float) {
  adminList(roleId: $roleId, search: $search, page: $page, limit: $limit) {
    data {
      _id
      fullName
      email
      roleId
      roleType
      __typename
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useAdminListQuery__
 *
 * To run a query within a React component, call `useAdminListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminListQuery(baseOptions?: Apollo.QueryHookOptions<AdminListQuery, AdminListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListQuery, AdminListQueryVariables>(AdminListDocument, options);
      }
export function useAdminListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListQuery, AdminListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListQuery, AdminListQueryVariables>(AdminListDocument, options);
        }
export type AdminListQueryHookResult = ReturnType<typeof useAdminListQuery>;
export type AdminListLazyQueryHookResult = ReturnType<typeof useAdminListLazyQuery>;
export type AdminListQueryResult = Apollo.QueryResult<AdminListQuery, AdminListQueryVariables>;
export const AdminDetailsDocument = gql`
    query adminDetails($_id: ID!) {
  adminDetails(_id: $_id) {
    _id
    fullName
    email
    roleId
  }
}
    `;

/**
 * __useAdminDetailsQuery__
 *
 * To run a query within a React component, call `useAdminDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useAdminDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdminDetailsQuery, AdminDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDetailsQuery, AdminDetailsQueryVariables>(AdminDetailsDocument, options);
      }
export function useAdminDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDetailsQuery, AdminDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDetailsQuery, AdminDetailsQueryVariables>(AdminDetailsDocument, options);
        }
export type AdminDetailsQueryHookResult = ReturnType<typeof useAdminDetailsQuery>;
export type AdminDetailsLazyQueryHookResult = ReturnType<typeof useAdminDetailsLazyQuery>;
export type AdminDetailsQueryResult = Apollo.QueryResult<AdminDetailsQuery, AdminDetailsQueryVariables>;
export const RoleListDocument = gql`
    query roleList {
  roleList {
    _id
    roleName
    permissions
    roleType
  }
}
    `;

/**
 * __useRoleListQuery__
 *
 * To run a query within a React component, call `useRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoleListQuery(baseOptions?: Apollo.QueryHookOptions<RoleListQuery, RoleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleListQuery, RoleListQueryVariables>(RoleListDocument, options);
      }
export function useRoleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleListQuery, RoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleListQuery, RoleListQueryVariables>(RoleListDocument, options);
        }
export type RoleListQueryHookResult = ReturnType<typeof useRoleListQuery>;
export type RoleListLazyQueryHookResult = ReturnType<typeof useRoleListLazyQuery>;
export type RoleListQueryResult = Apollo.QueryResult<RoleListQuery, RoleListQueryVariables>;
export const CreateAdminDocument = gql`
    mutation createAdmin($fullName: String!, $email: String!, $password: String!, $roleId: String!) {
  createAdmin(
    input: {fullName: $fullName, email: $email, password: $password, roleId: $roleId}
  ) {
    code
    message
  }
}
    `;
export type CreateAdminMutationFn = Apollo.MutationFunction<CreateAdminMutation, CreateAdminMutationVariables>;

/**
 * __useCreateAdminMutation__
 *
 * To run a mutation, you first call `useCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminMutation, { data, loading, error }] = useCreateAdminMutation({
 *   variables: {
 *      fullName: // value for 'fullName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminMutation, CreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminMutation, CreateAdminMutationVariables>(CreateAdminDocument, options);
      }
export type CreateAdminMutationHookResult = ReturnType<typeof useCreateAdminMutation>;
export type CreateAdminMutationResult = Apollo.MutationResult<CreateAdminMutation>;
export type CreateAdminMutationOptions = Apollo.BaseMutationOptions<CreateAdminMutation, CreateAdminMutationVariables>;
export const DeleteAdminDocument = gql`
    mutation deleteAdmin($_id: ID!) {
  deleteAdmin(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteAdminMutationFn = Apollo.MutationFunction<DeleteAdminMutation, DeleteAdminMutationVariables>;

/**
 * __useDeleteAdminMutation__
 *
 * To run a mutation, you first call `useDeleteAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminMutation, { data, loading, error }] = useDeleteAdminMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminMutation, DeleteAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminMutation, DeleteAdminMutationVariables>(DeleteAdminDocument, options);
      }
export type DeleteAdminMutationHookResult = ReturnType<typeof useDeleteAdminMutation>;
export type DeleteAdminMutationResult = Apollo.MutationResult<DeleteAdminMutation>;
export type DeleteAdminMutationOptions = Apollo.BaseMutationOptions<DeleteAdminMutation, DeleteAdminMutationVariables>;
export const UpdateGeneralSettingDocument = gql`
    mutation UpdateGeneralSetting($slug: String!, $allowSellerRegistration: Boolean!) {
  updateGeneralSetting(
    slug: $slug
    allowSellerRegistration: $allowSellerRegistration
  ) {
    code
    message
  }
}
    `;
export type UpdateGeneralSettingMutationFn = Apollo.MutationFunction<UpdateGeneralSettingMutation, UpdateGeneralSettingMutationVariables>;

/**
 * __useUpdateGeneralSettingMutation__
 *
 * To run a mutation, you first call `useUpdateGeneralSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneralSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneralSettingMutation, { data, loading, error }] = useUpdateGeneralSettingMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      allowSellerRegistration: // value for 'allowSellerRegistration'
 *   },
 * });
 */
export function useUpdateGeneralSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneralSettingMutation, UpdateGeneralSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneralSettingMutation, UpdateGeneralSettingMutationVariables>(UpdateGeneralSettingDocument, options);
      }
export type UpdateGeneralSettingMutationHookResult = ReturnType<typeof useUpdateGeneralSettingMutation>;
export type UpdateGeneralSettingMutationResult = Apollo.MutationResult<UpdateGeneralSettingMutation>;
export type UpdateGeneralSettingMutationOptions = Apollo.BaseMutationOptions<UpdateGeneralSettingMutation, UpdateGeneralSettingMutationVariables>;
export const AdminPromotedAdvListDocument = gql`
    query AdminPromotedAdvList($page: Float!, $limit: Float!, $advertisementStatus: String, $sectionTypeId: ID, $categoryId: ID, $filterBy: String) {
  adminPromotedAdvList(
    page: $page
    limit: $limit
    advertisementStatus: $advertisementStatus
    sectionTypeId: $sectionTypeId
    categoryId: $categoryId
    filterBy: $filterBy
  ) {
    data {
      _id
      sectionTypeId
      userId
      advertisementType
      bannerTitle
      bannerDescription
      perDayPrice
      startDate
      endDate
      totalDays
      totalPayableAmount
      categoryId
      bannerType
      brandId
      sellerId
      productId
      subCategoryIds
      addedBy
      brandName
      productName
      productImage
      sellerBusinessName
      advertisementStatus
      advertisementCancelReason
      bannerImageMobile
      bannerImageWeb
      verifiedByAdmin
      sectionTypeName
      isPaymentDone
    }
    totalRecords
  }
}
    `;

/**
 * __useAdminPromotedAdvListQuery__
 *
 * To run a query within a React component, call `useAdminPromotedAdvListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPromotedAdvListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPromotedAdvListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      advertisementStatus: // value for 'advertisementStatus'
 *      sectionTypeId: // value for 'sectionTypeId'
 *      categoryId: // value for 'categoryId'
 *      filterBy: // value for 'filterBy'
 *   },
 * });
 */
export function useAdminPromotedAdvListQuery(baseOptions: Apollo.QueryHookOptions<AdminPromotedAdvListQuery, AdminPromotedAdvListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPromotedAdvListQuery, AdminPromotedAdvListQueryVariables>(AdminPromotedAdvListDocument, options);
      }
export function useAdminPromotedAdvListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPromotedAdvListQuery, AdminPromotedAdvListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPromotedAdvListQuery, AdminPromotedAdvListQueryVariables>(AdminPromotedAdvListDocument, options);
        }
export type AdminPromotedAdvListQueryHookResult = ReturnType<typeof useAdminPromotedAdvListQuery>;
export type AdminPromotedAdvListLazyQueryHookResult = ReturnType<typeof useAdminPromotedAdvListLazyQuery>;
export type AdminPromotedAdvListQueryResult = Apollo.QueryResult<AdminPromotedAdvListQuery, AdminPromotedAdvListQueryVariables>;
export const AdvertisementVerifiedByAdminDocument = gql`
    mutation AdvertisementVerifiedByAdmin($id: ID!, $verifiedByAdmin: String!, $advertisementCancelReason: String) {
  advertisementVerifiedByAdmin(
    _id: $id
    verifiedByAdmin: $verifiedByAdmin
    advertisementCancelReason: $advertisementCancelReason
  ) {
    message
    code
  }
}
    `;
export type AdvertisementVerifiedByAdminMutationFn = Apollo.MutationFunction<AdvertisementVerifiedByAdminMutation, AdvertisementVerifiedByAdminMutationVariables>;

/**
 * __useAdvertisementVerifiedByAdminMutation__
 *
 * To run a mutation, you first call `useAdvertisementVerifiedByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdvertisementVerifiedByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [advertisementVerifiedByAdminMutation, { data, loading, error }] = useAdvertisementVerifiedByAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      verifiedByAdmin: // value for 'verifiedByAdmin'
 *      advertisementCancelReason: // value for 'advertisementCancelReason'
 *   },
 * });
 */
export function useAdvertisementVerifiedByAdminMutation(baseOptions?: Apollo.MutationHookOptions<AdvertisementVerifiedByAdminMutation, AdvertisementVerifiedByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdvertisementVerifiedByAdminMutation, AdvertisementVerifiedByAdminMutationVariables>(AdvertisementVerifiedByAdminDocument, options);
      }
export type AdvertisementVerifiedByAdminMutationHookResult = ReturnType<typeof useAdvertisementVerifiedByAdminMutation>;
export type AdvertisementVerifiedByAdminMutationResult = Apollo.MutationResult<AdvertisementVerifiedByAdminMutation>;
export type AdvertisementVerifiedByAdminMutationOptions = Apollo.BaseMutationOptions<AdvertisementVerifiedByAdminMutation, AdvertisementVerifiedByAdminMutationVariables>;
export const ActionRequiredOnUserPromotedAdvDocument = gql`
    mutation ActionRequiredOnUserPromotedAdv($id: ID!) {
  actionRequiredOnUserPromotedAdv(_id: $id) {
    isActionRequired
  }
}
    `;
export type ActionRequiredOnUserPromotedAdvMutationFn = Apollo.MutationFunction<ActionRequiredOnUserPromotedAdvMutation, ActionRequiredOnUserPromotedAdvMutationVariables>;

/**
 * __useActionRequiredOnUserPromotedAdvMutation__
 *
 * To run a mutation, you first call `useActionRequiredOnUserPromotedAdvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionRequiredOnUserPromotedAdvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionRequiredOnUserPromotedAdvMutation, { data, loading, error }] = useActionRequiredOnUserPromotedAdvMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionRequiredOnUserPromotedAdvMutation(baseOptions?: Apollo.MutationHookOptions<ActionRequiredOnUserPromotedAdvMutation, ActionRequiredOnUserPromotedAdvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActionRequiredOnUserPromotedAdvMutation, ActionRequiredOnUserPromotedAdvMutationVariables>(ActionRequiredOnUserPromotedAdvDocument, options);
      }
export type ActionRequiredOnUserPromotedAdvMutationHookResult = ReturnType<typeof useActionRequiredOnUserPromotedAdvMutation>;
export type ActionRequiredOnUserPromotedAdvMutationResult = Apollo.MutationResult<ActionRequiredOnUserPromotedAdvMutation>;
export type ActionRequiredOnUserPromotedAdvMutationOptions = Apollo.BaseMutationOptions<ActionRequiredOnUserPromotedAdvMutation, ActionRequiredOnUserPromotedAdvMutationVariables>;
export const ProductAttributeAddDocument = gql`
    mutation ProductAttributeAdd($input: ProductAttributeCreateInput!) {
  productAttributeAdd(input: $input) {
    code
    message
    __typename
  }
}
    `;
export type ProductAttributeAddMutationFn = Apollo.MutationFunction<ProductAttributeAddMutation, ProductAttributeAddMutationVariables>;

/**
 * __useProductAttributeAddMutation__
 *
 * To run a mutation, you first call `useProductAttributeAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductAttributeAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productAttributeAddMutation, { data, loading, error }] = useProductAttributeAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductAttributeAddMutation(baseOptions?: Apollo.MutationHookOptions<ProductAttributeAddMutation, ProductAttributeAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductAttributeAddMutation, ProductAttributeAddMutationVariables>(ProductAttributeAddDocument, options);
      }
export type ProductAttributeAddMutationHookResult = ReturnType<typeof useProductAttributeAddMutation>;
export type ProductAttributeAddMutationResult = Apollo.MutationResult<ProductAttributeAddMutation>;
export type ProductAttributeAddMutationOptions = Apollo.BaseMutationOptions<ProductAttributeAddMutation, ProductAttributeAddMutationVariables>;
export const GetCategoryAttributeByIdDocument = gql`
    query GetCategoryAttributeById($attributeId: String!) {
  getCategoryAttributeById(attributeId: $attributeId) {
    _id
    categoryId
    subCategoryIds
    attributeName
    isRequired
    status
    isYarnCount
  }
}
    `;

/**
 * __useGetCategoryAttributeByIdQuery__
 *
 * To run a query within a React component, call `useGetCategoryAttributeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryAttributeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryAttributeByIdQuery({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useGetCategoryAttributeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryAttributeByIdQuery, GetCategoryAttributeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryAttributeByIdQuery, GetCategoryAttributeByIdQueryVariables>(GetCategoryAttributeByIdDocument, options);
      }
export function useGetCategoryAttributeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryAttributeByIdQuery, GetCategoryAttributeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryAttributeByIdQuery, GetCategoryAttributeByIdQueryVariables>(GetCategoryAttributeByIdDocument, options);
        }
export type GetCategoryAttributeByIdQueryHookResult = ReturnType<typeof useGetCategoryAttributeByIdQuery>;
export type GetCategoryAttributeByIdLazyQueryHookResult = ReturnType<typeof useGetCategoryAttributeByIdLazyQuery>;
export type GetCategoryAttributeByIdQueryResult = Apollo.QueryResult<GetCategoryAttributeByIdQuery, GetCategoryAttributeByIdQueryVariables>;
export const UpdateCategoryAttributeByIdDocument = gql`
    mutation UpdateCategoryAttributeById($args: UpdateCategoryAttributeById!) {
  updateCategoryAttributeById(args: $args) {
    code
    message
  }
}
    `;
export type UpdateCategoryAttributeByIdMutationFn = Apollo.MutationFunction<UpdateCategoryAttributeByIdMutation, UpdateCategoryAttributeByIdMutationVariables>;

/**
 * __useUpdateCategoryAttributeByIdMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryAttributeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryAttributeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryAttributeByIdMutation, { data, loading, error }] = useUpdateCategoryAttributeByIdMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateCategoryAttributeByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryAttributeByIdMutation, UpdateCategoryAttributeByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryAttributeByIdMutation, UpdateCategoryAttributeByIdMutationVariables>(UpdateCategoryAttributeByIdDocument, options);
      }
export type UpdateCategoryAttributeByIdMutationHookResult = ReturnType<typeof useUpdateCategoryAttributeByIdMutation>;
export type UpdateCategoryAttributeByIdMutationResult = Apollo.MutationResult<UpdateCategoryAttributeByIdMutation>;
export type UpdateCategoryAttributeByIdMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryAttributeByIdMutation, UpdateCategoryAttributeByIdMutationVariables>;
export const CategoryAttributesListWithSearchAndPaginationDocument = gql`
    query CategoryAttributesListWithSearchAndPagination($categoryId: ID!, $page: Float!, $limit: Float!, $search: String) {
  categoryAttributesListWithSearchAndPagination(
    categoryId: $categoryId
    page: $page
    limit: $limit
    search: $search
  ) {
    data {
      _id
      attributeName
      productCount
      status
      subCategories
      fullAttributeName
      createdAt
    }
    totalRecords
  }
}
    `;

/**
 * __useCategoryAttributesListWithSearchAndPaginationQuery__
 *
 * To run a query within a React component, call `useCategoryAttributesListWithSearchAndPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryAttributesListWithSearchAndPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryAttributesListWithSearchAndPaginationQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCategoryAttributesListWithSearchAndPaginationQuery(baseOptions: Apollo.QueryHookOptions<CategoryAttributesListWithSearchAndPaginationQuery, CategoryAttributesListWithSearchAndPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryAttributesListWithSearchAndPaginationQuery, CategoryAttributesListWithSearchAndPaginationQueryVariables>(CategoryAttributesListWithSearchAndPaginationDocument, options);
      }
export function useCategoryAttributesListWithSearchAndPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryAttributesListWithSearchAndPaginationQuery, CategoryAttributesListWithSearchAndPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryAttributesListWithSearchAndPaginationQuery, CategoryAttributesListWithSearchAndPaginationQueryVariables>(CategoryAttributesListWithSearchAndPaginationDocument, options);
        }
export type CategoryAttributesListWithSearchAndPaginationQueryHookResult = ReturnType<typeof useCategoryAttributesListWithSearchAndPaginationQuery>;
export type CategoryAttributesListWithSearchAndPaginationLazyQueryHookResult = ReturnType<typeof useCategoryAttributesListWithSearchAndPaginationLazyQuery>;
export type CategoryAttributesListWithSearchAndPaginationQueryResult = Apollo.QueryResult<CategoryAttributesListWithSearchAndPaginationQuery, CategoryAttributesListWithSearchAndPaginationQueryVariables>;
export const AttributeTypesAndValuesListDocument = gql`
    query AttributeTypesAndValuesList($productAttributeId: String!) {
  attributeTypesAndValuesList(productAttributeId: $productAttributeId) {
    data {
      _id
      productAttributeId
      inputType
      label
      placeholder
      title
      min
      max
      isRequired
      values {
        _id
        attributeValueName
      }
      reviewAttributeValues {
        _id
        attributeValueName
        verifiedByAdmin
        userDetails {
          businessName
          name
        }
      }
      allowToAddNewValue
      suffix
      isInitialValue
    }
    productsCount
  }
}
    `;

/**
 * __useAttributeTypesAndValuesListQuery__
 *
 * To run a query within a React component, call `useAttributeTypesAndValuesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeTypesAndValuesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeTypesAndValuesListQuery({
 *   variables: {
 *      productAttributeId: // value for 'productAttributeId'
 *   },
 * });
 */
export function useAttributeTypesAndValuesListQuery(baseOptions: Apollo.QueryHookOptions<AttributeTypesAndValuesListQuery, AttributeTypesAndValuesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeTypesAndValuesListQuery, AttributeTypesAndValuesListQueryVariables>(AttributeTypesAndValuesListDocument, options);
      }
export function useAttributeTypesAndValuesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeTypesAndValuesListQuery, AttributeTypesAndValuesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeTypesAndValuesListQuery, AttributeTypesAndValuesListQueryVariables>(AttributeTypesAndValuesListDocument, options);
        }
export type AttributeTypesAndValuesListQueryHookResult = ReturnType<typeof useAttributeTypesAndValuesListQuery>;
export type AttributeTypesAndValuesListLazyQueryHookResult = ReturnType<typeof useAttributeTypesAndValuesListLazyQuery>;
export type AttributeTypesAndValuesListQueryResult = Apollo.QueryResult<AttributeTypesAndValuesListQuery, AttributeTypesAndValuesListQueryVariables>;
export const ManageAttributeDocument = gql`
    mutation ManageAttribute($attributeId: ID!, $addUpdatedPayload: [ProductAttributeTypesAndValuesInput!]!, $deletedPayload: [ID!]) {
  manageAttribute(
    attributeId: $attributeId
    addUpdatedPayload: $addUpdatedPayload
    deletedPayload: $deletedPayload
  ) {
    code
    message
  }
}
    `;
export type ManageAttributeMutationFn = Apollo.MutationFunction<ManageAttributeMutation, ManageAttributeMutationVariables>;

/**
 * __useManageAttributeMutation__
 *
 * To run a mutation, you first call `useManageAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageAttributeMutation, { data, loading, error }] = useManageAttributeMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      addUpdatedPayload: // value for 'addUpdatedPayload'
 *      deletedPayload: // value for 'deletedPayload'
 *   },
 * });
 */
export function useManageAttributeMutation(baseOptions?: Apollo.MutationHookOptions<ManageAttributeMutation, ManageAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageAttributeMutation, ManageAttributeMutationVariables>(ManageAttributeDocument, options);
      }
export type ManageAttributeMutationHookResult = ReturnType<typeof useManageAttributeMutation>;
export type ManageAttributeMutationResult = Apollo.MutationResult<ManageAttributeMutation>;
export type ManageAttributeMutationOptions = Apollo.BaseMutationOptions<ManageAttributeMutation, ManageAttributeMutationVariables>;
export const AttributeDeleteByIdDocument = gql`
    mutation AttributeDeleteById($attributeId: ID!) {
  attributeDeleteById(attributeId: $attributeId) {
    code
    message
  }
}
    `;
export type AttributeDeleteByIdMutationFn = Apollo.MutationFunction<AttributeDeleteByIdMutation, AttributeDeleteByIdMutationVariables>;

/**
 * __useAttributeDeleteByIdMutation__
 *
 * To run a mutation, you first call `useAttributeDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeDeleteByIdMutation, { data, loading, error }] = useAttributeDeleteByIdMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useAttributeDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<AttributeDeleteByIdMutation, AttributeDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeDeleteByIdMutation, AttributeDeleteByIdMutationVariables>(AttributeDeleteByIdDocument, options);
      }
export type AttributeDeleteByIdMutationHookResult = ReturnType<typeof useAttributeDeleteByIdMutation>;
export type AttributeDeleteByIdMutationResult = Apollo.MutationResult<AttributeDeleteByIdMutation>;
export type AttributeDeleteByIdMutationOptions = Apollo.BaseMutationOptions<AttributeDeleteByIdMutation, AttributeDeleteByIdMutationVariables>;
export const ReviewAttributeValueByIdDocument = gql`
    mutation ReviewAttributeValueById($input: ApproveRejectProductAttributeValueInput!) {
  reviewAttributeValueById(input: $input) {
    code
    message
  }
}
    `;
export type ReviewAttributeValueByIdMutationFn = Apollo.MutationFunction<ReviewAttributeValueByIdMutation, ReviewAttributeValueByIdMutationVariables>;

/**
 * __useReviewAttributeValueByIdMutation__
 *
 * To run a mutation, you first call `useReviewAttributeValueByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewAttributeValueByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewAttributeValueByIdMutation, { data, loading, error }] = useReviewAttributeValueByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewAttributeValueByIdMutation(baseOptions?: Apollo.MutationHookOptions<ReviewAttributeValueByIdMutation, ReviewAttributeValueByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewAttributeValueByIdMutation, ReviewAttributeValueByIdMutationVariables>(ReviewAttributeValueByIdDocument, options);
      }
export type ReviewAttributeValueByIdMutationHookResult = ReturnType<typeof useReviewAttributeValueByIdMutation>;
export type ReviewAttributeValueByIdMutationResult = Apollo.MutationResult<ReviewAttributeValueByIdMutation>;
export type ReviewAttributeValueByIdMutationOptions = Apollo.BaseMutationOptions<ReviewAttributeValueByIdMutation, ReviewAttributeValueByIdMutationVariables>;
export const AdminLoginDocument = gql`
    mutation adminLogin($email: String!, $password: String!) {
  adminLogin(email: $email, password: $password) {
    code
    message
    data {
      _id
      fullName
      email
      token
      refreshToken
      roleType
      roleId
      roles {
        moduleId
        moduleName
        moduleSlug
        permissionTypes {
          _id
          permissionTypeName
          permissionTypeSlug
          isDefault
          __typename
        }
      }
      isSellerRegistrationAllowed
    }
  }
}
    `;
export type AdminLoginMutationFn = Apollo.MutationFunction<AdminLoginMutation, AdminLoginMutationVariables>;

/**
 * __useAdminLoginMutation__
 *
 * To run a mutation, you first call `useAdminLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLoginMutation, { data, loading, error }] = useAdminLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAdminLoginMutation(baseOptions?: Apollo.MutationHookOptions<AdminLoginMutation, AdminLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLoginMutation, AdminLoginMutationVariables>(AdminLoginDocument, options);
      }
export type AdminLoginMutationHookResult = ReturnType<typeof useAdminLoginMutation>;
export type AdminLoginMutationResult = Apollo.MutationResult<AdminLoginMutation>;
export type AdminLoginMutationOptions = Apollo.BaseMutationOptions<AdminLoginMutation, AdminLoginMutationVariables>;
export const GenerateNewAccessTokenDocument = gql`
    mutation generateNewAccessToken($accessToken: String!, $refreshToken: String!) {
  generateNewAccessToken(accessToken: $accessToken, refreshToken: $refreshToken) {
    code
    message
    data {
      accessToken
    }
  }
}
    `;
export type GenerateNewAccessTokenMutationFn = Apollo.MutationFunction<GenerateNewAccessTokenMutation, GenerateNewAccessTokenMutationVariables>;

/**
 * __useGenerateNewAccessTokenMutation__
 *
 * To run a mutation, you first call `useGenerateNewAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateNewAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateNewAccessTokenMutation, { data, loading, error }] = useGenerateNewAccessTokenMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useGenerateNewAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateNewAccessTokenMutation, GenerateNewAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateNewAccessTokenMutation, GenerateNewAccessTokenMutationVariables>(GenerateNewAccessTokenDocument, options);
      }
export type GenerateNewAccessTokenMutationHookResult = ReturnType<typeof useGenerateNewAccessTokenMutation>;
export type GenerateNewAccessTokenMutationResult = Apollo.MutationResult<GenerateNewAccessTokenMutation>;
export type GenerateNewAccessTokenMutationOptions = Apollo.BaseMutationOptions<GenerateNewAccessTokenMutation, GenerateNewAccessTokenMutationVariables>;
export const BankListPaginationDocument = gql`
    query bankListPagination($search: String, $page: Float, $limit: Float) {
  bankListPagination(search: $search, page: $page, limit: $limit) {
    data {
      _id
      bankName
      isActive
      __typename
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useBankListPaginationQuery__
 *
 * To run a query within a React component, call `useBankListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBankListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<BankListPaginationQuery, BankListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankListPaginationQuery, BankListPaginationQueryVariables>(BankListPaginationDocument, options);
      }
export function useBankListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankListPaginationQuery, BankListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankListPaginationQuery, BankListPaginationQueryVariables>(BankListPaginationDocument, options);
        }
export type BankListPaginationQueryHookResult = ReturnType<typeof useBankListPaginationQuery>;
export type BankListPaginationLazyQueryHookResult = ReturnType<typeof useBankListPaginationLazyQuery>;
export type BankListPaginationQueryResult = Apollo.QueryResult<BankListPaginationQuery, BankListPaginationQueryVariables>;
export const BankDetailsDocument = gql`
    query bankDetails($_id: ID!) {
  bankDetails(_id: $_id) {
    _id
    bankName
    bankLogo
    isActive
    __typename
  }
}
    `;

/**
 * __useBankDetailsQuery__
 *
 * To run a query within a React component, call `useBankDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useBankDetailsQuery(baseOptions: Apollo.QueryHookOptions<BankDetailsQuery, BankDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankDetailsQuery, BankDetailsQueryVariables>(BankDetailsDocument, options);
      }
export function useBankDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankDetailsQuery, BankDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankDetailsQuery, BankDetailsQueryVariables>(BankDetailsDocument, options);
        }
export type BankDetailsQueryHookResult = ReturnType<typeof useBankDetailsQuery>;
export type BankDetailsLazyQueryHookResult = ReturnType<typeof useBankDetailsLazyQuery>;
export type BankDetailsQueryResult = Apollo.QueryResult<BankDetailsQuery, BankDetailsQueryVariables>;
export const BankAddDocument = gql`
    mutation bankAdd($bankName: String!, $bankLogo: String!) {
  bankAdd(input: {bankName: $bankName, bankLogo: $bankLogo}) {
    code
    message
  }
}
    `;
export type BankAddMutationFn = Apollo.MutationFunction<BankAddMutation, BankAddMutationVariables>;

/**
 * __useBankAddMutation__
 *
 * To run a mutation, you first call `useBankAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankAddMutation, { data, loading, error }] = useBankAddMutation({
 *   variables: {
 *      bankName: // value for 'bankName'
 *      bankLogo: // value for 'bankLogo'
 *   },
 * });
 */
export function useBankAddMutation(baseOptions?: Apollo.MutationHookOptions<BankAddMutation, BankAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankAddMutation, BankAddMutationVariables>(BankAddDocument, options);
      }
export type BankAddMutationHookResult = ReturnType<typeof useBankAddMutation>;
export type BankAddMutationResult = Apollo.MutationResult<BankAddMutation>;
export type BankAddMutationOptions = Apollo.BaseMutationOptions<BankAddMutation, BankAddMutationVariables>;
export const BankUpdateDocument = gql`
    mutation bankUpdate($_id: ID!, $bankName: String, $bankLogo: String, $isActive: String) {
  bankUpdate(
    _id: $_id
    bankName: $bankName
    bankLogo: $bankLogo
    isActive: $isActive
  ) {
    code
    message
  }
}
    `;
export type BankUpdateMutationFn = Apollo.MutationFunction<BankUpdateMutation, BankUpdateMutationVariables>;

/**
 * __useBankUpdateMutation__
 *
 * To run a mutation, you first call `useBankUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankUpdateMutation, { data, loading, error }] = useBankUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      bankName: // value for 'bankName'
 *      bankLogo: // value for 'bankLogo'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useBankUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BankUpdateMutation, BankUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankUpdateMutation, BankUpdateMutationVariables>(BankUpdateDocument, options);
      }
export type BankUpdateMutationHookResult = ReturnType<typeof useBankUpdateMutation>;
export type BankUpdateMutationResult = Apollo.MutationResult<BankUpdateMutation>;
export type BankUpdateMutationOptions = Apollo.BaseMutationOptions<BankUpdateMutation, BankUpdateMutationVariables>;
export const DeleteBankDocument = gql`
    mutation deleteBank($_id: ID!) {
  deleteBank(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteBankMutationFn = Apollo.MutationFunction<DeleteBankMutation, DeleteBankMutationVariables>;

/**
 * __useDeleteBankMutation__
 *
 * To run a mutation, you first call `useDeleteBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankMutation, { data, loading, error }] = useDeleteBankMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteBankMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankMutation, DeleteBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankMutation, DeleteBankMutationVariables>(DeleteBankDocument, options);
      }
export type DeleteBankMutationHookResult = ReturnType<typeof useDeleteBankMutation>;
export type DeleteBankMutationResult = Apollo.MutationResult<DeleteBankMutation>;
export type DeleteBankMutationOptions = Apollo.BaseMutationOptions<DeleteBankMutation, DeleteBankMutationVariables>;
export const GetBrandListDocument = gql`
    query getBrandList($filterBy: String, $search: String, $page: Float!, $limit: Float!) {
  brandList(filterBy: $filterBy, search: $search, page: $page, limit: $limit) {
    data {
      _id
      userId
      brandName
      brandLogo
      brandDocument
      brandDocumentType
      isBrandOwner
      verifiedByAdmin
      brandCancelReason
      userDetails {
        businessName
        name
      }
      __typename
    }
    totalRecords
  }
}
    `;

/**
 * __useGetBrandListQuery__
 *
 * To run a query within a React component, call `useGetBrandListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandListQuery({
 *   variables: {
 *      filterBy: // value for 'filterBy'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBrandListQuery(baseOptions: Apollo.QueryHookOptions<GetBrandListQuery, GetBrandListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandListQuery, GetBrandListQueryVariables>(GetBrandListDocument, options);
      }
export function useGetBrandListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandListQuery, GetBrandListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandListQuery, GetBrandListQueryVariables>(GetBrandListDocument, options);
        }
export type GetBrandListQueryHookResult = ReturnType<typeof useGetBrandListQuery>;
export type GetBrandListLazyQueryHookResult = ReturnType<typeof useGetBrandListLazyQuery>;
export type GetBrandListQueryResult = Apollo.QueryResult<GetBrandListQuery, GetBrandListQueryVariables>;
export const BrandReviewDocument = gql`
    mutation BrandReview($brandId: ID!, $isBrandOwner: Boolean!, $approvalType: String!, $userId: ID!, $rejectReason: String) {
  brandReview(
    brandId: $brandId
    isBrandOwner: $isBrandOwner
    approvalType: $approvalType
    userId: $userId
    rejectReason: $rejectReason
  ) {
    code
    message
  }
}
    `;
export type BrandReviewMutationFn = Apollo.MutationFunction<BrandReviewMutation, BrandReviewMutationVariables>;

/**
 * __useBrandReviewMutation__
 *
 * To run a mutation, you first call `useBrandReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandReviewMutation, { data, loading, error }] = useBrandReviewMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      isBrandOwner: // value for 'isBrandOwner'
 *      approvalType: // value for 'approvalType'
 *      userId: // value for 'userId'
 *      rejectReason: // value for 'rejectReason'
 *   },
 * });
 */
export function useBrandReviewMutation(baseOptions?: Apollo.MutationHookOptions<BrandReviewMutation, BrandReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandReviewMutation, BrandReviewMutationVariables>(BrandReviewDocument, options);
      }
export type BrandReviewMutationHookResult = ReturnType<typeof useBrandReviewMutation>;
export type BrandReviewMutationResult = Apollo.MutationResult<BrandReviewMutation>;
export type BrandReviewMutationOptions = Apollo.BaseMutationOptions<BrandReviewMutation, BrandReviewMutationVariables>;
export const BrandGroupListByIdDocument = gql`
    query BrandGroupListById($page: Float!, $limit: Float!, $brandId: ID, $filterBy: String, $search: String) {
  brandGroupListById(
    page: $page
    limit: $limit
    brandId: $brandId
    filterBy: $filterBy
    search: $search
  ) {
    data {
      _id
      userId
      brandDocument
      brandDocumentType
      isBrandOwner
      verifiedByAdmin
      brandCancelReason
      businessName
      userName
    }
    totalRecords
  }
}
    `;

/**
 * __useBrandGroupListByIdQuery__
 *
 * To run a query within a React component, call `useBrandGroupListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandGroupListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandGroupListByIdQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      brandId: // value for 'brandId'
 *      filterBy: // value for 'filterBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBrandGroupListByIdQuery(baseOptions: Apollo.QueryHookOptions<BrandGroupListByIdQuery, BrandGroupListByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandGroupListByIdQuery, BrandGroupListByIdQueryVariables>(BrandGroupListByIdDocument, options);
      }
export function useBrandGroupListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandGroupListByIdQuery, BrandGroupListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandGroupListByIdQuery, BrandGroupListByIdQueryVariables>(BrandGroupListByIdDocument, options);
        }
export type BrandGroupListByIdQueryHookResult = ReturnType<typeof useBrandGroupListByIdQuery>;
export type BrandGroupListByIdLazyQueryHookResult = ReturnType<typeof useBrandGroupListByIdLazyQuery>;
export type BrandGroupListByIdQueryResult = Apollo.QueryResult<BrandGroupListByIdQuery, BrandGroupListByIdQueryVariables>;
export const BrandListWithSearchDocument = gql`
    query BrandListWithSearch {
  brandListWithSearch {
    _id
    brandName
    brandLogo
  }
}
    `;

/**
 * __useBrandListWithSearchQuery__
 *
 * To run a query within a React component, call `useBrandListWithSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandListWithSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandListWithSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandListWithSearchQuery(baseOptions?: Apollo.QueryHookOptions<BrandListWithSearchQuery, BrandListWithSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandListWithSearchQuery, BrandListWithSearchQueryVariables>(BrandListWithSearchDocument, options);
      }
export function useBrandListWithSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandListWithSearchQuery, BrandListWithSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandListWithSearchQuery, BrandListWithSearchQueryVariables>(BrandListWithSearchDocument, options);
        }
export type BrandListWithSearchQueryHookResult = ReturnType<typeof useBrandListWithSearchQuery>;
export type BrandListWithSearchLazyQueryHookResult = ReturnType<typeof useBrandListWithSearchLazyQuery>;
export type BrandListWithSearchQueryResult = Apollo.QueryResult<BrandListWithSearchQuery, BrandListWithSearchQueryVariables>;
export const BrandListByProductCategoryDocument = gql`
    query BrandListByProductCategory($categoryId: ID, $search: String) {
  brandListByProductCategory(categoryId: $categoryId, search: $search) {
    _id
    userId
    brandName
    brandLogo
    brandDocument
    brandDocumentType
    isBrandOwner
    isGroupedOrNot
    verifiedByAdmin
    brandCancelReason
    userDetails {
      _id
      email
      phoneNumber
      languageType
      phoneVerificationStatus
      businessName
      name
      referralCode
      emailVerificationStatus
      kycStatus
      orderNotification
      emailNotification
      pushNotification
      whatsAppNotification
      isActive
      token
      refreshToken
      userType
      buyerProfileCompletionPercentage
      sellerProfileCompletionPercentage
      businessLogo
      isSellerApplied
      verifiedByAdmin
      sellerCancelReason
      cancelReasonTypes
      isSellerRegistrationAllowed
      juspayCustomerId
    }
  }
}
    `;

/**
 * __useBrandListByProductCategoryQuery__
 *
 * To run a query within a React component, call `useBrandListByProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandListByProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandListByProductCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBrandListByProductCategoryQuery(baseOptions?: Apollo.QueryHookOptions<BrandListByProductCategoryQuery, BrandListByProductCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandListByProductCategoryQuery, BrandListByProductCategoryQueryVariables>(BrandListByProductCategoryDocument, options);
      }
export function useBrandListByProductCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandListByProductCategoryQuery, BrandListByProductCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandListByProductCategoryQuery, BrandListByProductCategoryQueryVariables>(BrandListByProductCategoryDocument, options);
        }
export type BrandListByProductCategoryQueryHookResult = ReturnType<typeof useBrandListByProductCategoryQuery>;
export type BrandListByProductCategoryLazyQueryHookResult = ReturnType<typeof useBrandListByProductCategoryLazyQuery>;
export type BrandListByProductCategoryQueryResult = Apollo.QueryResult<BrandListByProductCategoryQuery, BrandListByProductCategoryQueryVariables>;
export const CreateBrandSectionDocument = gql`
    mutation CreateBrandSection($input: BrandSectionAddInput!) {
  createBrandSection(input: $input) {
    code
    message
  }
}
    `;
export type CreateBrandSectionMutationFn = Apollo.MutationFunction<CreateBrandSectionMutation, CreateBrandSectionMutationVariables>;

/**
 * __useCreateBrandSectionMutation__
 *
 * To run a mutation, you first call `useCreateBrandSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandSectionMutation, { data, loading, error }] = useCreateBrandSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrandSectionMutation, CreateBrandSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrandSectionMutation, CreateBrandSectionMutationVariables>(CreateBrandSectionDocument, options);
      }
export type CreateBrandSectionMutationHookResult = ReturnType<typeof useCreateBrandSectionMutation>;
export type CreateBrandSectionMutationResult = Apollo.MutationResult<CreateBrandSectionMutation>;
export type CreateBrandSectionMutationOptions = Apollo.BaseMutationOptions<CreateBrandSectionMutation, CreateBrandSectionMutationVariables>;
export const BrandSectionPaginationListDocument = gql`
    query BrandSectionPaginationList($categoryId: ID!, $page: Float!, $limit: Float!, $search: String) {
  brandSectionPaginationList(
    categoryId: $categoryId
    page: $page
    limit: $limit
    search: $search
  ) {
    data {
      _id
      brandId
      categoryId
      brandImage
      brandName
    }
    totalRecords
  }
}
    `;

/**
 * __useBrandSectionPaginationListQuery__
 *
 * To run a query within a React component, call `useBrandSectionPaginationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSectionPaginationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSectionPaginationListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useBrandSectionPaginationListQuery(baseOptions: Apollo.QueryHookOptions<BrandSectionPaginationListQuery, BrandSectionPaginationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSectionPaginationListQuery, BrandSectionPaginationListQueryVariables>(BrandSectionPaginationListDocument, options);
      }
export function useBrandSectionPaginationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSectionPaginationListQuery, BrandSectionPaginationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSectionPaginationListQuery, BrandSectionPaginationListQueryVariables>(BrandSectionPaginationListDocument, options);
        }
export type BrandSectionPaginationListQueryHookResult = ReturnType<typeof useBrandSectionPaginationListQuery>;
export type BrandSectionPaginationListLazyQueryHookResult = ReturnType<typeof useBrandSectionPaginationListLazyQuery>;
export type BrandSectionPaginationListQueryResult = Apollo.QueryResult<BrandSectionPaginationListQuery, BrandSectionPaginationListQueryVariables>;
export const DeleteBrandSectionDocument = gql`
    mutation DeleteBrandSection($id: ID!) {
  deleteBrandSection(_id: $id) {
    code
    message
  }
}
    `;
export type DeleteBrandSectionMutationFn = Apollo.MutationFunction<DeleteBrandSectionMutation, DeleteBrandSectionMutationVariables>;

/**
 * __useDeleteBrandSectionMutation__
 *
 * To run a mutation, you first call `useDeleteBrandSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandSectionMutation, { data, loading, error }] = useDeleteBrandSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBrandSectionMutation, DeleteBrandSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBrandSectionMutation, DeleteBrandSectionMutationVariables>(DeleteBrandSectionDocument, options);
      }
export type DeleteBrandSectionMutationHookResult = ReturnType<typeof useDeleteBrandSectionMutation>;
export type DeleteBrandSectionMutationResult = Apollo.MutationResult<DeleteBrandSectionMutation>;
export type DeleteBrandSectionMutationOptions = Apollo.BaseMutationOptions<DeleteBrandSectionMutation, DeleteBrandSectionMutationVariables>;
export const BulkUploadSheetListDocument = gql`
    query BulkUploadSheetList($page: Float!, $limit: Float!) {
  bulkUploadSheetList(page: $page, limit: $limit) {
    data {
      _id
      userId
      sheetId
      sheetName
      categorySlug
      categoryName
      sellerName
      businessName
      createdAt
      updatedAt
      successCount
      failureCount
      status
    }
    totalRecords
  }
}
    `;

/**
 * __useBulkUploadSheetListQuery__
 *
 * To run a query within a React component, call `useBulkUploadSheetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadSheetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkUploadSheetListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBulkUploadSheetListQuery(baseOptions: Apollo.QueryHookOptions<BulkUploadSheetListQuery, BulkUploadSheetListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkUploadSheetListQuery, BulkUploadSheetListQueryVariables>(BulkUploadSheetListDocument, options);
      }
export function useBulkUploadSheetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkUploadSheetListQuery, BulkUploadSheetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkUploadSheetListQuery, BulkUploadSheetListQueryVariables>(BulkUploadSheetListDocument, options);
        }
export type BulkUploadSheetListQueryHookResult = ReturnType<typeof useBulkUploadSheetListQuery>;
export type BulkUploadSheetListLazyQueryHookResult = ReturnType<typeof useBulkUploadSheetListLazyQuery>;
export type BulkUploadSheetListQueryResult = Apollo.QueryResult<BulkUploadSheetListQuery, BulkUploadSheetListQueryVariables>;
export const UserBulkProductsListDocument = gql`
    query UserBulkProductsList($categoryId: ID, $limit: Float!, $page: Float!, $search: String, $productStatus: String, $verifiedByAdmin: ID, $apiSlug: String, $sheetId: ID) {
  userProductsList(
    categoryId: $categoryId
    limit: $limit
    page: $page
    search: $search
    productStatus: $productStatus
    verifiedByAdmin: $verifiedByAdmin
    apiSlug: $apiSlug
    sheetId: $sheetId
  ) {
    data {
      _id
      categorySlug
      listingTitle
      brandName
      categoryName
      subCategoryName
      productStatus
      verifiedByAdmin
      productCancelReason
      productImage
      userDetails {
        businessName
      }
    }
    totalRecords
  }
}
    `;

/**
 * __useUserBulkProductsListQuery__
 *
 * To run a query within a React component, call `useUserBulkProductsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBulkProductsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBulkProductsListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      productStatus: // value for 'productStatus'
 *      verifiedByAdmin: // value for 'verifiedByAdmin'
 *      apiSlug: // value for 'apiSlug'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useUserBulkProductsListQuery(baseOptions: Apollo.QueryHookOptions<UserBulkProductsListQuery, UserBulkProductsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBulkProductsListQuery, UserBulkProductsListQueryVariables>(UserBulkProductsListDocument, options);
      }
export function useUserBulkProductsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBulkProductsListQuery, UserBulkProductsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBulkProductsListQuery, UserBulkProductsListQueryVariables>(UserBulkProductsListDocument, options);
        }
export type UserBulkProductsListQueryHookResult = ReturnType<typeof useUserBulkProductsListQuery>;
export type UserBulkProductsListLazyQueryHookResult = ReturnType<typeof useUserBulkProductsListLazyQuery>;
export type UserBulkProductsListQueryResult = Apollo.QueryResult<UserBulkProductsListQuery, UserBulkProductsListQueryVariables>;
export const BusinessTypeListPaginationDocument = gql`
    query businessTypeListPagination($search: String, $page: Float, $limit: Float) {
  businessTypeListPagination(search: $search, page: $page, limit: $limit) {
    data {
      _id
      businessTypeName
      isActive
      __typename
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useBusinessTypeListPaginationQuery__
 *
 * To run a query within a React component, call `useBusinessTypeListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessTypeListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessTypeListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBusinessTypeListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<BusinessTypeListPaginationQuery, BusinessTypeListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessTypeListPaginationQuery, BusinessTypeListPaginationQueryVariables>(BusinessTypeListPaginationDocument, options);
      }
export function useBusinessTypeListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessTypeListPaginationQuery, BusinessTypeListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessTypeListPaginationQuery, BusinessTypeListPaginationQueryVariables>(BusinessTypeListPaginationDocument, options);
        }
export type BusinessTypeListPaginationQueryHookResult = ReturnType<typeof useBusinessTypeListPaginationQuery>;
export type BusinessTypeListPaginationLazyQueryHookResult = ReturnType<typeof useBusinessTypeListPaginationLazyQuery>;
export type BusinessTypeListPaginationQueryResult = Apollo.QueryResult<BusinessTypeListPaginationQuery, BusinessTypeListPaginationQueryVariables>;
export const BusinessTypeDetailsDocument = gql`
    query businessTypeDetails($_id: ID!) {
  businessTypeDetails(_id: $_id) {
    _id
    businessTypeName
    isActive
    __typename
  }
}
    `;

/**
 * __useBusinessTypeDetailsQuery__
 *
 * To run a query within a React component, call `useBusinessTypeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessTypeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessTypeDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useBusinessTypeDetailsQuery(baseOptions: Apollo.QueryHookOptions<BusinessTypeDetailsQuery, BusinessTypeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessTypeDetailsQuery, BusinessTypeDetailsQueryVariables>(BusinessTypeDetailsDocument, options);
      }
export function useBusinessTypeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessTypeDetailsQuery, BusinessTypeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessTypeDetailsQuery, BusinessTypeDetailsQueryVariables>(BusinessTypeDetailsDocument, options);
        }
export type BusinessTypeDetailsQueryHookResult = ReturnType<typeof useBusinessTypeDetailsQuery>;
export type BusinessTypeDetailsLazyQueryHookResult = ReturnType<typeof useBusinessTypeDetailsLazyQuery>;
export type BusinessTypeDetailsQueryResult = Apollo.QueryResult<BusinessTypeDetailsQuery, BusinessTypeDetailsQueryVariables>;
export const DeleteBusinessTypeDocument = gql`
    mutation deleteBusinessType($_id: ID!) {
  deleteBusinessType(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteBusinessTypeMutationFn = Apollo.MutationFunction<DeleteBusinessTypeMutation, DeleteBusinessTypeMutationVariables>;

/**
 * __useDeleteBusinessTypeMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessTypeMutation, { data, loading, error }] = useDeleteBusinessTypeMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteBusinessTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessTypeMutation, DeleteBusinessTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessTypeMutation, DeleteBusinessTypeMutationVariables>(DeleteBusinessTypeDocument, options);
      }
export type DeleteBusinessTypeMutationHookResult = ReturnType<typeof useDeleteBusinessTypeMutation>;
export type DeleteBusinessTypeMutationResult = Apollo.MutationResult<DeleteBusinessTypeMutation>;
export type DeleteBusinessTypeMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessTypeMutation, DeleteBusinessTypeMutationVariables>;
export const BusinessTypeUpdateDocument = gql`
    mutation businessTypeUpdate($_id: ID!, $businessTypeName: String, $isActive: String) {
  businessTypeUpdate(
    _id: $_id
    businessTypeName: $businessTypeName
    isActive: $isActive
  ) {
    code
    message
  }
}
    `;
export type BusinessTypeUpdateMutationFn = Apollo.MutationFunction<BusinessTypeUpdateMutation, BusinessTypeUpdateMutationVariables>;

/**
 * __useBusinessTypeUpdateMutation__
 *
 * To run a mutation, you first call `useBusinessTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessTypeUpdateMutation, { data, loading, error }] = useBusinessTypeUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      businessTypeName: // value for 'businessTypeName'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useBusinessTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BusinessTypeUpdateMutation, BusinessTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessTypeUpdateMutation, BusinessTypeUpdateMutationVariables>(BusinessTypeUpdateDocument, options);
      }
export type BusinessTypeUpdateMutationHookResult = ReturnType<typeof useBusinessTypeUpdateMutation>;
export type BusinessTypeUpdateMutationResult = Apollo.MutationResult<BusinessTypeUpdateMutation>;
export type BusinessTypeUpdateMutationOptions = Apollo.BaseMutationOptions<BusinessTypeUpdateMutation, BusinessTypeUpdateMutationVariables>;
export const BusinessTypeAddDocument = gql`
    mutation businessTypeAdd($businessTypeName: String!) {
  businessTypeAdd(input: {businessTypeName: $businessTypeName}) {
    code
    message
  }
}
    `;
export type BusinessTypeAddMutationFn = Apollo.MutationFunction<BusinessTypeAddMutation, BusinessTypeAddMutationVariables>;

/**
 * __useBusinessTypeAddMutation__
 *
 * To run a mutation, you first call `useBusinessTypeAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessTypeAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessTypeAddMutation, { data, loading, error }] = useBusinessTypeAddMutation({
 *   variables: {
 *      businessTypeName: // value for 'businessTypeName'
 *   },
 * });
 */
export function useBusinessTypeAddMutation(baseOptions?: Apollo.MutationHookOptions<BusinessTypeAddMutation, BusinessTypeAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessTypeAddMutation, BusinessTypeAddMutationVariables>(BusinessTypeAddDocument, options);
      }
export type BusinessTypeAddMutationHookResult = ReturnType<typeof useBusinessTypeAddMutation>;
export type BusinessTypeAddMutationResult = Apollo.MutationResult<BusinessTypeAddMutation>;
export type BusinessTypeAddMutationOptions = Apollo.BaseMutationOptions<BusinessTypeAddMutation, BusinessTypeAddMutationVariables>;
export const CategoryListPaginationDocument = gql`
    query CategoryListPagination($page: Float, $limit: Float) {
  categoryListPagination(page: $page, limit: $limit) {
    data {
      _id
      categoryName
      categoryLogos {
        original
        medium
        small
      }
      isActive
      categorySlug
      categoryBulkUploadInstructions
      bulkUploadSheetVersion
      cashDiscountPercentage
      comissionRate
      totalPopularStyleCodes
      totalOffers
      totalTopDeals
      totalExploreStyles
      totalBrandSections
    }
    totalRecords
  }
}
    `;

/**
 * __useCategoryListPaginationQuery__
 *
 * To run a query within a React component, call `useCategoryListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCategoryListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListPaginationQuery, CategoryListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListPaginationQuery, CategoryListPaginationQueryVariables>(CategoryListPaginationDocument, options);
      }
export function useCategoryListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListPaginationQuery, CategoryListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListPaginationQuery, CategoryListPaginationQueryVariables>(CategoryListPaginationDocument, options);
        }
export type CategoryListPaginationQueryHookResult = ReturnType<typeof useCategoryListPaginationQuery>;
export type CategoryListPaginationLazyQueryHookResult = ReturnType<typeof useCategoryListPaginationLazyQuery>;
export type CategoryListPaginationQueryResult = Apollo.QueryResult<CategoryListPaginationQuery, CategoryListPaginationQueryVariables>;
export const CategoryListDocument = gql`
    query CategoryList {
  categoryList {
    _id
    categoryName
    categorySlug
    cashDiscountPercentage
    comissionRate
    __typename
  }
}
    `;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<CategoryListQuery, CategoryListQueryVariables>;
export const CategoryDetailsDocument = gql`
    query categoryDetails($_id: ID!) {
  categoryDetails(_id: $_id) {
    _id
    categoryName
    categorySlug
    categoryLogo
    isActive
    comissionRate
    cashDiscountPercentage
    categoryBulkUploadInstructions
    __typename
  }
}
    `;

/**
 * __useCategoryDetailsQuery__
 *
 * To run a query within a React component, call `useCategoryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useCategoryDetailsQuery(baseOptions: Apollo.QueryHookOptions<CategoryDetailsQuery, CategoryDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryDetailsQuery, CategoryDetailsQueryVariables>(CategoryDetailsDocument, options);
      }
export function useCategoryDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryDetailsQuery, CategoryDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryDetailsQuery, CategoryDetailsQueryVariables>(CategoryDetailsDocument, options);
        }
export type CategoryDetailsQueryHookResult = ReturnType<typeof useCategoryDetailsQuery>;
export type CategoryDetailsLazyQueryHookResult = ReturnType<typeof useCategoryDetailsLazyQuery>;
export type CategoryDetailsQueryResult = Apollo.QueryResult<CategoryDetailsQuery, CategoryDetailsQueryVariables>;
export const CategoryAddDocument = gql`
    mutation categoryAdd($categoryLogo: String!, $categoryName: String!, $cashDiscountPercentage: Float!, $comissionRate: Float!, $categoryBulkUploadInstructions: String) {
  categoryAdd(
    input: {categoryLogo: $categoryLogo, categoryName: $categoryName, cashDiscountPercentage: $cashDiscountPercentage, comissionRate: $comissionRate, categoryBulkUploadInstructions: $categoryBulkUploadInstructions}
  ) {
    code
    message
  }
}
    `;
export type CategoryAddMutationFn = Apollo.MutationFunction<CategoryAddMutation, CategoryAddMutationVariables>;

/**
 * __useCategoryAddMutation__
 *
 * To run a mutation, you first call `useCategoryAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryAddMutation, { data, loading, error }] = useCategoryAddMutation({
 *   variables: {
 *      categoryLogo: // value for 'categoryLogo'
 *      categoryName: // value for 'categoryName'
 *      cashDiscountPercentage: // value for 'cashDiscountPercentage'
 *      comissionRate: // value for 'comissionRate'
 *      categoryBulkUploadInstructions: // value for 'categoryBulkUploadInstructions'
 *   },
 * });
 */
export function useCategoryAddMutation(baseOptions?: Apollo.MutationHookOptions<CategoryAddMutation, CategoryAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CategoryAddMutation, CategoryAddMutationVariables>(CategoryAddDocument, options);
      }
export type CategoryAddMutationHookResult = ReturnType<typeof useCategoryAddMutation>;
export type CategoryAddMutationResult = Apollo.MutationResult<CategoryAddMutation>;
export type CategoryAddMutationOptions = Apollo.BaseMutationOptions<CategoryAddMutation, CategoryAddMutationVariables>;
export const CategoryUpdateDocument = gql`
    mutation categoryUpdate($_id: ID!, $categoryName: String, $categoryLogo: String, $isActive: String, $comissionRate: Float, $cashDiscountPercentage: Float, $categoryBulkUploadInstructions: String) {
  categoryUpdate(
    _id: $_id
    categoryName: $categoryName
    categoryLogo: $categoryLogo
    isActive: $isActive
    cashDiscountPercentage: $cashDiscountPercentage
    comissionRate: $comissionRate
    categoryBulkUploadInstructions: $categoryBulkUploadInstructions
  ) {
    code
    message
  }
}
    `;
export type CategoryUpdateMutationFn = Apollo.MutationFunction<CategoryUpdateMutation, CategoryUpdateMutationVariables>;

/**
 * __useCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryUpdateMutation, { data, loading, error }] = useCategoryUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      categoryName: // value for 'categoryName'
 *      categoryLogo: // value for 'categoryLogo'
 *      isActive: // value for 'isActive'
 *      comissionRate: // value for 'comissionRate'
 *      cashDiscountPercentage: // value for 'cashDiscountPercentage'
 *      categoryBulkUploadInstructions: // value for 'categoryBulkUploadInstructions'
 *   },
 * });
 */
export function useCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CategoryUpdateMutation, CategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CategoryUpdateMutation, CategoryUpdateMutationVariables>(CategoryUpdateDocument, options);
      }
export type CategoryUpdateMutationHookResult = ReturnType<typeof useCategoryUpdateMutation>;
export type CategoryUpdateMutationResult = Apollo.MutationResult<CategoryUpdateMutation>;
export type CategoryUpdateMutationOptions = Apollo.BaseMutationOptions<CategoryUpdateMutation, CategoryUpdateMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation deleteCategory($_id: ID!) {
  deleteCategory(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const SubCategoryAddDocument = gql`
    mutation SubCategoryAdd($input: SubCategoryCreateInput!) {
  subCategoryAdd(input: $input) {
    code
    message
  }
}
    `;
export type SubCategoryAddMutationFn = Apollo.MutationFunction<SubCategoryAddMutation, SubCategoryAddMutationVariables>;

/**
 * __useSubCategoryAddMutation__
 *
 * To run a mutation, you first call `useSubCategoryAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubCategoryAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subCategoryAddMutation, { data, loading, error }] = useSubCategoryAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubCategoryAddMutation(baseOptions?: Apollo.MutationHookOptions<SubCategoryAddMutation, SubCategoryAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubCategoryAddMutation, SubCategoryAddMutationVariables>(SubCategoryAddDocument, options);
      }
export type SubCategoryAddMutationHookResult = ReturnType<typeof useSubCategoryAddMutation>;
export type SubCategoryAddMutationResult = Apollo.MutationResult<SubCategoryAddMutation>;
export type SubCategoryAddMutationOptions = Apollo.BaseMutationOptions<SubCategoryAddMutation, SubCategoryAddMutationVariables>;
export const SubCategoryUpdateDocument = gql`
    mutation SubCategoryUpdate($id: ID!, $subCategoryName: String!, $categoryId: String!, $subCategoryLevel: Float!, $subCategoryImage: String, $subCategoryTabImage: String, $parentSubCategoryId: String) {
  subCategoryUpdate(
    _id: $id
    subCategoryName: $subCategoryName
    categoryId: $categoryId
    subCategoryLevel: $subCategoryLevel
    subCategoryImage: $subCategoryImage
    subCategoryTabImage: $subCategoryTabImage
    parentSubCategoryId: $parentSubCategoryId
  ) {
    code
    message
  }
}
    `;
export type SubCategoryUpdateMutationFn = Apollo.MutationFunction<SubCategoryUpdateMutation, SubCategoryUpdateMutationVariables>;

/**
 * __useSubCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useSubCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subCategoryUpdateMutation, { data, loading, error }] = useSubCategoryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      subCategoryName: // value for 'subCategoryName'
 *      categoryId: // value for 'categoryId'
 *      subCategoryLevel: // value for 'subCategoryLevel'
 *      subCategoryImage: // value for 'subCategoryImage'
 *      subCategoryTabImage: // value for 'subCategoryTabImage'
 *      parentSubCategoryId: // value for 'parentSubCategoryId'
 *   },
 * });
 */
export function useSubCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SubCategoryUpdateMutation, SubCategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubCategoryUpdateMutation, SubCategoryUpdateMutationVariables>(SubCategoryUpdateDocument, options);
      }
export type SubCategoryUpdateMutationHookResult = ReturnType<typeof useSubCategoryUpdateMutation>;
export type SubCategoryUpdateMutationResult = Apollo.MutationResult<SubCategoryUpdateMutation>;
export type SubCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<SubCategoryUpdateMutation, SubCategoryUpdateMutationVariables>;
export const SubCategoryListDocument = gql`
    query subCategoryList($categoryId: ID, $parentSubCategoryId: ID) {
  subCategoryListCms(
    categoryId: $categoryId
    parentSubCategoryId: $parentSubCategoryId
  ) {
    _id
    subCategoryName
    subCategoryImage
    subCategoryTabImage
    categoryId
    parentSubCategoryId
    subCategoryLevel
    isActive
    childSubCategories {
      _id
      subCategoryName
      subCategoryImage
      categoryId
      parentSubCategoryId
      subCategoryLevel
      isActive
      childSubCategories {
        _id
        subCategoryName
        subCategoryImage
        categoryId
        parentSubCategoryId
        subCategoryLevel
        isActive
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useSubCategoryListQuery__
 *
 * To run a query within a React component, call `useSubCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubCategoryListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      parentSubCategoryId: // value for 'parentSubCategoryId'
 *   },
 * });
 */
export function useSubCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<SubCategoryListQuery, SubCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubCategoryListQuery, SubCategoryListQueryVariables>(SubCategoryListDocument, options);
      }
export function useSubCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubCategoryListQuery, SubCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubCategoryListQuery, SubCategoryListQueryVariables>(SubCategoryListDocument, options);
        }
export type SubCategoryListQueryHookResult = ReturnType<typeof useSubCategoryListQuery>;
export type SubCategoryListLazyQueryHookResult = ReturnType<typeof useSubCategoryListLazyQuery>;
export type SubCategoryListQueryResult = Apollo.QueryResult<SubCategoryListQuery, SubCategoryListQueryVariables>;
export const NewSubCategoryListCmsDocument = gql`
    query newSubCategoryListCms($categoryId: ID, $parentSubCategoryId: ID) {
  newSubCategoryListCms(
    categoryId: $categoryId
    parentSubCategoryId: $parentSubCategoryId
  ) {
    _id
    subCategoryName
    subCategoryImage
    subCategoryTabImage
    categoryId
    parentSubCategoryId
    subCategoryLevel
    isActive
    childSubCategories {
      _id
      subCategoryName
      subCategoryImage
      categoryId
      parentSubCategoryId
      subCategoryLevel
      isActive
      childSubCategories {
        _id
        subCategoryName
        subCategoryImage
        categoryId
        parentSubCategoryId
        subCategoryLevel
        isActive
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useNewSubCategoryListCmsQuery__
 *
 * To run a query within a React component, call `useNewSubCategoryListCmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewSubCategoryListCmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewSubCategoryListCmsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      parentSubCategoryId: // value for 'parentSubCategoryId'
 *   },
 * });
 */
export function useNewSubCategoryListCmsQuery(baseOptions?: Apollo.QueryHookOptions<NewSubCategoryListCmsQuery, NewSubCategoryListCmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewSubCategoryListCmsQuery, NewSubCategoryListCmsQueryVariables>(NewSubCategoryListCmsDocument, options);
      }
export function useNewSubCategoryListCmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewSubCategoryListCmsQuery, NewSubCategoryListCmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewSubCategoryListCmsQuery, NewSubCategoryListCmsQueryVariables>(NewSubCategoryListCmsDocument, options);
        }
export type NewSubCategoryListCmsQueryHookResult = ReturnType<typeof useNewSubCategoryListCmsQuery>;
export type NewSubCategoryListCmsLazyQueryHookResult = ReturnType<typeof useNewSubCategoryListCmsLazyQuery>;
export type NewSubCategoryListCmsQueryResult = Apollo.QueryResult<NewSubCategoryListCmsQuery, NewSubCategoryListCmsQueryVariables>;
export const DeleteSubCategoryDocument = gql`
    mutation deleteSubCategory($_id: ID!) {
  deleteSubCategory(_id: $_id) {
    code
    message
    __typename
  }
}
    `;
export type DeleteSubCategoryMutationFn = Apollo.MutationFunction<DeleteSubCategoryMutation, DeleteSubCategoryMutationVariables>;

/**
 * __useDeleteSubCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubCategoryMutation, { data, loading, error }] = useDeleteSubCategoryMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubCategoryMutation, DeleteSubCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubCategoryMutation, DeleteSubCategoryMutationVariables>(DeleteSubCategoryDocument, options);
      }
export type DeleteSubCategoryMutationHookResult = ReturnType<typeof useDeleteSubCategoryMutation>;
export type DeleteSubCategoryMutationResult = Apollo.MutationResult<DeleteSubCategoryMutation>;
export type DeleteSubCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteSubCategoryMutation, DeleteSubCategoryMutationVariables>;
export const SubCategoryListBySearchDocument = gql`
    query subCategoryListBySearch($categoryId: ID!, $search: String) {
  subCategoryListBySearch(categoryId: $categoryId, search: $search) {
    _id
    parentSubCategoryId
    parentSubCategoryName
    __typename
  }
}
    `;

/**
 * __useSubCategoryListBySearchQuery__
 *
 * To run a query within a React component, call `useSubCategoryListBySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubCategoryListBySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubCategoryListBySearchQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSubCategoryListBySearchQuery(baseOptions: Apollo.QueryHookOptions<SubCategoryListBySearchQuery, SubCategoryListBySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubCategoryListBySearchQuery, SubCategoryListBySearchQueryVariables>(SubCategoryListBySearchDocument, options);
      }
export function useSubCategoryListBySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubCategoryListBySearchQuery, SubCategoryListBySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubCategoryListBySearchQuery, SubCategoryListBySearchQueryVariables>(SubCategoryListBySearchDocument, options);
        }
export type SubCategoryListBySearchQueryHookResult = ReturnType<typeof useSubCategoryListBySearchQuery>;
export type SubCategoryListBySearchLazyQueryHookResult = ReturnType<typeof useSubCategoryListBySearchLazyQuery>;
export type SubCategoryListBySearchQueryResult = Apollo.QueryResult<SubCategoryListBySearchQuery, SubCategoryListBySearchQueryVariables>;
export const ActiveInActiveSubCategoryDocument = gql`
    mutation ActiveInActiveSubCategory($id: ID!, $isActive: String!) {
  activeInActiveSubCategory(_id: $id, isActive: $isActive) {
    code
    message
  }
}
    `;
export type ActiveInActiveSubCategoryMutationFn = Apollo.MutationFunction<ActiveInActiveSubCategoryMutation, ActiveInActiveSubCategoryMutationVariables>;

/**
 * __useActiveInActiveSubCategoryMutation__
 *
 * To run a mutation, you first call `useActiveInActiveSubCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveInActiveSubCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeInActiveSubCategoryMutation, { data, loading, error }] = useActiveInActiveSubCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useActiveInActiveSubCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ActiveInActiveSubCategoryMutation, ActiveInActiveSubCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveInActiveSubCategoryMutation, ActiveInActiveSubCategoryMutationVariables>(ActiveInActiveSubCategoryDocument, options);
      }
export type ActiveInActiveSubCategoryMutationHookResult = ReturnType<typeof useActiveInActiveSubCategoryMutation>;
export type ActiveInActiveSubCategoryMutationResult = Apollo.MutationResult<ActiveInActiveSubCategoryMutation>;
export type ActiveInActiveSubCategoryMutationOptions = Apollo.BaseMutationOptions<ActiveInActiveSubCategoryMutation, ActiveInActiveSubCategoryMutationVariables>;
export const ProductListingGuidelineAddEditDocument = gql`
    mutation ProductListingGuidelineAddEdit($input: ProductListingGuidelineAddEditInput!) {
  productListingGuidelineAddEdit(input: $input) {
    code
    message
  }
}
    `;
export type ProductListingGuidelineAddEditMutationFn = Apollo.MutationFunction<ProductListingGuidelineAddEditMutation, ProductListingGuidelineAddEditMutationVariables>;

/**
 * __useProductListingGuidelineAddEditMutation__
 *
 * To run a mutation, you first call `useProductListingGuidelineAddEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductListingGuidelineAddEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productListingGuidelineAddEditMutation, { data, loading, error }] = useProductListingGuidelineAddEditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductListingGuidelineAddEditMutation(baseOptions?: Apollo.MutationHookOptions<ProductListingGuidelineAddEditMutation, ProductListingGuidelineAddEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductListingGuidelineAddEditMutation, ProductListingGuidelineAddEditMutationVariables>(ProductListingGuidelineAddEditDocument, options);
      }
export type ProductListingGuidelineAddEditMutationHookResult = ReturnType<typeof useProductListingGuidelineAddEditMutation>;
export type ProductListingGuidelineAddEditMutationResult = Apollo.MutationResult<ProductListingGuidelineAddEditMutation>;
export type ProductListingGuidelineAddEditMutationOptions = Apollo.BaseMutationOptions<ProductListingGuidelineAddEditMutation, ProductListingGuidelineAddEditMutationVariables>;
export const ProductListingGuidelineDetailsDocument = gql`
    query ProductListingGuidelineDetails($subCategoryId: ID, $categoryId: ID) {
  productListingGuidelineDetails(
    subCategoryId: $subCategoryId
    categoryId: $categoryId
  ) {
    categoryId
    subCategoryId
    guidelineDocument
    guidelineDocumentType
  }
}
    `;

/**
 * __useProductListingGuidelineDetailsQuery__
 *
 * To run a query within a React component, call `useProductListingGuidelineDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListingGuidelineDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListingGuidelineDetailsQuery({
 *   variables: {
 *      subCategoryId: // value for 'subCategoryId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useProductListingGuidelineDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ProductListingGuidelineDetailsQuery, ProductListingGuidelineDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListingGuidelineDetailsQuery, ProductListingGuidelineDetailsQueryVariables>(ProductListingGuidelineDetailsDocument, options);
      }
export function useProductListingGuidelineDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListingGuidelineDetailsQuery, ProductListingGuidelineDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListingGuidelineDetailsQuery, ProductListingGuidelineDetailsQueryVariables>(ProductListingGuidelineDetailsDocument, options);
        }
export type ProductListingGuidelineDetailsQueryHookResult = ReturnType<typeof useProductListingGuidelineDetailsQuery>;
export type ProductListingGuidelineDetailsLazyQueryHookResult = ReturnType<typeof useProductListingGuidelineDetailsLazyQuery>;
export type ProductListingGuidelineDetailsQueryResult = Apollo.QueryResult<ProductListingGuidelineDetailsQuery, ProductListingGuidelineDetailsQueryVariables>;
export const SeoContentAddEditDocument = gql`
    mutation SeoContentAddEdit($input: SeoContentInput!) {
  seoContentAddEdit(input: $input) {
    code
    message
  }
}
    `;
export type SeoContentAddEditMutationFn = Apollo.MutationFunction<SeoContentAddEditMutation, SeoContentAddEditMutationVariables>;

/**
 * __useSeoContentAddEditMutation__
 *
 * To run a mutation, you first call `useSeoContentAddEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeoContentAddEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seoContentAddEditMutation, { data, loading, error }] = useSeoContentAddEditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSeoContentAddEditMutation(baseOptions?: Apollo.MutationHookOptions<SeoContentAddEditMutation, SeoContentAddEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeoContentAddEditMutation, SeoContentAddEditMutationVariables>(SeoContentAddEditDocument, options);
      }
export type SeoContentAddEditMutationHookResult = ReturnType<typeof useSeoContentAddEditMutation>;
export type SeoContentAddEditMutationResult = Apollo.MutationResult<SeoContentAddEditMutation>;
export type SeoContentAddEditMutationOptions = Apollo.BaseMutationOptions<SeoContentAddEditMutation, SeoContentAddEditMutationVariables>;
export const SeoContentDetailsDocument = gql`
    query SeoContentDetails($categoryId: String!, $subCategoryId: String!) {
  seoContentDetails(categoryId: $categoryId, subCategoryId: $subCategoryId) {
    _id
    categoryId
    subCategoryId
    seoContent
  }
}
    `;

/**
 * __useSeoContentDetailsQuery__
 *
 * To run a query within a React component, call `useSeoContentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoContentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoContentDetailsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      subCategoryId: // value for 'subCategoryId'
 *   },
 * });
 */
export function useSeoContentDetailsQuery(baseOptions: Apollo.QueryHookOptions<SeoContentDetailsQuery, SeoContentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeoContentDetailsQuery, SeoContentDetailsQueryVariables>(SeoContentDetailsDocument, options);
      }
export function useSeoContentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeoContentDetailsQuery, SeoContentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeoContentDetailsQuery, SeoContentDetailsQueryVariables>(SeoContentDetailsDocument, options);
        }
export type SeoContentDetailsQueryHookResult = ReturnType<typeof useSeoContentDetailsQuery>;
export type SeoContentDetailsLazyQueryHookResult = ReturnType<typeof useSeoContentDetailsLazyQuery>;
export type SeoContentDetailsQueryResult = Apollo.QueryResult<SeoContentDetailsQuery, SeoContentDetailsQueryVariables>;
export const DeleteCategoryReturnPolicyDocument = gql`
    mutation DeleteCategoryReturnPolicy($categoryId: ID!) {
  deleteCategoryReturnPolicy(categoryId: $categoryId) {
    code
    message
  }
}
    `;
export type DeleteCategoryReturnPolicyMutationFn = Apollo.MutationFunction<DeleteCategoryReturnPolicyMutation, DeleteCategoryReturnPolicyMutationVariables>;

/**
 * __useDeleteCategoryReturnPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryReturnPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryReturnPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryReturnPolicyMutation, { data, loading, error }] = useDeleteCategoryReturnPolicyMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteCategoryReturnPolicyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryReturnPolicyMutation, DeleteCategoryReturnPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryReturnPolicyMutation, DeleteCategoryReturnPolicyMutationVariables>(DeleteCategoryReturnPolicyDocument, options);
      }
export type DeleteCategoryReturnPolicyMutationHookResult = ReturnType<typeof useDeleteCategoryReturnPolicyMutation>;
export type DeleteCategoryReturnPolicyMutationResult = Apollo.MutationResult<DeleteCategoryReturnPolicyMutation>;
export type DeleteCategoryReturnPolicyMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryReturnPolicyMutation, DeleteCategoryReturnPolicyMutationVariables>;
export const GetCategoryReturnPolicyListDocument = gql`
    query GetCategoryReturnPolicyList($page: Float!, $limit: Float!) {
  getCategoryReturnPolicyList(page: $page, limit: $limit) {
    data {
      _id
      categoryId
      title
      description
      categoryDetails {
        _id
        categoryName
        categoryLogos {
          original
          medium
          small
        }
        isActive
        categorySlug
      }
      days
    }
    totalRecords
  }
}
    `;

/**
 * __useGetCategoryReturnPolicyListQuery__
 *
 * To run a query within a React component, call `useGetCategoryReturnPolicyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryReturnPolicyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryReturnPolicyListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCategoryReturnPolicyListQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryReturnPolicyListQuery, GetCategoryReturnPolicyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryReturnPolicyListQuery, GetCategoryReturnPolicyListQueryVariables>(GetCategoryReturnPolicyListDocument, options);
      }
export function useGetCategoryReturnPolicyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryReturnPolicyListQuery, GetCategoryReturnPolicyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryReturnPolicyListQuery, GetCategoryReturnPolicyListQueryVariables>(GetCategoryReturnPolicyListDocument, options);
        }
export type GetCategoryReturnPolicyListQueryHookResult = ReturnType<typeof useGetCategoryReturnPolicyListQuery>;
export type GetCategoryReturnPolicyListLazyQueryHookResult = ReturnType<typeof useGetCategoryReturnPolicyListLazyQuery>;
export type GetCategoryReturnPolicyListQueryResult = Apollo.QueryResult<GetCategoryReturnPolicyListQuery, GetCategoryReturnPolicyListQueryVariables>;
export const AddUpdateCategoryReturnPolicyDocument = gql`
    mutation AddUpdateCategoryReturnPolicy($title: String!, $description: String!, $categoryReturnPolicySlug: String!, $categoryId: ID, $id: ID, $days: Float!) {
  addUpdateCategoryReturnPolicy(
    title: $title
    description: $description
    categoryReturnPolicySlug: $categoryReturnPolicySlug
    categoryId: $categoryId
    _id: $id
    days: $days
  ) {
    code
    message
  }
}
    `;
export type AddUpdateCategoryReturnPolicyMutationFn = Apollo.MutationFunction<AddUpdateCategoryReturnPolicyMutation, AddUpdateCategoryReturnPolicyMutationVariables>;

/**
 * __useAddUpdateCategoryReturnPolicyMutation__
 *
 * To run a mutation, you first call `useAddUpdateCategoryReturnPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateCategoryReturnPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateCategoryReturnPolicyMutation, { data, loading, error }] = useAddUpdateCategoryReturnPolicyMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      categoryReturnPolicySlug: // value for 'categoryReturnPolicySlug'
 *      categoryId: // value for 'categoryId'
 *      id: // value for 'id'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useAddUpdateCategoryReturnPolicyMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateCategoryReturnPolicyMutation, AddUpdateCategoryReturnPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateCategoryReturnPolicyMutation, AddUpdateCategoryReturnPolicyMutationVariables>(AddUpdateCategoryReturnPolicyDocument, options);
      }
export type AddUpdateCategoryReturnPolicyMutationHookResult = ReturnType<typeof useAddUpdateCategoryReturnPolicyMutation>;
export type AddUpdateCategoryReturnPolicyMutationResult = Apollo.MutationResult<AddUpdateCategoryReturnPolicyMutation>;
export type AddUpdateCategoryReturnPolicyMutationOptions = Apollo.BaseMutationOptions<AddUpdateCategoryReturnPolicyMutation, AddUpdateCategoryReturnPolicyMutationVariables>;
export const GetReturnPolicyCategoryByIdDocument = gql`
    query GetReturnPolicyCategoryById($categoryId: ID!) {
  getReturnPolicyCategoryById(categoryId: $categoryId) {
    _id
    categoryId
    title
    description
    categoryDetails {
      _id
      categoryLogos {
        medium
        original
        small
      }
      categoryName
      categorySlug
      isActive
    }
    days
  }
}
    `;

/**
 * __useGetReturnPolicyCategoryByIdQuery__
 *
 * To run a query within a React component, call `useGetReturnPolicyCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnPolicyCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnPolicyCategoryByIdQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetReturnPolicyCategoryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetReturnPolicyCategoryByIdQuery, GetReturnPolicyCategoryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnPolicyCategoryByIdQuery, GetReturnPolicyCategoryByIdQueryVariables>(GetReturnPolicyCategoryByIdDocument, options);
      }
export function useGetReturnPolicyCategoryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnPolicyCategoryByIdQuery, GetReturnPolicyCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnPolicyCategoryByIdQuery, GetReturnPolicyCategoryByIdQueryVariables>(GetReturnPolicyCategoryByIdDocument, options);
        }
export type GetReturnPolicyCategoryByIdQueryHookResult = ReturnType<typeof useGetReturnPolicyCategoryByIdQuery>;
export type GetReturnPolicyCategoryByIdLazyQueryHookResult = ReturnType<typeof useGetReturnPolicyCategoryByIdLazyQuery>;
export type GetReturnPolicyCategoryByIdQueryResult = Apollo.QueryResult<GetReturnPolicyCategoryByIdQuery, GetReturnPolicyCategoryByIdQueryVariables>;
export const ColorListPaginationDocument = gql`
    query ColorListPagination($page: Float, $limit: Float, $search: String) {
  colorListPagination(page: $page, limit: $limit, search: $search) {
    data {
      _id
      colorCode
      colorName
      isActive
      isMultiColor
      multiColorImage
    }
    totalRecords
  }
}
    `;

/**
 * __useColorListPaginationQuery__
 *
 * To run a query within a React component, call `useColorListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorListPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useColorListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<ColorListPaginationQuery, ColorListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColorListPaginationQuery, ColorListPaginationQueryVariables>(ColorListPaginationDocument, options);
      }
export function useColorListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColorListPaginationQuery, ColorListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColorListPaginationQuery, ColorListPaginationQueryVariables>(ColorListPaginationDocument, options);
        }
export type ColorListPaginationQueryHookResult = ReturnType<typeof useColorListPaginationQuery>;
export type ColorListPaginationLazyQueryHookResult = ReturnType<typeof useColorListPaginationLazyQuery>;
export type ColorListPaginationQueryResult = Apollo.QueryResult<ColorListPaginationQuery, ColorListPaginationQueryVariables>;
export const ColorDetailsDocument = gql`
    query ColorDetails($id: ID!) {
  colorDetails(_id: $id) {
    _id
    colorCode
    colorName
    isActive
    isMultiColor
    multiColorImage
  }
}
    `;

/**
 * __useColorDetailsQuery__
 *
 * To run a query within a React component, call `useColorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useColorDetailsQuery(baseOptions: Apollo.QueryHookOptions<ColorDetailsQuery, ColorDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColorDetailsQuery, ColorDetailsQueryVariables>(ColorDetailsDocument, options);
      }
export function useColorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColorDetailsQuery, ColorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColorDetailsQuery, ColorDetailsQueryVariables>(ColorDetailsDocument, options);
        }
export type ColorDetailsQueryHookResult = ReturnType<typeof useColorDetailsQuery>;
export type ColorDetailsLazyQueryHookResult = ReturnType<typeof useColorDetailsLazyQuery>;
export type ColorDetailsQueryResult = Apollo.QueryResult<ColorDetailsQuery, ColorDetailsQueryVariables>;
export const ColorAddDocument = gql`
    mutation ColorAdd($input: ColorCreateInput!) {
  colorAdd(input: $input) {
    code
    message
  }
}
    `;
export type ColorAddMutationFn = Apollo.MutationFunction<ColorAddMutation, ColorAddMutationVariables>;

/**
 * __useColorAddMutation__
 *
 * To run a mutation, you first call `useColorAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useColorAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [colorAddMutation, { data, loading, error }] = useColorAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useColorAddMutation(baseOptions?: Apollo.MutationHookOptions<ColorAddMutation, ColorAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ColorAddMutation, ColorAddMutationVariables>(ColorAddDocument, options);
      }
export type ColorAddMutationHookResult = ReturnType<typeof useColorAddMutation>;
export type ColorAddMutationResult = Apollo.MutationResult<ColorAddMutation>;
export type ColorAddMutationOptions = Apollo.BaseMutationOptions<ColorAddMutation, ColorAddMutationVariables>;
export const ColorUpdateDocument = gql`
    mutation ColorUpdate($id: ID!, $colorCode: String, $colorName: String, $isActive: String, $isMultiColor: Boolean, $multiColorImage: String) {
  colorUpdate(
    _id: $id
    colorCode: $colorCode
    colorName: $colorName
    isActive: $isActive
    isMultiColor: $isMultiColor
    multiColorImage: $multiColorImage
  ) {
    code
    message
  }
}
    `;
export type ColorUpdateMutationFn = Apollo.MutationFunction<ColorUpdateMutation, ColorUpdateMutationVariables>;

/**
 * __useColorUpdateMutation__
 *
 * To run a mutation, you first call `useColorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useColorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [colorUpdateMutation, { data, loading, error }] = useColorUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      colorCode: // value for 'colorCode'
 *      colorName: // value for 'colorName'
 *      isActive: // value for 'isActive'
 *      isMultiColor: // value for 'isMultiColor'
 *      multiColorImage: // value for 'multiColorImage'
 *   },
 * });
 */
export function useColorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ColorUpdateMutation, ColorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ColorUpdateMutation, ColorUpdateMutationVariables>(ColorUpdateDocument, options);
      }
export type ColorUpdateMutationHookResult = ReturnType<typeof useColorUpdateMutation>;
export type ColorUpdateMutationResult = Apollo.MutationResult<ColorUpdateMutation>;
export type ColorUpdateMutationOptions = Apollo.BaseMutationOptions<ColorUpdateMutation, ColorUpdateMutationVariables>;
export const DeleteColorDocument = gql`
    mutation deleteColor($_id: ID!) {
  deleteColor(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteColorMutationFn = Apollo.MutationFunction<DeleteColorMutation, DeleteColorMutationVariables>;

/**
 * __useDeleteColorMutation__
 *
 * To run a mutation, you first call `useDeleteColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteColorMutation, { data, loading, error }] = useDeleteColorMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteColorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteColorMutation, DeleteColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteColorMutation, DeleteColorMutationVariables>(DeleteColorDocument, options);
      }
export type DeleteColorMutationHookResult = ReturnType<typeof useDeleteColorMutation>;
export type DeleteColorMutationResult = Apollo.MutationResult<DeleteColorMutation>;
export type DeleteColorMutationOptions = Apollo.BaseMutationOptions<DeleteColorMutation, DeleteColorMutationVariables>;
export const DashboardListDocument = gql`
    query dashboardList($roleId: ID!) {
  dashboardList(roleId: $roleId) {
    moduleId
    moduleName
    moduleSlug
    count
  }
}
    `;

/**
 * __useDashboardListQuery__
 *
 * To run a query within a React component, call `useDashboardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDashboardListQuery(baseOptions: Apollo.QueryHookOptions<DashboardListQuery, DashboardListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardListQuery, DashboardListQueryVariables>(DashboardListDocument, options);
      }
export function useDashboardListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardListQuery, DashboardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardListQuery, DashboardListQueryVariables>(DashboardListDocument, options);
        }
export type DashboardListQueryHookResult = ReturnType<typeof useDashboardListQuery>;
export type DashboardListLazyQueryHookResult = ReturnType<typeof useDashboardListLazyQuery>;
export type DashboardListQueryResult = Apollo.QueryResult<DashboardListQuery, DashboardListQueryVariables>;
export const DeleteContentImageDocument = gql`
    mutation deleteContentImage($contentImageName: String!) {
  deleteStaticPageContentImages(contentImageName: $contentImageName) {
    code
    message
    __typename
  }
}
    `;
export type DeleteContentImageMutationFn = Apollo.MutationFunction<DeleteContentImageMutation, DeleteContentImageMutationVariables>;

/**
 * __useDeleteContentImageMutation__
 *
 * To run a mutation, you first call `useDeleteContentImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentImageMutation, { data, loading, error }] = useDeleteContentImageMutation({
 *   variables: {
 *      contentImageName: // value for 'contentImageName'
 *   },
 * });
 */
export function useDeleteContentImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentImageMutation, DeleteContentImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentImageMutation, DeleteContentImageMutationVariables>(DeleteContentImageDocument, options);
      }
export type DeleteContentImageMutationHookResult = ReturnType<typeof useDeleteContentImageMutation>;
export type DeleteContentImageMutationResult = Apollo.MutationResult<DeleteContentImageMutation>;
export type DeleteContentImageMutationOptions = Apollo.BaseMutationOptions<DeleteContentImageMutation, DeleteContentImageMutationVariables>;
export const DesignationListPaginationDocument = gql`
    query designationListPagination($search: String, $page: Float, $limit: Float) {
  designationListPagination(search: $search, page: $page, limit: $limit) {
    data {
      _id
      designationName
      isActive
      __typename
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useDesignationListPaginationQuery__
 *
 * To run a query within a React component, call `useDesignationListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignationListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignationListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDesignationListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<DesignationListPaginationQuery, DesignationListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignationListPaginationQuery, DesignationListPaginationQueryVariables>(DesignationListPaginationDocument, options);
      }
export function useDesignationListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignationListPaginationQuery, DesignationListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignationListPaginationQuery, DesignationListPaginationQueryVariables>(DesignationListPaginationDocument, options);
        }
export type DesignationListPaginationQueryHookResult = ReturnType<typeof useDesignationListPaginationQuery>;
export type DesignationListPaginationLazyQueryHookResult = ReturnType<typeof useDesignationListPaginationLazyQuery>;
export type DesignationListPaginationQueryResult = Apollo.QueryResult<DesignationListPaginationQuery, DesignationListPaginationQueryVariables>;
export const DesignationDetailsDocument = gql`
    query designationDetails($_id: ID!) {
  designationDetails(_id: $_id) {
    _id
    designationName
    isActive
    __typename
  }
}
    `;

/**
 * __useDesignationDetailsQuery__
 *
 * To run a query within a React component, call `useDesignationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignationDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDesignationDetailsQuery(baseOptions: Apollo.QueryHookOptions<DesignationDetailsQuery, DesignationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignationDetailsQuery, DesignationDetailsQueryVariables>(DesignationDetailsDocument, options);
      }
export function useDesignationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignationDetailsQuery, DesignationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignationDetailsQuery, DesignationDetailsQueryVariables>(DesignationDetailsDocument, options);
        }
export type DesignationDetailsQueryHookResult = ReturnType<typeof useDesignationDetailsQuery>;
export type DesignationDetailsLazyQueryHookResult = ReturnType<typeof useDesignationDetailsLazyQuery>;
export type DesignationDetailsQueryResult = Apollo.QueryResult<DesignationDetailsQuery, DesignationDetailsQueryVariables>;
export const DesignationListDocument = gql`
    query designationList {
  designationList {
    _id
    designationName
    isActive
    __typename
  }
}
    `;

/**
 * __useDesignationListQuery__
 *
 * To run a query within a React component, call `useDesignationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignationListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDesignationListQuery(baseOptions?: Apollo.QueryHookOptions<DesignationListQuery, DesignationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignationListQuery, DesignationListQueryVariables>(DesignationListDocument, options);
      }
export function useDesignationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignationListQuery, DesignationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignationListQuery, DesignationListQueryVariables>(DesignationListDocument, options);
        }
export type DesignationListQueryHookResult = ReturnType<typeof useDesignationListQuery>;
export type DesignationListLazyQueryHookResult = ReturnType<typeof useDesignationListLazyQuery>;
export type DesignationListQueryResult = Apollo.QueryResult<DesignationListQuery, DesignationListQueryVariables>;
export const DeleteDesignationDocument = gql`
    mutation deleteDesignation($_id: ID!) {
  deleteDesignation(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteDesignationMutationFn = Apollo.MutationFunction<DeleteDesignationMutation, DeleteDesignationMutationVariables>;

/**
 * __useDeleteDesignationMutation__
 *
 * To run a mutation, you first call `useDeleteDesignationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDesignationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDesignationMutation, { data, loading, error }] = useDeleteDesignationMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteDesignationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDesignationMutation, DeleteDesignationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDesignationMutation, DeleteDesignationMutationVariables>(DeleteDesignationDocument, options);
      }
export type DeleteDesignationMutationHookResult = ReturnType<typeof useDeleteDesignationMutation>;
export type DeleteDesignationMutationResult = Apollo.MutationResult<DeleteDesignationMutation>;
export type DeleteDesignationMutationOptions = Apollo.BaseMutationOptions<DeleteDesignationMutation, DeleteDesignationMutationVariables>;
export const DesignationUpdateDocument = gql`
    mutation designationUpdate($_id: ID!, $designationName: String, $isActive: String) {
  designationUpdate(
    _id: $_id
    designationName: $designationName
    isActive: $isActive
  ) {
    code
    message
  }
}
    `;
export type DesignationUpdateMutationFn = Apollo.MutationFunction<DesignationUpdateMutation, DesignationUpdateMutationVariables>;

/**
 * __useDesignationUpdateMutation__
 *
 * To run a mutation, you first call `useDesignationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designationUpdateMutation, { data, loading, error }] = useDesignationUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      designationName: // value for 'designationName'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useDesignationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DesignationUpdateMutation, DesignationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DesignationUpdateMutation, DesignationUpdateMutationVariables>(DesignationUpdateDocument, options);
      }
export type DesignationUpdateMutationHookResult = ReturnType<typeof useDesignationUpdateMutation>;
export type DesignationUpdateMutationResult = Apollo.MutationResult<DesignationUpdateMutation>;
export type DesignationUpdateMutationOptions = Apollo.BaseMutationOptions<DesignationUpdateMutation, DesignationUpdateMutationVariables>;
export const DesignationAddDocument = gql`
    mutation designationAdd($designationName: String!) {
  designationAdd(input: {designationName: $designationName}) {
    code
    message
  }
}
    `;
export type DesignationAddMutationFn = Apollo.MutationFunction<DesignationAddMutation, DesignationAddMutationVariables>;

/**
 * __useDesignationAddMutation__
 *
 * To run a mutation, you first call `useDesignationAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignationAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designationAddMutation, { data, loading, error }] = useDesignationAddMutation({
 *   variables: {
 *      designationName: // value for 'designationName'
 *   },
 * });
 */
export function useDesignationAddMutation(baseOptions?: Apollo.MutationHookOptions<DesignationAddMutation, DesignationAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DesignationAddMutation, DesignationAddMutationVariables>(DesignationAddDocument, options);
      }
export type DesignationAddMutationHookResult = ReturnType<typeof useDesignationAddMutation>;
export type DesignationAddMutationResult = Apollo.MutationResult<DesignationAddMutation>;
export type DesignationAddMutationOptions = Apollo.BaseMutationOptions<DesignationAddMutation, DesignationAddMutationVariables>;
export const ExploreStylesListDocument = gql`
    query ExploreStylesList($categoryId: ID) {
  exploreStylesList(categoryId: $categoryId) {
    _id
    image
    categoryId
    subCategoryId
    categoryName
    categorySlug
    subCategoryName
  }
}
    `;

/**
 * __useExploreStylesListQuery__
 *
 * To run a query within a React component, call `useExploreStylesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreStylesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreStylesListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useExploreStylesListQuery(baseOptions?: Apollo.QueryHookOptions<ExploreStylesListQuery, ExploreStylesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExploreStylesListQuery, ExploreStylesListQueryVariables>(ExploreStylesListDocument, options);
      }
export function useExploreStylesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExploreStylesListQuery, ExploreStylesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExploreStylesListQuery, ExploreStylesListQueryVariables>(ExploreStylesListDocument, options);
        }
export type ExploreStylesListQueryHookResult = ReturnType<typeof useExploreStylesListQuery>;
export type ExploreStylesListLazyQueryHookResult = ReturnType<typeof useExploreStylesListLazyQuery>;
export type ExploreStylesListQueryResult = Apollo.QueryResult<ExploreStylesListQuery, ExploreStylesListQueryVariables>;
export const ExploreStyleDetailsByIdDocument = gql`
    query ExploreStyleDetailsById($categoryId: ID, $id: ID) {
  exploreStyleDetailsById(categoryId: $categoryId, _id: $id) {
    _id
    image
    categoryId
    subCategoryId
    categoryName
    categorySlug
    subCategoryName
  }
}
    `;

/**
 * __useExploreStyleDetailsByIdQuery__
 *
 * To run a query within a React component, call `useExploreStyleDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreStyleDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreStyleDetailsByIdQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExploreStyleDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<ExploreStyleDetailsByIdQuery, ExploreStyleDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExploreStyleDetailsByIdQuery, ExploreStyleDetailsByIdQueryVariables>(ExploreStyleDetailsByIdDocument, options);
      }
export function useExploreStyleDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExploreStyleDetailsByIdQuery, ExploreStyleDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExploreStyleDetailsByIdQuery, ExploreStyleDetailsByIdQueryVariables>(ExploreStyleDetailsByIdDocument, options);
        }
export type ExploreStyleDetailsByIdQueryHookResult = ReturnType<typeof useExploreStyleDetailsByIdQuery>;
export type ExploreStyleDetailsByIdLazyQueryHookResult = ReturnType<typeof useExploreStyleDetailsByIdLazyQuery>;
export type ExploreStyleDetailsByIdQueryResult = Apollo.QueryResult<ExploreStyleDetailsByIdQuery, ExploreStyleDetailsByIdQueryVariables>;
export const DeleteExploreStylesDocument = gql`
    mutation DeleteExploreStyles($id: ID) {
  deleteExploreStyles(_id: $id) {
    code
    message
  }
}
    `;
export type DeleteExploreStylesMutationFn = Apollo.MutationFunction<DeleteExploreStylesMutation, DeleteExploreStylesMutationVariables>;

/**
 * __useDeleteExploreStylesMutation__
 *
 * To run a mutation, you first call `useDeleteExploreStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExploreStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExploreStylesMutation, { data, loading, error }] = useDeleteExploreStylesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExploreStylesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExploreStylesMutation, DeleteExploreStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExploreStylesMutation, DeleteExploreStylesMutationVariables>(DeleteExploreStylesDocument, options);
      }
export type DeleteExploreStylesMutationHookResult = ReturnType<typeof useDeleteExploreStylesMutation>;
export type DeleteExploreStylesMutationResult = Apollo.MutationResult<DeleteExploreStylesMutation>;
export type DeleteExploreStylesMutationOptions = Apollo.BaseMutationOptions<DeleteExploreStylesMutation, DeleteExploreStylesMutationVariables>;
export const AddExploreStyleDocument = gql`
    mutation AddExploreStyle($input: ExploreStylesCreateInput!) {
  addExploreStyle(input: $input) {
    code
    message
  }
}
    `;
export type AddExploreStyleMutationFn = Apollo.MutationFunction<AddExploreStyleMutation, AddExploreStyleMutationVariables>;

/**
 * __useAddExploreStyleMutation__
 *
 * To run a mutation, you first call `useAddExploreStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExploreStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExploreStyleMutation, { data, loading, error }] = useAddExploreStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExploreStyleMutation(baseOptions?: Apollo.MutationHookOptions<AddExploreStyleMutation, AddExploreStyleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExploreStyleMutation, AddExploreStyleMutationVariables>(AddExploreStyleDocument, options);
      }
export type AddExploreStyleMutationHookResult = ReturnType<typeof useAddExploreStyleMutation>;
export type AddExploreStyleMutationResult = Apollo.MutationResult<AddExploreStyleMutation>;
export type AddExploreStyleMutationOptions = Apollo.BaseMutationOptions<AddExploreStyleMutation, AddExploreStyleMutationVariables>;
export const UpdateExploreStyleDocument = gql`
    mutation UpdateExploreStyle($id: ID!, $image: String!) {
  updateExploreStyle(_id: $id, image: $image) {
    code
    message
  }
}
    `;
export type UpdateExploreStyleMutationFn = Apollo.MutationFunction<UpdateExploreStyleMutation, UpdateExploreStyleMutationVariables>;

/**
 * __useUpdateExploreStyleMutation__
 *
 * To run a mutation, you first call `useUpdateExploreStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExploreStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExploreStyleMutation, { data, loading, error }] = useUpdateExploreStyleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpdateExploreStyleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExploreStyleMutation, UpdateExploreStyleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExploreStyleMutation, UpdateExploreStyleMutationVariables>(UpdateExploreStyleDocument, options);
      }
export type UpdateExploreStyleMutationHookResult = ReturnType<typeof useUpdateExploreStyleMutation>;
export type UpdateExploreStyleMutationResult = Apollo.MutationResult<UpdateExploreStyleMutation>;
export type UpdateExploreStyleMutationOptions = Apollo.BaseMutationOptions<UpdateExploreStyleMutation, UpdateExploreStyleMutationVariables>;
export const ExploreStylesListPaginationDocument = gql`
    query ExploreStylesListPagination($page: Float!, $limit: Float!, $categoryId: ID, $search: String) {
  exploreStylesListPagination(
    page: $page
    limit: $limit
    categoryId: $categoryId
    search: $search
  ) {
    data {
      _id
      image
      categoryId
      subCategoryId
      categoryName
      categorySlug
      subCategoryName
    }
    totalRecords
  }
}
    `;

/**
 * __useExploreStylesListPaginationQuery__
 *
 * To run a query within a React component, call `useExploreStylesListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreStylesListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreStylesListPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExploreStylesListPaginationQuery(baseOptions: Apollo.QueryHookOptions<ExploreStylesListPaginationQuery, ExploreStylesListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExploreStylesListPaginationQuery, ExploreStylesListPaginationQueryVariables>(ExploreStylesListPaginationDocument, options);
      }
export function useExploreStylesListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExploreStylesListPaginationQuery, ExploreStylesListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExploreStylesListPaginationQuery, ExploreStylesListPaginationQueryVariables>(ExploreStylesListPaginationDocument, options);
        }
export type ExploreStylesListPaginationQueryHookResult = ReturnType<typeof useExploreStylesListPaginationQuery>;
export type ExploreStylesListPaginationLazyQueryHookResult = ReturnType<typeof useExploreStylesListPaginationLazyQuery>;
export type ExploreStylesListPaginationQueryResult = Apollo.QueryResult<ExploreStylesListPaginationQuery, ExploreStylesListPaginationQueryVariables>;
export const FaqTypeListPaginationDocument = gql`
    query faqTypeListPagination($search: String, $page: Float, $limit: Float) {
  faqTypeListPagination(search: $search, page: $page, limit: $limit) {
    data {
      _id
      faqTypeName
      __typename
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useFaqTypeListPaginationQuery__
 *
 * To run a query within a React component, call `useFaqTypeListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqTypeListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqTypeListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFaqTypeListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<FaqTypeListPaginationQuery, FaqTypeListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqTypeListPaginationQuery, FaqTypeListPaginationQueryVariables>(FaqTypeListPaginationDocument, options);
      }
export function useFaqTypeListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqTypeListPaginationQuery, FaqTypeListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqTypeListPaginationQuery, FaqTypeListPaginationQueryVariables>(FaqTypeListPaginationDocument, options);
        }
export type FaqTypeListPaginationQueryHookResult = ReturnType<typeof useFaqTypeListPaginationQuery>;
export type FaqTypeListPaginationLazyQueryHookResult = ReturnType<typeof useFaqTypeListPaginationLazyQuery>;
export type FaqTypeListPaginationQueryResult = Apollo.QueryResult<FaqTypeListPaginationQuery, FaqTypeListPaginationQueryVariables>;
export const FaqTypeDetailsDocument = gql`
    query faqTypeDetails($_id: ID!) {
  faqTypeDetails(_id: $_id) {
    _id
    faqTypeName
    __typename
  }
}
    `;

/**
 * __useFaqTypeDetailsQuery__
 *
 * To run a query within a React component, call `useFaqTypeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqTypeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqTypeDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useFaqTypeDetailsQuery(baseOptions: Apollo.QueryHookOptions<FaqTypeDetailsQuery, FaqTypeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqTypeDetailsQuery, FaqTypeDetailsQueryVariables>(FaqTypeDetailsDocument, options);
      }
export function useFaqTypeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqTypeDetailsQuery, FaqTypeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqTypeDetailsQuery, FaqTypeDetailsQueryVariables>(FaqTypeDetailsDocument, options);
        }
export type FaqTypeDetailsQueryHookResult = ReturnType<typeof useFaqTypeDetailsQuery>;
export type FaqTypeDetailsLazyQueryHookResult = ReturnType<typeof useFaqTypeDetailsLazyQuery>;
export type FaqTypeDetailsQueryResult = Apollo.QueryResult<FaqTypeDetailsQuery, FaqTypeDetailsQueryVariables>;
export const AddFaqTypeDocument = gql`
    mutation addFaqType($faqTypeName: String!) {
  addFaqType(input: {faqTypeName: $faqTypeName}) {
    code
    message
  }
}
    `;
export type AddFaqTypeMutationFn = Apollo.MutationFunction<AddFaqTypeMutation, AddFaqTypeMutationVariables>;

/**
 * __useAddFaqTypeMutation__
 *
 * To run a mutation, you first call `useAddFaqTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFaqTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFaqTypeMutation, { data, loading, error }] = useAddFaqTypeMutation({
 *   variables: {
 *      faqTypeName: // value for 'faqTypeName'
 *   },
 * });
 */
export function useAddFaqTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddFaqTypeMutation, AddFaqTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFaqTypeMutation, AddFaqTypeMutationVariables>(AddFaqTypeDocument, options);
      }
export type AddFaqTypeMutationHookResult = ReturnType<typeof useAddFaqTypeMutation>;
export type AddFaqTypeMutationResult = Apollo.MutationResult<AddFaqTypeMutation>;
export type AddFaqTypeMutationOptions = Apollo.BaseMutationOptions<AddFaqTypeMutation, AddFaqTypeMutationVariables>;
export const FaqTypeUpdateDocument = gql`
    mutation faqTypeUpdate($_id: ID!, $faqTypeName: String!) {
  faqTypeUpdate(_id: $_id, faqTypeName: $faqTypeName) {
    code
    message
  }
}
    `;
export type FaqTypeUpdateMutationFn = Apollo.MutationFunction<FaqTypeUpdateMutation, FaqTypeUpdateMutationVariables>;

/**
 * __useFaqTypeUpdateMutation__
 *
 * To run a mutation, you first call `useFaqTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFaqTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [faqTypeUpdateMutation, { data, loading, error }] = useFaqTypeUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      faqTypeName: // value for 'faqTypeName'
 *   },
 * });
 */
export function useFaqTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FaqTypeUpdateMutation, FaqTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FaqTypeUpdateMutation, FaqTypeUpdateMutationVariables>(FaqTypeUpdateDocument, options);
      }
export type FaqTypeUpdateMutationHookResult = ReturnType<typeof useFaqTypeUpdateMutation>;
export type FaqTypeUpdateMutationResult = Apollo.MutationResult<FaqTypeUpdateMutation>;
export type FaqTypeUpdateMutationOptions = Apollo.BaseMutationOptions<FaqTypeUpdateMutation, FaqTypeUpdateMutationVariables>;
export const DeleteFaqTypeDocument = gql`
    mutation deleteFaqType($_id: ID!) {
  deleteFaqType(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteFaqTypeMutationFn = Apollo.MutationFunction<DeleteFaqTypeMutation, DeleteFaqTypeMutationVariables>;

/**
 * __useDeleteFaqTypeMutation__
 *
 * To run a mutation, you first call `useDeleteFaqTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaqTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaqTypeMutation, { data, loading, error }] = useDeleteFaqTypeMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteFaqTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaqTypeMutation, DeleteFaqTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaqTypeMutation, DeleteFaqTypeMutationVariables>(DeleteFaqTypeDocument, options);
      }
export type DeleteFaqTypeMutationHookResult = ReturnType<typeof useDeleteFaqTypeMutation>;
export type DeleteFaqTypeMutationResult = Apollo.MutationResult<DeleteFaqTypeMutation>;
export type DeleteFaqTypeMutationOptions = Apollo.BaseMutationOptions<DeleteFaqTypeMutation, DeleteFaqTypeMutationVariables>;
export const FaqTypeListDocument = gql`
    query faqTypeList {
  faqTypeList {
    _id
    faqTypeName
    __typename
  }
}
    `;

/**
 * __useFaqTypeListQuery__
 *
 * To run a query within a React component, call `useFaqTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqTypeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFaqTypeListQuery(baseOptions?: Apollo.QueryHookOptions<FaqTypeListQuery, FaqTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqTypeListQuery, FaqTypeListQueryVariables>(FaqTypeListDocument, options);
      }
export function useFaqTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqTypeListQuery, FaqTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqTypeListQuery, FaqTypeListQueryVariables>(FaqTypeListDocument, options);
        }
export type FaqTypeListQueryHookResult = ReturnType<typeof useFaqTypeListQuery>;
export type FaqTypeListLazyQueryHookResult = ReturnType<typeof useFaqTypeListLazyQuery>;
export type FaqTypeListQueryResult = Apollo.QueryResult<FaqTypeListQuery, FaqTypeListQueryVariables>;
export const FaqDetailsDocument = gql`
    query faqDetails($_id: ID!) {
  faqDetails(_id: $_id) {
    _id
    faqTypeId
    faqTypeDetails {
      _id
      faqTypeName
      __typename
    }
    question
    answer
    __typename
  }
}
    `;

/**
 * __useFaqDetailsQuery__
 *
 * To run a query within a React component, call `useFaqDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useFaqDetailsQuery(baseOptions: Apollo.QueryHookOptions<FaqDetailsQuery, FaqDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqDetailsQuery, FaqDetailsQueryVariables>(FaqDetailsDocument, options);
      }
export function useFaqDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqDetailsQuery, FaqDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqDetailsQuery, FaqDetailsQueryVariables>(FaqDetailsDocument, options);
        }
export type FaqDetailsQueryHookResult = ReturnType<typeof useFaqDetailsQuery>;
export type FaqDetailsLazyQueryHookResult = ReturnType<typeof useFaqDetailsLazyQuery>;
export type FaqDetailsQueryResult = Apollo.QueryResult<FaqDetailsQuery, FaqDetailsQueryVariables>;
export const FaqListPaginationDocument = gql`
    query faqListPagination($faqTypeId: ID, $search: String, $page: Float, $limit: Float) {
  faqListPagination(
    faqTypeId: $faqTypeId
    search: $search
    page: $page
    limit: $limit
  ) {
    data {
      _id
      faqTypeId
      question
      answer
      faqTypeDetails {
        _id
        faqTypeName
        __typename
      }
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useFaqListPaginationQuery__
 *
 * To run a query within a React component, call `useFaqListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqListPaginationQuery({
 *   variables: {
 *      faqTypeId: // value for 'faqTypeId'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFaqListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<FaqListPaginationQuery, FaqListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqListPaginationQuery, FaqListPaginationQueryVariables>(FaqListPaginationDocument, options);
      }
export function useFaqListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqListPaginationQuery, FaqListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqListPaginationQuery, FaqListPaginationQueryVariables>(FaqListPaginationDocument, options);
        }
export type FaqListPaginationQueryHookResult = ReturnType<typeof useFaqListPaginationQuery>;
export type FaqListPaginationLazyQueryHookResult = ReturnType<typeof useFaqListPaginationLazyQuery>;
export type FaqListPaginationQueryResult = Apollo.QueryResult<FaqListPaginationQuery, FaqListPaginationQueryVariables>;
export const AddFaqDocument = gql`
    mutation addFaq($faqTypeId: ID!, $question: String!, $answer: String!) {
  addFaq(input: {faqTypeId: $faqTypeId, question: $question, answer: $answer}) {
    code
    message
  }
}
    `;
export type AddFaqMutationFn = Apollo.MutationFunction<AddFaqMutation, AddFaqMutationVariables>;

/**
 * __useAddFaqMutation__
 *
 * To run a mutation, you first call `useAddFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFaqMutation, { data, loading, error }] = useAddFaqMutation({
 *   variables: {
 *      faqTypeId: // value for 'faqTypeId'
 *      question: // value for 'question'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useAddFaqMutation(baseOptions?: Apollo.MutationHookOptions<AddFaqMutation, AddFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFaqMutation, AddFaqMutationVariables>(AddFaqDocument, options);
      }
export type AddFaqMutationHookResult = ReturnType<typeof useAddFaqMutation>;
export type AddFaqMutationResult = Apollo.MutationResult<AddFaqMutation>;
export type AddFaqMutationOptions = Apollo.BaseMutationOptions<AddFaqMutation, AddFaqMutationVariables>;
export const FaqUpdateDocument = gql`
    mutation faqUpdate($_id: ID!, $faqTypeId: String!, $question: String!, $answer: String!) {
  faqUpdate(
    _id: $_id
    faqTypeId: $faqTypeId
    question: $question
    answer: $answer
  ) {
    code
    message
  }
}
    `;
export type FaqUpdateMutationFn = Apollo.MutationFunction<FaqUpdateMutation, FaqUpdateMutationVariables>;

/**
 * __useFaqUpdateMutation__
 *
 * To run a mutation, you first call `useFaqUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFaqUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [faqUpdateMutation, { data, loading, error }] = useFaqUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      faqTypeId: // value for 'faqTypeId'
 *      question: // value for 'question'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useFaqUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FaqUpdateMutation, FaqUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FaqUpdateMutation, FaqUpdateMutationVariables>(FaqUpdateDocument, options);
      }
export type FaqUpdateMutationHookResult = ReturnType<typeof useFaqUpdateMutation>;
export type FaqUpdateMutationResult = Apollo.MutationResult<FaqUpdateMutation>;
export type FaqUpdateMutationOptions = Apollo.BaseMutationOptions<FaqUpdateMutation, FaqUpdateMutationVariables>;
export const DeleteFaqDocument = gql`
    mutation deleteFaq($_id: ID!) {
  deleteFaq(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteFaqMutationFn = Apollo.MutationFunction<DeleteFaqMutation, DeleteFaqMutationVariables>;

/**
 * __useDeleteFaqMutation__
 *
 * To run a mutation, you first call `useDeleteFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaqMutation, { data, loading, error }] = useDeleteFaqMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteFaqMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaqMutation, DeleteFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaqMutation, DeleteFaqMutationVariables>(DeleteFaqDocument, options);
      }
export type DeleteFaqMutationHookResult = ReturnType<typeof useDeleteFaqMutation>;
export type DeleteFaqMutationResult = Apollo.MutationResult<DeleteFaqMutation>;
export type DeleteFaqMutationOptions = Apollo.BaseMutationOptions<DeleteFaqMutation, DeleteFaqMutationVariables>;
export const DeleteFeedbackByIdDocument = gql`
    mutation DeleteFeedbackById($feedbackId: ID!) {
  deleteFeedbackById(feedbackId: $feedbackId) {
    code
    message
  }
}
    `;
export type DeleteFeedbackByIdMutationFn = Apollo.MutationFunction<DeleteFeedbackByIdMutation, DeleteFeedbackByIdMutationVariables>;

/**
 * __useDeleteFeedbackByIdMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackByIdMutation, { data, loading, error }] = useDeleteFeedbackByIdMutation({
 *   variables: {
 *      feedbackId: // value for 'feedbackId'
 *   },
 * });
 */
export function useDeleteFeedbackByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeedbackByIdMutation, DeleteFeedbackByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeedbackByIdMutation, DeleteFeedbackByIdMutationVariables>(DeleteFeedbackByIdDocument, options);
      }
export type DeleteFeedbackByIdMutationHookResult = ReturnType<typeof useDeleteFeedbackByIdMutation>;
export type DeleteFeedbackByIdMutationResult = Apollo.MutationResult<DeleteFeedbackByIdMutation>;
export type DeleteFeedbackByIdMutationOptions = Apollo.BaseMutationOptions<DeleteFeedbackByIdMutation, DeleteFeedbackByIdMutationVariables>;
export const GetAllFeedbackListDocument = gql`
    query GetAllFeedbackList($page: Float!, $limit: Float!) {
  getAllFeedbackList(page: $page, limit: $limit) {
    data {
      _id
      userId
      userDetails {
        email
        phoneNumber
        businessName
        name
      }
      rating
      description
      createdAt
    }
    totalRecords
  }
}
    `;

/**
 * __useGetAllFeedbackListQuery__
 *
 * To run a query within a React component, call `useGetAllFeedbackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFeedbackListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFeedbackListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllFeedbackListQuery(baseOptions: Apollo.QueryHookOptions<GetAllFeedbackListQuery, GetAllFeedbackListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFeedbackListQuery, GetAllFeedbackListQueryVariables>(GetAllFeedbackListDocument, options);
      }
export function useGetAllFeedbackListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFeedbackListQuery, GetAllFeedbackListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFeedbackListQuery, GetAllFeedbackListQueryVariables>(GetAllFeedbackListDocument, options);
        }
export type GetAllFeedbackListQueryHookResult = ReturnType<typeof useGetAllFeedbackListQuery>;
export type GetAllFeedbackListLazyQueryHookResult = ReturnType<typeof useGetAllFeedbackListLazyQuery>;
export type GetAllFeedbackListQueryResult = Apollo.QueryResult<GetAllFeedbackListQuery, GetAllFeedbackListQueryVariables>;
export const HsnCodeListDocument = gql`
    query HsnCodeList {
  hsnCodeList {
    _id
    hsnCode
    hsnDescription
  }
}
    `;

/**
 * __useHsnCodeListQuery__
 *
 * To run a query within a React component, call `useHsnCodeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHsnCodeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHsnCodeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useHsnCodeListQuery(baseOptions?: Apollo.QueryHookOptions<HsnCodeListQuery, HsnCodeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HsnCodeListQuery, HsnCodeListQueryVariables>(HsnCodeListDocument, options);
      }
export function useHsnCodeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HsnCodeListQuery, HsnCodeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HsnCodeListQuery, HsnCodeListQueryVariables>(HsnCodeListDocument, options);
        }
export type HsnCodeListQueryHookResult = ReturnType<typeof useHsnCodeListQuery>;
export type HsnCodeListLazyQueryHookResult = ReturnType<typeof useHsnCodeListLazyQuery>;
export type HsnCodeListQueryResult = Apollo.QueryResult<HsnCodeListQuery, HsnCodeListQueryVariables>;
export const HsnCodeListWithPaginationDocument = gql`
    query HsnCodeListWithPagination($search: String, $page: Float!, $limit: Float!) {
  hsnCodeListWithPagination(search: $search, page: $page, limit: $limit) {
    data {
      _id
      hsnCode
      hsnDescription
    }
    totalRecords
  }
}
    `;

/**
 * __useHsnCodeListWithPaginationQuery__
 *
 * To run a query within a React component, call `useHsnCodeListWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHsnCodeListWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHsnCodeListWithPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useHsnCodeListWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<HsnCodeListWithPaginationQuery, HsnCodeListWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HsnCodeListWithPaginationQuery, HsnCodeListWithPaginationQueryVariables>(HsnCodeListWithPaginationDocument, options);
      }
export function useHsnCodeListWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HsnCodeListWithPaginationQuery, HsnCodeListWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HsnCodeListWithPaginationQuery, HsnCodeListWithPaginationQueryVariables>(HsnCodeListWithPaginationDocument, options);
        }
export type HsnCodeListWithPaginationQueryHookResult = ReturnType<typeof useHsnCodeListWithPaginationQuery>;
export type HsnCodeListWithPaginationLazyQueryHookResult = ReturnType<typeof useHsnCodeListWithPaginationLazyQuery>;
export type HsnCodeListWithPaginationQueryResult = Apollo.QueryResult<HsnCodeListWithPaginationQuery, HsnCodeListWithPaginationQueryVariables>;
export const HsnCodeUpdateByIdDocument = gql`
    mutation HsnCodeUpdateById($id: ID!, $hsnCode: String!, $hsnDescription: String!) {
  hsnCodeUpdateById(_id: $id, hsnCode: $hsnCode, hsnDescription: $hsnDescription) {
    code
    message
  }
}
    `;
export type HsnCodeUpdateByIdMutationFn = Apollo.MutationFunction<HsnCodeUpdateByIdMutation, HsnCodeUpdateByIdMutationVariables>;

/**
 * __useHsnCodeUpdateByIdMutation__
 *
 * To run a mutation, you first call `useHsnCodeUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHsnCodeUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hsnCodeUpdateByIdMutation, { data, loading, error }] = useHsnCodeUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hsnCode: // value for 'hsnCode'
 *      hsnDescription: // value for 'hsnDescription'
 *   },
 * });
 */
export function useHsnCodeUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<HsnCodeUpdateByIdMutation, HsnCodeUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HsnCodeUpdateByIdMutation, HsnCodeUpdateByIdMutationVariables>(HsnCodeUpdateByIdDocument, options);
      }
export type HsnCodeUpdateByIdMutationHookResult = ReturnType<typeof useHsnCodeUpdateByIdMutation>;
export type HsnCodeUpdateByIdMutationResult = Apollo.MutationResult<HsnCodeUpdateByIdMutation>;
export type HsnCodeUpdateByIdMutationOptions = Apollo.BaseMutationOptions<HsnCodeUpdateByIdMutation, HsnCodeUpdateByIdMutationVariables>;
export const HsnCodeAddUpdateDocument = gql`
    mutation HsnCodeAddUpdate($input: HsnCodeAddUpdateInput!) {
  hsnCodeAddUpdate(input: $input) {
    code
    message
  }
}
    `;
export type HsnCodeAddUpdateMutationFn = Apollo.MutationFunction<HsnCodeAddUpdateMutation, HsnCodeAddUpdateMutationVariables>;

/**
 * __useHsnCodeAddUpdateMutation__
 *
 * To run a mutation, you first call `useHsnCodeAddUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHsnCodeAddUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hsnCodeAddUpdateMutation, { data, loading, error }] = useHsnCodeAddUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHsnCodeAddUpdateMutation(baseOptions?: Apollo.MutationHookOptions<HsnCodeAddUpdateMutation, HsnCodeAddUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HsnCodeAddUpdateMutation, HsnCodeAddUpdateMutationVariables>(HsnCodeAddUpdateDocument, options);
      }
export type HsnCodeAddUpdateMutationHookResult = ReturnType<typeof useHsnCodeAddUpdateMutation>;
export type HsnCodeAddUpdateMutationResult = Apollo.MutationResult<HsnCodeAddUpdateMutation>;
export type HsnCodeAddUpdateMutationOptions = Apollo.BaseMutationOptions<HsnCodeAddUpdateMutation, HsnCodeAddUpdateMutationVariables>;
export const AddRssNewsUrlDocument = gql`
    mutation AddRssNewsUrl($input: AddRssFeedInput!) {
  addRssNewsUrl(input: $input) {
    code
    message
  }
}
    `;
export type AddRssNewsUrlMutationFn = Apollo.MutationFunction<AddRssNewsUrlMutation, AddRssNewsUrlMutationVariables>;

/**
 * __useAddRssNewsUrlMutation__
 *
 * To run a mutation, you first call `useAddRssNewsUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRssNewsUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRssNewsUrlMutation, { data, loading, error }] = useAddRssNewsUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRssNewsUrlMutation(baseOptions?: Apollo.MutationHookOptions<AddRssNewsUrlMutation, AddRssNewsUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRssNewsUrlMutation, AddRssNewsUrlMutationVariables>(AddRssNewsUrlDocument, options);
      }
export type AddRssNewsUrlMutationHookResult = ReturnType<typeof useAddRssNewsUrlMutation>;
export type AddRssNewsUrlMutationResult = Apollo.MutationResult<AddRssNewsUrlMutation>;
export type AddRssNewsUrlMutationOptions = Apollo.BaseMutationOptions<AddRssNewsUrlMutation, AddRssNewsUrlMutationVariables>;
export const RssNewsUrlListDocument = gql`
    query RssNewsUrlList {
  rssNewsUrlList {
    data {
      _id
      url
      description
      status
    }
    totalUrl
  }
}
    `;

/**
 * __useRssNewsUrlListQuery__
 *
 * To run a query within a React component, call `useRssNewsUrlListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRssNewsUrlListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRssNewsUrlListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRssNewsUrlListQuery(baseOptions?: Apollo.QueryHookOptions<RssNewsUrlListQuery, RssNewsUrlListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RssNewsUrlListQuery, RssNewsUrlListQueryVariables>(RssNewsUrlListDocument, options);
      }
export function useRssNewsUrlListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RssNewsUrlListQuery, RssNewsUrlListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RssNewsUrlListQuery, RssNewsUrlListQueryVariables>(RssNewsUrlListDocument, options);
        }
export type RssNewsUrlListQueryHookResult = ReturnType<typeof useRssNewsUrlListQuery>;
export type RssNewsUrlListLazyQueryHookResult = ReturnType<typeof useRssNewsUrlListLazyQuery>;
export type RssNewsUrlListQueryResult = Apollo.QueryResult<RssNewsUrlListQuery, RssNewsUrlListQueryVariables>;
export const DeleteNewsUrlByIdDocument = gql`
    query DeleteNewsUrlById($id: String!) {
  deleteNewsUrlById(_id: $id) {
    code
    message
  }
}
    `;

/**
 * __useDeleteNewsUrlByIdQuery__
 *
 * To run a query within a React component, call `useDeleteNewsUrlByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsUrlByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteNewsUrlByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNewsUrlByIdQuery(baseOptions: Apollo.QueryHookOptions<DeleteNewsUrlByIdQuery, DeleteNewsUrlByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteNewsUrlByIdQuery, DeleteNewsUrlByIdQueryVariables>(DeleteNewsUrlByIdDocument, options);
      }
export function useDeleteNewsUrlByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteNewsUrlByIdQuery, DeleteNewsUrlByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteNewsUrlByIdQuery, DeleteNewsUrlByIdQueryVariables>(DeleteNewsUrlByIdDocument, options);
        }
export type DeleteNewsUrlByIdQueryHookResult = ReturnType<typeof useDeleteNewsUrlByIdQuery>;
export type DeleteNewsUrlByIdLazyQueryHookResult = ReturnType<typeof useDeleteNewsUrlByIdLazyQuery>;
export type DeleteNewsUrlByIdQueryResult = Apollo.QueryResult<DeleteNewsUrlByIdQuery, DeleteNewsUrlByIdQueryVariables>;
export const AddOfferDocument = gql`
    mutation AddOffer($input: OffersCreateInput!) {
  addOffer(input: $input) {
    code
    message
  }
}
    `;
export type AddOfferMutationFn = Apollo.MutationFunction<AddOfferMutation, AddOfferMutationVariables>;

/**
 * __useAddOfferMutation__
 *
 * To run a mutation, you first call `useAddOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfferMutation, { data, loading, error }] = useAddOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOfferMutation(baseOptions?: Apollo.MutationHookOptions<AddOfferMutation, AddOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOfferMutation, AddOfferMutationVariables>(AddOfferDocument, options);
      }
export type AddOfferMutationHookResult = ReturnType<typeof useAddOfferMutation>;
export type AddOfferMutationResult = Apollo.MutationResult<AddOfferMutation>;
export type AddOfferMutationOptions = Apollo.BaseMutationOptions<AddOfferMutation, AddOfferMutationVariables>;
export const DeleteOffersDocument = gql`
    mutation DeleteOffers($id: ID) {
  deleteOffers(_id: $id) {
    code
    message
  }
}
    `;
export type DeleteOffersMutationFn = Apollo.MutationFunction<DeleteOffersMutation, DeleteOffersMutationVariables>;

/**
 * __useDeleteOffersMutation__
 *
 * To run a mutation, you first call `useDeleteOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOffersMutation, { data, loading, error }] = useDeleteOffersMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOffersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOffersMutation, DeleteOffersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOffersMutation, DeleteOffersMutationVariables>(DeleteOffersDocument, options);
      }
export type DeleteOffersMutationHookResult = ReturnType<typeof useDeleteOffersMutation>;
export type DeleteOffersMutationResult = Apollo.MutationResult<DeleteOffersMutation>;
export type DeleteOffersMutationOptions = Apollo.BaseMutationOptions<DeleteOffersMutation, DeleteOffersMutationVariables>;
export const OffersListDocument = gql`
    query OffersList($categoryId: ID) {
  offersList(categoryId: $categoryId) {
    _id
    brandId
    categoryId
    categoryName
    categorySlug
    offerImage
    brandName
    brandLogo
    minOfferDiscount
    maxOfferDiscount
  }
}
    `;

/**
 * __useOffersListQuery__
 *
 * To run a query within a React component, call `useOffersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useOffersListQuery(baseOptions?: Apollo.QueryHookOptions<OffersListQuery, OffersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffersListQuery, OffersListQueryVariables>(OffersListDocument, options);
      }
export function useOffersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersListQuery, OffersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffersListQuery, OffersListQueryVariables>(OffersListDocument, options);
        }
export type OffersListQueryHookResult = ReturnType<typeof useOffersListQuery>;
export type OffersListLazyQueryHookResult = ReturnType<typeof useOffersListLazyQuery>;
export type OffersListQueryResult = Apollo.QueryResult<OffersListQuery, OffersListQueryVariables>;
export const OfferDetailsByIdDocument = gql`
    query OfferDetailsById($id: ID, $categoryId: ID) {
  offerDetailsById(_id: $id, categoryId: $categoryId) {
    _id
    brandId
    categoryId
    categoryName
    categorySlug
    offerImage
    brandName
    brandLogo
    minOfferDiscount
    maxOfferDiscount
  }
}
    `;

/**
 * __useOfferDetailsByIdQuery__
 *
 * To run a query within a React component, call `useOfferDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useOfferDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<OfferDetailsByIdQuery, OfferDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferDetailsByIdQuery, OfferDetailsByIdQueryVariables>(OfferDetailsByIdDocument, options);
      }
export function useOfferDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferDetailsByIdQuery, OfferDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferDetailsByIdQuery, OfferDetailsByIdQueryVariables>(OfferDetailsByIdDocument, options);
        }
export type OfferDetailsByIdQueryHookResult = ReturnType<typeof useOfferDetailsByIdQuery>;
export type OfferDetailsByIdLazyQueryHookResult = ReturnType<typeof useOfferDetailsByIdLazyQuery>;
export type OfferDetailsByIdQueryResult = Apollo.QueryResult<OfferDetailsByIdQuery, OfferDetailsByIdQueryVariables>;
export const UpdateOfferDocument = gql`
    mutation UpdateOffer($id: ID!, $offerImage: String!, $minOfferDiscount: Float!, $maxOfferDiscount: Float!) {
  updateOffer(
    _id: $id
    offerImage: $offerImage
    minOfferDiscount: $minOfferDiscount
    maxOfferDiscount: $maxOfferDiscount
  ) {
    code
    message
  }
}
    `;
export type UpdateOfferMutationFn = Apollo.MutationFunction<UpdateOfferMutation, UpdateOfferMutationVariables>;

/**
 * __useUpdateOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferMutation, { data, loading, error }] = useUpdateOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      offerImage: // value for 'offerImage'
 *      minOfferDiscount: // value for 'minOfferDiscount'
 *      maxOfferDiscount: // value for 'maxOfferDiscount'
 *   },
 * });
 */
export function useUpdateOfferMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferMutation, UpdateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferMutation, UpdateOfferMutationVariables>(UpdateOfferDocument, options);
      }
export type UpdateOfferMutationHookResult = ReturnType<typeof useUpdateOfferMutation>;
export type UpdateOfferMutationResult = Apollo.MutationResult<UpdateOfferMutation>;
export type UpdateOfferMutationOptions = Apollo.BaseMutationOptions<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const OffersListPaginationDocument = gql`
    query OffersListPagination($page: Float!, $limit: Float!, $categoryId: ID, $search: String) {
  offersListPagination(
    page: $page
    limit: $limit
    categoryId: $categoryId
    search: $search
  ) {
    data {
      _id
      brandId
      categoryId
      categoryName
      categorySlug
      offerImage
      brandName
      brandLogo
      minOfferDiscount
      maxOfferDiscount
    }
    totalRecords
  }
}
    `;

/**
 * __useOffersListPaginationQuery__
 *
 * To run a query within a React component, call `useOffersListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersListPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOffersListPaginationQuery(baseOptions: Apollo.QueryHookOptions<OffersListPaginationQuery, OffersListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffersListPaginationQuery, OffersListPaginationQueryVariables>(OffersListPaginationDocument, options);
      }
export function useOffersListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersListPaginationQuery, OffersListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffersListPaginationQuery, OffersListPaginationQueryVariables>(OffersListPaginationDocument, options);
        }
export type OffersListPaginationQueryHookResult = ReturnType<typeof useOffersListPaginationQuery>;
export type OffersListPaginationLazyQueryHookResult = ReturnType<typeof useOffersListPaginationLazyQuery>;
export type OffersListPaginationQueryResult = Apollo.QueryResult<OffersListPaginationQuery, OffersListPaginationQueryVariables>;
export const CouponCodeListPaginationDocument = gql`
    query CouponCodeListPagination($page: Float!, $limit: Float!, $categoryId: ID, $filterByStatus: String) {
  couponCodeListPagination(
    page: $page
    limit: $limit
    categoryId: $categoryId
    filterByStatus: $filterByStatus
  ) {
    data {
      _id
      categoryIds
      couponType
      couponStatus
      couponCode
      startDate
      endDate
      title
      description
      restrictNumberOfUsers
      restrictedUsersCount
      isCouponApplyOnOrderAmount
      appliedOrderAmount
      ddCoins
      isFreeDelivery
      isDiscountInPercentage
      discountPercentage
      discountAmount
      uptoDiscountAmount
      categories
    }
    totalRecords
  }
}
    `;

/**
 * __useCouponCodeListPaginationQuery__
 *
 * To run a query within a React component, call `useCouponCodeListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponCodeListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponCodeListPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      categoryId: // value for 'categoryId'
 *      filterByStatus: // value for 'filterByStatus'
 *   },
 * });
 */
export function useCouponCodeListPaginationQuery(baseOptions: Apollo.QueryHookOptions<CouponCodeListPaginationQuery, CouponCodeListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponCodeListPaginationQuery, CouponCodeListPaginationQueryVariables>(CouponCodeListPaginationDocument, options);
      }
export function useCouponCodeListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponCodeListPaginationQuery, CouponCodeListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponCodeListPaginationQuery, CouponCodeListPaginationQueryVariables>(CouponCodeListPaginationDocument, options);
        }
export type CouponCodeListPaginationQueryHookResult = ReturnType<typeof useCouponCodeListPaginationQuery>;
export type CouponCodeListPaginationLazyQueryHookResult = ReturnType<typeof useCouponCodeListPaginationLazyQuery>;
export type CouponCodeListPaginationQueryResult = Apollo.QueryResult<CouponCodeListPaginationQuery, CouponCodeListPaginationQueryVariables>;
export const CouponCodeDetailsByIdDocument = gql`
    query CouponCodeDetailsById($id: ID!) {
  couponCodeDetailsById(_id: $id) {
    _id
    categoryIds
    couponType
    couponStatus
    couponCode
    startDate
    endDate
    title
    description
    restrictNumberOfUsers
    restrictedUsersCount
    isCouponApplyOnOrderAmount
    appliedOrderAmount
    ddCoins
    isFreeDelivery
    isDiscountInPercentage
    discountPercentage
    discountAmount
    uptoDiscountAmount
    categories
  }
}
    `;

/**
 * __useCouponCodeDetailsByIdQuery__
 *
 * To run a query within a React component, call `useCouponCodeDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponCodeDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponCodeDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCouponCodeDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<CouponCodeDetailsByIdQuery, CouponCodeDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponCodeDetailsByIdQuery, CouponCodeDetailsByIdQueryVariables>(CouponCodeDetailsByIdDocument, options);
      }
export function useCouponCodeDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponCodeDetailsByIdQuery, CouponCodeDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponCodeDetailsByIdQuery, CouponCodeDetailsByIdQueryVariables>(CouponCodeDetailsByIdDocument, options);
        }
export type CouponCodeDetailsByIdQueryHookResult = ReturnType<typeof useCouponCodeDetailsByIdQuery>;
export type CouponCodeDetailsByIdLazyQueryHookResult = ReturnType<typeof useCouponCodeDetailsByIdLazyQuery>;
export type CouponCodeDetailsByIdQueryResult = Apollo.QueryResult<CouponCodeDetailsByIdQuery, CouponCodeDetailsByIdQueryVariables>;
export const AddUpdateCouponCodeDocument = gql`
    mutation AddUpdateCouponCode($input: CouponCodeAddUpdateInput!) {
  addUpdateCouponCode(input: $input) {
    code
    message
  }
}
    `;
export type AddUpdateCouponCodeMutationFn = Apollo.MutationFunction<AddUpdateCouponCodeMutation, AddUpdateCouponCodeMutationVariables>;

/**
 * __useAddUpdateCouponCodeMutation__
 *
 * To run a mutation, you first call `useAddUpdateCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateCouponCodeMutation, { data, loading, error }] = useAddUpdateCouponCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateCouponCodeMutation, AddUpdateCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateCouponCodeMutation, AddUpdateCouponCodeMutationVariables>(AddUpdateCouponCodeDocument, options);
      }
export type AddUpdateCouponCodeMutationHookResult = ReturnType<typeof useAddUpdateCouponCodeMutation>;
export type AddUpdateCouponCodeMutationResult = Apollo.MutationResult<AddUpdateCouponCodeMutation>;
export type AddUpdateCouponCodeMutationOptions = Apollo.BaseMutationOptions<AddUpdateCouponCodeMutation, AddUpdateCouponCodeMutationVariables>;
export const DeleteCouponCodeDocument = gql`
    mutation DeleteCouponCode($id: ID!) {
  deleteCouponCode(_id: $id) {
    code
    message
  }
}
    `;
export type DeleteCouponCodeMutationFn = Apollo.MutationFunction<DeleteCouponCodeMutation, DeleteCouponCodeMutationVariables>;

/**
 * __useDeleteCouponCodeMutation__
 *
 * To run a mutation, you first call `useDeleteCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponCodeMutation, { data, loading, error }] = useDeleteCouponCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCouponCodeMutation, DeleteCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCouponCodeMutation, DeleteCouponCodeMutationVariables>(DeleteCouponCodeDocument, options);
      }
export type DeleteCouponCodeMutationHookResult = ReturnType<typeof useDeleteCouponCodeMutation>;
export type DeleteCouponCodeMutationResult = Apollo.MutationResult<DeleteCouponCodeMutation>;
export type DeleteCouponCodeMutationOptions = Apollo.BaseMutationOptions<DeleteCouponCodeMutation, DeleteCouponCodeMutationVariables>;
export const OrderListForAdminDocument = gql`
    query OrderListForAdmin($page: Float!, $limit: Float!, $categoryId: ID, $search: String, $trackingOrderStatus: String, $orderType: String) {
  orderListForAdmin(
    page: $page
    limit: $limit
    categoryId: $categoryId
    search: $search
    trackingOrderStatus: $trackingOrderStatus
    orderType: $orderType
  ) {
    totalRecords
    data {
      _id
      buyerUserId
      sellerUserId
      categoryId
      orderNumberId
      orderVerificationStatus
      trackingOrderStatus
      shipmentManagementType
      isPaymentCompleted
      isDeliveryChargeApplied
      orderImages {
        productImage
      }
      expectedDeliveryDate
      buyerBusinessName
      sellerBusinessName
      categoryName
      categorySlug
      createdAt
      updatedAt
      manualQuotationOrderId
    }
  }
}
    `;

/**
 * __useOrderListForAdminQuery__
 *
 * To run a query within a React component, call `useOrderListForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderListForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderListForAdminQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *      trackingOrderStatus: // value for 'trackingOrderStatus'
 *      orderType: // value for 'orderType'
 *   },
 * });
 */
export function useOrderListForAdminQuery(baseOptions: Apollo.QueryHookOptions<OrderListForAdminQuery, OrderListForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderListForAdminQuery, OrderListForAdminQueryVariables>(OrderListForAdminDocument, options);
      }
export function useOrderListForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderListForAdminQuery, OrderListForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderListForAdminQuery, OrderListForAdminQueryVariables>(OrderListForAdminDocument, options);
        }
export type OrderListForAdminQueryHookResult = ReturnType<typeof useOrderListForAdminQuery>;
export type OrderListForAdminLazyQueryHookResult = ReturnType<typeof useOrderListForAdminLazyQuery>;
export type OrderListForAdminQueryResult = Apollo.QueryResult<OrderListForAdminQuery, OrderListForAdminQueryVariables>;
export const OrderDetailsByIdDocument = gql`
    query OrderDetailsById($id: ID) {
  orderDetailsById(_id: $id) {
    _id
    buyerUserId
    sellerUserId
    categoryId
    orderNumberId
    invoiceNumberId
    orderVerificationStatus
    trackingOrderStatus
    shipmentManagementType
    isPaymentCompleted
    isDeliveryChargeApplied
    orderImages {
      productImage
    }
    expectedDeliveryDate
    totalPackageWeight
    buyerBusinessName
    sellerBusinessName
    categoryName
    categorySlug
    productImage
    productName
    createdAt
    updatedAt
    soldBy
    subOrderList {
      productImage
      productName
      _id
      setQuantity
      setPrice
      colors {
        colorId
        colorName
        colorCode
        length
        quantity
      }
      sizes {
        sizeId
        sizeValue
        quantity
      }
      unit
      quantityInSet
      totalOrderSetQuantity
      totalOrderSetPrice
    }
    invoiceOrderPaymentDetails {
      totalPrice
      discountOnPrice
      gstRatePrice
      cartDiscountPrice
      totalPayableAmount
      deliveryCharge
      totalDeliveryCharge
      couponDiscountPrice
      isFreeDelivery
      deliveryType
    }
    sourceAddress {
      cityName
      stateName
      fullAddress
      pinCode
      phoneNumber
      addressType
    }
    destinationAddress {
      cityName
      stateName
      fullAddress
      pinCode
      phoneNumber
      addressType
    }
    buyerUserName
    buyerUserDetails {
      name
      businessName
      email
      phoneNumber
      fullAddress
    }
    sellerUserDetails {
      name
      businessName
      email
      phoneNumber
      fullAddress
    }
    shipmentTrackingDetails {
      trackingStatus
      trackingStatusName
      trackingDateTime
    }
    deliveredDate
    reportBuyerDetails {
      _id
      orderId
      buyerUserId
      sellerUserId
      reason
      description
    }
    isBuyerReported
    isOrderOnHold
    orderHoldingDateTime
    isCouponApplied
    couponType
    isSampleOrder
    sampleOrderType
    sampleOrderQuantity
    sampleOrderMeasurementUnit
  }
}
    `;

/**
 * __useOrderDetailsByIdQuery__
 *
 * To run a query within a React component, call `useOrderDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<OrderDetailsByIdQuery, OrderDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetailsByIdQuery, OrderDetailsByIdQueryVariables>(OrderDetailsByIdDocument, options);
      }
export function useOrderDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetailsByIdQuery, OrderDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetailsByIdQuery, OrderDetailsByIdQueryVariables>(OrderDetailsByIdDocument, options);
        }
export type OrderDetailsByIdQueryHookResult = ReturnType<typeof useOrderDetailsByIdQuery>;
export type OrderDetailsByIdLazyQueryHookResult = ReturnType<typeof useOrderDetailsByIdLazyQuery>;
export type OrderDetailsByIdQueryResult = Apollo.QueryResult<OrderDetailsByIdQuery, OrderDetailsByIdQueryVariables>;
export const AddDeliveryChargeDocument = gql`
    mutation AddDeliveryCharge($orderId: ID!, $deliveryCharge: Float, $totalDeliveryCharge: Float, $deliveryType: String!) {
  addDeliveryCharge(
    orderId: $orderId
    deliveryCharge: $deliveryCharge
    totalDeliveryCharge: $totalDeliveryCharge
    deliveryType: $deliveryType
  ) {
    code
    message
  }
}
    `;
export type AddDeliveryChargeMutationFn = Apollo.MutationFunction<AddDeliveryChargeMutation, AddDeliveryChargeMutationVariables>;

/**
 * __useAddDeliveryChargeMutation__
 *
 * To run a mutation, you first call `useAddDeliveryChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeliveryChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeliveryChargeMutation, { data, loading, error }] = useAddDeliveryChargeMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      deliveryCharge: // value for 'deliveryCharge'
 *      totalDeliveryCharge: // value for 'totalDeliveryCharge'
 *      deliveryType: // value for 'deliveryType'
 *   },
 * });
 */
export function useAddDeliveryChargeMutation(baseOptions?: Apollo.MutationHookOptions<AddDeliveryChargeMutation, AddDeliveryChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeliveryChargeMutation, AddDeliveryChargeMutationVariables>(AddDeliveryChargeDocument, options);
      }
export type AddDeliveryChargeMutationHookResult = ReturnType<typeof useAddDeliveryChargeMutation>;
export type AddDeliveryChargeMutationResult = Apollo.MutationResult<AddDeliveryChargeMutation>;
export type AddDeliveryChargeMutationOptions = Apollo.BaseMutationOptions<AddDeliveryChargeMutation, AddDeliveryChargeMutationVariables>;
export const UpdateTrackingOrderStatusAdminDocument = gql`
    mutation UpdateTrackingOrderStatusAdmin($id: ID, $trackingOrderStatus: String) {
  updateTrackingOrderStatusAdmin(
    _id: $id
    trackingOrderStatus: $trackingOrderStatus
  ) {
    code
    message
  }
}
    `;
export type UpdateTrackingOrderStatusAdminMutationFn = Apollo.MutationFunction<UpdateTrackingOrderStatusAdminMutation, UpdateTrackingOrderStatusAdminMutationVariables>;

/**
 * __useUpdateTrackingOrderStatusAdminMutation__
 *
 * To run a mutation, you first call `useUpdateTrackingOrderStatusAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackingOrderStatusAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackingOrderStatusAdminMutation, { data, loading, error }] = useUpdateTrackingOrderStatusAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingOrderStatus: // value for 'trackingOrderStatus'
 *   },
 * });
 */
export function useUpdateTrackingOrderStatusAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackingOrderStatusAdminMutation, UpdateTrackingOrderStatusAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackingOrderStatusAdminMutation, UpdateTrackingOrderStatusAdminMutationVariables>(UpdateTrackingOrderStatusAdminDocument, options);
      }
export type UpdateTrackingOrderStatusAdminMutationHookResult = ReturnType<typeof useUpdateTrackingOrderStatusAdminMutation>;
export type UpdateTrackingOrderStatusAdminMutationResult = Apollo.MutationResult<UpdateTrackingOrderStatusAdminMutation>;
export type UpdateTrackingOrderStatusAdminMutationOptions = Apollo.BaseMutationOptions<UpdateTrackingOrderStatusAdminMutation, UpdateTrackingOrderStatusAdminMutationVariables>;
export const PolicyListPaginationDocument = gql`
    query policyListPagination($search: String, $page: Float, $limit: Float) {
  policyListPagination(search: $search, page: $page, limit: $limit) {
    data {
      _id
      title
      description
      __typename
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __usePolicyListPaginationQuery__
 *
 * To run a query within a React component, call `usePolicyListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePolicyListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<PolicyListPaginationQuery, PolicyListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyListPaginationQuery, PolicyListPaginationQueryVariables>(PolicyListPaginationDocument, options);
      }
export function usePolicyListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyListPaginationQuery, PolicyListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyListPaginationQuery, PolicyListPaginationQueryVariables>(PolicyListPaginationDocument, options);
        }
export type PolicyListPaginationQueryHookResult = ReturnType<typeof usePolicyListPaginationQuery>;
export type PolicyListPaginationLazyQueryHookResult = ReturnType<typeof usePolicyListPaginationLazyQuery>;
export type PolicyListPaginationQueryResult = Apollo.QueryResult<PolicyListPaginationQuery, PolicyListPaginationQueryVariables>;
export const PolicyDetailsDocument = gql`
    query policyDetails($_id: ID!) {
  policyDetails(_id: $_id) {
    _id
    title
    description
    __typename
  }
}
    `;

/**
 * __usePolicyDetailsQuery__
 *
 * To run a query within a React component, call `usePolicyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePolicyDetailsQuery(baseOptions: Apollo.QueryHookOptions<PolicyDetailsQuery, PolicyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyDetailsQuery, PolicyDetailsQueryVariables>(PolicyDetailsDocument, options);
      }
export function usePolicyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyDetailsQuery, PolicyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyDetailsQuery, PolicyDetailsQueryVariables>(PolicyDetailsDocument, options);
        }
export type PolicyDetailsQueryHookResult = ReturnType<typeof usePolicyDetailsQuery>;
export type PolicyDetailsLazyQueryHookResult = ReturnType<typeof usePolicyDetailsLazyQuery>;
export type PolicyDetailsQueryResult = Apollo.QueryResult<PolicyDetailsQuery, PolicyDetailsQueryVariables>;
export const PolicyAddDocument = gql`
    mutation policyAdd($title: String!, $description: String!) {
  policyAdd(input: {title: $title, description: $description}) {
    code
    message
  }
}
    `;
export type PolicyAddMutationFn = Apollo.MutationFunction<PolicyAddMutation, PolicyAddMutationVariables>;

/**
 * __usePolicyAddMutation__
 *
 * To run a mutation, you first call `usePolicyAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolicyAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policyAddMutation, { data, loading, error }] = usePolicyAddMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function usePolicyAddMutation(baseOptions?: Apollo.MutationHookOptions<PolicyAddMutation, PolicyAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyAddMutation, PolicyAddMutationVariables>(PolicyAddDocument, options);
      }
export type PolicyAddMutationHookResult = ReturnType<typeof usePolicyAddMutation>;
export type PolicyAddMutationResult = Apollo.MutationResult<PolicyAddMutation>;
export type PolicyAddMutationOptions = Apollo.BaseMutationOptions<PolicyAddMutation, PolicyAddMutationVariables>;
export const PolicyUpdateDocument = gql`
    mutation policyUpdate($_id: ID!, $title: String!, $description: String!) {
  policyUpdate(_id: $_id, title: $title, description: $description) {
    code
    message
  }
}
    `;
export type PolicyUpdateMutationFn = Apollo.MutationFunction<PolicyUpdateMutation, PolicyUpdateMutationVariables>;

/**
 * __usePolicyUpdateMutation__
 *
 * To run a mutation, you first call `usePolicyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolicyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policyUpdateMutation, { data, loading, error }] = usePolicyUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function usePolicyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolicyUpdateMutation, PolicyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyUpdateMutation, PolicyUpdateMutationVariables>(PolicyUpdateDocument, options);
      }
export type PolicyUpdateMutationHookResult = ReturnType<typeof usePolicyUpdateMutation>;
export type PolicyUpdateMutationResult = Apollo.MutationResult<PolicyUpdateMutation>;
export type PolicyUpdateMutationOptions = Apollo.BaseMutationOptions<PolicyUpdateMutation, PolicyUpdateMutationVariables>;
export const DeletePolicyDocument = gql`
    mutation deletePolicy($_id: ID!) {
  deletePolicy(_id: $_id) {
    code
    message
  }
}
    `;
export type DeletePolicyMutationFn = Apollo.MutationFunction<DeletePolicyMutation, DeletePolicyMutationVariables>;

/**
 * __useDeletePolicyMutation__
 *
 * To run a mutation, you first call `useDeletePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePolicyMutation, { data, loading, error }] = useDeletePolicyMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeletePolicyMutation(baseOptions?: Apollo.MutationHookOptions<DeletePolicyMutation, DeletePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePolicyMutation, DeletePolicyMutationVariables>(DeletePolicyDocument, options);
      }
export type DeletePolicyMutationHookResult = ReturnType<typeof useDeletePolicyMutation>;
export type DeletePolicyMutationResult = Apollo.MutationResult<DeletePolicyMutation>;
export type DeletePolicyMutationOptions = Apollo.BaseMutationOptions<DeletePolicyMutation, DeletePolicyMutationVariables>;
export const PopularStyleCodesListDocument = gql`
    query PopularStyleCodesList($categoryId: ID) {
  popularStyleCodesList(categoryId: $categoryId) {
    _id
    popularStyleCodeName
    image
    categoryId
    subCategoryId
    categoryName
    categorySlug
    subCategoryName
  }
}
    `;

/**
 * __usePopularStyleCodesListQuery__
 *
 * To run a query within a React component, call `usePopularStyleCodesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularStyleCodesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularStyleCodesListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function usePopularStyleCodesListQuery(baseOptions?: Apollo.QueryHookOptions<PopularStyleCodesListQuery, PopularStyleCodesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularStyleCodesListQuery, PopularStyleCodesListQueryVariables>(PopularStyleCodesListDocument, options);
      }
export function usePopularStyleCodesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularStyleCodesListQuery, PopularStyleCodesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularStyleCodesListQuery, PopularStyleCodesListQueryVariables>(PopularStyleCodesListDocument, options);
        }
export type PopularStyleCodesListQueryHookResult = ReturnType<typeof usePopularStyleCodesListQuery>;
export type PopularStyleCodesListLazyQueryHookResult = ReturnType<typeof usePopularStyleCodesListLazyQuery>;
export type PopularStyleCodesListQueryResult = Apollo.QueryResult<PopularStyleCodesListQuery, PopularStyleCodesListQueryVariables>;
export const PopularStyleCodesDetailsByIdDocument = gql`
    query PopularStyleCodesDetailsById($categoryId: ID, $id: ID) {
  popularStyleCodesDetailsById(categoryId: $categoryId, _id: $id) {
    _id
    popularStyleCodeName
    image
    categoryId
    subCategoryId
    categoryName
    categorySlug
    subCategoryName
  }
}
    `;

/**
 * __usePopularStyleCodesDetailsByIdQuery__
 *
 * To run a query within a React component, call `usePopularStyleCodesDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularStyleCodesDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularStyleCodesDetailsByIdQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePopularStyleCodesDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<PopularStyleCodesDetailsByIdQuery, PopularStyleCodesDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularStyleCodesDetailsByIdQuery, PopularStyleCodesDetailsByIdQueryVariables>(PopularStyleCodesDetailsByIdDocument, options);
      }
export function usePopularStyleCodesDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularStyleCodesDetailsByIdQuery, PopularStyleCodesDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularStyleCodesDetailsByIdQuery, PopularStyleCodesDetailsByIdQueryVariables>(PopularStyleCodesDetailsByIdDocument, options);
        }
export type PopularStyleCodesDetailsByIdQueryHookResult = ReturnType<typeof usePopularStyleCodesDetailsByIdQuery>;
export type PopularStyleCodesDetailsByIdLazyQueryHookResult = ReturnType<typeof usePopularStyleCodesDetailsByIdLazyQuery>;
export type PopularStyleCodesDetailsByIdQueryResult = Apollo.QueryResult<PopularStyleCodesDetailsByIdQuery, PopularStyleCodesDetailsByIdQueryVariables>;
export const DeletePopularStyleCodesDocument = gql`
    mutation DeletePopularStyleCodes($id: ID) {
  deletePopularStyleCodes(_id: $id) {
    code
    message
  }
}
    `;
export type DeletePopularStyleCodesMutationFn = Apollo.MutationFunction<DeletePopularStyleCodesMutation, DeletePopularStyleCodesMutationVariables>;

/**
 * __useDeletePopularStyleCodesMutation__
 *
 * To run a mutation, you first call `useDeletePopularStyleCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePopularStyleCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePopularStyleCodesMutation, { data, loading, error }] = useDeletePopularStyleCodesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePopularStyleCodesMutation(baseOptions?: Apollo.MutationHookOptions<DeletePopularStyleCodesMutation, DeletePopularStyleCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePopularStyleCodesMutation, DeletePopularStyleCodesMutationVariables>(DeletePopularStyleCodesDocument, options);
      }
export type DeletePopularStyleCodesMutationHookResult = ReturnType<typeof useDeletePopularStyleCodesMutation>;
export type DeletePopularStyleCodesMutationResult = Apollo.MutationResult<DeletePopularStyleCodesMutation>;
export type DeletePopularStyleCodesMutationOptions = Apollo.BaseMutationOptions<DeletePopularStyleCodesMutation, DeletePopularStyleCodesMutationVariables>;
export const AddPopularStyleCodeDocument = gql`
    mutation AddPopularStyleCode($input: PopularStyleCodesCreateInput!) {
  addPopularStyleCode(input: $input) {
    code
    message
  }
}
    `;
export type AddPopularStyleCodeMutationFn = Apollo.MutationFunction<AddPopularStyleCodeMutation, AddPopularStyleCodeMutationVariables>;

/**
 * __useAddPopularStyleCodeMutation__
 *
 * To run a mutation, you first call `useAddPopularStyleCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPopularStyleCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPopularStyleCodeMutation, { data, loading, error }] = useAddPopularStyleCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPopularStyleCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddPopularStyleCodeMutation, AddPopularStyleCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPopularStyleCodeMutation, AddPopularStyleCodeMutationVariables>(AddPopularStyleCodeDocument, options);
      }
export type AddPopularStyleCodeMutationHookResult = ReturnType<typeof useAddPopularStyleCodeMutation>;
export type AddPopularStyleCodeMutationResult = Apollo.MutationResult<AddPopularStyleCodeMutation>;
export type AddPopularStyleCodeMutationOptions = Apollo.BaseMutationOptions<AddPopularStyleCodeMutation, AddPopularStyleCodeMutationVariables>;
export const UpdatePopularStyleCodeDocument = gql`
    mutation UpdatePopularStyleCode($id: ID!, $image: String!) {
  updatePopularStyleCode(_id: $id, image: $image) {
    code
    message
  }
}
    `;
export type UpdatePopularStyleCodeMutationFn = Apollo.MutationFunction<UpdatePopularStyleCodeMutation, UpdatePopularStyleCodeMutationVariables>;

/**
 * __useUpdatePopularStyleCodeMutation__
 *
 * To run a mutation, you first call `useUpdatePopularStyleCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePopularStyleCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePopularStyleCodeMutation, { data, loading, error }] = useUpdatePopularStyleCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpdatePopularStyleCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePopularStyleCodeMutation, UpdatePopularStyleCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePopularStyleCodeMutation, UpdatePopularStyleCodeMutationVariables>(UpdatePopularStyleCodeDocument, options);
      }
export type UpdatePopularStyleCodeMutationHookResult = ReturnType<typeof useUpdatePopularStyleCodeMutation>;
export type UpdatePopularStyleCodeMutationResult = Apollo.MutationResult<UpdatePopularStyleCodeMutation>;
export type UpdatePopularStyleCodeMutationOptions = Apollo.BaseMutationOptions<UpdatePopularStyleCodeMutation, UpdatePopularStyleCodeMutationVariables>;
export const PopularStyleCodesListPaginationDocument = gql`
    query PopularStyleCodesListPagination($page: Float!, $limit: Float!, $categoryId: ID, $search: String) {
  popularStyleCodesListPagination(
    page: $page
    limit: $limit
    categoryId: $categoryId
    search: $search
  ) {
    data {
      _id
      popularStyleCodeName
      image
      categoryId
      subCategoryId
      categoryName
      categorySlug
      subCategoryName
    }
    totalRecords
  }
}
    `;

/**
 * __usePopularStyleCodesListPaginationQuery__
 *
 * To run a query within a React component, call `usePopularStyleCodesListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularStyleCodesListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularStyleCodesListPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePopularStyleCodesListPaginationQuery(baseOptions: Apollo.QueryHookOptions<PopularStyleCodesListPaginationQuery, PopularStyleCodesListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularStyleCodesListPaginationQuery, PopularStyleCodesListPaginationQueryVariables>(PopularStyleCodesListPaginationDocument, options);
      }
export function usePopularStyleCodesListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularStyleCodesListPaginationQuery, PopularStyleCodesListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularStyleCodesListPaginationQuery, PopularStyleCodesListPaginationQueryVariables>(PopularStyleCodesListPaginationDocument, options);
        }
export type PopularStyleCodesListPaginationQueryHookResult = ReturnType<typeof usePopularStyleCodesListPaginationQuery>;
export type PopularStyleCodesListPaginationLazyQueryHookResult = ReturnType<typeof usePopularStyleCodesListPaginationLazyQuery>;
export type PopularStyleCodesListPaginationQueryResult = Apollo.QueryResult<PopularStyleCodesListPaginationQuery, PopularStyleCodesListPaginationQueryVariables>;
export const UserProductsListDocument = gql`
    query UserProductsList($categoryId: ID, $limit: Float!, $page: Float!, $search: String, $productStatus: String, $verifiedByAdmin: ID, $apiSlug: String) {
  userProductsList(
    categoryId: $categoryId
    limit: $limit
    page: $page
    search: $search
    productStatus: $productStatus
    verifiedByAdmin: $verifiedByAdmin
    apiSlug: $apiSlug
  ) {
    data {
      _id
      categorySlug
      listingTitle
      brandName
      categoryName
      subCategoryName
      productStatus
      verifiedByAdmin
      productCancelReason
      productImage
      userDetails {
        businessName
      }
      productStatusChangedBy
    }
    totalRecords
  }
}
    `;

/**
 * __useUserProductsListQuery__
 *
 * To run a query within a React component, call `useUserProductsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProductsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProductsListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      productStatus: // value for 'productStatus'
 *      verifiedByAdmin: // value for 'verifiedByAdmin'
 *      apiSlug: // value for 'apiSlug'
 *   },
 * });
 */
export function useUserProductsListQuery(baseOptions: Apollo.QueryHookOptions<UserProductsListQuery, UserProductsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProductsListQuery, UserProductsListQueryVariables>(UserProductsListDocument, options);
      }
export function useUserProductsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProductsListQuery, UserProductsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProductsListQuery, UserProductsListQueryVariables>(UserProductsListDocument, options);
        }
export type UserProductsListQueryHookResult = ReturnType<typeof useUserProductsListQuery>;
export type UserProductsListLazyQueryHookResult = ReturnType<typeof useUserProductsListLazyQuery>;
export type UserProductsListQueryResult = Apollo.QueryResult<UserProductsListQuery, UserProductsListQueryVariables>;
export const UpdateProductStatusDocument = gql`
    mutation UpdateProductStatus($productId: ID!, $productStatusChangedBy: String!, $productStatus: String!) {
  updateProductStatus(
    productId: $productId
    productStatusChangedBy: $productStatusChangedBy
    productStatus: $productStatus
  ) {
    code
    message
  }
}
    `;
export type UpdateProductStatusMutationFn = Apollo.MutationFunction<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>;

/**
 * __useUpdateProductStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStatusMutation, { data, loading, error }] = useUpdateProductStatusMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      productStatusChangedBy: // value for 'productStatusChangedBy'
 *      productStatus: // value for 'productStatus'
 *   },
 * });
 */
export function useUpdateProductStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>(UpdateProductStatusDocument, options);
      }
export type UpdateProductStatusMutationHookResult = ReturnType<typeof useUpdateProductStatusMutation>;
export type UpdateProductStatusMutationResult = Apollo.MutationResult<UpdateProductStatusMutation>;
export type UpdateProductStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>;
export const ProductVerifiedByAdminDocument = gql`
    mutation ProductVerifiedByAdmin($productIds: [ID!]!, $verifiedByAdmin: String!, $productCancelReason: String) {
  productVerifiedByAdmin(
    productIds: $productIds
    verifiedByAdmin: $verifiedByAdmin
    productCancelReason: $productCancelReason
  ) {
    code
    message
  }
}
    `;
export type ProductVerifiedByAdminMutationFn = Apollo.MutationFunction<ProductVerifiedByAdminMutation, ProductVerifiedByAdminMutationVariables>;

/**
 * __useProductVerifiedByAdminMutation__
 *
 * To run a mutation, you first call `useProductVerifiedByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductVerifiedByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productVerifiedByAdminMutation, { data, loading, error }] = useProductVerifiedByAdminMutation({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      verifiedByAdmin: // value for 'verifiedByAdmin'
 *      productCancelReason: // value for 'productCancelReason'
 *   },
 * });
 */
export function useProductVerifiedByAdminMutation(baseOptions?: Apollo.MutationHookOptions<ProductVerifiedByAdminMutation, ProductVerifiedByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductVerifiedByAdminMutation, ProductVerifiedByAdminMutationVariables>(ProductVerifiedByAdminDocument, options);
      }
export type ProductVerifiedByAdminMutationHookResult = ReturnType<typeof useProductVerifiedByAdminMutation>;
export type ProductVerifiedByAdminMutationResult = Apollo.MutationResult<ProductVerifiedByAdminMutation>;
export type ProductVerifiedByAdminMutationOptions = Apollo.BaseMutationOptions<ProductVerifiedByAdminMutation, ProductVerifiedByAdminMutationVariables>;
export const GetProductListAttributeBySubCategoryIdDocument = gql`
    query GetProductListAttributeBySubCategoryId($subCategoryId: ID) {
  getProductListAttributeBySubCategoryId(subCategoryId: $subCategoryId) {
    _id
    attributeName
    isRequired
    status
  }
}
    `;

/**
 * __useGetProductListAttributeBySubCategoryIdQuery__
 *
 * To run a query within a React component, call `useGetProductListAttributeBySubCategoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductListAttributeBySubCategoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductListAttributeBySubCategoryIdQuery({
 *   variables: {
 *      subCategoryId: // value for 'subCategoryId'
 *   },
 * });
 */
export function useGetProductListAttributeBySubCategoryIdQuery(baseOptions?: Apollo.QueryHookOptions<GetProductListAttributeBySubCategoryIdQuery, GetProductListAttributeBySubCategoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductListAttributeBySubCategoryIdQuery, GetProductListAttributeBySubCategoryIdQueryVariables>(GetProductListAttributeBySubCategoryIdDocument, options);
      }
export function useGetProductListAttributeBySubCategoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductListAttributeBySubCategoryIdQuery, GetProductListAttributeBySubCategoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductListAttributeBySubCategoryIdQuery, GetProductListAttributeBySubCategoryIdQueryVariables>(GetProductListAttributeBySubCategoryIdDocument, options);
        }
export type GetProductListAttributeBySubCategoryIdQueryHookResult = ReturnType<typeof useGetProductListAttributeBySubCategoryIdQuery>;
export type GetProductListAttributeBySubCategoryIdLazyQueryHookResult = ReturnType<typeof useGetProductListAttributeBySubCategoryIdLazyQuery>;
export type GetProductListAttributeBySubCategoryIdQueryResult = Apollo.QueryResult<GetProductListAttributeBySubCategoryIdQuery, GetProductListAttributeBySubCategoryIdQueryVariables>;
export const AddUpdateProductNameDocument = gql`
    mutation AddUpdateProductName($input: ProductNameAddUpdateInput!) {
  addUpdateProductName(input: $input) {
    code
    message
  }
}
    `;
export type AddUpdateProductNameMutationFn = Apollo.MutationFunction<AddUpdateProductNameMutation, AddUpdateProductNameMutationVariables>;

/**
 * __useAddUpdateProductNameMutation__
 *
 * To run a mutation, you first call `useAddUpdateProductNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateProductNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateProductNameMutation, { data, loading, error }] = useAddUpdateProductNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateProductNameMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateProductNameMutation, AddUpdateProductNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateProductNameMutation, AddUpdateProductNameMutationVariables>(AddUpdateProductNameDocument, options);
      }
export type AddUpdateProductNameMutationHookResult = ReturnType<typeof useAddUpdateProductNameMutation>;
export type AddUpdateProductNameMutationResult = Apollo.MutationResult<AddUpdateProductNameMutation>;
export type AddUpdateProductNameMutationOptions = Apollo.BaseMutationOptions<AddUpdateProductNameMutation, AddUpdateProductNameMutationVariables>;
export const GetProductNameListBySubCategoryIdDocument = gql`
    query GetProductNameListBySubCategoryId($subCategoryId: ID) {
  getProductNameListBySubCategoryId(subCategoryId: $subCategoryId) {
    _id
    categoryId
    subCategoryId
    productAttributeNameIds
  }
}
    `;

/**
 * __useGetProductNameListBySubCategoryIdQuery__
 *
 * To run a query within a React component, call `useGetProductNameListBySubCategoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductNameListBySubCategoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductNameListBySubCategoryIdQuery({
 *   variables: {
 *      subCategoryId: // value for 'subCategoryId'
 *   },
 * });
 */
export function useGetProductNameListBySubCategoryIdQuery(baseOptions?: Apollo.QueryHookOptions<GetProductNameListBySubCategoryIdQuery, GetProductNameListBySubCategoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductNameListBySubCategoryIdQuery, GetProductNameListBySubCategoryIdQueryVariables>(GetProductNameListBySubCategoryIdDocument, options);
      }
export function useGetProductNameListBySubCategoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductNameListBySubCategoryIdQuery, GetProductNameListBySubCategoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductNameListBySubCategoryIdQuery, GetProductNameListBySubCategoryIdQueryVariables>(GetProductNameListBySubCategoryIdDocument, options);
        }
export type GetProductNameListBySubCategoryIdQueryHookResult = ReturnType<typeof useGetProductNameListBySubCategoryIdQuery>;
export type GetProductNameListBySubCategoryIdLazyQueryHookResult = ReturnType<typeof useGetProductNameListBySubCategoryIdLazyQuery>;
export type GetProductNameListBySubCategoryIdQueryResult = Apollo.QueryResult<GetProductNameListBySubCategoryIdQuery, GetProductNameListBySubCategoryIdQueryVariables>;
export const GetProductDetailsByIdDocument = gql`
    query GetProductDetailsById($productId: ID, $apiPlatformType: String) {
  getProductDetailsById(productId: $productId, apiPlatformType: $apiPlatformType) {
    _id
    userId
    userDetails {
      businessName
      name
      email
      phoneNumber
    }
    productImages {
      name
      isCover
      imagePathUrl
    }
    brandId
    brandName
    productDetails {
      inputTitle
      values
    }
    additionalDetails {
      productId
      listingTitle
      listingDescription
      moq
      skuId
      hsnCodeId
      hsnCode
      gstRate
      isPricePerPieceIncludesGst
      listingExpiryDays
      isSampleAvailable
      freeSampleDetails {
        quantity
        price
        measurementUnit
      }
      paidSampleDetails {
        quantity
        price
        measurementUnit
      }
      discount
      productVideo
      features
    }
    productStatus
    verifiedByAdmin
    productCancelReason
    productCreatedSets {
      _id
      productId
      selectedColors {
        colorId
        colorCode
        colorName
        image
        length
        contents {
          sizeId
          quantity
          sizeValue
        }
      }
      priceMoq {
        minSetOrder
        perPiecePrice
        perPieceMrp
        availableQuantity
      }
      regularPrice {
        moqSet
        price
      }
      bulkPrice {
        moqSet
        moqPricePerPiece
      }
      miscellaneous
      packageWeight {
        unitMeasurement
        weight
      }
      packageDimensions {
        unitMeasurement
        length
        breadth
        height
      }
      unitOfMeasurement
      setPrice
      quantityInSet
      quantityUnit
    }
    productYarnListDetailId
    productYarnListDetails {
      _id
      productId
      priceMoq {
        moq
        perKgMrp
        perKgMinPrice
        perKgMaxPrice
        availableQuantity
      }
      packageWeight {
        unitMeasurement
        weight
      }
      packageDimensions {
        unitMeasurement
        length
        breadth
        height
      }
      miscellaneous
    }
    prodId
    productRatingReviewDetails {
      averageRatings
      totalReviewCounts
      starRatingReviewCounts {
        ratingsValue
        reviewsCount
      }
    }
    productPriceDetails {
      ... on ProductSetDetailsDto {
        perSetPrice
        discountedPrice
        perPieceMrp
        moq
        unitOfMeasurement
        marginPercentage
      }
      ... on ProductYarnListingDetailDto {
        discountedMinPrice
        discountedMaxPrice
        moq
        perKgMrp
        perKgMinPrice
        perKgMaxPrice
        unitOfMeasurement
        availableQuantity
        marginPercentage
      }
    }
    ddFee
    cashDiscountPercentage
    soldBy
    categorySlug
    sizeChart
    testReport
  }
}
    `;

/**
 * __useGetProductDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetProductDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductDetailsByIdQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      apiPlatformType: // value for 'apiPlatformType'
 *   },
 * });
 */
export function useGetProductDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetProductDetailsByIdQuery, GetProductDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductDetailsByIdQuery, GetProductDetailsByIdQueryVariables>(GetProductDetailsByIdDocument, options);
      }
export function useGetProductDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductDetailsByIdQuery, GetProductDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductDetailsByIdQuery, GetProductDetailsByIdQueryVariables>(GetProductDetailsByIdDocument, options);
        }
export type GetProductDetailsByIdQueryHookResult = ReturnType<typeof useGetProductDetailsByIdQuery>;
export type GetProductDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetProductDetailsByIdLazyQuery>;
export type GetProductDetailsByIdQueryResult = Apollo.QueryResult<GetProductDetailsByIdQuery, GetProductDetailsByIdQueryVariables>;
export const GetProductRatingsReviewsByProductIdDocument = gql`
    query GetProductRatingsReviewsByProductId($productId: String!, $page: Float!, $limit: Float!) {
  getProductRatingsReviewsByProductId(
    productId: $productId
    page: $page
    limit: $limit
  ) {
    data {
      ratings
      reviews
      userName
      dateOfReview
    }
    totalRecords
  }
}
    `;

/**
 * __useGetProductRatingsReviewsByProductIdQuery__
 *
 * To run a query within a React component, call `useGetProductRatingsReviewsByProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductRatingsReviewsByProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductRatingsReviewsByProductIdQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProductRatingsReviewsByProductIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductRatingsReviewsByProductIdQuery, GetProductRatingsReviewsByProductIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductRatingsReviewsByProductIdQuery, GetProductRatingsReviewsByProductIdQueryVariables>(GetProductRatingsReviewsByProductIdDocument, options);
      }
export function useGetProductRatingsReviewsByProductIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductRatingsReviewsByProductIdQuery, GetProductRatingsReviewsByProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductRatingsReviewsByProductIdQuery, GetProductRatingsReviewsByProductIdQueryVariables>(GetProductRatingsReviewsByProductIdDocument, options);
        }
export type GetProductRatingsReviewsByProductIdQueryHookResult = ReturnType<typeof useGetProductRatingsReviewsByProductIdQuery>;
export type GetProductRatingsReviewsByProductIdLazyQueryHookResult = ReturnType<typeof useGetProductRatingsReviewsByProductIdLazyQuery>;
export type GetProductRatingsReviewsByProductIdQueryResult = Apollo.QueryResult<GetProductRatingsReviewsByProductIdQuery, GetProductRatingsReviewsByProductIdQueryVariables>;
export const ProductSetSizeListByCategoryDocument = gql`
    query ProductSetSizeListByCategory($categoryId: ID!) {
  productSetSizeListByCategory(categoryId: $categoryId) {
    data {
      _id
      subCategoryName
      subCategoryImage
      subCategoryLevel
      isActive
      sizeSets {
        _id
        sizeGroupTitle
        values {
          _id
          sizeValue
        }
      }
      productCount
    }
  }
}
    `;

/**
 * __useProductSetSizeListByCategoryQuery__
 *
 * To run a query within a React component, call `useProductSetSizeListByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSetSizeListByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSetSizeListByCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useProductSetSizeListByCategoryQuery(baseOptions: Apollo.QueryHookOptions<ProductSetSizeListByCategoryQuery, ProductSetSizeListByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSetSizeListByCategoryQuery, ProductSetSizeListByCategoryQueryVariables>(ProductSetSizeListByCategoryDocument, options);
      }
export function useProductSetSizeListByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSetSizeListByCategoryQuery, ProductSetSizeListByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSetSizeListByCategoryQuery, ProductSetSizeListByCategoryQueryVariables>(ProductSetSizeListByCategoryDocument, options);
        }
export type ProductSetSizeListByCategoryQueryHookResult = ReturnType<typeof useProductSetSizeListByCategoryQuery>;
export type ProductSetSizeListByCategoryLazyQueryHookResult = ReturnType<typeof useProductSetSizeListByCategoryLazyQuery>;
export type ProductSetSizeListByCategoryQueryResult = Apollo.QueryResult<ProductSetSizeListByCategoryQuery, ProductSetSizeListByCategoryQueryVariables>;
export const ProductSetSizeListBySubCategoryDocument = gql`
    query ProductSetSizeListBySubCategory($categoryId: ID!, $subCategoryId: ID) {
  productSetSizeListBySubCategory(
    categoryId: $categoryId
    subCategoryId: $subCategoryId
  ) {
    data {
      _id
      sizeGroupTitle
      values {
        _id
        sizeValue
      }
    }
    productCount
  }
}
    `;

/**
 * __useProductSetSizeListBySubCategoryQuery__
 *
 * To run a query within a React component, call `useProductSetSizeListBySubCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSetSizeListBySubCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSetSizeListBySubCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      subCategoryId: // value for 'subCategoryId'
 *   },
 * });
 */
export function useProductSetSizeListBySubCategoryQuery(baseOptions: Apollo.QueryHookOptions<ProductSetSizeListBySubCategoryQuery, ProductSetSizeListBySubCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSetSizeListBySubCategoryQuery, ProductSetSizeListBySubCategoryQueryVariables>(ProductSetSizeListBySubCategoryDocument, options);
      }
export function useProductSetSizeListBySubCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSetSizeListBySubCategoryQuery, ProductSetSizeListBySubCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSetSizeListBySubCategoryQuery, ProductSetSizeListBySubCategoryQueryVariables>(ProductSetSizeListBySubCategoryDocument, options);
        }
export type ProductSetSizeListBySubCategoryQueryHookResult = ReturnType<typeof useProductSetSizeListBySubCategoryQuery>;
export type ProductSetSizeListBySubCategoryLazyQueryHookResult = ReturnType<typeof useProductSetSizeListBySubCategoryLazyQuery>;
export type ProductSetSizeListBySubCategoryQueryResult = Apollo.QueryResult<ProductSetSizeListBySubCategoryQuery, ProductSetSizeListBySubCategoryQueryVariables>;
export const ManageProductSetSizesDocument = gql`
    mutation ManageProductSetSizes($categoryId: ID!, $subCategoryId: ID!, $deletedPayload: [ID!], $addUpdatedPayload: [ProductSetSizeTypesAndValuesInput!]!) {
  manageProductSetSizes(
    categoryId: $categoryId
    subCategoryId: $subCategoryId
    deletedPayload: $deletedPayload
    addUpdatedPayload: $addUpdatedPayload
  ) {
    code
    message
  }
}
    `;
export type ManageProductSetSizesMutationFn = Apollo.MutationFunction<ManageProductSetSizesMutation, ManageProductSetSizesMutationVariables>;

/**
 * __useManageProductSetSizesMutation__
 *
 * To run a mutation, you first call `useManageProductSetSizesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageProductSetSizesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageProductSetSizesMutation, { data, loading, error }] = useManageProductSetSizesMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      subCategoryId: // value for 'subCategoryId'
 *      deletedPayload: // value for 'deletedPayload'
 *      addUpdatedPayload: // value for 'addUpdatedPayload'
 *   },
 * });
 */
export function useManageProductSetSizesMutation(baseOptions?: Apollo.MutationHookOptions<ManageProductSetSizesMutation, ManageProductSetSizesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageProductSetSizesMutation, ManageProductSetSizesMutationVariables>(ManageProductSetSizesDocument, options);
      }
export type ManageProductSetSizesMutationHookResult = ReturnType<typeof useManageProductSetSizesMutation>;
export type ManageProductSetSizesMutationResult = Apollo.MutationResult<ManageProductSetSizesMutation>;
export type ManageProductSetSizesMutationOptions = Apollo.BaseMutationOptions<ManageProductSetSizesMutation, ManageProductSetSizesMutationVariables>;
export const ProductAttributeSetSizeListingDocument = gql`
    query ProductAttributeSetSizeListing($categoryId: ID!, $page: Float!, $limit: Float!) {
  productAttributeSetSizeListing(
    categoryId: $categoryId
    page: $page
    limit: $limit
  ) {
    data {
      sizeGroupId
      categoryId
      sizeGroupTitle
      values {
        _id
        sizeValue
      }
      subCategoryIds
      subCategories
    }
    totalRecords
  }
}
    `;

/**
 * __useProductAttributeSetSizeListingQuery__
 *
 * To run a query within a React component, call `useProductAttributeSetSizeListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAttributeSetSizeListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAttributeSetSizeListingQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductAttributeSetSizeListingQuery(baseOptions: Apollo.QueryHookOptions<ProductAttributeSetSizeListingQuery, ProductAttributeSetSizeListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAttributeSetSizeListingQuery, ProductAttributeSetSizeListingQueryVariables>(ProductAttributeSetSizeListingDocument, options);
      }
export function useProductAttributeSetSizeListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAttributeSetSizeListingQuery, ProductAttributeSetSizeListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAttributeSetSizeListingQuery, ProductAttributeSetSizeListingQueryVariables>(ProductAttributeSetSizeListingDocument, options);
        }
export type ProductAttributeSetSizeListingQueryHookResult = ReturnType<typeof useProductAttributeSetSizeListingQuery>;
export type ProductAttributeSetSizeListingLazyQueryHookResult = ReturnType<typeof useProductAttributeSetSizeListingLazyQuery>;
export type ProductAttributeSetSizeListingQueryResult = Apollo.QueryResult<ProductAttributeSetSizeListingQuery, ProductAttributeSetSizeListingQueryVariables>;
export const ProductSetSizesGroupsListingDocument = gql`
    query ProductSetSizesGroupsListing {
  productSetSizesGroupsListing {
    _id
    sizeGroupTitle
  }
}
    `;

/**
 * __useProductSetSizesGroupsListingQuery__
 *
 * To run a query within a React component, call `useProductSetSizesGroupsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSetSizesGroupsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSetSizesGroupsListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductSetSizesGroupsListingQuery(baseOptions?: Apollo.QueryHookOptions<ProductSetSizesGroupsListingQuery, ProductSetSizesGroupsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSetSizesGroupsListingQuery, ProductSetSizesGroupsListingQueryVariables>(ProductSetSizesGroupsListingDocument, options);
      }
export function useProductSetSizesGroupsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSetSizesGroupsListingQuery, ProductSetSizesGroupsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSetSizesGroupsListingQuery, ProductSetSizesGroupsListingQueryVariables>(ProductSetSizesGroupsListingDocument, options);
        }
export type ProductSetSizesGroupsListingQueryHookResult = ReturnType<typeof useProductSetSizesGroupsListingQuery>;
export type ProductSetSizesGroupsListingLazyQueryHookResult = ReturnType<typeof useProductSetSizesGroupsListingLazyQuery>;
export type ProductSetSizesGroupsListingQueryResult = Apollo.QueryResult<ProductSetSizesGroupsListingQuery, ProductSetSizesGroupsListingQueryVariables>;
export const ManageAttributeProductSetSizesDocument = gql`
    mutation ManageAttributeProductSetSizes($input: ProductAttributeSetSizeInput!) {
  manageAttributeProductSetSizes(input: $input) {
    code
    message
  }
}
    `;
export type ManageAttributeProductSetSizesMutationFn = Apollo.MutationFunction<ManageAttributeProductSetSizesMutation, ManageAttributeProductSetSizesMutationVariables>;

/**
 * __useManageAttributeProductSetSizesMutation__
 *
 * To run a mutation, you first call `useManageAttributeProductSetSizesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageAttributeProductSetSizesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageAttributeProductSetSizesMutation, { data, loading, error }] = useManageAttributeProductSetSizesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManageAttributeProductSetSizesMutation(baseOptions?: Apollo.MutationHookOptions<ManageAttributeProductSetSizesMutation, ManageAttributeProductSetSizesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageAttributeProductSetSizesMutation, ManageAttributeProductSetSizesMutationVariables>(ManageAttributeProductSetSizesDocument, options);
      }
export type ManageAttributeProductSetSizesMutationHookResult = ReturnType<typeof useManageAttributeProductSetSizesMutation>;
export type ManageAttributeProductSetSizesMutationResult = Apollo.MutationResult<ManageAttributeProductSetSizesMutation>;
export type ManageAttributeProductSetSizesMutationOptions = Apollo.BaseMutationOptions<ManageAttributeProductSetSizesMutation, ManageAttributeProductSetSizesMutationVariables>;
export const ProductSetSizesGroupDetailsDocument = gql`
    query ProductSetSizesGroupDetails($sizeGroupId: ID!) {
  productSetSizesGroupDetails(sizeGroupId: $sizeGroupId) {
    categoryId
    subCategoryIds
    sizeGroupId
    sizeGroupTitle
    values {
      _id
      sizeValue
    }
  }
}
    `;

/**
 * __useProductSetSizesGroupDetailsQuery__
 *
 * To run a query within a React component, call `useProductSetSizesGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSetSizesGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSetSizesGroupDetailsQuery({
 *   variables: {
 *      sizeGroupId: // value for 'sizeGroupId'
 *   },
 * });
 */
export function useProductSetSizesGroupDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductSetSizesGroupDetailsQuery, ProductSetSizesGroupDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSetSizesGroupDetailsQuery, ProductSetSizesGroupDetailsQueryVariables>(ProductSetSizesGroupDetailsDocument, options);
      }
export function useProductSetSizesGroupDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSetSizesGroupDetailsQuery, ProductSetSizesGroupDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSetSizesGroupDetailsQuery, ProductSetSizesGroupDetailsQueryVariables>(ProductSetSizesGroupDetailsDocument, options);
        }
export type ProductSetSizesGroupDetailsQueryHookResult = ReturnType<typeof useProductSetSizesGroupDetailsQuery>;
export type ProductSetSizesGroupDetailsLazyQueryHookResult = ReturnType<typeof useProductSetSizesGroupDetailsLazyQuery>;
export type ProductSetSizesGroupDetailsQueryResult = Apollo.QueryResult<ProductSetSizesGroupDetailsQuery, ProductSetSizesGroupDetailsQueryVariables>;
export const AdminUpdateDocument = gql`
    mutation adminUpdate($_id: ID!, $fullName: String!, $password: String, $roleId: ID) {
  adminUpdate(
    _id: $_id
    fullName: $fullName
    password: $password
    roleId: $roleId
  ) {
    code
    message
    data {
      _id
      fullName
      __typename
    }
  }
}
    `;
export type AdminUpdateMutationFn = Apollo.MutationFunction<AdminUpdateMutation, AdminUpdateMutationVariables>;

/**
 * __useAdminUpdateMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMutation, { data, loading, error }] = useAdminUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      fullName: // value for 'fullName'
 *      password: // value for 'password'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAdminUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMutation, AdminUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMutation, AdminUpdateMutationVariables>(AdminUpdateDocument, options);
      }
export type AdminUpdateMutationHookResult = ReturnType<typeof useAdminUpdateMutation>;
export type AdminUpdateMutationResult = Apollo.MutationResult<AdminUpdateMutation>;
export type AdminUpdateMutationOptions = Apollo.BaseMutationOptions<AdminUpdateMutation, AdminUpdateMutationVariables>;
export const PromoteYourAdvListPaginationDocument = gql`
    query PromoteYourAdvListPagination($id: ID, $categoryId: ID, $search: String, $filterBy: String, $page: Float, $limit: Float) {
  promoteYourAdvListPagination(
    _id: $id
    categoryId: $categoryId
    search: $search
    filterBy: $filterBy
    page: $page
    limit: $limit
  ) {
    data {
      _id
      price
      categoryId
      categoryName
      advertisementType
      sectionType
      sectionTypeName
      uniqueImpressions
      bulkPrice {
        price
        days
      }
      totalAdvCounts
    }
    totalRecords
  }
}
    `;

/**
 * __usePromoteYourAdvListPaginationQuery__
 *
 * To run a query within a React component, call `usePromoteYourAdvListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoteYourAdvListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoteYourAdvListPaginationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *      filterBy: // value for 'filterBy'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePromoteYourAdvListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<PromoteYourAdvListPaginationQuery, PromoteYourAdvListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoteYourAdvListPaginationQuery, PromoteYourAdvListPaginationQueryVariables>(PromoteYourAdvListPaginationDocument, options);
      }
export function usePromoteYourAdvListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoteYourAdvListPaginationQuery, PromoteYourAdvListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoteYourAdvListPaginationQuery, PromoteYourAdvListPaginationQueryVariables>(PromoteYourAdvListPaginationDocument, options);
        }
export type PromoteYourAdvListPaginationQueryHookResult = ReturnType<typeof usePromoteYourAdvListPaginationQuery>;
export type PromoteYourAdvListPaginationLazyQueryHookResult = ReturnType<typeof usePromoteYourAdvListPaginationLazyQuery>;
export type PromoteYourAdvListPaginationQueryResult = Apollo.QueryResult<PromoteYourAdvListPaginationQuery, PromoteYourAdvListPaginationQueryVariables>;
export const PromoteYourAdvDetailsDocument = gql`
    query PromoteYourAdvDetails($id: ID, $categoryId: ID, $search: String, $filterBy: String, $page: Float, $limit: Float) {
  promoteYourAdvDetails(
    _id: $id
    categoryId: $categoryId
    search: $search
    filterBy: $filterBy
    page: $page
    limit: $limit
  ) {
    _id
    price
    categoryId
    categoryName
    advertisementType
    sectionType
    sectionTypeName
    uniqueImpressions
    bulkPrice {
      price
      days
    }
  }
}
    `;

/**
 * __usePromoteYourAdvDetailsQuery__
 *
 * To run a query within a React component, call `usePromoteYourAdvDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoteYourAdvDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoteYourAdvDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *      filterBy: // value for 'filterBy'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePromoteYourAdvDetailsQuery(baseOptions?: Apollo.QueryHookOptions<PromoteYourAdvDetailsQuery, PromoteYourAdvDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoteYourAdvDetailsQuery, PromoteYourAdvDetailsQueryVariables>(PromoteYourAdvDetailsDocument, options);
      }
export function usePromoteYourAdvDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoteYourAdvDetailsQuery, PromoteYourAdvDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoteYourAdvDetailsQuery, PromoteYourAdvDetailsQueryVariables>(PromoteYourAdvDetailsDocument, options);
        }
export type PromoteYourAdvDetailsQueryHookResult = ReturnType<typeof usePromoteYourAdvDetailsQuery>;
export type PromoteYourAdvDetailsLazyQueryHookResult = ReturnType<typeof usePromoteYourAdvDetailsLazyQuery>;
export type PromoteYourAdvDetailsQueryResult = Apollo.QueryResult<PromoteYourAdvDetailsQuery, PromoteYourAdvDetailsQueryVariables>;
export const UpdatePromoteYourAdvDocument = gql`
    mutation UpdatePromoteYourAdv($input: PromoteYourAdvUpdateInput!) {
  updatePromoteYourAdv(input: $input) {
    code
    message
  }
}
    `;
export type UpdatePromoteYourAdvMutationFn = Apollo.MutationFunction<UpdatePromoteYourAdvMutation, UpdatePromoteYourAdvMutationVariables>;

/**
 * __useUpdatePromoteYourAdvMutation__
 *
 * To run a mutation, you first call `useUpdatePromoteYourAdvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromoteYourAdvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromoteYourAdvMutation, { data, loading, error }] = useUpdatePromoteYourAdvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePromoteYourAdvMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePromoteYourAdvMutation, UpdatePromoteYourAdvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePromoteYourAdvMutation, UpdatePromoteYourAdvMutationVariables>(UpdatePromoteYourAdvDocument, options);
      }
export type UpdatePromoteYourAdvMutationHookResult = ReturnType<typeof useUpdatePromoteYourAdvMutation>;
export type UpdatePromoteYourAdvMutationResult = Apollo.MutationResult<UpdatePromoteYourAdvMutation>;
export type UpdatePromoteYourAdvMutationOptions = Apollo.BaseMutationOptions<UpdatePromoteYourAdvMutation, UpdatePromoteYourAdvMutationVariables>;
export const AddPromoteYourAdvDocument = gql`
    mutation AddPromoteYourAdv($input: PromoteYourAdvUpdateInput!) {
  addPromoteYourAdv(input: $input) {
    code
    message
  }
}
    `;
export type AddPromoteYourAdvMutationFn = Apollo.MutationFunction<AddPromoteYourAdvMutation, AddPromoteYourAdvMutationVariables>;

/**
 * __useAddPromoteYourAdvMutation__
 *
 * To run a mutation, you first call `useAddPromoteYourAdvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPromoteYourAdvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPromoteYourAdvMutation, { data, loading, error }] = useAddPromoteYourAdvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPromoteYourAdvMutation(baseOptions?: Apollo.MutationHookOptions<AddPromoteYourAdvMutation, AddPromoteYourAdvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPromoteYourAdvMutation, AddPromoteYourAdvMutationVariables>(AddPromoteYourAdvDocument, options);
      }
export type AddPromoteYourAdvMutationHookResult = ReturnType<typeof useAddPromoteYourAdvMutation>;
export type AddPromoteYourAdvMutationResult = Apollo.MutationResult<AddPromoteYourAdvMutation>;
export type AddPromoteYourAdvMutationOptions = Apollo.BaseMutationOptions<AddPromoteYourAdvMutation, AddPromoteYourAdvMutationVariables>;
export const AdvertisementSellerListDocument = gql`
    query AdvertisementSellerList {
  advertisementSellerList {
    email
    _id
    businessName
  }
}
    `;

/**
 * __useAdvertisementSellerListQuery__
 *
 * To run a query within a React component, call `useAdvertisementSellerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertisementSellerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertisementSellerListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdvertisementSellerListQuery(baseOptions?: Apollo.QueryHookOptions<AdvertisementSellerListQuery, AdvertisementSellerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvertisementSellerListQuery, AdvertisementSellerListQueryVariables>(AdvertisementSellerListDocument, options);
      }
export function useAdvertisementSellerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvertisementSellerListQuery, AdvertisementSellerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvertisementSellerListQuery, AdvertisementSellerListQueryVariables>(AdvertisementSellerListDocument, options);
        }
export type AdvertisementSellerListQueryHookResult = ReturnType<typeof useAdvertisementSellerListQuery>;
export type AdvertisementSellerListLazyQueryHookResult = ReturnType<typeof useAdvertisementSellerListLazyQuery>;
export type AdvertisementSellerListQueryResult = Apollo.QueryResult<AdvertisementSellerListQuery, AdvertisementSellerListQueryVariables>;
export const SubCategoryListAdvertisementDocument = gql`
    query SubCategoryListAdvertisement($categoryId: ID!) {
  subCategoryListAdvertisement(categoryId: $categoryId) {
    _id
    parentSubCategoryId
    parentSubCategoryName
  }
}
    `;

/**
 * __useSubCategoryListAdvertisementQuery__
 *
 * To run a query within a React component, call `useSubCategoryListAdvertisementQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubCategoryListAdvertisementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubCategoryListAdvertisementQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useSubCategoryListAdvertisementQuery(baseOptions: Apollo.QueryHookOptions<SubCategoryListAdvertisementQuery, SubCategoryListAdvertisementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubCategoryListAdvertisementQuery, SubCategoryListAdvertisementQueryVariables>(SubCategoryListAdvertisementDocument, options);
      }
export function useSubCategoryListAdvertisementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubCategoryListAdvertisementQuery, SubCategoryListAdvertisementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubCategoryListAdvertisementQuery, SubCategoryListAdvertisementQueryVariables>(SubCategoryListAdvertisementDocument, options);
        }
export type SubCategoryListAdvertisementQueryHookResult = ReturnType<typeof useSubCategoryListAdvertisementQuery>;
export type SubCategoryListAdvertisementLazyQueryHookResult = ReturnType<typeof useSubCategoryListAdvertisementLazyQuery>;
export type SubCategoryListAdvertisementQueryResult = Apollo.QueryResult<SubCategoryListAdvertisementQuery, SubCategoryListAdvertisementQueryVariables>;
export const AdvertisementBrandListDocument = gql`
    query AdvertisementBrandList {
  advertisementBrandList {
    _id
    brandName
    brandLogo
    parentSubCategoryId
    parentSubCategoryName
    apiSlug
  }
}
    `;

/**
 * __useAdvertisementBrandListQuery__
 *
 * To run a query within a React component, call `useAdvertisementBrandListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertisementBrandListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertisementBrandListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdvertisementBrandListQuery(baseOptions?: Apollo.QueryHookOptions<AdvertisementBrandListQuery, AdvertisementBrandListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvertisementBrandListQuery, AdvertisementBrandListQueryVariables>(AdvertisementBrandListDocument, options);
      }
export function useAdvertisementBrandListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvertisementBrandListQuery, AdvertisementBrandListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvertisementBrandListQuery, AdvertisementBrandListQueryVariables>(AdvertisementBrandListDocument, options);
        }
export type AdvertisementBrandListQueryHookResult = ReturnType<typeof useAdvertisementBrandListQuery>;
export type AdvertisementBrandListLazyQueryHookResult = ReturnType<typeof useAdvertisementBrandListLazyQuery>;
export type AdvertisementBrandListQueryResult = Apollo.QueryResult<AdvertisementBrandListQuery, AdvertisementBrandListQueryVariables>;
export const AddUpdateUserPromotedAdvDocument = gql`
    mutation AddUpdateUserPromotedAdv($input: UserPromotedAdvCreateUpdateInput!) {
  addUpdateUserPromotedAdv(input: $input) {
    code
    message
  }
}
    `;
export type AddUpdateUserPromotedAdvMutationFn = Apollo.MutationFunction<AddUpdateUserPromotedAdvMutation, AddUpdateUserPromotedAdvMutationVariables>;

/**
 * __useAddUpdateUserPromotedAdvMutation__
 *
 * To run a mutation, you first call `useAddUpdateUserPromotedAdvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateUserPromotedAdvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateUserPromotedAdvMutation, { data, loading, error }] = useAddUpdateUserPromotedAdvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateUserPromotedAdvMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateUserPromotedAdvMutation, AddUpdateUserPromotedAdvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateUserPromotedAdvMutation, AddUpdateUserPromotedAdvMutationVariables>(AddUpdateUserPromotedAdvDocument, options);
      }
export type AddUpdateUserPromotedAdvMutationHookResult = ReturnType<typeof useAddUpdateUserPromotedAdvMutation>;
export type AddUpdateUserPromotedAdvMutationResult = Apollo.MutationResult<AddUpdateUserPromotedAdvMutation>;
export type AddUpdateUserPromotedAdvMutationOptions = Apollo.BaseMutationOptions<AddUpdateUserPromotedAdvMutation, AddUpdateUserPromotedAdvMutationVariables>;
export const UpdateUserPromotedAdvStatusDocument = gql`
    mutation UpdateUserPromotedAdvStatus($id: ID!, $advertisementStatus: String) {
  updateUserPromotedAdvStatus(_id: $id, advertisementStatus: $advertisementStatus) {
    code
    message
  }
}
    `;
export type UpdateUserPromotedAdvStatusMutationFn = Apollo.MutationFunction<UpdateUserPromotedAdvStatusMutation, UpdateUserPromotedAdvStatusMutationVariables>;

/**
 * __useUpdateUserPromotedAdvStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserPromotedAdvStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPromotedAdvStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPromotedAdvStatusMutation, { data, loading, error }] = useUpdateUserPromotedAdvStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      advertisementStatus: // value for 'advertisementStatus'
 *   },
 * });
 */
export function useUpdateUserPromotedAdvStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPromotedAdvStatusMutation, UpdateUserPromotedAdvStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPromotedAdvStatusMutation, UpdateUserPromotedAdvStatusMutationVariables>(UpdateUserPromotedAdvStatusDocument, options);
      }
export type UpdateUserPromotedAdvStatusMutationHookResult = ReturnType<typeof useUpdateUserPromotedAdvStatusMutation>;
export type UpdateUserPromotedAdvStatusMutationResult = Apollo.MutationResult<UpdateUserPromotedAdvStatusMutation>;
export type UpdateUserPromotedAdvStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserPromotedAdvStatusMutation, UpdateUserPromotedAdvStatusMutationVariables>;
export const DeletUserPromotedAdvDocument = gql`
    mutation DeletUserPromotedAdv($id: ID!) {
  deletUserPromotedAdv(_id: $id) {
    code
    message
  }
}
    `;
export type DeletUserPromotedAdvMutationFn = Apollo.MutationFunction<DeletUserPromotedAdvMutation, DeletUserPromotedAdvMutationVariables>;

/**
 * __useDeletUserPromotedAdvMutation__
 *
 * To run a mutation, you first call `useDeletUserPromotedAdvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletUserPromotedAdvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletUserPromotedAdvMutation, { data, loading, error }] = useDeletUserPromotedAdvMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletUserPromotedAdvMutation(baseOptions?: Apollo.MutationHookOptions<DeletUserPromotedAdvMutation, DeletUserPromotedAdvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletUserPromotedAdvMutation, DeletUserPromotedAdvMutationVariables>(DeletUserPromotedAdvDocument, options);
      }
export type DeletUserPromotedAdvMutationHookResult = ReturnType<typeof useDeletUserPromotedAdvMutation>;
export type DeletUserPromotedAdvMutationResult = Apollo.MutationResult<DeletUserPromotedAdvMutation>;
export type DeletUserPromotedAdvMutationOptions = Apollo.BaseMutationOptions<DeletUserPromotedAdvMutation, DeletUserPromotedAdvMutationVariables>;
export const ManualOrderQuotationListDocument = gql`
    query ManualOrderQuotationList($page: Float!, $limit: Float!, $search: String) {
  manualOrderQuotationList(page: $page, limit: $limit, search: $search) {
    data {
      _id
      categoryName
      quotationOrderStatus
      buyerName
      businessName
      createdAt
    }
    totalRecords
  }
}
    `;

/**
 * __useManualOrderQuotationListQuery__
 *
 * To run a query within a React component, call `useManualOrderQuotationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualOrderQuotationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualOrderQuotationListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useManualOrderQuotationListQuery(baseOptions: Apollo.QueryHookOptions<ManualOrderQuotationListQuery, ManualOrderQuotationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualOrderQuotationListQuery, ManualOrderQuotationListQueryVariables>(ManualOrderQuotationListDocument, options);
      }
export function useManualOrderQuotationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualOrderQuotationListQuery, ManualOrderQuotationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualOrderQuotationListQuery, ManualOrderQuotationListQueryVariables>(ManualOrderQuotationListDocument, options);
        }
export type ManualOrderQuotationListQueryHookResult = ReturnType<typeof useManualOrderQuotationListQuery>;
export type ManualOrderQuotationListLazyQueryHookResult = ReturnType<typeof useManualOrderQuotationListLazyQuery>;
export type ManualOrderQuotationListQueryResult = Apollo.QueryResult<ManualOrderQuotationListQuery, ManualOrderQuotationListQueryVariables>;
export const AddManualQuotationPaymentDocument = gql`
    mutation AddManualQuotationPayment($input: ManualQuotationPaymentDetailInput!) {
  addManualQuotationPayment(input: $input) {
    code
    message
    data {
      receivedOrderAmount
    }
  }
}
    `;
export type AddManualQuotationPaymentMutationFn = Apollo.MutationFunction<AddManualQuotationPaymentMutation, AddManualQuotationPaymentMutationVariables>;

/**
 * __useAddManualQuotationPaymentMutation__
 *
 * To run a mutation, you first call `useAddManualQuotationPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManualQuotationPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManualQuotationPaymentMutation, { data, loading, error }] = useAddManualQuotationPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddManualQuotationPaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddManualQuotationPaymentMutation, AddManualQuotationPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddManualQuotationPaymentMutation, AddManualQuotationPaymentMutationVariables>(AddManualQuotationPaymentDocument, options);
      }
export type AddManualQuotationPaymentMutationHookResult = ReturnType<typeof useAddManualQuotationPaymentMutation>;
export type AddManualQuotationPaymentMutationResult = Apollo.MutationResult<AddManualQuotationPaymentMutation>;
export type AddManualQuotationPaymentMutationOptions = Apollo.BaseMutationOptions<AddManualQuotationPaymentMutation, AddManualQuotationPaymentMutationVariables>;
export const AddUpdateManualQuotationOrderDocument = gql`
    mutation AddUpdateManualQuotationOrder($input: ManualQuotationOrderAddUpdateInput!) {
  addUpdateManualQuotationOrder(input: $input) {
    code
    message
  }
}
    `;
export type AddUpdateManualQuotationOrderMutationFn = Apollo.MutationFunction<AddUpdateManualQuotationOrderMutation, AddUpdateManualQuotationOrderMutationVariables>;

/**
 * __useAddUpdateManualQuotationOrderMutation__
 *
 * To run a mutation, you first call `useAddUpdateManualQuotationOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateManualQuotationOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateManualQuotationOrderMutation, { data, loading, error }] = useAddUpdateManualQuotationOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateManualQuotationOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateManualQuotationOrderMutation, AddUpdateManualQuotationOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateManualQuotationOrderMutation, AddUpdateManualQuotationOrderMutationVariables>(AddUpdateManualQuotationOrderDocument, options);
      }
export type AddUpdateManualQuotationOrderMutationHookResult = ReturnType<typeof useAddUpdateManualQuotationOrderMutation>;
export type AddUpdateManualQuotationOrderMutationResult = Apollo.MutationResult<AddUpdateManualQuotationOrderMutation>;
export type AddUpdateManualQuotationOrderMutationOptions = Apollo.BaseMutationOptions<AddUpdateManualQuotationOrderMutation, AddUpdateManualQuotationOrderMutationVariables>;
export const ManualQuotationDetailDocument = gql`
    query ManualQuotationDetail($id: ID!) {
  manualQuotationDetail(_id: $id) {
    _id
    products {
      _id
      productId
      productName
      unitPrice
      quantity
      totalAmount
      productDescription
      unit
      hsnCode
      hsnCodeId
    }
    categoryId
    buyerId
    sellerId
    quotationOrderStatus
    shippingAddress {
      _id
      phoneNumber
      addressLine1
      cityId
      stateId
      pinCode
      addressType
      cityName
      stateName
      otherAddressTypeName
      gstNumber
      fullAddress
      countryCode
    }
    brokerName
    brokerContactNumber
    deliveryType
    buyerCreditBalance
    billingAddress {
      _id
      phoneNumber
      addressLine1
      cityId
      stateId
      pinCode
      addressType
      cityName
      stateName
      otherAddressTypeName
      gstNumber
      fullAddress
      countryCode
    }
    additionalCharges {
      _id
      type
      title
      amount
    }
    paymentTerms {
      isAdvancePayment
      isPaymentAgainstDelivery
      isCreditPayment
      creditLimitDays
      isSplitPayment
      onArrivalPaymentPercentage
      onDeliveryPaymentPercentage
    }
    transportDetails {
      transportName
      vehicleNumber
    }
    quotationDescription
    termsAndConditions
    receivedOrderAmount
    gstPercentage
    gstAmount
    cgstPercentage
    cgstAmount
    sgstPercentage
    sgstAmount
    igstPercentage
    igstAmount
    totalOrderAmount
    roundOffType
    roundOffAmount
    isQuotationConfirmed
    isQuotationCompleted
    isQuotationCancelled
    isSellerBuyerAddressSame
    buyerDetails {
      _id
      fullAddress
      buyerName
      businessName
      phoneNumber
    }
    salesOrderId
  }
}
    `;

/**
 * __useManualQuotationDetailQuery__
 *
 * To run a query within a React component, call `useManualQuotationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualQuotationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualQuotationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManualQuotationDetailQuery(baseOptions: Apollo.QueryHookOptions<ManualQuotationDetailQuery, ManualQuotationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualQuotationDetailQuery, ManualQuotationDetailQueryVariables>(ManualQuotationDetailDocument, options);
      }
export function useManualQuotationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualQuotationDetailQuery, ManualQuotationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualQuotationDetailQuery, ManualQuotationDetailQueryVariables>(ManualQuotationDetailDocument, options);
        }
export type ManualQuotationDetailQueryHookResult = ReturnType<typeof useManualQuotationDetailQuery>;
export type ManualQuotationDetailLazyQueryHookResult = ReturnType<typeof useManualQuotationDetailLazyQuery>;
export type ManualQuotationDetailQueryResult = Apollo.QueryResult<ManualQuotationDetailQuery, ManualQuotationDetailQueryVariables>;
export const UserListForQuotationDocument = gql`
    query UserListForQuotation($categoryId: ID, $filterBy: String, $search: String) {
  userListForQuotation(
    categoryId: $categoryId
    filterBy: $filterBy
    search: $search
  ) {
    _id
    businessName
    creditLimitAmount
    name
    phoneNumber
    sellerBusinessAddressDetails {
      fullAddress
      cityId
      stateId
      pinCode
      cityName
      stateName
    }
  }
}
    `;

/**
 * __useUserListForQuotationQuery__
 *
 * To run a query within a React component, call `useUserListForQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListForQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListForQuotationQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      filterBy: // value for 'filterBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUserListForQuotationQuery(baseOptions?: Apollo.QueryHookOptions<UserListForQuotationQuery, UserListForQuotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListForQuotationQuery, UserListForQuotationQueryVariables>(UserListForQuotationDocument, options);
      }
export function useUserListForQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListForQuotationQuery, UserListForQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListForQuotationQuery, UserListForQuotationQueryVariables>(UserListForQuotationDocument, options);
        }
export type UserListForQuotationQueryHookResult = ReturnType<typeof useUserListForQuotationQuery>;
export type UserListForQuotationLazyQueryHookResult = ReturnType<typeof useUserListForQuotationLazyQuery>;
export type UserListForQuotationQueryResult = Apollo.QueryResult<UserListForQuotationQuery, UserListForQuotationQueryVariables>;
export const UserAddressesListForQuotationDocument = gql`
    query UserAddressesListForQuotation($userId: ID!) {
  userAddressesListForQuotation(userId: $userId) {
    _id
    userId
    phoneNumber
    addressLine1
    cityName
    stateName
    landMark
    cityId
    stateId
    pinCode
    addressType
    otherAddressTypeName
    fullAddress
    isDefault
    gstNumber
  }
}
    `;

/**
 * __useUserAddressesListForQuotationQuery__
 *
 * To run a query within a React component, call `useUserAddressesListForQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressesListForQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAddressesListForQuotationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAddressesListForQuotationQuery(baseOptions: Apollo.QueryHookOptions<UserAddressesListForQuotationQuery, UserAddressesListForQuotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAddressesListForQuotationQuery, UserAddressesListForQuotationQueryVariables>(UserAddressesListForQuotationDocument, options);
      }
export function useUserAddressesListForQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAddressesListForQuotationQuery, UserAddressesListForQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAddressesListForQuotationQuery, UserAddressesListForQuotationQueryVariables>(UserAddressesListForQuotationDocument, options);
        }
export type UserAddressesListForQuotationQueryHookResult = ReturnType<typeof useUserAddressesListForQuotationQuery>;
export type UserAddressesListForQuotationLazyQueryHookResult = ReturnType<typeof useUserAddressesListForQuotationLazyQuery>;
export type UserAddressesListForQuotationQueryResult = Apollo.QueryResult<UserAddressesListForQuotationQuery, UserAddressesListForQuotationQueryVariables>;
export const GenerateJusPaySdkPayloadDocument = gql`
    mutation GenerateJusPaySDKPayload($userId: ID!, $amount: Float!) {
  generateJusPaySDKPayload(userId: $userId, amount: $amount) {
    code
    message
    data {
      jusPayResponse
    }
  }
}
    `;
export type GenerateJusPaySdkPayloadMutationFn = Apollo.MutationFunction<GenerateJusPaySdkPayloadMutation, GenerateJusPaySdkPayloadMutationVariables>;

/**
 * __useGenerateJusPaySdkPayloadMutation__
 *
 * To run a mutation, you first call `useGenerateJusPaySdkPayloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateJusPaySdkPayloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateJusPaySdkPayloadMutation, { data, loading, error }] = useGenerateJusPaySdkPayloadMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useGenerateJusPaySdkPayloadMutation(baseOptions?: Apollo.MutationHookOptions<GenerateJusPaySdkPayloadMutation, GenerateJusPaySdkPayloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateJusPaySdkPayloadMutation, GenerateJusPaySdkPayloadMutationVariables>(GenerateJusPaySdkPayloadDocument, options);
      }
export type GenerateJusPaySdkPayloadMutationHookResult = ReturnType<typeof useGenerateJusPaySdkPayloadMutation>;
export type GenerateJusPaySdkPayloadMutationResult = Apollo.MutationResult<GenerateJusPaySdkPayloadMutation>;
export type GenerateJusPaySdkPayloadMutationOptions = Apollo.BaseMutationOptions<GenerateJusPaySdkPayloadMutation, GenerateJusPaySdkPayloadMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: UserRegisterInput!) {
  createUser(input: $input) {
    code
    message
    data {
      _id
      email
      phoneNumber
      name
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const ManualSubOrderQuotationListDocument = gql`
    query ManualSubOrderQuotationList($page: Float!, $limit: Float!, $manualQuotationOrderId: ID) {
  manualSubOrderQuotationList(
    page: $page
    limit: $limit
    manualQuotationOrderId: $manualQuotationOrderId
  ) {
    data {
      _id
      manualQuotationOrderId
      subOrderNumberId
      productName
      orderVerificationStatus
      trackingOrderStatus
      createdAt
      updatedAt
    }
    totalRecords
    buyerDetails {
      _id
      fullAddress
      buyerName
      businessName
      phoneNumber
    }
    isQuotationCancelled
    totalOrderAmount
    receivedOrderAmount
    salesOrderId
    salesOrderDocument
    isQuotationCompleted
  }
}
    `;

/**
 * __useManualSubOrderQuotationListQuery__
 *
 * To run a query within a React component, call `useManualSubOrderQuotationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualSubOrderQuotationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualSubOrderQuotationListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      manualQuotationOrderId: // value for 'manualQuotationOrderId'
 *   },
 * });
 */
export function useManualSubOrderQuotationListQuery(baseOptions: Apollo.QueryHookOptions<ManualSubOrderQuotationListQuery, ManualSubOrderQuotationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualSubOrderQuotationListQuery, ManualSubOrderQuotationListQueryVariables>(ManualSubOrderQuotationListDocument, options);
      }
export function useManualSubOrderQuotationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualSubOrderQuotationListQuery, ManualSubOrderQuotationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualSubOrderQuotationListQuery, ManualSubOrderQuotationListQueryVariables>(ManualSubOrderQuotationListDocument, options);
        }
export type ManualSubOrderQuotationListQueryHookResult = ReturnType<typeof useManualSubOrderQuotationListQuery>;
export type ManualSubOrderQuotationListLazyQueryHookResult = ReturnType<typeof useManualSubOrderQuotationListLazyQuery>;
export type ManualSubOrderQuotationListQueryResult = Apollo.QueryResult<ManualSubOrderQuotationListQuery, ManualSubOrderQuotationListQueryVariables>;
export const AddManualQuotationSubOrderDocument = gql`
    mutation AddManualQuotationSubOrder($input: ManualQuotationSubOrderAddInput!) {
  addManualQuotationSubOrder(input: $input) {
    code
    message
  }
}
    `;
export type AddManualQuotationSubOrderMutationFn = Apollo.MutationFunction<AddManualQuotationSubOrderMutation, AddManualQuotationSubOrderMutationVariables>;

/**
 * __useAddManualQuotationSubOrderMutation__
 *
 * To run a mutation, you first call `useAddManualQuotationSubOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManualQuotationSubOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManualQuotationSubOrderMutation, { data, loading, error }] = useAddManualQuotationSubOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddManualQuotationSubOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddManualQuotationSubOrderMutation, AddManualQuotationSubOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddManualQuotationSubOrderMutation, AddManualQuotationSubOrderMutationVariables>(AddManualQuotationSubOrderDocument, options);
      }
export type AddManualQuotationSubOrderMutationHookResult = ReturnType<typeof useAddManualQuotationSubOrderMutation>;
export type AddManualQuotationSubOrderMutationResult = Apollo.MutationResult<AddManualQuotationSubOrderMutation>;
export type AddManualQuotationSubOrderMutationOptions = Apollo.BaseMutationOptions<AddManualQuotationSubOrderMutation, AddManualQuotationSubOrderMutationVariables>;
export const ManualQuotationGstDetailsDocument = gql`
    query ManualQuotationGSTDetails($productId: ID!, $totalAmount: Float!, $isSellerBuyerAddressSame: Boolean!) {
  manualQuotationGSTDetails(
    productId: $productId
    totalAmount: $totalAmount
    isSellerBuyerAddressSame: $isSellerBuyerAddressSame
  ) {
    gstPercentage
    gstAmount
    cgstPercentage
    cgstAmount
    sgstPercentage
    sgstAmount
    igstPercentage
    igstAmount
    totalOrderAmount
    roundOffType
    roundOffAmount
  }
}
    `;

/**
 * __useManualQuotationGstDetailsQuery__
 *
 * To run a query within a React component, call `useManualQuotationGstDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualQuotationGstDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualQuotationGstDetailsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      totalAmount: // value for 'totalAmount'
 *      isSellerBuyerAddressSame: // value for 'isSellerBuyerAddressSame'
 *   },
 * });
 */
export function useManualQuotationGstDetailsQuery(baseOptions: Apollo.QueryHookOptions<ManualQuotationGstDetailsQuery, ManualQuotationGstDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualQuotationGstDetailsQuery, ManualQuotationGstDetailsQueryVariables>(ManualQuotationGstDetailsDocument, options);
      }
export function useManualQuotationGstDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualQuotationGstDetailsQuery, ManualQuotationGstDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualQuotationGstDetailsQuery, ManualQuotationGstDetailsQueryVariables>(ManualQuotationGstDetailsDocument, options);
        }
export type ManualQuotationGstDetailsQueryHookResult = ReturnType<typeof useManualQuotationGstDetailsQuery>;
export type ManualQuotationGstDetailsLazyQueryHookResult = ReturnType<typeof useManualQuotationGstDetailsLazyQuery>;
export type ManualQuotationGstDetailsQueryResult = Apollo.QueryResult<ManualQuotationGstDetailsQuery, ManualQuotationGstDetailsQueryVariables>;
export const UpdateManualQuotationConfirmationStatusDocument = gql`
    mutation UpdateManualQuotationConfirmationStatus($id: ID!) {
  updateManualQuotationConfirmationStatus(_id: $id) {
    code
    message
  }
}
    `;
export type UpdateManualQuotationConfirmationStatusMutationFn = Apollo.MutationFunction<UpdateManualQuotationConfirmationStatusMutation, UpdateManualQuotationConfirmationStatusMutationVariables>;

/**
 * __useUpdateManualQuotationConfirmationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateManualQuotationConfirmationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualQuotationConfirmationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualQuotationConfirmationStatusMutation, { data, loading, error }] = useUpdateManualQuotationConfirmationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateManualQuotationConfirmationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualQuotationConfirmationStatusMutation, UpdateManualQuotationConfirmationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManualQuotationConfirmationStatusMutation, UpdateManualQuotationConfirmationStatusMutationVariables>(UpdateManualQuotationConfirmationStatusDocument, options);
      }
export type UpdateManualQuotationConfirmationStatusMutationHookResult = ReturnType<typeof useUpdateManualQuotationConfirmationStatusMutation>;
export type UpdateManualQuotationConfirmationStatusMutationResult = Apollo.MutationResult<UpdateManualQuotationConfirmationStatusMutation>;
export type UpdateManualQuotationConfirmationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateManualQuotationConfirmationStatusMutation, UpdateManualQuotationConfirmationStatusMutationVariables>;
export const UpdateManualQuotationCompletedStatusDocument = gql`
    mutation UpdateManualQuotationCompletedStatus($id: ID!) {
  updateManualQuotationCompletedStatus(_id: $id) {
    code
    message
  }
}
    `;
export type UpdateManualQuotationCompletedStatusMutationFn = Apollo.MutationFunction<UpdateManualQuotationCompletedStatusMutation, UpdateManualQuotationCompletedStatusMutationVariables>;

/**
 * __useUpdateManualQuotationCompletedStatusMutation__
 *
 * To run a mutation, you first call `useUpdateManualQuotationCompletedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualQuotationCompletedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualQuotationCompletedStatusMutation, { data, loading, error }] = useUpdateManualQuotationCompletedStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateManualQuotationCompletedStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualQuotationCompletedStatusMutation, UpdateManualQuotationCompletedStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManualQuotationCompletedStatusMutation, UpdateManualQuotationCompletedStatusMutationVariables>(UpdateManualQuotationCompletedStatusDocument, options);
      }
export type UpdateManualQuotationCompletedStatusMutationHookResult = ReturnType<typeof useUpdateManualQuotationCompletedStatusMutation>;
export type UpdateManualQuotationCompletedStatusMutationResult = Apollo.MutationResult<UpdateManualQuotationCompletedStatusMutation>;
export type UpdateManualQuotationCompletedStatusMutationOptions = Apollo.BaseMutationOptions<UpdateManualQuotationCompletedStatusMutation, UpdateManualQuotationCompletedStatusMutationVariables>;
export const ManualQuotationSubOrderDetailDocument = gql`
    query ManualQuotationSubOrderDetail($id: ID!) {
  manualQuotationSubOrderDetail(_id: $id) {
    _id
    manualQuotationOrderId
    products {
      _id
      productId
      productName
      unitPrice
      quantity
      totalAmount
      productDescription
      unit
      hsnCode
      hsnCodeId
    }
    trackingOrderStatus
    orderVerificationStatus
    subOrderNumberId
    invoiceNumberId
    additionalCharges {
      _id
      type
      title
      amount
    }
    transportDetails {
      transportName
      vehicleNumber
    }
    quotationDescription
    termsAndConditions
    receivedOrderAmount
    gstPercentage
    gstAmount
    cgstPercentage
    cgstAmount
    sgstPercentage
    sgstAmount
    igstPercentage
    igstAmount
    totalOrderAmount
    roundOffType
    roundOffAmount
    eWayBillNumber
    buyerDetails {
      _id
      fullAddress
      buyerName
      businessName
      phoneNumber
    }
    shipmentTrackingDetails {
      trackingStatus
      trackingStatusName
      trackingDateTime
    }
  }
}
    `;

/**
 * __useManualQuotationSubOrderDetailQuery__
 *
 * To run a query within a React component, call `useManualQuotationSubOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualQuotationSubOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualQuotationSubOrderDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManualQuotationSubOrderDetailQuery(baseOptions: Apollo.QueryHookOptions<ManualQuotationSubOrderDetailQuery, ManualQuotationSubOrderDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualQuotationSubOrderDetailQuery, ManualQuotationSubOrderDetailQueryVariables>(ManualQuotationSubOrderDetailDocument, options);
      }
export function useManualQuotationSubOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualQuotationSubOrderDetailQuery, ManualQuotationSubOrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualQuotationSubOrderDetailQuery, ManualQuotationSubOrderDetailQueryVariables>(ManualQuotationSubOrderDetailDocument, options);
        }
export type ManualQuotationSubOrderDetailQueryHookResult = ReturnType<typeof useManualQuotationSubOrderDetailQuery>;
export type ManualQuotationSubOrderDetailLazyQueryHookResult = ReturnType<typeof useManualQuotationSubOrderDetailLazyQuery>;
export type ManualQuotationSubOrderDetailQueryResult = Apollo.QueryResult<ManualQuotationSubOrderDetailQuery, ManualQuotationSubOrderDetailQueryVariables>;
export const UpdateManualQuotationTrackingOrderStatusDocument = gql`
    mutation UpdateManualQuotationTrackingOrderStatus($id: ID!, $trackingOrderStatus: String) {
  updateManualQuotationTrackingOrderStatus(
    _id: $id
    trackingOrderStatus: $trackingOrderStatus
  ) {
    code
    message
  }
}
    `;
export type UpdateManualQuotationTrackingOrderStatusMutationFn = Apollo.MutationFunction<UpdateManualQuotationTrackingOrderStatusMutation, UpdateManualQuotationTrackingOrderStatusMutationVariables>;

/**
 * __useUpdateManualQuotationTrackingOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateManualQuotationTrackingOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualQuotationTrackingOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualQuotationTrackingOrderStatusMutation, { data, loading, error }] = useUpdateManualQuotationTrackingOrderStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingOrderStatus: // value for 'trackingOrderStatus'
 *   },
 * });
 */
export function useUpdateManualQuotationTrackingOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualQuotationTrackingOrderStatusMutation, UpdateManualQuotationTrackingOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManualQuotationTrackingOrderStatusMutation, UpdateManualQuotationTrackingOrderStatusMutationVariables>(UpdateManualQuotationTrackingOrderStatusDocument, options);
      }
export type UpdateManualQuotationTrackingOrderStatusMutationHookResult = ReturnType<typeof useUpdateManualQuotationTrackingOrderStatusMutation>;
export type UpdateManualQuotationTrackingOrderStatusMutationResult = Apollo.MutationResult<UpdateManualQuotationTrackingOrderStatusMutation>;
export type UpdateManualQuotationTrackingOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateManualQuotationTrackingOrderStatusMutation, UpdateManualQuotationTrackingOrderStatusMutationVariables>;
export const ManualQuotationPaymentHistoryListDocument = gql`
    query ManualQuotationPaymentHistoryList($page: Float!, $limit: Float!, $manualQuotationOrderId: ID) {
  manualQuotationPaymentHistoryList(
    page: $page
    limit: $limit
    manualQuotationOrderId: $manualQuotationOrderId
  ) {
    data {
      paymentLink
      paymentReferenceNumber
      paymentMode
      amount
      paymentDate
      paymentStatus
    }
    totalRecords
  }
}
    `;

/**
 * __useManualQuotationPaymentHistoryListQuery__
 *
 * To run a query within a React component, call `useManualQuotationPaymentHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualQuotationPaymentHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualQuotationPaymentHistoryListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      manualQuotationOrderId: // value for 'manualQuotationOrderId'
 *   },
 * });
 */
export function useManualQuotationPaymentHistoryListQuery(baseOptions: Apollo.QueryHookOptions<ManualQuotationPaymentHistoryListQuery, ManualQuotationPaymentHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualQuotationPaymentHistoryListQuery, ManualQuotationPaymentHistoryListQueryVariables>(ManualQuotationPaymentHistoryListDocument, options);
      }
export function useManualQuotationPaymentHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualQuotationPaymentHistoryListQuery, ManualQuotationPaymentHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualQuotationPaymentHistoryListQuery, ManualQuotationPaymentHistoryListQueryVariables>(ManualQuotationPaymentHistoryListDocument, options);
        }
export type ManualQuotationPaymentHistoryListQueryHookResult = ReturnType<typeof useManualQuotationPaymentHistoryListQuery>;
export type ManualQuotationPaymentHistoryListLazyQueryHookResult = ReturnType<typeof useManualQuotationPaymentHistoryListLazyQuery>;
export type ManualQuotationPaymentHistoryListQueryResult = Apollo.QueryResult<ManualQuotationPaymentHistoryListQuery, ManualQuotationPaymentHistoryListQueryVariables>;
export const ProductListForQuotationDocument = gql`
    query ProductListForQuotation($userId: ID, $categoryId: ID, $search: String) {
  productListForQuotation(
    userId: $userId
    categoryId: $categoryId
    search: $search
  ) {
    _id
    productName
    productImage
    productDescription
    hsnCodeId
    hsnCode
    unit
    availableQuantity
  }
}
    `;

/**
 * __useProductListForQuotationQuery__
 *
 * To run a query within a React component, call `useProductListForQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListForQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListForQuotationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      categoryId: // value for 'categoryId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProductListForQuotationQuery(baseOptions?: Apollo.QueryHookOptions<ProductListForQuotationQuery, ProductListForQuotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListForQuotationQuery, ProductListForQuotationQueryVariables>(ProductListForQuotationDocument, options);
      }
export function useProductListForQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListForQuotationQuery, ProductListForQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListForQuotationQuery, ProductListForQuotationQueryVariables>(ProductListForQuotationDocument, options);
        }
export type ProductListForQuotationQueryHookResult = ReturnType<typeof useProductListForQuotationQuery>;
export type ProductListForQuotationLazyQueryHookResult = ReturnType<typeof useProductListForQuotationLazyQuery>;
export type ProductListForQuotationQueryResult = Apollo.QueryResult<ProductListForQuotationQuery, ProductListForQuotationQueryVariables>;
export const ManageDocumentsForManualQuotationDocument = gql`
    mutation ManageDocumentsForManualQuotation($manualQuotationSubOrderId: ID!, $documentType: String!, $documentFileName: String!) {
  manageDocumentsForManualQuotation(
    manualQuotationSubOrderId: $manualQuotationSubOrderId
    documentType: $documentType
    documentFileName: $documentFileName
  ) {
    code
    message
  }
}
    `;
export type ManageDocumentsForManualQuotationMutationFn = Apollo.MutationFunction<ManageDocumentsForManualQuotationMutation, ManageDocumentsForManualQuotationMutationVariables>;

/**
 * __useManageDocumentsForManualQuotationMutation__
 *
 * To run a mutation, you first call `useManageDocumentsForManualQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageDocumentsForManualQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageDocumentsForManualQuotationMutation, { data, loading, error }] = useManageDocumentsForManualQuotationMutation({
 *   variables: {
 *      manualQuotationSubOrderId: // value for 'manualQuotationSubOrderId'
 *      documentType: // value for 'documentType'
 *      documentFileName: // value for 'documentFileName'
 *   },
 * });
 */
export function useManageDocumentsForManualQuotationMutation(baseOptions?: Apollo.MutationHookOptions<ManageDocumentsForManualQuotationMutation, ManageDocumentsForManualQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageDocumentsForManualQuotationMutation, ManageDocumentsForManualQuotationMutationVariables>(ManageDocumentsForManualQuotationDocument, options);
      }
export type ManageDocumentsForManualQuotationMutationHookResult = ReturnType<typeof useManageDocumentsForManualQuotationMutation>;
export type ManageDocumentsForManualQuotationMutationResult = Apollo.MutationResult<ManageDocumentsForManualQuotationMutation>;
export type ManageDocumentsForManualQuotationMutationOptions = Apollo.BaseMutationOptions<ManageDocumentsForManualQuotationMutation, ManageDocumentsForManualQuotationMutationVariables>;
export const ManageDocumentListDocument = gql`
    query ManageDocumentList($id: ID!) {
  manageDocumentList(_id: $id) {
    documentType
    documentName
    documentCreationDate
    documentFileName
  }
}
    `;

/**
 * __useManageDocumentListQuery__
 *
 * To run a query within a React component, call `useManageDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageDocumentListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManageDocumentListQuery(baseOptions: Apollo.QueryHookOptions<ManageDocumentListQuery, ManageDocumentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageDocumentListQuery, ManageDocumentListQueryVariables>(ManageDocumentListDocument, options);
      }
export function useManageDocumentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageDocumentListQuery, ManageDocumentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageDocumentListQuery, ManageDocumentListQueryVariables>(ManageDocumentListDocument, options);
        }
export type ManageDocumentListQueryHookResult = ReturnType<typeof useManageDocumentListQuery>;
export type ManageDocumentListLazyQueryHookResult = ReturnType<typeof useManageDocumentListLazyQuery>;
export type ManageDocumentListQueryResult = Apollo.QueryResult<ManageDocumentListQuery, ManageDocumentListQueryVariables>;
export const CancelManualQuotationOrderDocument = gql`
    mutation CancelManualQuotationOrder($id: ID!) {
  cancelManualQuotationOrder(_id: $id) {
    code
    message
  }
}
    `;
export type CancelManualQuotationOrderMutationFn = Apollo.MutationFunction<CancelManualQuotationOrderMutation, CancelManualQuotationOrderMutationVariables>;

/**
 * __useCancelManualQuotationOrderMutation__
 *
 * To run a mutation, you first call `useCancelManualQuotationOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelManualQuotationOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelManualQuotationOrderMutation, { data, loading, error }] = useCancelManualQuotationOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelManualQuotationOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelManualQuotationOrderMutation, CancelManualQuotationOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelManualQuotationOrderMutation, CancelManualQuotationOrderMutationVariables>(CancelManualQuotationOrderDocument, options);
      }
export type CancelManualQuotationOrderMutationHookResult = ReturnType<typeof useCancelManualQuotationOrderMutation>;
export type CancelManualQuotationOrderMutationResult = Apollo.MutationResult<CancelManualQuotationOrderMutation>;
export type CancelManualQuotationOrderMutationOptions = Apollo.BaseMutationOptions<CancelManualQuotationOrderMutation, CancelManualQuotationOrderMutationVariables>;
export const RolePaginationListDocument = gql`
    query rolePaginationList($search: String, $page: Float, $limit: Float) {
  rolePaginationList(search: $search, page: $page, limit: $limit) {
    data {
      _id
      roleName
      permissions
      roleType
      adminCount
    }
    totalRecords
  }
}
    `;

/**
 * __useRolePaginationListQuery__
 *
 * To run a query within a React component, call `useRolePaginationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolePaginationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolePaginationListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRolePaginationListQuery(baseOptions?: Apollo.QueryHookOptions<RolePaginationListQuery, RolePaginationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolePaginationListQuery, RolePaginationListQueryVariables>(RolePaginationListDocument, options);
      }
export function useRolePaginationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolePaginationListQuery, RolePaginationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolePaginationListQuery, RolePaginationListQueryVariables>(RolePaginationListDocument, options);
        }
export type RolePaginationListQueryHookResult = ReturnType<typeof useRolePaginationListQuery>;
export type RolePaginationListLazyQueryHookResult = ReturnType<typeof useRolePaginationListLazyQuery>;
export type RolePaginationListQueryResult = Apollo.QueryResult<RolePaginationListQuery, RolePaginationListQueryVariables>;
export const ModulePermissionListDocument = gql`
    query modulePermissionList($roleId: ID!) {
  modulePermissionList(roleId: $roleId) {
    moduleId
    moduleName
    moduleSlug
    permissions {
      permissionTypeId
      permissionId
      permissionTypeName
      permissionTypeSlug
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useModulePermissionListQuery__
 *
 * To run a query within a React component, call `useModulePermissionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useModulePermissionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModulePermissionListQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useModulePermissionListQuery(baseOptions: Apollo.QueryHookOptions<ModulePermissionListQuery, ModulePermissionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModulePermissionListQuery, ModulePermissionListQueryVariables>(ModulePermissionListDocument, options);
      }
export function useModulePermissionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModulePermissionListQuery, ModulePermissionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModulePermissionListQuery, ModulePermissionListQueryVariables>(ModulePermissionListDocument, options);
        }
export type ModulePermissionListQueryHookResult = ReturnType<typeof useModulePermissionListQuery>;
export type ModulePermissionListLazyQueryHookResult = ReturnType<typeof useModulePermissionListLazyQuery>;
export type ModulePermissionListQueryResult = Apollo.QueryResult<ModulePermissionListQuery, ModulePermissionListQueryVariables>;
export const RoleDetailsDocument = gql`
    query roleDetails($_id: ID!) {
  roleDetails(_id: $_id) {
    _id
    roleName
    permissions
  }
}
    `;

/**
 * __useRoleDetailsQuery__
 *
 * To run a query within a React component, call `useRoleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRoleDetailsQuery(baseOptions: Apollo.QueryHookOptions<RoleDetailsQuery, RoleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleDetailsQuery, RoleDetailsQueryVariables>(RoleDetailsDocument, options);
      }
export function useRoleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleDetailsQuery, RoleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleDetailsQuery, RoleDetailsQueryVariables>(RoleDetailsDocument, options);
        }
export type RoleDetailsQueryHookResult = ReturnType<typeof useRoleDetailsQuery>;
export type RoleDetailsLazyQueryHookResult = ReturnType<typeof useRoleDetailsLazyQuery>;
export type RoleDetailsQueryResult = Apollo.QueryResult<RoleDetailsQuery, RoleDetailsQueryVariables>;
export const AddRoleDocument = gql`
    mutation addRole($roleName: String!, $permissions: [String!]!) {
  addRole(input: {roleName: $roleName, permissions: $permissions}) {
    code
    message
  }
}
    `;
export type AddRoleMutationFn = Apollo.MutationFunction<AddRoleMutation, AddRoleMutationVariables>;

/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleMutation, { data, loading, error }] = useAddRoleMutation({
 *   variables: {
 *      roleName: // value for 'roleName'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAddRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddRoleMutation, AddRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoleMutation, AddRoleMutationVariables>(AddRoleDocument, options);
      }
export type AddRoleMutationHookResult = ReturnType<typeof useAddRoleMutation>;
export type AddRoleMutationResult = Apollo.MutationResult<AddRoleMutation>;
export type AddRoleMutationOptions = Apollo.BaseMutationOptions<AddRoleMutation, AddRoleMutationVariables>;
export const RoleUpdateDocument = gql`
    mutation roleUpdate($_id: ID!, $roleName: String!, $permissions: [String!]!) {
  roleUpdate(_id: $_id, roleName: $roleName, permissions: $permissions) {
    code
    message
  }
}
    `;
export type RoleUpdateMutationFn = Apollo.MutationFunction<RoleUpdateMutation, RoleUpdateMutationVariables>;

/**
 * __useRoleUpdateMutation__
 *
 * To run a mutation, you first call `useRoleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roleUpdateMutation, { data, loading, error }] = useRoleUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      roleName: // value for 'roleName'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useRoleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RoleUpdateMutation, RoleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoleUpdateMutation, RoleUpdateMutationVariables>(RoleUpdateDocument, options);
      }
export type RoleUpdateMutationHookResult = ReturnType<typeof useRoleUpdateMutation>;
export type RoleUpdateMutationResult = Apollo.MutationResult<RoleUpdateMutation>;
export type RoleUpdateMutationOptions = Apollo.BaseMutationOptions<RoleUpdateMutation, RoleUpdateMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($_id: ID!) {
  deleteRole(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const SellerPromotedAdvListDocument = gql`
    query sellerPromotedAdvList($page: Float, $limit: Float, $categoryId: ID, $sectionTypeId: ID, $advertisementStatus: String, $filterBy: String) {
  sellerPromotedAdvList(
    page: $page
    limit: $limit
    categoryId: $categoryId
    sectionTypeId: $sectionTypeId
    advertisementStatus: $advertisementStatus
    filterBy: $filterBy
  ) {
    data {
      _id
      sectionTypeId
      userId
      advertisementType
      bannerTitle
      bannerDescription
      perDayPrice
      startDate
      endDate
      totalDays
      totalPayableAmount
      categoryId
      bannerType
      brandId
      sellerId
      productId
      subCategoryIds
      addedBy
      brandName
      productName
      productImage
      sellerBusinessName
      verifiedByAdmin
      advertisementCancelReason
      advertisementStatus
      bannerImageMobile
      bannerImageWeb
      isPaymentDone
      sectionTypeName
      jusPayPaymentStatus
    }
    totalRecords
  }
}
    `;

/**
 * __useSellerPromotedAdvListQuery__
 *
 * To run a query within a React component, call `useSellerPromotedAdvListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerPromotedAdvListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerPromotedAdvListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      categoryId: // value for 'categoryId'
 *      sectionTypeId: // value for 'sectionTypeId'
 *      advertisementStatus: // value for 'advertisementStatus'
 *      filterBy: // value for 'filterBy'
 *   },
 * });
 */
export function useSellerPromotedAdvListQuery(baseOptions?: Apollo.QueryHookOptions<SellerPromotedAdvListQuery, SellerPromotedAdvListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerPromotedAdvListQuery, SellerPromotedAdvListQueryVariables>(SellerPromotedAdvListDocument, options);
      }
export function useSellerPromotedAdvListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerPromotedAdvListQuery, SellerPromotedAdvListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerPromotedAdvListQuery, SellerPromotedAdvListQueryVariables>(SellerPromotedAdvListDocument, options);
        }
export type SellerPromotedAdvListQueryHookResult = ReturnType<typeof useSellerPromotedAdvListQuery>;
export type SellerPromotedAdvListLazyQueryHookResult = ReturnType<typeof useSellerPromotedAdvListLazyQuery>;
export type SellerPromotedAdvListQueryResult = Apollo.QueryResult<SellerPromotedAdvListQuery, SellerPromotedAdvListQueryVariables>;
export const StateListDocument = gql`
    query StateList {
  stateList {
    _id
    name
    country_code
    state_code
  }
}
    `;

/**
 * __useStateListQuery__
 *
 * To run a query within a React component, call `useStateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateListQuery({
 *   variables: {
 *   },
 * });
 */
export function useStateListQuery(baseOptions?: Apollo.QueryHookOptions<StateListQuery, StateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StateListQuery, StateListQueryVariables>(StateListDocument, options);
      }
export function useStateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StateListQuery, StateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StateListQuery, StateListQueryVariables>(StateListDocument, options);
        }
export type StateListQueryHookResult = ReturnType<typeof useStateListQuery>;
export type StateListLazyQueryHookResult = ReturnType<typeof useStateListLazyQuery>;
export type StateListQueryResult = Apollo.QueryResult<StateListQuery, StateListQueryVariables>;
export const CityListDocument = gql`
    query CityList($countryCode: String!, $stateCode: String!) {
  cityList(country_code: $countryCode, state_code: $stateCode) {
    _id
    name
    country_code
    state_code
    latitude
    longitude
  }
}
    `;

/**
 * __useCityListQuery__
 *
 * To run a query within a React component, call `useCityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityListQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useCityListQuery(baseOptions: Apollo.QueryHookOptions<CityListQuery, CityListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CityListQuery, CityListQueryVariables>(CityListDocument, options);
      }
export function useCityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CityListQuery, CityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CityListQuery, CityListQueryVariables>(CityListDocument, options);
        }
export type CityListQueryHookResult = ReturnType<typeof useCityListQuery>;
export type CityListLazyQueryHookResult = ReturnType<typeof useCityListLazyQuery>;
export type CityListQueryResult = Apollo.QueryResult<CityListQuery, CityListQueryVariables>;
export const StaticPageListPaginationDocument = gql`
    query staticPageListPagination($search: String, $page: Float, $limit: Float) {
  staticPageListPagination(search: $search, page: $page, limit: $limit) {
    data {
      _id
      title
      description
      __typename
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useStaticPageListPaginationQuery__
 *
 * To run a query within a React component, call `useStaticPageListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticPageListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticPageListPaginationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useStaticPageListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<StaticPageListPaginationQuery, StaticPageListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticPageListPaginationQuery, StaticPageListPaginationQueryVariables>(StaticPageListPaginationDocument, options);
      }
export function useStaticPageListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticPageListPaginationQuery, StaticPageListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticPageListPaginationQuery, StaticPageListPaginationQueryVariables>(StaticPageListPaginationDocument, options);
        }
export type StaticPageListPaginationQueryHookResult = ReturnType<typeof useStaticPageListPaginationQuery>;
export type StaticPageListPaginationLazyQueryHookResult = ReturnType<typeof useStaticPageListPaginationLazyQuery>;
export type StaticPageListPaginationQueryResult = Apollo.QueryResult<StaticPageListPaginationQuery, StaticPageListPaginationQueryVariables>;
export const StaticPageDetailsDocument = gql`
    query staticPageDetails($_id: ID!) {
  staticPageDetails(_id: $_id) {
    _id
    title
    description
    __typename
  }
}
    `;

/**
 * __useStaticPageDetailsQuery__
 *
 * To run a query within a React component, call `useStaticPageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticPageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticPageDetailsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useStaticPageDetailsQuery(baseOptions: Apollo.QueryHookOptions<StaticPageDetailsQuery, StaticPageDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticPageDetailsQuery, StaticPageDetailsQueryVariables>(StaticPageDetailsDocument, options);
      }
export function useStaticPageDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticPageDetailsQuery, StaticPageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticPageDetailsQuery, StaticPageDetailsQueryVariables>(StaticPageDetailsDocument, options);
        }
export type StaticPageDetailsQueryHookResult = ReturnType<typeof useStaticPageDetailsQuery>;
export type StaticPageDetailsLazyQueryHookResult = ReturnType<typeof useStaticPageDetailsLazyQuery>;
export type StaticPageDetailsQueryResult = Apollo.QueryResult<StaticPageDetailsQuery, StaticPageDetailsQueryVariables>;
export const StaticPageAddDocument = gql`
    mutation staticPageAdd($title: String!, $slug: String!, $description: String!) {
  staticPageAdd(input: {title: $title, slug: $slug, description: $description}) {
    code
    message
  }
}
    `;
export type StaticPageAddMutationFn = Apollo.MutationFunction<StaticPageAddMutation, StaticPageAddMutationVariables>;

/**
 * __useStaticPageAddMutation__
 *
 * To run a mutation, you first call `useStaticPageAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStaticPageAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [staticPageAddMutation, { data, loading, error }] = useStaticPageAddMutation({
 *   variables: {
 *      title: // value for 'title'
 *      slug: // value for 'slug'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useStaticPageAddMutation(baseOptions?: Apollo.MutationHookOptions<StaticPageAddMutation, StaticPageAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StaticPageAddMutation, StaticPageAddMutationVariables>(StaticPageAddDocument, options);
      }
export type StaticPageAddMutationHookResult = ReturnType<typeof useStaticPageAddMutation>;
export type StaticPageAddMutationResult = Apollo.MutationResult<StaticPageAddMutation>;
export type StaticPageAddMutationOptions = Apollo.BaseMutationOptions<StaticPageAddMutation, StaticPageAddMutationVariables>;
export const StaticPageUpdateDocument = gql`
    mutation staticPageUpdate($_id: ID!, $title: String!, $description: String!) {
  staticPageUpdate(_id: $_id, title: $title, description: $description) {
    code
    message
  }
}
    `;
export type StaticPageUpdateMutationFn = Apollo.MutationFunction<StaticPageUpdateMutation, StaticPageUpdateMutationVariables>;

/**
 * __useStaticPageUpdateMutation__
 *
 * To run a mutation, you first call `useStaticPageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStaticPageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [staticPageUpdateMutation, { data, loading, error }] = useStaticPageUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useStaticPageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StaticPageUpdateMutation, StaticPageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StaticPageUpdateMutation, StaticPageUpdateMutationVariables>(StaticPageUpdateDocument, options);
      }
export type StaticPageUpdateMutationHookResult = ReturnType<typeof useStaticPageUpdateMutation>;
export type StaticPageUpdateMutationResult = Apollo.MutationResult<StaticPageUpdateMutation>;
export type StaticPageUpdateMutationOptions = Apollo.BaseMutationOptions<StaticPageUpdateMutation, StaticPageUpdateMutationVariables>;
export const DeleteStaticPageDocument = gql`
    mutation deleteStaticPage($_id: ID!) {
  deleteStaticPage(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteStaticPageMutationFn = Apollo.MutationFunction<DeleteStaticPageMutation, DeleteStaticPageMutationVariables>;

/**
 * __useDeleteStaticPageMutation__
 *
 * To run a mutation, you first call `useDeleteStaticPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStaticPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStaticPageMutation, { data, loading, error }] = useDeleteStaticPageMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteStaticPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStaticPageMutation, DeleteStaticPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStaticPageMutation, DeleteStaticPageMutationVariables>(DeleteStaticPageDocument, options);
      }
export type DeleteStaticPageMutationHookResult = ReturnType<typeof useDeleteStaticPageMutation>;
export type DeleteStaticPageMutationResult = Apollo.MutationResult<DeleteStaticPageMutation>;
export type DeleteStaticPageMutationOptions = Apollo.BaseMutationOptions<DeleteStaticPageMutation, DeleteStaticPageMutationVariables>;
export const TopDealsListDocument = gql`
    query TopDealsList($categoryId: ID) {
  topDealsList(categoryId: $categoryId) {
    _id
    dealName
    image
    categoryId
    subCategoryId
    price
    categoryName
    categorySlug
    subCategoryName
  }
}
    `;

/**
 * __useTopDealsListQuery__
 *
 * To run a query within a React component, call `useTopDealsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopDealsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopDealsListQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useTopDealsListQuery(baseOptions?: Apollo.QueryHookOptions<TopDealsListQuery, TopDealsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopDealsListQuery, TopDealsListQueryVariables>(TopDealsListDocument, options);
      }
export function useTopDealsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopDealsListQuery, TopDealsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopDealsListQuery, TopDealsListQueryVariables>(TopDealsListDocument, options);
        }
export type TopDealsListQueryHookResult = ReturnType<typeof useTopDealsListQuery>;
export type TopDealsListLazyQueryHookResult = ReturnType<typeof useTopDealsListLazyQuery>;
export type TopDealsListQueryResult = Apollo.QueryResult<TopDealsListQuery, TopDealsListQueryVariables>;
export const TopDealsListPaginationDocument = gql`
    query TopDealsListPagination($categoryId: ID!, $page: Float!, $limit: Float!, $search: String) {
  topDealsListPagination(
    categoryId: $categoryId
    page: $page
    limit: $limit
    search: $search
  ) {
    data {
      _id
      dealName
      image
      categoryId
      subCategoryId
      price
      categoryName
      categorySlug
      subCategoryName
    }
    totalRecords
  }
}
    `;

/**
 * __useTopDealsListPaginationQuery__
 *
 * To run a query within a React component, call `useTopDealsListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopDealsListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopDealsListPaginationQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTopDealsListPaginationQuery(baseOptions: Apollo.QueryHookOptions<TopDealsListPaginationQuery, TopDealsListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopDealsListPaginationQuery, TopDealsListPaginationQueryVariables>(TopDealsListPaginationDocument, options);
      }
export function useTopDealsListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopDealsListPaginationQuery, TopDealsListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopDealsListPaginationQuery, TopDealsListPaginationQueryVariables>(TopDealsListPaginationDocument, options);
        }
export type TopDealsListPaginationQueryHookResult = ReturnType<typeof useTopDealsListPaginationQuery>;
export type TopDealsListPaginationLazyQueryHookResult = ReturnType<typeof useTopDealsListPaginationLazyQuery>;
export type TopDealsListPaginationQueryResult = Apollo.QueryResult<TopDealsListPaginationQuery, TopDealsListPaginationQueryVariables>;
export const TopDealsDetailsByIdDocument = gql`
    query TopDealsDetailsById($categoryId: ID, $id: ID) {
  topDealsDetailsById(categoryId: $categoryId, _id: $id) {
    _id
    dealName
    image
    categoryId
    subCategoryId
    price
    categoryName
    categorySlug
    subCategoryName
  }
}
    `;

/**
 * __useTopDealsDetailsByIdQuery__
 *
 * To run a query within a React component, call `useTopDealsDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopDealsDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopDealsDetailsByIdQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTopDealsDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<TopDealsDetailsByIdQuery, TopDealsDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopDealsDetailsByIdQuery, TopDealsDetailsByIdQueryVariables>(TopDealsDetailsByIdDocument, options);
      }
export function useTopDealsDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopDealsDetailsByIdQuery, TopDealsDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopDealsDetailsByIdQuery, TopDealsDetailsByIdQueryVariables>(TopDealsDetailsByIdDocument, options);
        }
export type TopDealsDetailsByIdQueryHookResult = ReturnType<typeof useTopDealsDetailsByIdQuery>;
export type TopDealsDetailsByIdLazyQueryHookResult = ReturnType<typeof useTopDealsDetailsByIdLazyQuery>;
export type TopDealsDetailsByIdQueryResult = Apollo.QueryResult<TopDealsDetailsByIdQuery, TopDealsDetailsByIdQueryVariables>;
export const DeleteTopDealsDocument = gql`
    mutation DeleteTopDeals($id: ID) {
  deleteTopDeals(_id: $id) {
    code
    message
  }
}
    `;
export type DeleteTopDealsMutationFn = Apollo.MutationFunction<DeleteTopDealsMutation, DeleteTopDealsMutationVariables>;

/**
 * __useDeleteTopDealsMutation__
 *
 * To run a mutation, you first call `useDeleteTopDealsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTopDealsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTopDealsMutation, { data, loading, error }] = useDeleteTopDealsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTopDealsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTopDealsMutation, DeleteTopDealsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTopDealsMutation, DeleteTopDealsMutationVariables>(DeleteTopDealsDocument, options);
      }
export type DeleteTopDealsMutationHookResult = ReturnType<typeof useDeleteTopDealsMutation>;
export type DeleteTopDealsMutationResult = Apollo.MutationResult<DeleteTopDealsMutation>;
export type DeleteTopDealsMutationOptions = Apollo.BaseMutationOptions<DeleteTopDealsMutation, DeleteTopDealsMutationVariables>;
export const AddTopDealDocument = gql`
    mutation AddTopDeal($input: TopDealsCreateInput!) {
  addTopDeal(input: $input) {
    code
    message
  }
}
    `;
export type AddTopDealMutationFn = Apollo.MutationFunction<AddTopDealMutation, AddTopDealMutationVariables>;

/**
 * __useAddTopDealMutation__
 *
 * To run a mutation, you first call `useAddTopDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTopDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTopDealMutation, { data, loading, error }] = useAddTopDealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTopDealMutation(baseOptions?: Apollo.MutationHookOptions<AddTopDealMutation, AddTopDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTopDealMutation, AddTopDealMutationVariables>(AddTopDealDocument, options);
      }
export type AddTopDealMutationHookResult = ReturnType<typeof useAddTopDealMutation>;
export type AddTopDealMutationResult = Apollo.MutationResult<AddTopDealMutation>;
export type AddTopDealMutationOptions = Apollo.BaseMutationOptions<AddTopDealMutation, AddTopDealMutationVariables>;
export const UpdateTopDealDocument = gql`
    mutation UpdateTopDeal($image: String!, $price: Float!, $id: ID) {
  updateTopDeal(image: $image, price: $price, _id: $id) {
    code
    message
  }
}
    `;
export type UpdateTopDealMutationFn = Apollo.MutationFunction<UpdateTopDealMutation, UpdateTopDealMutationVariables>;

/**
 * __useUpdateTopDealMutation__
 *
 * To run a mutation, you first call `useUpdateTopDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopDealMutation, { data, loading, error }] = useUpdateTopDealMutation({
 *   variables: {
 *      image: // value for 'image'
 *      price: // value for 'price'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTopDealMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTopDealMutation, UpdateTopDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTopDealMutation, UpdateTopDealMutationVariables>(UpdateTopDealDocument, options);
      }
export type UpdateTopDealMutationHookResult = ReturnType<typeof useUpdateTopDealMutation>;
export type UpdateTopDealMutationResult = Apollo.MutationResult<UpdateTopDealMutation>;
export type UpdateTopDealMutationOptions = Apollo.BaseMutationOptions<UpdateTopDealMutation, UpdateTopDealMutationVariables>;
export const UserListPaginationDocument = gql`
    query userListPagination($filterBy: String, $search: String, $page: Float, $limit: Float, $kycStatusFilter: String) {
  userListPagination(
    filterBy: $filterBy
    search: $search
    page: $page
    limit: $limit
    kycStatusFilter: $kycStatusFilter
  ) {
    data {
      _id
      email
      phoneNumber
      name
      isActive
      businessName
      userType
      kycStatus
    }
    totalRecords
    __typename
  }
}
    `;

/**
 * __useUserListPaginationQuery__
 *
 * To run a query within a React component, call `useUserListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListPaginationQuery({
 *   variables: {
 *      filterBy: // value for 'filterBy'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      kycStatusFilter: // value for 'kycStatusFilter'
 *   },
 * });
 */
export function useUserListPaginationQuery(baseOptions?: Apollo.QueryHookOptions<UserListPaginationQuery, UserListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListPaginationQuery, UserListPaginationQueryVariables>(UserListPaginationDocument, options);
      }
export function useUserListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListPaginationQuery, UserListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListPaginationQuery, UserListPaginationQueryVariables>(UserListPaginationDocument, options);
        }
export type UserListPaginationQueryHookResult = ReturnType<typeof useUserListPaginationQuery>;
export type UserListPaginationLazyQueryHookResult = ReturnType<typeof useUserListPaginationLazyQuery>;
export type UserListPaginationQueryResult = Apollo.QueryResult<UserListPaginationQuery, UserListPaginationQueryVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($_id: ID!) {
  deleteUser(_id: $_id) {
    code
    message
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UserUpdateActiveStatusDocument = gql`
    mutation userUpdateActiveStatus($_id: ID!, $isActive: String!) {
  userActiveInActive(_id: $_id, isActive: $isActive) {
    code
    message
  }
}
    `;
export type UserUpdateActiveStatusMutationFn = Apollo.MutationFunction<UserUpdateActiveStatusMutation, UserUpdateActiveStatusMutationVariables>;

/**
 * __useUserUpdateActiveStatusMutation__
 *
 * To run a mutation, you first call `useUserUpdateActiveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateActiveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateActiveStatusMutation, { data, loading, error }] = useUserUpdateActiveStatusMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUserUpdateActiveStatusMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateActiveStatusMutation, UserUpdateActiveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateActiveStatusMutation, UserUpdateActiveStatusMutationVariables>(UserUpdateActiveStatusDocument, options);
      }
export type UserUpdateActiveStatusMutationHookResult = ReturnType<typeof useUserUpdateActiveStatusMutation>;
export type UserUpdateActiveStatusMutationResult = Apollo.MutationResult<UserUpdateActiveStatusMutation>;
export type UserUpdateActiveStatusMutationOptions = Apollo.BaseMutationOptions<UserUpdateActiveStatusMutation, UserUpdateActiveStatusMutationVariables>;
export const UserDetailsByIdDocument = gql`
    query userDetailsById($id: ID) {
  userDetailsById(_id: $id) {
    userPersonalDetails {
      _id
      email
      phoneNumber
      countryCode
      languageType
      name
      referralCode
      userType
      kycStatus
      sellerCancelReason
      verifiedByAdmin
      isSellerApplied
      cancelReasonTypes
      sellerProfileCompletionPercentage
      isAllowErpAccess
    }
    userBankAccountCounts
    userAddressesCounts
    userBusinessDetails {
      _id
      userId
      businessName
      businessTypeIds
      businessLogo
      businessDescription
      businessEstablishedDate
      isGstNumberVerified
      gstNumber
      companyPanNumber
      shopNumber
      streetAndArea
      landMark
      cityName
      stateName
      pinCode
      businessTypes {
        _id
        businessTypeName
      }
      products {
        categoryId
        categoryName
        categoryLogos {
          original
          medium
          small
        }
        productIds
        categoryProducts {
          _id
          subCategoryName
          subCategoryImage
          categoryId
          parentSubCategoryId
          subCategoryLevel
          isActive
        }
        productRangePrice {
          from
          to
        }
        productDesigns
        brandWebsite
      }
      businessTimings {
        sameEveryDay
        shopTimings {
          day
          timings {
            startTime
            endTime
          }
          status
        }
      }
      signatureImage
      aadharNumber
      businessEmail
      isAadharNumberVerified
      isBusinessEmailVerified
      annualTurnOver
      unit
    }
    userKycDocumentVerificationList {
      _id
      userId
      kycDocumentId
      kycDocumentVerificationNumber
      kycDocumentImage
      kycDocumentType
      kycDocumentStatus
      documentCancelReason
      verifiedByAdmin
      kycDocumentDetails {
        _id
        kycDocumentName
        kycDocumentSlug
        isRequired
      }
    }
    sellerComissionList {
      _id
      userId
      categoryId
      categoryName
      categorySlug
      isDefault
      comissionRate
    }
  }
}
    `;

/**
 * __useUserDetailsByIdQuery__
 *
 * To run a query within a React component, call `useUserDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailsByIdQuery, UserDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsByIdQuery, UserDetailsByIdQueryVariables>(UserDetailsByIdDocument, options);
      }
export function useUserDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsByIdQuery, UserDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsByIdQuery, UserDetailsByIdQueryVariables>(UserDetailsByIdDocument, options);
        }
export type UserDetailsByIdQueryHookResult = ReturnType<typeof useUserDetailsByIdQuery>;
export type UserDetailsByIdLazyQueryHookResult = ReturnType<typeof useUserDetailsByIdLazyQuery>;
export type UserDetailsByIdQueryResult = Apollo.QueryResult<UserDetailsByIdQuery, UserDetailsByIdQueryVariables>;
export const UserBankAccountListWithPaginationDocument = gql`
    query userBankAccountListWithPagination($userId: ID!, $search: String, $page: Float, $limit: Float) {
  userBankAccountListWithPagination(
    userId: $userId
    search: $search
    page: $page
    limit: $limit
  ) {
    data {
      _id
      userId
      ifscCode
      accountNumber
      accountType
      accountHolderName
      isDefault
      bankName
    }
    totalRecords
  }
}
    `;

/**
 * __useUserBankAccountListWithPaginationQuery__
 *
 * To run a query within a React component, call `useUserBankAccountListWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBankAccountListWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBankAccountListWithPaginationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserBankAccountListWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<UserBankAccountListWithPaginationQuery, UserBankAccountListWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBankAccountListWithPaginationQuery, UserBankAccountListWithPaginationQueryVariables>(UserBankAccountListWithPaginationDocument, options);
      }
export function useUserBankAccountListWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBankAccountListWithPaginationQuery, UserBankAccountListWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBankAccountListWithPaginationQuery, UserBankAccountListWithPaginationQueryVariables>(UserBankAccountListWithPaginationDocument, options);
        }
export type UserBankAccountListWithPaginationQueryHookResult = ReturnType<typeof useUserBankAccountListWithPaginationQuery>;
export type UserBankAccountListWithPaginationLazyQueryHookResult = ReturnType<typeof useUserBankAccountListWithPaginationLazyQuery>;
export type UserBankAccountListWithPaginationQueryResult = Apollo.QueryResult<UserBankAccountListWithPaginationQuery, UserBankAccountListWithPaginationQueryVariables>;
export const UserAddressesListWithPaginationDocument = gql`
    query UserAddressesListWithPagination($userId: ID!, $search: String, $limit: Float, $page: Float) {
  userAddressesListWithPagination(
    userId: $userId
    search: $search
    limit: $limit
    page: $page
  ) {
    data {
      _id
      userId
      phoneNumber
      addressLine1
      addressLine2
      landMark
      cityId
      stateId
      pinCode
      addressType
      isDefault
      cityName
      stateName
    }
    totalRecords
  }
}
    `;

/**
 * __useUserAddressesListWithPaginationQuery__
 *
 * To run a query within a React component, call `useUserAddressesListWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressesListWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAddressesListWithPaginationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUserAddressesListWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<UserAddressesListWithPaginationQuery, UserAddressesListWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAddressesListWithPaginationQuery, UserAddressesListWithPaginationQueryVariables>(UserAddressesListWithPaginationDocument, options);
      }
export function useUserAddressesListWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAddressesListWithPaginationQuery, UserAddressesListWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAddressesListWithPaginationQuery, UserAddressesListWithPaginationQueryVariables>(UserAddressesListWithPaginationDocument, options);
        }
export type UserAddressesListWithPaginationQueryHookResult = ReturnType<typeof useUserAddressesListWithPaginationQuery>;
export type UserAddressesListWithPaginationLazyQueryHookResult = ReturnType<typeof useUserAddressesListWithPaginationLazyQuery>;
export type UserAddressesListWithPaginationQueryResult = Apollo.QueryResult<UserAddressesListWithPaginationQuery, UserAddressesListWithPaginationQueryVariables>;
export const KycDocumentVerifiedByAdminDocument = gql`
    mutation kycDocumentVerifiedByAdmin($kycDocumentVerificationId: ID!, $documentVerified: String!, $documentCancelReason: String) {
  kycDocumentVerifiedByAdmin(
    kycDocumentVerificationId: $kycDocumentVerificationId
    documentVerified: $documentVerified
    documentCancelReason: $documentCancelReason
  ) {
    code
    message
    __typename
  }
}
    `;
export type KycDocumentVerifiedByAdminMutationFn = Apollo.MutationFunction<KycDocumentVerifiedByAdminMutation, KycDocumentVerifiedByAdminMutationVariables>;

/**
 * __useKycDocumentVerifiedByAdminMutation__
 *
 * To run a mutation, you first call `useKycDocumentVerifiedByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycDocumentVerifiedByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycDocumentVerifiedByAdminMutation, { data, loading, error }] = useKycDocumentVerifiedByAdminMutation({
 *   variables: {
 *      kycDocumentVerificationId: // value for 'kycDocumentVerificationId'
 *      documentVerified: // value for 'documentVerified'
 *      documentCancelReason: // value for 'documentCancelReason'
 *   },
 * });
 */
export function useKycDocumentVerifiedByAdminMutation(baseOptions?: Apollo.MutationHookOptions<KycDocumentVerifiedByAdminMutation, KycDocumentVerifiedByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycDocumentVerifiedByAdminMutation, KycDocumentVerifiedByAdminMutationVariables>(KycDocumentVerifiedByAdminDocument, options);
      }
export type KycDocumentVerifiedByAdminMutationHookResult = ReturnType<typeof useKycDocumentVerifiedByAdminMutation>;
export type KycDocumentVerifiedByAdminMutationResult = Apollo.MutationResult<KycDocumentVerifiedByAdminMutation>;
export type KycDocumentVerifiedByAdminMutationOptions = Apollo.BaseMutationOptions<KycDocumentVerifiedByAdminMutation, KycDocumentVerifiedByAdminMutationVariables>;
export const GetUserKycStatusDocument = gql`
    mutation getUserKycStatus($id: ID) {
  getUserKycStatus(_id: $id) {
    kycStatus
  }
}
    `;
export type GetUserKycStatusMutationFn = Apollo.MutationFunction<GetUserKycStatusMutation, GetUserKycStatusMutationVariables>;

/**
 * __useGetUserKycStatusMutation__
 *
 * To run a mutation, you first call `useGetUserKycStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUserKycStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUserKycStatusMutation, { data, loading, error }] = useGetUserKycStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserKycStatusMutation(baseOptions?: Apollo.MutationHookOptions<GetUserKycStatusMutation, GetUserKycStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetUserKycStatusMutation, GetUserKycStatusMutationVariables>(GetUserKycStatusDocument, options);
      }
export type GetUserKycStatusMutationHookResult = ReturnType<typeof useGetUserKycStatusMutation>;
export type GetUserKycStatusMutationResult = Apollo.MutationResult<GetUserKycStatusMutation>;
export type GetUserKycStatusMutationOptions = Apollo.BaseMutationOptions<GetUserKycStatusMutation, GetUserKycStatusMutationVariables>;
export const UpdateSellerComissionDetailsDocument = gql`
    mutation UpdateSellerComissionDetails($userId: ID!, $categoryId: ID!, $comissionRate: Float!) {
  updateSellerComissionDetails(
    userId: $userId
    categoryId: $categoryId
    comissionRate: $comissionRate
  ) {
    message
    code
  }
}
    `;
export type UpdateSellerComissionDetailsMutationFn = Apollo.MutationFunction<UpdateSellerComissionDetailsMutation, UpdateSellerComissionDetailsMutationVariables>;

/**
 * __useUpdateSellerComissionDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateSellerComissionDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerComissionDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerComissionDetailsMutation, { data, loading, error }] = useUpdateSellerComissionDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      categoryId: // value for 'categoryId'
 *      comissionRate: // value for 'comissionRate'
 *   },
 * });
 */
export function useUpdateSellerComissionDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerComissionDetailsMutation, UpdateSellerComissionDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerComissionDetailsMutation, UpdateSellerComissionDetailsMutationVariables>(UpdateSellerComissionDetailsDocument, options);
      }
export type UpdateSellerComissionDetailsMutationHookResult = ReturnType<typeof useUpdateSellerComissionDetailsMutation>;
export type UpdateSellerComissionDetailsMutationResult = Apollo.MutationResult<UpdateSellerComissionDetailsMutation>;
export type UpdateSellerComissionDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateSellerComissionDetailsMutation, UpdateSellerComissionDetailsMutationVariables>;
export const SellerApprovalDocument = gql`
    mutation SellerApproval($userId: ID!, $verifiedByAdmin: String!, $sellerCancelReason: String, $cancelReasonTypes: [String!]) {
  sellerApproval(
    userId: $userId
    verifiedByAdmin: $verifiedByAdmin
    sellerCancelReason: $sellerCancelReason
    cancelReasonTypes: $cancelReasonTypes
  ) {
    code
    message
  }
}
    `;
export type SellerApprovalMutationFn = Apollo.MutationFunction<SellerApprovalMutation, SellerApprovalMutationVariables>;

/**
 * __useSellerApprovalMutation__
 *
 * To run a mutation, you first call `useSellerApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellerApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellerApprovalMutation, { data, loading, error }] = useSellerApprovalMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      verifiedByAdmin: // value for 'verifiedByAdmin'
 *      sellerCancelReason: // value for 'sellerCancelReason'
 *      cancelReasonTypes: // value for 'cancelReasonTypes'
 *   },
 * });
 */
export function useSellerApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SellerApprovalMutation, SellerApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellerApprovalMutation, SellerApprovalMutationVariables>(SellerApprovalDocument, options);
      }
export type SellerApprovalMutationHookResult = ReturnType<typeof useSellerApprovalMutation>;
export type SellerApprovalMutationResult = Apollo.MutationResult<SellerApprovalMutation>;
export type SellerApprovalMutationOptions = Apollo.BaseMutationOptions<SellerApprovalMutation, SellerApprovalMutationVariables>;
export const GetUserBalanceDocument = gql`
    query GetUserBalance($userId: ID!, $page: Float!, $limit: Float!) {
  getUserBalance(userId: $userId, page: $page, limit: $limit) {
    data {
      _id
      userId
      amount
      description
      amountType
      orderNumberId
      createdAt
    }
    totalAmount
    totalRecords
  }
}
    `;

/**
 * __useGetUserBalanceQuery__
 *
 * To run a query within a React component, call `useGetUserBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBalanceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetUserBalanceQuery, GetUserBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBalanceQuery, GetUserBalanceQueryVariables>(GetUserBalanceDocument, options);
      }
export function useGetUserBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBalanceQuery, GetUserBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBalanceQuery, GetUserBalanceQueryVariables>(GetUserBalanceDocument, options);
        }
export type GetUserBalanceQueryHookResult = ReturnType<typeof useGetUserBalanceQuery>;
export type GetUserBalanceLazyQueryHookResult = ReturnType<typeof useGetUserBalanceLazyQuery>;
export type GetUserBalanceQueryResult = Apollo.QueryResult<GetUserBalanceQuery, GetUserBalanceQueryVariables>;
export const AddCreditDebitBalanceDocument = gql`
    mutation AddCreditDebitBalance($input: AddUserCreditDebitInput!) {
  addCreditDebitBalance(input: $input) {
    code
    message
  }
}
    `;
export type AddCreditDebitBalanceMutationFn = Apollo.MutationFunction<AddCreditDebitBalanceMutation, AddCreditDebitBalanceMutationVariables>;

/**
 * __useAddCreditDebitBalanceMutation__
 *
 * To run a mutation, you first call `useAddCreditDebitBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditDebitBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditDebitBalanceMutation, { data, loading, error }] = useAddCreditDebitBalanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCreditDebitBalanceMutation(baseOptions?: Apollo.MutationHookOptions<AddCreditDebitBalanceMutation, AddCreditDebitBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCreditDebitBalanceMutation, AddCreditDebitBalanceMutationVariables>(AddCreditDebitBalanceDocument, options);
      }
export type AddCreditDebitBalanceMutationHookResult = ReturnType<typeof useAddCreditDebitBalanceMutation>;
export type AddCreditDebitBalanceMutationResult = Apollo.MutationResult<AddCreditDebitBalanceMutation>;
export type AddCreditDebitBalanceMutationOptions = Apollo.BaseMutationOptions<AddCreditDebitBalanceMutation, AddCreditDebitBalanceMutationVariables>;
export const UpdateAllowErpAccessDocument = gql`
    query UpdateAllowErpAccess($id: ID) {
  updateAllowErpAccess(_id: $id) {
    code
    message
  }
}
    `;

/**
 * __useUpdateAllowErpAccessQuery__
 *
 * To run a query within a React component, call `useUpdateAllowErpAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowErpAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateAllowErpAccessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAllowErpAccessQuery(baseOptions?: Apollo.QueryHookOptions<UpdateAllowErpAccessQuery, UpdateAllowErpAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateAllowErpAccessQuery, UpdateAllowErpAccessQueryVariables>(UpdateAllowErpAccessDocument, options);
      }
export function useUpdateAllowErpAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateAllowErpAccessQuery, UpdateAllowErpAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateAllowErpAccessQuery, UpdateAllowErpAccessQueryVariables>(UpdateAllowErpAccessDocument, options);
        }
export type UpdateAllowErpAccessQueryHookResult = ReturnType<typeof useUpdateAllowErpAccessQuery>;
export type UpdateAllowErpAccessLazyQueryHookResult = ReturnType<typeof useUpdateAllowErpAccessLazyQuery>;
export type UpdateAllowErpAccessQueryResult = Apollo.QueryResult<UpdateAllowErpAccessQuery, UpdateAllowErpAccessQueryVariables>;
export const UpdateUserDetailsByAdminDocument = gql`
    mutation UpdateUserDetailsByAdmin($id: ID!, $email: String, $phoneNumber: Float, $countryCode: Float) {
  updateUserDetailsByAdmin(
    _id: $id
    email: $email
    phoneNumber: $phoneNumber
    countryCode: $countryCode
  ) {
    code
    message
  }
}
    `;
export type UpdateUserDetailsByAdminMutationFn = Apollo.MutationFunction<UpdateUserDetailsByAdminMutation, UpdateUserDetailsByAdminMutationVariables>;

/**
 * __useUpdateUserDetailsByAdminMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsByAdminMutation, { data, loading, error }] = useUpdateUserDetailsByAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useUpdateUserDetailsByAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsByAdminMutation, UpdateUserDetailsByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsByAdminMutation, UpdateUserDetailsByAdminMutationVariables>(UpdateUserDetailsByAdminDocument, options);
      }
export type UpdateUserDetailsByAdminMutationHookResult = ReturnType<typeof useUpdateUserDetailsByAdminMutation>;
export type UpdateUserDetailsByAdminMutationResult = Apollo.MutationResult<UpdateUserDetailsByAdminMutation>;
export type UpdateUserDetailsByAdminMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsByAdminMutation, UpdateUserDetailsByAdminMutationVariables>;
export const UserEscalatedIssuesListDocument = gql`
    query UserEscalatedIssuesList($page: Float!, $limit: Float!, $search: String) {
  userEscalatedIssuesList(page: $page, limit: $limit, search: $search) {
    data {
      _id
      userId
      userDetail {
        name
        businessName
      }
      subject
      queryDescription
      status
      ticketId
      createdAt
    }
    totalRecords
  }
}
    `;

/**
 * __useUserEscalatedIssuesListQuery__
 *
 * To run a query within a React component, call `useUserEscalatedIssuesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEscalatedIssuesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEscalatedIssuesListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUserEscalatedIssuesListQuery(baseOptions: Apollo.QueryHookOptions<UserEscalatedIssuesListQuery, UserEscalatedIssuesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEscalatedIssuesListQuery, UserEscalatedIssuesListQueryVariables>(UserEscalatedIssuesListDocument, options);
      }
export function useUserEscalatedIssuesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEscalatedIssuesListQuery, UserEscalatedIssuesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEscalatedIssuesListQuery, UserEscalatedIssuesListQueryVariables>(UserEscalatedIssuesListDocument, options);
        }
export type UserEscalatedIssuesListQueryHookResult = ReturnType<typeof useUserEscalatedIssuesListQuery>;
export type UserEscalatedIssuesListLazyQueryHookResult = ReturnType<typeof useUserEscalatedIssuesListLazyQuery>;
export type UserEscalatedIssuesListQueryResult = Apollo.QueryResult<UserEscalatedIssuesListQuery, UserEscalatedIssuesListQueryVariables>;
export const ResolveUserEscalatedIssueDocument = gql`
    mutation ResolveUserEscalatedIssue($id: ID!) {
  resolveUserEscalatedIssue(_id: $id) {
    code
    message
  }
}
    `;
export type ResolveUserEscalatedIssueMutationFn = Apollo.MutationFunction<ResolveUserEscalatedIssueMutation, ResolveUserEscalatedIssueMutationVariables>;

/**
 * __useResolveUserEscalatedIssueMutation__
 *
 * To run a mutation, you first call `useResolveUserEscalatedIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveUserEscalatedIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveUserEscalatedIssueMutation, { data, loading, error }] = useResolveUserEscalatedIssueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResolveUserEscalatedIssueMutation(baseOptions?: Apollo.MutationHookOptions<ResolveUserEscalatedIssueMutation, ResolveUserEscalatedIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveUserEscalatedIssueMutation, ResolveUserEscalatedIssueMutationVariables>(ResolveUserEscalatedIssueDocument, options);
      }
export type ResolveUserEscalatedIssueMutationHookResult = ReturnType<typeof useResolveUserEscalatedIssueMutation>;
export type ResolveUserEscalatedIssueMutationResult = Apollo.MutationResult<ResolveUserEscalatedIssueMutation>;
export type ResolveUserEscalatedIssueMutationOptions = Apollo.BaseMutationOptions<ResolveUserEscalatedIssueMutation, ResolveUserEscalatedIssueMutationVariables>;
export const VerifyBusinessEmailDocument = gql`
    mutation verifyBusinessEmail($userId: ID!) {
  verifyBusinessEmail(userId: $userId) {
    code
    message
  }
}
    `;
export type VerifyBusinessEmailMutationFn = Apollo.MutationFunction<VerifyBusinessEmailMutation, VerifyBusinessEmailMutationVariables>;

/**
 * __useVerifyBusinessEmailMutation__
 *
 * To run a mutation, you first call `useVerifyBusinessEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyBusinessEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyBusinessEmailMutation, { data, loading, error }] = useVerifyBusinessEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useVerifyBusinessEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyBusinessEmailMutation, VerifyBusinessEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyBusinessEmailMutation, VerifyBusinessEmailMutationVariables>(VerifyBusinessEmailDocument, options);
      }
export type VerifyBusinessEmailMutationHookResult = ReturnType<typeof useVerifyBusinessEmailMutation>;
export type VerifyBusinessEmailMutationResult = Apollo.MutationResult<VerifyBusinessEmailMutation>;
export type VerifyBusinessEmailMutationOptions = Apollo.BaseMutationOptions<VerifyBusinessEmailMutation, VerifyBusinessEmailMutationVariables>;